import gql from 'graphql-tag';
import { createMutationFunction, createSmartQueryOptionsFunction, createSmartSubscriptionOptionsFunction } from 'vue-apollo-smart-ops';
import { ApolloError } from 'apollo-client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateImmutable: any;
  DateTime: any;
  FileUpload: any;
};

export enum AccountType {
  Premium = 'premium',
  Test = 'test',
  Trial = 'trial'
}

export type ActivityFeedItem = {
  __typename?: 'ActivityFeedItem';
  createdAt?: Maybe<Scalars['DateTime']>;
  translations?: Maybe<Array<ActivityFeedItemTranslation>>;
  user?: Maybe<User>;
};


export type ActivityFeedItemTranslationsArgs = {
  locale?: InputMaybe<Locale>;
};

export type ActivityFeedItemConnection = {
  __typename?: 'ActivityFeedItemConnection';
  edges?: Maybe<Array<Maybe<ActivityFeedItemEdge>>>;
  pageInfo: PageInfo;
  queryCount?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ActivityFeedItemEdge = {
  __typename?: 'ActivityFeedItemEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<ActivityFeedItem>;
};

export type ActivityFeedItemTranslation = {
  __typename?: 'ActivityFeedItemTranslation';
  attachment?: Maybe<ActivityFeedItemTranslationAttachment>;
  locale?: Maybe<Locale>;
  text?: Maybe<Scalars['String']>;
};

export type ActivityFeedItemTranslationAttachment = {
  __typename?: 'ActivityFeedItemTranslationAttachment';
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
};

export enum ActivityFeedType {
  Global = 'global',
  Mine = 'mine'
}

export type AddNodeToInnovationFieldsInput = {
  innovationFieldIds: Array<Scalars['ID']>;
  nodeId: Scalars['ID'];
};

export type AddNodesToInnovationFieldsInput = {
  innovationFieldIds: Array<Scalars['ID']>;
  nodeIds: Array<Scalars['ID']>;
};

export type AddNodesToWorkspacesInput = {
  nodeIds: Array<Scalars['ID']>;
  workspaceIds: Array<Scalars['ID']>;
};

export type AiChallengesAndOpportunitiesInput = {
  industry: Scalars['String'];
  locale: Locale;
  /** Macro-Trend id */
  trendId: Scalars['ID'];
};

export type AiQuery = {
  __typename?: 'AiQuery';
  challengesAndOpportunities: ChallengesAndOpportunitiesResult;
  explainTrend: Scalars['String'];
};


export type AiQueryChallengesAndOpportunitiesArgs = {
  input: AiChallengesAndOpportunitiesInput;
};


export type AiQueryExplainTrendArgs = {
  input: ExplainTrendInput;
};

export type ChallengesAndOpportunities = {
  __typename?: 'ChallengesAndOpportunities';
  author?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  deletable: Scalars['Boolean'];
  editable: Scalars['Boolean'];
  id: Scalars['ID'];
  industry?: Maybe<Industry>;
  translations: Array<ChallengesAndOpportunitiesTranslation>;
  type: ChallengesAndOpportunitiesType;
};


export type ChallengesAndOpportunitiesTranslationsArgs = {
  locale?: InputMaybe<Locale>;
};

export type ChallengesAndOpportunitiesResult = {
  __typename?: 'ChallengesAndOpportunitiesResult';
  challenges: Scalars['String'];
  opportunities: Scalars['String'];
};

export type ChallengesAndOpportunitiesTranslation = {
  __typename?: 'ChallengesAndOpportunitiesTranslation';
  challenges: Scalars['String'];
  locale: Locale;
  opportunities: Scalars['String'];
  title: Scalars['String'];
};

export enum ChallengesAndOpportunitiesType {
  AdditionalChallengesAndOpportunities = 'ADDITIONAL_CHALLENGES_AND_OPPORTUNITIES',
  CompanyChallengesAndOpportunities = 'COMPANY_CHALLENGES_AND_OPPORTUNITIES',
  TrendoneChallengesAndOpportunities = 'TRENDONE_CHALLENGES_AND_OPPORTUNITIES'
}

export type ChangePasswordInput = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};

export type Comment = NodeInterface & {
  __typename?: 'Comment';
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  owner: User;
  post?: Maybe<Post>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommentInput = {
  body: Scalars['String'];
};

export type CommentMutations = {
  __typename?: 'CommentMutations';
  delete?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Comment>;
};


export type CommentMutationsUpdateArgs = {
  input: UpdateCommentInput;
};

export type Company = NodeInterface & {
  __typename?: 'Company';
  accountType: AccountType;
  automaticUniverseUpdate: Scalars['Boolean'];
  color?: Maybe<Scalars['String']>;
  defaultLocale?: Maybe<Locale>;
  enabledUsers?: Maybe<Scalars['Int']>;
  endDate?: Maybe<Scalars['Date']>;
  exportTemplates?: Maybe<Array<ExportTemplate>>;
  features?: Maybe<Array<Feature>>;
  id: Scalars['ID'];
  locales?: Maybe<Array<Locale>>;
  maxUsers?: Maybe<Scalars['Int']>;
  notificationEmails?: Maybe<Array<Scalars['String']>>;
  passwordLogin: Scalars['Boolean'];
  product?: Maybe<CompanyProduct>;
  publicInnovationFields: Scalars['Boolean'];
  publicInnovationProjects: Scalars['Boolean'];
  startDate?: Maybe<Scalars['Date']>;
  tenantIds?: Maybe<Array<Scalars['String']>>;
  testAccount?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  userSoftLimit?: Maybe<Scalars['Int']>;
  users?: Maybe<PaginatedUsers>;
};


export type CompanyUsersArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type CompanyMacrotrend = MacrotrendInterface & NodeInterface & {
  __typename?: 'CompanyMacrotrend';
  active?: Maybe<Scalars['Boolean']>;
  author?: Maybe<User>;
  challengesAndOpportunities: Array<ChallengesAndOpportunities>;
  color?: Maybe<Scalars['String']>;
  company?: Maybe<Company>;
  copyOfMacrotrend?: Maybe<Macrotrend>;
  drivers: Array<Driver>;
  evaluations?: Maybe<Array<TrendRadarMacrotrendEvaluation>>;
  facets?: Maybe<SearchFacets>;
  hasSubscription?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  innovationFields?: Maybe<PaginatedInnovationFields>;
  innovationProjects: PaginatedInnovationProjects;
  insider?: Maybe<Array<Insider>>;
  mainstreamAdoption?: Maybe<MainstreamAdoption>;
  megatrend?: Maybe<MegatrendInterface>;
  pins?: Maybe<Array<MicrotrendPin>>;
  posts?: Maybe<PaginatedPosts>;
  publicUrl?: Maybe<Scalars['String']>;
  relatedMacrotrends?: Maybe<PaginatedMacrotrends>;
  relatedMicrotrends?: Maybe<PaginatedMicrotrends>;
  search?: Maybe<CompanyMacrotrendSearch>;
  translations?: Maybe<Array<Maybe<CompanyMacrotrendTranslation>>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageCounts?: Maybe<UsageCounts>;
};


export type CompanyMacrotrendImageArgs = {
  gravity?: InputMaybe<ImageGravity>;
  height?: InputMaybe<Scalars['Int']>;
  resize?: InputMaybe<ImageResizeMethod>;
  width?: InputMaybe<Scalars['Int']>;
};


export type CompanyMacrotrendImagesArgs = {
  gravity?: InputMaybe<ImageGravity>;
  height?: InputMaybe<Scalars['Int']>;
  resize?: InputMaybe<ImageResizeMethod>;
  width?: InputMaybe<Scalars['Int']>;
};


export type CompanyMacrotrendInnovationFieldsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type CompanyMacrotrendInnovationProjectsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type CompanyMacrotrendPostsArgs = {
  category: PostCategory;
  companyId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type CompanyMacrotrendPublicUrlArgs = {
  locale: Locale;
};


export type CompanyMacrotrendRelatedMacrotrendsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type CompanyMacrotrendRelatedMicrotrendsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type CompanyMacrotrendTranslationsArgs = {
  locale?: InputMaybe<Locale>;
};

export type CompanyMacrotrendSearch = {
  __typename?: 'CompanyMacrotrendSearch';
  filter?: Maybe<CompanyMacrotrendSearchFilters>;
  query?: Maybe<Scalars['String']>;
};

export type CompanyMacrotrendSearchFilters = {
  __typename?: 'CompanyMacrotrendSearchFilters';
  countries?: Maybe<Array<Scalars['ID']>>;
  industries?: Maybe<Array<Scalars['ID']>>;
  innovationType?: Maybe<Array<Scalars['ID']>>;
  macrotrends?: Maybe<Array<Scalars['ID']>>;
  megatrends?: Maybe<Array<Scalars['ID']>>;
  regions?: Maybe<Array<Scalars['ID']>>;
  sdgs?: Maybe<Array<Scalars['ID']>>;
};

export type CompanyMacrotrendTranslation = MacrotrendTranslationInterface & {
  __typename?: 'CompanyMacrotrendTranslation';
  description?: Maybe<Scalars['String']>;
  locale?: Maybe<Locale>;
  title?: Maybe<Scalars['String']>;
};

export type CompanyMegatrend = MegatrendInterface & NodeInterface & {
  __typename?: 'CompanyMegatrend';
  active?: Maybe<Scalars['Boolean']>;
  author?: Maybe<User>;
  color?: Maybe<Scalars['String']>;
  company: Company;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  macrotrends: Array<MacrotrendInterface>;
  posts?: Maybe<PaginatedPosts>;
  publicUrl?: Maybe<Scalars['String']>;
  relatedMicrotrends?: Maybe<PaginatedMicrotrends>;
  translations?: Maybe<Array<Maybe<CompanyMegatrendTranslation>>>;
};


export type CompanyMegatrendImageArgs = {
  gravity?: InputMaybe<ImageGravity>;
  height?: InputMaybe<Scalars['Int']>;
  resize?: InputMaybe<ImageResizeMethod>;
  width?: InputMaybe<Scalars['Int']>;
};


export type CompanyMegatrendImagesArgs = {
  gravity?: InputMaybe<ImageGravity>;
  height?: InputMaybe<Scalars['Int']>;
  resize?: InputMaybe<ImageResizeMethod>;
  width?: InputMaybe<Scalars['Int']>;
};


export type CompanyMegatrendPostsArgs = {
  category: PostCategory;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type CompanyMegatrendPublicUrlArgs = {
  locale: Locale;
};


export type CompanyMegatrendRelatedMicrotrendsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type CompanyMegatrendTranslationsArgs = {
  locale?: InputMaybe<Locale>;
};

export type CompanyMegatrendTranslation = MegatrendTranslationInterface & {
  __typename?: 'CompanyMegatrendTranslation';
  description?: Maybe<Scalars['String']>;
  locale?: Maybe<Locale>;
  title?: Maybe<Scalars['String']>;
};

export type CompanyMicrotrend = MicrotrendInterface & NodeInterface & {
  __typename?: 'CompanyMicrotrend';
  author?: Maybe<User>;
  comment: Scalars['String'];
  countries?: Maybe<Array<Country>>;
  id: Scalars['ID'];
  identifiedAt?: Maybe<Scalars['DateTime']>;
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  industries: Array<Industry>;
  initiators?: Maybe<Array<Initiator>>;
  innovationTypes?: Maybe<Array<InnovationType>>;
  macrotrends: Array<MacrotrendInterface>;
  megatrends: Array<MegatrendInterface>;
  pins?: Maybe<Array<MicrotrendPin>>;
  publicUrl?: Maybe<Scalars['String']>;
  relatedMicrotrends?: Maybe<PaginatedMicrotrends>;
  sdgs: Array<Sdg>;
  translations?: Maybe<Array<Maybe<MicrotrendTranslation>>>;
  url?: Maybe<Scalars['String']>;
  useCases: Array<MicrotrendUseCase>;
  videos?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CompanyMicrotrendImagesArgs = {
  gravity?: InputMaybe<ImageGravity>;
  height?: InputMaybe<Scalars['Int']>;
  resize?: InputMaybe<ImageResizeMethod>;
  width?: InputMaybe<Scalars['Int']>;
};


export type CompanyMicrotrendRelatedMicrotrendsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type CompanyMicrotrendTranslationsArgs = {
  locale?: InputMaybe<Locale>;
};


export type CompanyMicrotrendUseCasesArgs = {
  locale: Locale;
};

export type CompanyMicrotrendTranslationInput = {
  description: Scalars['String'];
  locale: Locale;
  title: Scalars['String'];
};

export enum CompanyProduct {
  All = 'all',
  Radar = 'radar',
  Strategizer = 'strategizer',
  Trendexplorer = 'trendexplorer',
  Trendmanager = 'trendmanager'
}

export type CopyTrendRadarInput = {
  title: Scalars['String'];
};

export type Country = NodeInterface & {
  __typename?: 'Country';
  code: Scalars['String'];
  id: Scalars['ID'];
  region?: Maybe<Region>;
  translations?: Maybe<Array<Maybe<CountryTranslation>>>;
};


export type CountryTranslationsArgs = {
  locale?: InputMaybe<Locale>;
};

export type CountrySearchFacet = {
  __typename?: 'CountrySearchFacet';
  node: Country;
};

export type CountryTranslation = {
  __typename?: 'CountryTranslation';
  locale?: Maybe<Locale>;
  title?: Maybe<Scalars['String']>;
};

export type CreateCnOInput = {
  challenges: Scalars['String'];
  locale: Locale;
  opportunities: Scalars['String'];
  title: Scalars['String'];
};

export type CreateCompanyMicrotrendInput = {
  comment?: InputMaybe<Scalars['String']>;
  countryIds?: InputMaybe<Array<Scalars['ID']>>;
  image?: InputMaybe<Scalars['FileUpload']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  industryIds?: InputMaybe<Array<Scalars['ID']>>;
  initiators?: InputMaybe<Array<Scalars['String']>>;
  innovationTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  macrotrendIds?: InputMaybe<Array<Scalars['ID']>>;
  translations: Array<CompanyMicrotrendTranslationInput>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateInnovationProjectInput = {
  description: Scalars['String'];
  environment: Scalars['String'];
  image: Scalars['FileUpload'];
  innovationFieldIds: Array<Scalars['ID']>;
  macrotrendIds: Array<Scalars['ID']>;
  objective: Scalars['String'];
  participantIds: Array<Scalars['ID']>;
  publishingState: PublishingState;
  state: InnovationProjectState;
  title: Scalars['String'];
  trendRadarIds: Array<Scalars['ID']>;
};

export type CreateMicrotrendUseCaseInput = {
  locale: Locale;
  microtrendId: Scalars['ID'];
  text: Scalars['String'];
  title: Scalars['String'];
};

export type CreatePostInput = {
  body: Scalars['String'];
  category: PostCategory;
  nodeId: Scalars['ID'];
  title: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
};

export type CreatePostsInput = {
  body: Scalars['String'];
  category: PostCategory;
  nodeIds: Array<Scalars['ID']>;
  title: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
};

export type CreateSearchAgentInput = {
  newWorkspaceTitle?: InputMaybe<Scalars['String']>;
  search: SearchInput;
  title: Scalars['String'];
  workspaces?: InputMaybe<Array<Scalars['ID']>>;
};

export type CreateTrendRadarInput = {
  criteriaSetId: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  managerIds?: InputMaybe<Array<Scalars['ID']>>;
  title: Scalars['String'];
};

export type Criteria = {
  __typename?: 'Criteria';
  adsorb: Scalars['Boolean'];
  id: Scalars['String'];
  marks: Scalars['Int'];
  max: Scalars['Int'];
  min: Scalars['Int'];
  nullable: Scalars['Boolean'];
  scale: Scale;
  translations: Array<CriteriaTranslation>;
  type: CriteriaType;
};


export type CriteriaTranslationsArgs = {
  locale?: InputMaybe<Locale>;
};

export type CriteriaSet = NodeInterface & {
  __typename?: 'CriteriaSet';
  criterias: Array<Criteria>;
  id: Scalars['ID'];
  recommendedActionFormulas: RecommendedActionFormulas;
  translations: Array<CriteriaSetTranslation>;
};


export type CriteriaSetTranslationsArgs = {
  locale?: InputMaybe<Locale>;
};

export type CriteriaSetTranslation = {
  __typename?: 'CriteriaSetTranslation';
  locale: Locale;
  readinessAssessment?: Maybe<ReadinessAssessmentContent>;
  recommendedAction?: Maybe<RecommendedActionContent>;
  title: Scalars['String'];
};

export type CriteriaTranslation = {
  __typename?: 'CriteriaTranslation';
  description?: Maybe<Scalars['String']>;
  labels: Array<Scalars['String']>;
  locale: Scalars['String'];
  title: Scalars['String'];
};

export enum CriteriaType {
  Competences = 'competences',
  Custom = 'custom',
  Maturity = 'maturity',
  Potential = 'potential'
}

export type DateRangeInput = {
  end: Scalars['DateImmutable'];
  start: Scalars['DateImmutable'];
};

export type DeleteCnOInput = {
  id: Scalars['ID'];
};

export type DeleteCompanyMicrotrendInput = {
  id: Scalars['ID'];
};

export type DeleteInnovationProjectInput = {
  id: Scalars['ID'];
};

export type DeleteMicrotrendUseCaseInput = {
  id: Scalars['ID'];
};

export type DeprecatedMacrotrends = {
  __typename?: 'DeprecatedMacrotrends';
  macrotrends?: Maybe<Array<Macrotrend>>;
  panel: TrendRadarPanel;
};

export type DirectSearch = {
  __typename?: 'DirectSearch';
  macrotrends?: Maybe<PaginatedMacrotrends>;
  megatrends?: Maybe<PaginatedMegatrends>;
  microtrends?: Maybe<PaginatedMicrotrends>;
};


export type DirectSearchMacrotrendsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<MacrotrendsSort>;
};


export type DirectSearchMegatrendsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<MegatrendsSort>;
};


export type DirectSearchMicrotrendsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<MicrotrendsSort>;
};

export type Driver = {
  __typename?: 'Driver';
  translations?: Maybe<Array<DriverTranslation>>;
};


export type DriverTranslationsArgs = {
  locale?: InputMaybe<Locale>;
};

export type DriverTranslation = {
  __typename?: 'DriverTranslation';
  description?: Maybe<Scalars['String']>;
  locale?: Maybe<Locale>;
  title?: Maybe<Scalars['String']>;
};

export type EmbeddingTrendradarSharingOption = {
  __typename?: 'EmbeddingTrendradarSharingOption';
  enabled: Scalars['Boolean'];
  id?: Maybe<Scalars['String']>;
};

export type EvaluateMacrotrendInput = {
  macrotrendId: Scalars['ID'];
  trendRadarId: Scalars['ID'];
  values: Array<EvaluationValueInput>;
};

export type Evaluation = {
  __typename?: 'Evaluation';
  id: Scalars['ID'];
  readinessAssessment?: Maybe<ReadinessAssessmentValues>;
  recommendedAction: RecommendedActionValues;
  values?: Maybe<Array<EvaluationValue>>;
};

export type EvaluationValue = {
  __typename?: 'EvaluationValue';
  criteria: Criteria;
  value?: Maybe<Scalars['Float']>;
};

export type EvaluationValueInput = {
  criteriaId: Scalars['String'];
  value?: InputMaybe<Scalars['Float']>;
};

export type ExplainTrendInput = {
  industry: Scalars['String'];
  locale: Locale;
  /** Micro-trend or Macro-Trend id */
  trendId: Scalars['ID'];
};

export type Export = NodeInterface & {
  __typename?: 'Export';
  id: Scalars['ID'];
  status?: Maybe<ExportStatus>;
  url?: Maybe<Scalars['String']>;
};

export enum ExportFormat {
  Pdf = 'pdf',
  Pptx = 'pptx'
}

export type ExportInput = {
  format: ExportFormat;
  id: Scalars['ID'];
  template?: InputMaybe<Scalars['String']>;
};

export enum ExportStatus {
  Error = 'error',
  InProgress = 'in_progress',
  Ready = 'ready'
}

export type ExportTemplate = {
  __typename?: 'ExportTemplate';
  exportTypes?: Maybe<Array<ExportType>>;
  id: Scalars['ID'];
  title: Scalars['String'];
};

export enum ExportType {
  InnovationField = 'innovationField',
  InnovationProject = 'innovationProject',
  Macrotrend = 'macrotrend',
  Microtrend = 'microtrend',
  Trendradar = 'trendradar',
  Workspace = 'workspace'
}

export enum Feature {
  AiBeta = 'AI_BETA',
  AiCompanyTrends = 'AI_COMPANY_TRENDS',
  CompanyMacroMegaTrend = 'COMPANY_MACRO_MEGA_TREND',
  CompanyMicroTrend = 'COMPANY_MICRO_TREND',
  InnovationField = 'INNOVATION_FIELD',
  InnovationProject = 'INNOVATION_PROJECT',
  Insider = 'INSIDER',
  Insights = 'INSIGHTS',
  Pins = 'PINS',
  PublicInnovationFields = 'PUBLIC_INNOVATION_FIELDS',
  PublicInnovationProjects = 'PUBLIC_INNOVATION_PROJECTS',
  SearchAgent = 'SEARCH_AGENT',
  Trendradar = 'TRENDRADAR',
  TrendradarPersonalizedEvaluation = 'TRENDRADAR_PERSONALIZED_EVALUATION',
  TrendradarPublicEvaluation = 'TRENDRADAR_PUBLIC_EVALUATION',
  TrendradarSharingOptions = 'TRENDRADAR_SHARING_OPTIONS',
  UniverseAdmin = 'UNIVERSE_ADMIN',
  UnlockedMicrotrend = 'UNLOCKED_MICROTREND',
  Workspace = 'WORKSPACE'
}

export type FeedbackIntroTranslationInput = {
  locale: Locale;
  text: Scalars['String'];
};

export enum ImageGravity {
  Ce = 'ce',
  Ea = 'ea',
  No = 'no',
  Sm = 'sm',
  So = 'so',
  We = 'we'
}

export enum ImageResizeMethod {
  Crop = 'crop',
  Fill = 'fill',
  Fit = 'fit'
}

export type Industry = NodeInterface & {
  __typename?: 'Industry';
  id: Scalars['ID'];
  translations?: Maybe<Array<Maybe<IndustryTranslation>>>;
};


export type IndustryTranslationsArgs = {
  locale?: InputMaybe<Locale>;
};

export type IndustrySearchFacet = {
  __typename?: 'IndustrySearchFacet';
  node: Industry;
};

export type IndustryTranslation = {
  __typename?: 'IndustryTranslation';
  locale?: Maybe<Locale>;
  title?: Maybe<Scalars['String']>;
};

export type Initiator = NodeInterface & {
  __typename?: 'Initiator';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};

export type InnovationField = NodeInterface & {
  __typename?: 'InnovationField';
  capabilities?: Maybe<Scalars['String']>;
  contactPerson?: Maybe<User>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deprecatedMacrotrends: Array<Macrotrend>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  innovationProjects: PaginatedInnovationProjects;
  macrotrends: Array<MacrotrendInterface>;
  marketOpportunities?: Maybe<Scalars['String']>;
  megatrends: Array<MegatrendInterface>;
  posts: PaginatedPosts;
  publishingState?: Maybe<InnovationFieldPublishingState>;
  relatedMicrotrends: PaginatedMicrotrends;
  technologicalOpportunities?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  trendRadars: PaginatedTrendRadars;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type InnovationFieldImageArgs = {
  gravity?: InputMaybe<ImageGravity>;
  height?: InputMaybe<Scalars['Int']>;
  resize?: InputMaybe<ImageResizeMethod>;
  width?: InputMaybe<Scalars['Int']>;
};


export type InnovationFieldInnovationProjectsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  publishingState?: InputMaybe<PublishingState>;
};


export type InnovationFieldPostsArgs = {
  category: PostCategory;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type InnovationFieldRelatedMicrotrendsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type InnovationFieldTrendRadarsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type InnovationFieldFacets = {
  __typename?: 'InnovationFieldFacets';
  innovationProjects: Array<InnovationProject>;
  trendRadars: Array<TrendRadar>;
};

export type InnovationFieldFilterInput = {
  innovationProject?: InputMaybe<Scalars['ID']>;
  publishingState?: InputMaybe<InnovationFieldPublishingState>;
  trendRadar?: InputMaybe<Scalars['ID']>;
};

export type InnovationFieldInput = {
  capabilities?: InputMaybe<Scalars['String']>;
  contactPersonId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['FileUpload']>;
  innovationProjects?: InputMaybe<Array<Scalars['ID']>>;
  macrotrends?: InputMaybe<Array<Scalars['ID']>>;
  marketOpportunities?: InputMaybe<Scalars['String']>;
  publishingState: InnovationFieldPublishingState;
  technologicalOpportunities?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  trendRadars?: InputMaybe<Array<Scalars['ID']>>;
};

export type InnovationFieldMutations = {
  __typename?: 'InnovationFieldMutations';
  delete?: Maybe<Scalars['Boolean']>;
  removeNodes?: Maybe<InnovationField>;
  update?: Maybe<InnovationField>;
};


export type InnovationFieldMutationsRemoveNodesArgs = {
  input: RemoveNodesInput;
};


export type InnovationFieldMutationsUpdateArgs = {
  input: InnovationFieldInput;
};

export enum InnovationFieldPublishingState {
  Draft = 'draft',
  Published = 'published'
}

export type InnovationFieldsSort = {
  direction: SortOrder;
  field: InnovationFieldsSortSortFields;
};

export enum InnovationFieldsSortSortFields {
  CreatedAt = 'createdAt',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

export type InnovationProject = NodeInterface & {
  __typename?: 'InnovationProject';
  createdAt?: Maybe<Scalars['DateTime']>;
  deprecatedMacrotrends: Array<Macrotrend>;
  description: Scalars['String'];
  environment: Scalars['String'];
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  innovationFields: Array<InnovationField>;
  macrotrends: Array<MacrotrendInterface>;
  megatrends: Array<MegatrendInterface>;
  objective: Scalars['String'];
  participants: Array<User>;
  posts: PaginatedPosts;
  publishingState: PublishingState;
  state: InnovationProjectState;
  title: Scalars['String'];
  trendRadars: Array<PublishedTrendRadar>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type InnovationProjectImageArgs = {
  gravity?: InputMaybe<ImageGravity>;
  height?: InputMaybe<Scalars['Int']>;
  resize?: InputMaybe<ImageResizeMethod>;
  width?: InputMaybe<Scalars['Int']>;
};


export type InnovationProjectPostsArgs = {
  category: PostCategory;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type InnovationProjectFacets = {
  __typename?: 'InnovationProjectFacets';
  innovationFields: Array<NodeSearchFacet>;
  states: Array<InnovationProjectStateFacet>;
  trendRadars: Array<NodeSearchFacet>;
};

export type InnovationProjectFilterInput = {
  innovationField?: InputMaybe<Scalars['ID']>;
  state?: InputMaybe<InnovationProjectState>;
  trendRadar?: InputMaybe<Scalars['ID']>;
};

export type InnovationProjectSort = {
  direction: SortOrder;
  field: InnovationProjectSortField;
};

export enum InnovationProjectSortField {
  CreatedAt = 'createdAt',
  State = 'state',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

export enum InnovationProjectState {
  Execution = 'execution',
  Idea = 'idea',
  Implementation = 'implementation',
  Preparation = 'preparation',
  Stopped = 'stopped'
}

export type InnovationProjectStateFacet = {
  __typename?: 'InnovationProjectStateFacet';
  count: Scalars['Int'];
  state: InnovationProjectState;
};

export type InnovationType = NodeInterface & {
  __typename?: 'InnovationType';
  id: Scalars['ID'];
  translations?: Maybe<Array<Maybe<InnovationTypeTranslation>>>;
};


export type InnovationTypeTranslationsArgs = {
  locale?: InputMaybe<Locale>;
};

export type InnovationTypeSearchFacet = {
  __typename?: 'InnovationTypeSearchFacet';
  node: InnovationType;
};

export type InnovationTypeTranslation = {
  __typename?: 'InnovationTypeTranslation';
  locale?: Maybe<Locale>;
  title?: Maybe<Scalars['String']>;
};

export type Insider = NodeInterface & {
  __typename?: 'Insider';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  trend: MacrotrendInterface;
  user: User;
};

export type Insight = TrendSummary | Trendcall | TrendingTopic;

export type InsightAuthor = {
  __typename?: 'InsightAuthor';
  id: Scalars['ID'];
  image: Scalars['String'];
  name: Scalars['String'];
  title: Scalars['String'];
};


export type InsightAuthorImageArgs = {
  gravity?: InputMaybe<ImageGravity>;
  height?: InputMaybe<Scalars['Int']>;
  resize?: InputMaybe<ImageResizeMethod>;
  width?: InputMaybe<Scalars['Int']>;
};

export type InsightsSort = {
  direction: SortOrder;
  field: InsightsSortField;
};

export enum InsightsSortField {
  Author = 'author',
  Date = 'date',
  Title = 'title'
}

export enum InsightsType {
  Trendcall = 'TRENDCALL',
  TrendingTopic = 'TRENDING_TOPIC',
  TrendSummary = 'TREND_SUMMARY'
}

export type InternalEvaluationOption = {
  __typename?: 'InternalEvaluationOption';
  enabled: Scalars['Boolean'];
  id: Scalars['String'];
  myParticipationId?: Maybe<Scalars['ID']>;
  participants: Array<Participant>;
  participationCounter: ParticipationCounter;
};

export type InternalEvaluationOptionMutations = {
  __typename?: 'InternalEvaluationOptionMutations';
  deleteParticipations: InternalEvaluationOption;
  inviteUsers: InternalEvaluationOption;
  sendMessage: Scalars['Boolean'];
  setEnabled: InternalEvaluationOption;
  uninviteUser: InternalEvaluationOption;
};


export type InternalEvaluationOptionMutationsInviteUsersArgs = {
  input: InviteUsersInput;
};


export type InternalEvaluationOptionMutationsSendMessageArgs = {
  input: SendMessageInput;
};


export type InternalEvaluationOptionMutationsSetEnabledArgs = {
  enabled: Scalars['Boolean'];
};


export type InternalEvaluationOptionMutationsUninviteUserArgs = {
  userId: Scalars['ID'];
};

export type InviteUsersInput = {
  message?: InputMaybe<Scalars['String']>;
  userIds: Array<Scalars['ID']>;
};

export enum Locale {
  De = 'de',
  En = 'en'
}

export type Macrotrend = MacrotrendInterface & NodeInterface & {
  __typename?: 'Macrotrend';
  active?: Maybe<Scalars['Boolean']>;
  challengesAndOpportunities: Array<ChallengesAndOpportunities>;
  color?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  drivers: Array<Driver>;
  evaluations?: Maybe<Array<TrendRadarMacrotrendEvaluation>>;
  hasSubscription?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  innovationFields?: Maybe<PaginatedInnovationFields>;
  innovationProjects: PaginatedInnovationProjects;
  insider?: Maybe<Array<Insider>>;
  mainstreamAdoption?: Maybe<MainstreamAdoption>;
  megatrend?: Maybe<MegatrendInterface>;
  pins?: Maybe<Array<MicrotrendPin>>;
  posts?: Maybe<PaginatedPosts>;
  publicUrl?: Maybe<Scalars['String']>;
  relatedMacrotrends?: Maybe<PaginatedMacrotrends>;
  relatedMicrotrends?: Maybe<PaginatedMicrotrends>;
  successor?: Maybe<MacrotrendInterface>;
  translations?: Maybe<Array<Maybe<MacrotrendTranslation>>>;
};


export type MacrotrendImageArgs = {
  gravity?: InputMaybe<ImageGravity>;
  height?: InputMaybe<Scalars['Int']>;
  resize?: InputMaybe<ImageResizeMethod>;
  width?: InputMaybe<Scalars['Int']>;
};


export type MacrotrendImagesArgs = {
  gravity?: InputMaybe<ImageGravity>;
  height?: InputMaybe<Scalars['Int']>;
  resize?: InputMaybe<ImageResizeMethod>;
  width?: InputMaybe<Scalars['Int']>;
};


export type MacrotrendInnovationFieldsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type MacrotrendInnovationProjectsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type MacrotrendPostsArgs = {
  category: PostCategory;
  companyId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type MacrotrendPublicUrlArgs = {
  locale: Locale;
};


export type MacrotrendRelatedMacrotrendsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type MacrotrendRelatedMicrotrendsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type MacrotrendTranslationsArgs = {
  locale?: InputMaybe<Locale>;
};

export type MacrotrendEvaluation = {
  __typename?: 'MacrotrendEvaluation';
  evaluation?: Maybe<Evaluation>;
  id: Scalars['ID'];
  macrotrend: MacrotrendInterface;
  perception?: Maybe<Scalars['String']>;
};

export type MacrotrendFilter = {
  dateRange: DateRangeInput;
};

export type MacrotrendInterface = {
  color?: Maybe<Scalars['String']>;
  evaluations?: Maybe<Array<TrendRadarMacrotrendEvaluation>>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  megatrend?: Maybe<MegatrendInterface>;
  translations?: Maybe<Array<Maybe<MacrotrendTranslationInterface>>>;
};


export type MacrotrendInterfaceImageArgs = {
  gravity?: InputMaybe<ImageGravity>;
  height?: InputMaybe<Scalars['Int']>;
  resize?: InputMaybe<ImageResizeMethod>;
  width?: InputMaybe<Scalars['Int']>;
};


export type MacrotrendInterfaceTranslationsArgs = {
  locale?: InputMaybe<Locale>;
};

export type MacrotrendMutation = {
  __typename?: 'MacrotrendMutation';
  createCnO: ChallengesAndOpportunities;
  deleteCnO: Scalars['Boolean'];
  updateCnO: ChallengesAndOpportunities;
};


export type MacrotrendMutationCreateCnOArgs = {
  input: CreateCnOInput;
};


export type MacrotrendMutationDeleteCnOArgs = {
  input: DeleteCnOInput;
};


export type MacrotrendMutationUpdateCnOArgs = {
  input: UpdateCnOInput;
};

export type MacrotrendSearchFacet = {
  __typename?: 'MacrotrendSearchFacet';
  node: MacrotrendInterface;
};

export type MacrotrendTranslation = MacrotrendTranslationInterface & {
  __typename?: 'MacrotrendTranslation';
  description?: Maybe<Scalars['String']>;
  locale?: Maybe<Locale>;
  title?: Maybe<Scalars['String']>;
  updateInfo?: Maybe<Scalars['String']>;
};

export type MacrotrendTranslationInterface = {
  description?: Maybe<Scalars['String']>;
  locale?: Maybe<Locale>;
  title?: Maybe<Scalars['String']>;
};

export type MacrotrendsSort = {
  direction: SortOrder;
  field: MacrotrendsSortFields;
};

export enum MacrotrendsSortFields {
  Title = 'title'
}

export type MainstreamAdoption = {
  __typename?: 'MainstreamAdoption';
  range?: Maybe<MainstreamAdoptionRange>;
  translations?: Maybe<Array<Maybe<MainstreamAdoptionTranslation>>>;
};


export type MainstreamAdoptionTranslationsArgs = {
  locale?: InputMaybe<Locale>;
};

export enum MainstreamAdoptionRange {
  From_0To_2Years = 'from_0_to_2_years',
  From_2To_4Years = 'from_2_to_4_years',
  From_4To_6Years = 'from_4_to_6_years',
  From_6To_8Years = 'from_6_to_8_years',
  From_8To_10Years = 'from_8_to_10_years',
  MoreThan_10Years = 'more_than_10_years'
}

export type MainstreamAdoptionTranslation = {
  __typename?: 'MainstreamAdoptionTranslation';
  locale?: Maybe<Locale>;
  text?: Maybe<Scalars['String']>;
};

export type ManagedMacrotrendEvaluation = {
  __typename?: 'ManagedMacrotrendEvaluation';
  averageEvaluation?: Maybe<Evaluation>;
  evaluationCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  macrotrend: MacrotrendInterface;
  overrideEvaluation?: Maybe<Evaluation>;
  panelEvaluations: Array<TrendRadarPanelEvaluation>;
  perception?: Maybe<Scalars['String']>;
};

export type MeMutations = {
  __typename?: 'MeMutations';
  becomeInsiderOf?: Maybe<MacrotrendInterface>;
  changePassword: User;
  deleteAvatar: User;
  setInsightsUpdatesSeen: User;
  setLastFeatureUpdate: User;
  setSeenIntroductionVideo: User;
  stopBeingInsiderOf?: Maybe<MacrotrendInterface>;
  updateProfile: User;
  uploadAvatar: User;
};


export type MeMutationsBecomeInsiderOfArgs = {
  id: Scalars['ID'];
};


export type MeMutationsChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MeMutationsStopBeingInsiderOfArgs = {
  id: Scalars['ID'];
};


export type MeMutationsUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MeMutationsUploadAvatarArgs = {
  input: UploadAvatarInput;
};

export type Megatrend = MegatrendInterface & NodeInterface & {
  __typename?: 'Megatrend';
  active?: Maybe<Scalars['Boolean']>;
  color?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  macrotrends: Array<MacrotrendInterface>;
  posts?: Maybe<PaginatedPosts>;
  publicUrl?: Maybe<Scalars['String']>;
  relatedMicrotrends?: Maybe<PaginatedMicrotrends>;
  successor?: Maybe<Megatrend>;
  translations?: Maybe<Array<Maybe<MegatrendTranslation>>>;
};


export type MegatrendImageArgs = {
  gravity?: InputMaybe<ImageGravity>;
  height?: InputMaybe<Scalars['Int']>;
  resize?: InputMaybe<ImageResizeMethod>;
  width?: InputMaybe<Scalars['Int']>;
};


export type MegatrendImagesArgs = {
  gravity?: InputMaybe<ImageGravity>;
  height?: InputMaybe<Scalars['Int']>;
  resize?: InputMaybe<ImageResizeMethod>;
  width?: InputMaybe<Scalars['Int']>;
};


export type MegatrendPostsArgs = {
  category: PostCategory;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type MegatrendPublicUrlArgs = {
  locale: Locale;
};


export type MegatrendRelatedMicrotrendsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type MegatrendTranslationsArgs = {
  locale?: InputMaybe<Locale>;
};

export type MegatrendInterface = {
  active?: Maybe<Scalars['Boolean']>;
  color?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  macrotrends: Array<MacrotrendInterface>;
  posts?: Maybe<PaginatedPosts>;
  publicUrl?: Maybe<Scalars['String']>;
  relatedMicrotrends?: Maybe<PaginatedMicrotrends>;
  translations?: Maybe<Array<Maybe<MegatrendTranslationInterface>>>;
};


export type MegatrendInterfaceImageArgs = {
  gravity?: InputMaybe<ImageGravity>;
  height?: InputMaybe<Scalars['Int']>;
  resize?: InputMaybe<ImageResizeMethod>;
  width?: InputMaybe<Scalars['Int']>;
};


export type MegatrendInterfaceImagesArgs = {
  gravity?: InputMaybe<ImageGravity>;
  height?: InputMaybe<Scalars['Int']>;
  resize?: InputMaybe<ImageResizeMethod>;
  width?: InputMaybe<Scalars['Int']>;
};


export type MegatrendInterfacePostsArgs = {
  category: PostCategory;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type MegatrendInterfacePublicUrlArgs = {
  locale: Locale;
};


export type MegatrendInterfaceRelatedMicrotrendsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type MegatrendInterfaceTranslationsArgs = {
  locale?: InputMaybe<Locale>;
};

export type MegatrendSearchFacet = {
  __typename?: 'MegatrendSearchFacet';
  node: MegatrendInterface;
};

export type MegatrendTranslation = MegatrendTranslationInterface & {
  __typename?: 'MegatrendTranslation';
  description?: Maybe<Scalars['String']>;
  locale?: Maybe<Locale>;
  title?: Maybe<Scalars['String']>;
  updateInfo?: Maybe<Scalars['String']>;
};

export type MegatrendTranslationInterface = {
  description?: Maybe<Scalars['String']>;
  locale?: Maybe<Locale>;
  title?: Maybe<Scalars['String']>;
};

export type MegatrendsSort = {
  direction: SortOrder;
  field: MegatrendsSortFields;
};

export enum MegatrendsSortFields {
  Title = 'title'
}

export type MergedMacrotrend = {
  __typename?: 'MergedMacrotrend';
  predecessor: Macrotrend;
  successor: Macrotrend;
};

export type Microtrend = MicrotrendInterface & NodeInterface & {
  __typename?: 'Microtrend';
  countries?: Maybe<Array<Country>>;
  id: Scalars['ID'];
  identifiedAt?: Maybe<Scalars['DateTime']>;
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  industries: Array<Industry>;
  initiators?: Maybe<Array<Initiator>>;
  innovationTypes?: Maybe<Array<InnovationType>>;
  macrotrends: Array<MacrotrendInterface>;
  megatrends: Array<MegatrendInterface>;
  pins?: Maybe<Array<MicrotrendPin>>;
  publicUrl?: Maybe<Scalars['String']>;
  relatedMicrotrends?: Maybe<PaginatedMicrotrends>;
  sdgs: Array<Sdg>;
  translations?: Maybe<Array<Maybe<MicrotrendTranslation>>>;
  url?: Maybe<Scalars['String']>;
  useCases: Array<MicrotrendUseCase>;
  videos?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MicrotrendImagesArgs = {
  gravity?: InputMaybe<ImageGravity>;
  height?: InputMaybe<Scalars['Int']>;
  resize?: InputMaybe<ImageResizeMethod>;
  width?: InputMaybe<Scalars['Int']>;
};


export type MicrotrendRelatedMicrotrendsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type MicrotrendTranslationsArgs = {
  locale?: InputMaybe<Locale>;
};


export type MicrotrendUseCasesArgs = {
  locale: Locale;
};

export type MicrotrendFilter = {
  dateRange: DateRangeInput;
};

export type MicrotrendInterface = {
  id: Scalars['ID'];
  identifiedAt?: Maybe<Scalars['DateTime']>;
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  sdgs: Array<Sdg>;
  translations?: Maybe<Array<Maybe<MicrotrendTranslation>>>;
  useCases: Array<MicrotrendUseCase>;
};


export type MicrotrendInterfaceImagesArgs = {
  gravity?: InputMaybe<ImageGravity>;
  height?: InputMaybe<Scalars['Int']>;
  resize?: InputMaybe<ImageResizeMethod>;
  width?: InputMaybe<Scalars['Int']>;
};


export type MicrotrendInterfaceTranslationsArgs = {
  locale?: InputMaybe<Locale>;
};


export type MicrotrendInterfaceUseCasesArgs = {
  locale: Locale;
};

export type MicrotrendPin = {
  __typename?: 'MicrotrendPin';
  id: Scalars['ID'];
  macrotrend: MacrotrendInterface;
  microtrend: MicrotrendInterface;
  pinnedBy?: Maybe<User>;
};

export type MicrotrendTranslation = {
  __typename?: 'MicrotrendTranslation';
  description?: Maybe<Scalars['String']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  locale?: Maybe<Locale>;
  title?: Maybe<Scalars['String']>;
};

export type MicrotrendUseCase = {
  __typename?: 'MicrotrendUseCase';
  author: Scalars['String'];
  createdOn: Scalars['DateTime'];
  deletable: Scalars['Boolean'];
  editable: Scalars['Boolean'];
  id: Scalars['ID'];
  text: Scalars['String'];
  title: Scalars['String'];
};

export type MicrotrendUseCaseMutation = {
  __typename?: 'MicrotrendUseCaseMutation';
  createUseCase: MicrotrendUseCase;
  deleteUseCase: Scalars['Boolean'];
  updateUseCase: MicrotrendUseCase;
};


export type MicrotrendUseCaseMutationCreateUseCaseArgs = {
  input: CreateMicrotrendUseCaseInput;
};


export type MicrotrendUseCaseMutationDeleteUseCaseArgs = {
  input: DeleteMicrotrendUseCaseInput;
};


export type MicrotrendUseCaseMutationUpdateUseCaseArgs = {
  input: UpdateMicrotrendUseCaseInput;
};

export type MicrotrendsSort = {
  direction: SortOrder;
  field: MicrotrendsSortSortFields;
};

export enum MicrotrendsSortSortFields {
  IdentifiedAt = 'identifiedAt',
  InnovationType = 'innovationType',
  Score = 'score',
  Title = 'title'
}

export type Mutation = {
  __typename?: 'Mutation';
  addNodeToInnovationFields: Array<InnovationField>;
  addNodesToInnovationFields: Array<InnovationField>;
  addNodesToWorkspaces: Array<Workspace>;
  comment?: Maybe<CommentMutations>;
  createCompanyMicrotrend?: Maybe<CompanyMicrotrend>;
  createInnovationField?: Maybe<InnovationField>;
  createInnovationProject: InnovationProject;
  createPost: Post;
  createPosts: Array<Post>;
  createSearchAgent?: Maybe<SearchAgent>;
  createTrendRadar?: Maybe<TrendRadarDraft>;
  createWorkspace?: Maybe<Workspace>;
  deleteCompanyMicrotrend: Scalars['Boolean'];
  deleteInnovationProject: Scalars['Boolean'];
  evaluateMacrotrend: TrendRadarParticipation;
  export: Export;
  exportWorkspace: Export;
  innovationField?: Maybe<InnovationFieldMutations>;
  logout: Scalars['Boolean'];
  macrotrend: MacrotrendMutation;
  me?: Maybe<MeMutations>;
  microtrendUseCase: MicrotrendUseCaseMutation;
  pinMicrotrends: Scalars['Boolean'];
  post?: Maybe<PostMutations>;
  proposeInnovationProject: Scalars['Boolean'];
  sendFeedback: Scalars['Boolean'];
  subscribeToMacrotrend?: Maybe<MacrotrendInterface>;
  trendRadar?: Maybe<TrendRadarMutations>;
  unpinMicrotrend: Scalars['Boolean'];
  unsubscribeFromMacrotrend?: Maybe<MacrotrendInterface>;
  updateCompanyMicrotrend: CompanyMicrotrend;
  updateInnovationProject: InnovationProject;
  updatePublicInnovationFieldsState: Scalars['Boolean'];
  updatePublicInnovationProjectsState: Scalars['Boolean'];
  updateSearchAgent?: Maybe<SearchAgent>;
  workspace?: Maybe<WorkspaceMutations>;
};


export type MutationAddNodeToInnovationFieldsArgs = {
  input: AddNodeToInnovationFieldsInput;
};


export type MutationAddNodesToInnovationFieldsArgs = {
  input: AddNodesToInnovationFieldsInput;
};


export type MutationAddNodesToWorkspacesArgs = {
  input: AddNodesToWorkspacesInput;
};


export type MutationCommentArgs = {
  id: Scalars['ID'];
};


export type MutationCreateCompanyMicrotrendArgs = {
  input: CreateCompanyMicrotrendInput;
};


export type MutationCreateInnovationFieldArgs = {
  input: InnovationFieldInput;
};


export type MutationCreateInnovationProjectArgs = {
  input: CreateInnovationProjectInput;
};


export type MutationCreatePostArgs = {
  input: CreatePostInput;
};


export type MutationCreatePostsArgs = {
  input: CreatePostsInput;
};


export type MutationCreateSearchAgentArgs = {
  input: CreateSearchAgentInput;
};


export type MutationCreateTrendRadarArgs = {
  input: CreateTrendRadarInput;
};


export type MutationCreateWorkspaceArgs = {
  input: WorkspaceInput;
};


export type MutationDeleteCompanyMicrotrendArgs = {
  input: DeleteCompanyMicrotrendInput;
};


export type MutationDeleteInnovationProjectArgs = {
  input: DeleteInnovationProjectInput;
};


export type MutationEvaluateMacrotrendArgs = {
  input: EvaluateMacrotrendInput;
};


export type MutationExportArgs = {
  input: ExportInput;
};


export type MutationExportWorkspaceArgs = {
  input: WorkspaceExportInput;
};


export type MutationInnovationFieldArgs = {
  id: Scalars['ID'];
};


export type MutationLogoutArgs = {
  path?: InputMaybe<Scalars['String']>;
};


export type MutationMacrotrendArgs = {
  id: Scalars['ID'];
};


export type MutationPinMicrotrendsArgs = {
  input: PinMicrotrendsInput;
};


export type MutationPostArgs = {
  id: Scalars['ID'];
};


export type MutationProposeInnovationProjectArgs = {
  input: ProposeInnovationProjectInput;
};


export type MutationSendFeedbackArgs = {
  input: SendFeedbackInput;
};


export type MutationSubscribeToMacrotrendArgs = {
  input: SubscribeToMacrotrendInput;
};


export type MutationTrendRadarArgs = {
  id: Scalars['ID'];
};


export type MutationUnpinMicrotrendArgs = {
  input: UnpinMicrotrendInput;
};


export type MutationUnsubscribeFromMacrotrendArgs = {
  input: UnsubscribeFromMacrotrendInput;
};


export type MutationUpdateCompanyMicrotrendArgs = {
  input: UpdateCompanyMicrotrendInput;
};


export type MutationUpdateInnovationProjectArgs = {
  input: UpdateInnovationProjectInput;
};


export type MutationUpdatePublicInnovationFieldsStateArgs = {
  input: PublicInnovationFieldsStateInput;
};


export type MutationUpdatePublicInnovationProjectsStateArgs = {
  input: PublicInnovationProjectsStateInput;
};


export type MutationUpdateSearchAgentArgs = {
  input: UpdateSearchAgentInput;
};


export type MutationWorkspaceArgs = {
  id: Scalars['ID'];
};

export type NodeInterface = {
  id: Scalars['ID'];
};

export type NodeSearchFacet = {
  __typename?: 'NodeSearchFacet';
  count: Scalars['Int'];
  node: NodeInterface;
};

export enum NotificationInterval {
  Daily = 'daily',
  Monthly = 'monthly',
  Off = 'off',
  Weekly = 'weekly'
}

export type OverrideEvaluationInput = {
  macrotrendId: Scalars['ID'];
  values: Array<EvaluationValueInput>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PaginatedCountries = {
  __typename?: 'PaginatedCountries';
  nodes: Array<Country>;
  pageInfo: PaginatedPageInfo;
};

export type PaginatedInitiators = {
  __typename?: 'PaginatedInitiators';
  nodes: Array<Initiator>;
  pageInfo: PaginatedPageInfo;
};

export type PaginatedInnovationFields = {
  __typename?: 'PaginatedInnovationFields';
  facets: InnovationFieldFacets;
  innovationProjectsPublic: Scalars['Boolean'];
  nodes: Array<InnovationField>;
  pageInfo: PaginatedPageInfo;
  privateTrendRadars: Array<Scalars['String']>;
};

export type PaginatedInnovationProjects = {
  __typename?: 'PaginatedInnovationProjects';
  facets: InnovationProjectFacets;
  nodes: Array<InnovationProject>;
  pageInfo: PaginatedPageInfo;
  privateTrendRadars: Array<Scalars['String']>;
};

export type PaginatedInnovationTypes = {
  __typename?: 'PaginatedInnovationTypes';
  nodes: Array<InnovationType>;
  pageInfo: PaginatedPageInfo;
};

export type PaginatedInsights = {
  __typename?: 'PaginatedInsights';
  nodes: Array<Insight>;
  pageInfo: PaginatedPageInfo;
};

export type PaginatedMacrotrends = {
  __typename?: 'PaginatedMacrotrends';
  nodes: Array<MacrotrendInterface>;
  pageInfo: PaginatedPageInfo;
};

export type PaginatedMegatrends = {
  __typename?: 'PaginatedMegatrends';
  nodes: Array<MegatrendInterface>;
  pageInfo: PaginatedPageInfo;
};

export type PaginatedMicrotrends = {
  __typename?: 'PaginatedMicrotrends';
  facets?: Maybe<SearchFacets>;
  nodes: Array<MicrotrendInterface>;
  pageInfo: PaginatedPageInfo;
};

export type PaginatedPageInfo = {
  __typename?: 'PaginatedPageInfo';
  currentPage: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalCount: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type PaginatedPosts = {
  __typename?: 'PaginatedPosts';
  nodes: Array<Post>;
  pageInfo: PaginatedPageInfo;
};

export type PaginatedSearchAgentMicrotrend = {
  __typename?: 'PaginatedSearchAgentMicrotrend';
  nodes?: Maybe<Array<Maybe<SearchAgentMicrotrend>>>;
  pageInfo: PaginatedPageInfo;
};

export type PaginatedSearchAgents = {
  __typename?: 'PaginatedSearchAgents';
  nodes: Array<SearchAgent>;
  pageInfo: PaginatedPageInfo;
};

export type PaginatedTrendRadarParticipations = {
  __typename?: 'PaginatedTrendRadarParticipations';
  nodes: Array<TrendRadarParticipation>;
  pageInfo: PaginatedPageInfo;
};

export type PaginatedTrendRadars = {
  __typename?: 'PaginatedTrendRadars';
  nodes: Array<TrendRadar>;
  pageInfo: PaginatedPageInfo;
};

export type PaginatedUsers = {
  __typename?: 'PaginatedUsers';
  nodes: Array<User>;
  pageInfo: PaginatedPageInfo;
};

export type PaginatedWorkspaceTrends = {
  __typename?: 'PaginatedWorkspaceTrends';
  nodes: Array<WorkspaceTrend>;
  pageInfo: PaginatedPageInfo;
};

export type PaginatedWorkspaces = {
  __typename?: 'PaginatedWorkspaces';
  nodes: Array<Workspace>;
  pageInfo: PaginatedPageInfo;
};

export type Participant = {
  __typename?: 'Participant';
  state: ParticipationState;
  user: User;
};

export enum ParticipantSelection {
  AllParticipants = 'all_participants',
  OnlyCompletedEvaluations = 'only_completed_evaluations',
  OnlyIncompleteEvaluations = 'only_incomplete_evaluations'
}

export type ParticipationCounter = {
  __typename?: 'ParticipationCounter';
  completed: Scalars['Int'];
  incomplete: Scalars['Int'];
  total: Scalars['Int'];
};

export enum ParticipationState {
  FullyEvaluated = 'FULLY_EVALUATED',
  IncompletelyEvaluated = 'INCOMPLETELY_EVALUATED',
  NotEvaluated = 'NOT_EVALUATED'
}

export type PinMicrotrendsInput = {
  macrotrendIds?: InputMaybe<Array<Scalars['ID']>>;
  microtrendIds: Array<Scalars['ID']>;
};

export type Post = NodeInterface & {
  __typename?: 'Post';
  body: Scalars['String'];
  category: PostCategory;
  comments?: Maybe<Array<Maybe<Comment>>>;
  company: Company;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  node: NodeInterface;
  owner: User;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
};

export enum PostCategory {
  Chances = 'chances',
  ExtendedSources = 'extendedSources',
  Risks = 'risks',
  Updates = 'updates'
}

export type PostMutations = {
  __typename?: 'PostMutations';
  comment?: Maybe<Comment>;
  delete?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Post>;
};


export type PostMutationsCommentArgs = {
  input: CommentInput;
};


export type PostMutationsUpdateArgs = {
  input: UpdatePostInput;
};

export type ProposeInnovationProjectInput = {
  description: Scalars['String'];
  title: Scalars['String'];
};

export type PublicEvaluationFeedbackIntroTranslation = {
  __typename?: 'PublicEvaluationFeedbackIntroTranslation';
  locale: Locale;
  text: Scalars['String'];
};

export type PublicEvaluationIntroTranslation = {
  __typename?: 'PublicEvaluationIntroTranslation';
  description: Scalars['String'];
  feedbackIntro: Scalars['String'];
  locale: Locale;
  title: Scalars['String'];
};

export type PublicEvaluationIntroTranslationInput = {
  description: Scalars['String'];
  locale: Locale;
  title: Scalars['String'];
};

export type PublicEvaluationOption = {
  __typename?: 'PublicEvaluationOption';
  enabled: Scalars['Boolean'];
  feedbackEnabled: Scalars['Boolean'];
  feedbackTranslations: Array<PublicEvaluationFeedbackIntroTranslation>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  participationCounter: ParticipationCounter;
  translations: Array<PublicEvaluationIntroTranslation>;
};


export type PublicEvaluationOptionImageArgs = {
  gravity?: InputMaybe<ImageGravity>;
  height?: InputMaybe<Scalars['Int']>;
  resize?: InputMaybe<ImageResizeMethod>;
  width?: InputMaybe<Scalars['Int']>;
};

export type PublicEvaluationOptionIntroTranslationsInput = {
  translations: Array<PublicEvaluationIntroTranslationInput>;
};

export type PublicEvaluationOptionMutations = {
  __typename?: 'PublicEvaluationOptionMutations';
  deleteParticipations: PublicEvaluationOption;
  deletePublicEvaluationLogo: PublicEvaluationOption;
  setEnabled: PublicEvaluationOption;
  setFeedbackEnabled: PublicEvaluationOption;
  updateFeedbackIntroText: PublicEvaluationOption;
  updateIntroTranslations: PublicEvaluationOption;
  updatePublicEvaluationLogo: PublicEvaluationOption;
};


export type PublicEvaluationOptionMutationsSetEnabledArgs = {
  enabled: Scalars['Boolean'];
};


export type PublicEvaluationOptionMutationsSetFeedbackEnabledArgs = {
  enabled: Scalars['Boolean'];
};


export type PublicEvaluationOptionMutationsUpdateFeedbackIntroTextArgs = {
  input: UpdateFeedbackIntroTextInput;
};


export type PublicEvaluationOptionMutationsUpdateIntroTranslationsArgs = {
  input: PublicEvaluationOptionIntroTranslationsInput;
};


export type PublicEvaluationOptionMutationsUpdatePublicEvaluationLogoArgs = {
  logo: Scalars['FileUpload'];
};

export type PublicInnovationFieldsStateInput = {
  active: Scalars['Boolean'];
};

export type PublicInnovationProjectsStateInput = {
  active: Scalars['Boolean'];
};

export type PublicViewTrendradarSharingOption = {
  __typename?: 'PublicViewTrendradarSharingOption';
  enabled: Scalars['Boolean'];
  id?: Maybe<Scalars['String']>;
};

export type PublishedTrendRadar = NodeInterface & TrendRadar & {
  __typename?: 'PublishedTrendRadar';
  criteriaSet: CriteriaSet;
  deprecatedMacrotrends: Array<DeprecatedMacrotrends>;
  description?: Maybe<Scalars['String']>;
  draftId: Scalars['ID'];
  evaluations: Array<MacrotrendEvaluation>;
  id: Scalars['ID'];
  image: Scalars['String'];
  innovationFields?: Maybe<PaginatedInnovationFields>;
  innovationProjects: PaginatedInnovationProjects;
  managers: Array<User>;
  posts?: Maybe<PaginatedPosts>;
  publicId: Scalars['ID'];
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type PublishedTrendRadarImageArgs = {
  gravity?: InputMaybe<ImageGravity>;
  height?: InputMaybe<Scalars['Int']>;
  resize?: InputMaybe<ImageResizeMethod>;
  width?: InputMaybe<Scalars['Int']>;
};


export type PublishedTrendRadarInnovationFieldsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type PublishedTrendRadarInnovationProjectsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type PublishedTrendRadarPostsArgs = {
  category: PostCategory;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  recommendedAction: RecommendedActionValues;
};

export enum PublishingState {
  Draft = 'draft',
  Published = 'published'
}

export type Query = {
  __typename?: 'Query';
  _trendReferences?: Maybe<TrendReferences>;
  activityFeed?: Maybe<ActivityFeedItemConnection>;
  ai: AiQuery;
  countries?: Maybe<PaginatedCountries>;
  criteriaSets?: Maybe<Array<CriteriaSet>>;
  directSearch?: Maybe<DirectSearch>;
  industries: Array<Industry>;
  initiators?: Maybe<PaginatedInitiators>;
  innovationFields?: Maybe<PaginatedInnovationFields>;
  innovationProjects?: Maybe<PaginatedInnovationProjects>;
  innovationTypes?: Maybe<PaginatedInnovationTypes>;
  insights?: Maybe<PaginatedInsights>;
  introducedMacrotrends: Array<Macrotrend>;
  introducedMegatrends: Array<Megatrend>;
  macrotrends: Array<MacrotrendInterface>;
  me?: Maybe<User>;
  mergedMacrotrends: Array<MergedMacrotrend>;
  node?: Maybe<NodeInterface>;
  nodes?: Maybe<Array<Maybe<NodeInterface>>>;
  publicInnovationFieldsUrl?: Maybe<Scalars['String']>;
  publicInnovationProjectsUrl?: Maybe<Scalars['String']>;
  recommendedActionPreview: RecommendedActionValues;
  replacedMacrotrends: Array<ReplacedMacrotrend>;
  revisedMacrotrends: Array<Macrotrend>;
  revisedMegatrends: Array<Megatrend>;
  scrapedInfos?: Maybe<ScrapedInfos>;
  search?: Maybe<Search>;
  trendRadarParticipations?: Maybe<PaginatedTrendRadarParticipations>;
  trendRadars?: Maybe<PaginatedTrendRadars>;
  ui: UserInterfaceInformation;
  updateableWorkspaces: Array<Workspace>;
  users: Array<User>;
  workspaces?: Maybe<PaginatedWorkspaces>;
};


export type QueryActivityFeedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<ActivityFeedType>;
};


export type QueryCountriesArgs = {
  filter?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Locale>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryDirectSearchArgs = {
  filter?: InputMaybe<SearchFiltersInput>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryInitiatorsArgs = {
  filter?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryInnovationFieldsArgs = {
  filter?: InputMaybe<InnovationFieldFilterInput>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<InnovationFieldsSort>;
};


export type QueryInnovationProjectsArgs = {
  filter?: InputMaybe<InnovationProjectFilterInput>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<InnovationProjectSort>;
};


export type QueryInnovationTypesArgs = {
  filter?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryInsightsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<InsightsSort>;
  type: InsightsType;
};


export type QueryNodeArgs = {
  id: Scalars['ID'];
};


export type QueryNodesArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryRecommendedActionPreviewArgs = {
  input: RecommendedActionPreviewInput;
};


export type QueryScrapedInfosArgs = {
  url: Scalars['String'];
};


export type QuerySearchArgs = {
  filter?: InputMaybe<SearchFiltersInput>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryTrendRadarParticipationsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<TrendRadarParticipationSort>;
};


export type QueryTrendRadarsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<TrendRadarSort>;
};


export type QueryUpdateableWorkspacesArgs = {
  sort?: InputMaybe<WorkspaceSort>;
};


export type QueryWorkspacesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<WorkspaceSort>;
};

export type ReadinessAssessmentContent = {
  __typename?: 'ReadinessAssessmentContent';
  buy?: Maybe<Scalars['String']>;
  learn?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  preserve?: Maybe<Scalars['String']>;
};

export enum ReadinessAssessmentValues {
  Buy = 'BUY',
  Learn = 'LEARN',
  Make = 'MAKE',
  Preserve = 'PRESERVE'
}

export type RecommendedActionContent = {
  __typename?: 'RecommendedActionContent';
  actDescription: Scalars['String'];
  actTitle: Scalars['String'];
  outOfScopeDescription: Scalars['String'];
  outOfScopeTitle: Scalars['String'];
  prepareDescription: Scalars['String'];
  prepareTitle: Scalars['String'];
  watchDescription: Scalars['String'];
  watchTitle: Scalars['String'];
};

export type RecommendedActionFormulas = {
  __typename?: 'RecommendedActionFormulas';
  act: Scalars['String'];
  prepare: Scalars['String'];
  watch: Scalars['String'];
};

export type RecommendedActionPreviewInput = {
  competences: Scalars['Float'];
  criteriaSetId: Scalars['ID'];
  maturity: Scalars['Float'];
  potential: Scalars['Float'];
};

export enum RecommendedActionValues {
  Act = 'ACT',
  OutOfScope = 'OUT_OF_SCOPE',
  Prepare = 'PREPARE',
  Watch = 'WATCH'
}

export type ReducedMacrotrend = MacrotrendInterface & NodeInterface & {
  __typename?: 'ReducedMacrotrend';
  color?: Maybe<Scalars['String']>;
  evaluations?: Maybe<Array<TrendRadarMacrotrendEvaluation>>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  megatrend?: Maybe<MegatrendInterface>;
  translations?: Maybe<Array<Maybe<MacrotrendTranslation>>>;
};


export type ReducedMacrotrendImageArgs = {
  gravity?: InputMaybe<ImageGravity>;
  height?: InputMaybe<Scalars['Int']>;
  resize?: InputMaybe<ImageResizeMethod>;
  width?: InputMaybe<Scalars['Int']>;
};


export type ReducedMacrotrendTranslationsArgs = {
  locale?: InputMaybe<Locale>;
};

export type ReducedMicrotrend = MicrotrendInterface & NodeInterface & {
  __typename?: 'ReducedMicrotrend';
  id: Scalars['ID'];
  identifiedAt?: Maybe<Scalars['DateTime']>;
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  sdgs: Array<Sdg>;
  translations?: Maybe<Array<Maybe<MicrotrendTranslation>>>;
  useCases: Array<MicrotrendUseCase>;
};


export type ReducedMicrotrendImagesArgs = {
  gravity?: InputMaybe<ImageGravity>;
  height?: InputMaybe<Scalars['Int']>;
  resize?: InputMaybe<ImageResizeMethod>;
  width?: InputMaybe<Scalars['Int']>;
};


export type ReducedMicrotrendTranslationsArgs = {
  locale?: InputMaybe<Locale>;
};


export type ReducedMicrotrendUseCasesArgs = {
  locale: Locale;
};

export type Region = NodeInterface & {
  __typename?: 'Region';
  code: Scalars['String'];
  countries?: Maybe<PaginatedCountries>;
  id: Scalars['ID'];
  translations?: Maybe<Array<Maybe<RegionTranslation>>>;
};


export type RegionCountriesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type RegionTranslationsArgs = {
  locale?: InputMaybe<Locale>;
};

export type RegionSearchFacet = {
  __typename?: 'RegionSearchFacet';
  node: Region;
};

export type RegionTranslation = {
  __typename?: 'RegionTranslation';
  locale?: Maybe<Locale>;
  title?: Maybe<Scalars['String']>;
};

export type RemoveNodesInput = {
  ids: Array<Scalars['ID']>;
};

export type ReplacedMacrotrend = {
  __typename?: 'ReplacedMacrotrend';
  predecessor: Macrotrend;
  successor: Macrotrend;
};

export enum Roles {
  RoleAdmin = 'ROLE_ADMIN',
  RoleSuperAdmin = 'ROLE_SUPER_ADMIN',
  RoleSuperAdminConsulting = 'ROLE_SUPER_ADMIN_CONSULTING',
  RoleSuperAdminInsights = 'ROLE_SUPER_ADMIN_INSIGHTS',
  RoleTrendManager = 'ROLE_TREND_MANAGER',
  RoleUser = 'ROLE_USER'
}

export type Sdg = {
  __typename?: 'SDG';
  id: Scalars['ID'];
  translations: Array<SdgTranslation>;
};


export type SdgTranslationsArgs = {
  locale?: InputMaybe<Locale>;
};

export type SdgTranslation = {
  __typename?: 'SDGTranslation';
  description: Scalars['String'];
  locale: Locale;
  title: Scalars['String'];
};

export enum Scale {
  FiveMarks = 'five_marks',
  HundredFree = 'hundred_free',
  SevenMarks = 'seven_marks',
  SixMarks = 'six_marks',
  ThreeMarks = 'three_marks'
}

export type ScrapedInfos = {
  __typename?: 'ScrapedInfos';
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type SdgSearchFacet = {
  __typename?: 'SdgSearchFacet';
  node: Sdg;
};

export type Search = {
  __typename?: 'Search';
  macrotrends?: Maybe<PaginatedMacrotrends>;
  megatrends?: Maybe<PaginatedMegatrends>;
  microtrends?: Maybe<PaginatedMicrotrends>;
};


export type SearchMacrotrendsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<MacrotrendsSort>;
};


export type SearchMegatrendsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<MegatrendsSort>;
};


export type SearchMicrotrendsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<MicrotrendsSort>;
};

export type SearchAgent = NodeInterface & {
  __typename?: 'SearchAgent';
  facets?: Maybe<SearchFacets>;
  hasDeprecatedMacrotrends: Scalars['Boolean'];
  id: Scalars['ID'];
  search?: Maybe<SearchParameters>;
  title: Scalars['String'];
  trendCounts: SearchAgentWorkspaceTrendCounts;
  trends?: Maybe<PaginatedSearchAgentMicrotrend>;
  workspaces?: Maybe<Array<Maybe<Workspace>>>;
};


export type SearchAgentTrendCountsArgs = {
  workspaceId: Scalars['ID'];
};


export type SearchAgentTrendsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<SearchAgentTrendType>;
  workspaceId: Scalars['ID'];
};

export type SearchAgentBatchVoteInput = {
  id: Scalars['ID'];
  type: SearchAgentTrendType;
};

export type SearchAgentMicrotrend = {
  __typename?: 'SearchAgentMicrotrend';
  microtrend?: Maybe<MicrotrendInterface>;
  new?: Maybe<Scalars['Boolean']>;
  searchAgent: SearchAgent;
};

export type SearchAgentTrendCounts = {
  __typename?: 'SearchAgentTrendCounts';
  new: Scalars['Int'];
  unvoted: Scalars['Int'];
};

export enum SearchAgentTrendType {
  Accepted = 'accepted',
  Rejected = 'rejected',
  Unvoted = 'unvoted'
}

export type SearchAgentWorkspaceTrendCounts = {
  __typename?: 'SearchAgentWorkspaceTrendCounts';
  accepted: Scalars['Int'];
  new: Scalars['Int'];
  rejected: Scalars['Int'];
  unvoted: Scalars['Int'];
};

export type SearchFacets = {
  __typename?: 'SearchFacets';
  countries: Array<CountrySearchFacet>;
  industries: Array<IndustrySearchFacet>;
  innovationType: Array<InnovationTypeSearchFacet>;
  macrotrends: Array<MacrotrendSearchFacet>;
  megatrends: Array<MegatrendSearchFacet>;
  regions: Array<RegionSearchFacet>;
  sdgs: Array<SdgSearchFacet>;
  trendradars: Array<TrendradarSearchFacet>;
};

export type SearchFilters = {
  __typename?: 'SearchFilters';
  countries?: Maybe<Array<Scalars['ID']>>;
  industries?: Maybe<Array<Scalars['ID']>>;
  innovationType?: Maybe<Array<Scalars['ID']>>;
  macrotrends?: Maybe<Array<Scalars['ID']>>;
  megatrends?: Maybe<Array<Scalars['ID']>>;
  regions?: Maybe<Array<Scalars['ID']>>;
  sdgs?: Maybe<Array<Scalars['ID']>>;
};

export type SearchFiltersInput = {
  companyTrendsOnly?: InputMaybe<Scalars['Boolean']>;
  countries?: InputMaybe<Array<Scalars['ID']>>;
  dateRange?: InputMaybe<DateRangeInput>;
  industries?: InputMaybe<Array<Scalars['ID']>>;
  innovationType?: InputMaybe<Array<Scalars['ID']>>;
  macrotrends?: InputMaybe<Array<Scalars['ID']>>;
  megatrends?: InputMaybe<Array<Scalars['ID']>>;
  regions?: InputMaybe<Array<Scalars['ID']>>;
  sdgs?: InputMaybe<Array<Scalars['ID']>>;
  trendoneTrendsOnly?: InputMaybe<Scalars['Boolean']>;
  trendradars?: InputMaybe<Array<Scalars['ID']>>;
  trendsWithUseCasesOnly?: InputMaybe<Scalars['Boolean']>;
};

export type SearchInput = {
  filter?: InputMaybe<SearchFiltersInput>;
  query?: InputMaybe<Scalars['String']>;
};

export type SearchParameters = {
  __typename?: 'SearchParameters';
  filter?: Maybe<SearchFilters>;
  query?: Maybe<Scalars['String']>;
};

export type SendFeedbackInput = {
  message: Scalars['String'];
  subject?: InputMaybe<Scalars['String']>;
};

export type SendMessageInput = {
  message: Scalars['String'];
  recipients: ParticipantSelection;
};

export type SetPerceptionInput = {
  macrotrendId: Scalars['ID'];
  text?: InputMaybe<Scalars['String']>;
};

export type SetSharingOptionsInput = {
  embedding: Scalars['Boolean'];
  publicView: Scalars['Boolean'];
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SubscribeToMacrotrendInput = {
  macrotrendId: Scalars['ID'];
};

export type TrendRadar = {
  criteriaSet: CriteriaSet;
  deprecatedMacrotrends: Array<DeprecatedMacrotrends>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image: Scalars['String'];
  innovationFields?: Maybe<PaginatedInnovationFields>;
  innovationProjects: PaginatedInnovationProjects;
  managers: Array<User>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type TrendRadarImageArgs = {
  gravity?: InputMaybe<ImageGravity>;
  height?: InputMaybe<Scalars['Int']>;
  resize?: InputMaybe<ImageResizeMethod>;
  width?: InputMaybe<Scalars['Int']>;
};


export type TrendRadarInnovationFieldsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type TrendRadarInnovationProjectsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type TrendRadarDraft = NodeInterface & TrendRadar & {
  __typename?: 'TrendRadarDraft';
  constraints: TrendRadarDraftConstraints;
  criteriaSet: CriteriaSet;
  criteriaSetChangeable: Scalars['Boolean'];
  deprecatedMacrotrends: Array<DeprecatedMacrotrends>;
  description?: Maybe<Scalars['String']>;
  evaluationEnabled: Scalars['Boolean'];
  evaluations?: Maybe<Array<ManagedMacrotrendEvaluation>>;
  hasUnpublishedChanges: Scalars['Boolean'];
  id: Scalars['ID'];
  image: Scalars['String'];
  innovationFields?: Maybe<PaginatedInnovationFields>;
  innovationProjects: PaginatedInnovationProjects;
  managers: Array<User>;
  panels: Array<TrendRadarPanel>;
  participants: Array<Participant>;
  publicEvaluationOption?: Maybe<PublicEvaluationOption>;
  publishable: Scalars['Boolean'];
  published: Scalars['Boolean'];
  publishedId?: Maybe<Scalars['ID']>;
  sharingOptions: TrendradarSharingOptions;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type TrendRadarDraftImageArgs = {
  gravity?: InputMaybe<ImageGravity>;
  height?: InputMaybe<Scalars['Int']>;
  resize?: InputMaybe<ImageResizeMethod>;
  width?: InputMaybe<Scalars['Int']>;
};


export type TrendRadarDraftInnovationFieldsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type TrendRadarDraftInnovationProjectsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type TrendRadarDraftConstraints = {
  __typename?: 'TrendRadarDraftConstraints';
  internalParticipantsMinimum: Scalars['Int'];
};

export type TrendRadarMacrotrendEvaluation = {
  __typename?: 'TrendRadarMacrotrendEvaluation';
  evaluation: Evaluation;
  id: Scalars['ID'];
  macrotrend: MacrotrendInterface;
  perception?: Maybe<Scalars['String']>;
  trendRadar: PublishedTrendRadar;
};

export type TrendRadarMutations = {
  __typename?: 'TrendRadarMutations';
  copy: TrendRadarDraft;
  createPanel: TrendRadarDraft;
  delete?: Maybe<Scalars['Boolean']>;
  deleteOverride?: Maybe<TrendRadarDraft>;
  deletePanel: TrendRadarDraft;
  deleteSharingOptionsLogo?: Maybe<TrendRadarDraft>;
  overrideEvaluation?: Maybe<TrendRadarDraft>;
  panel: TrendRadarPanelMutations;
  publish?: Maybe<TrendRadarDraft>;
  republish?: Maybe<TrendRadarDraft>;
  setEvaluationEnabled: TrendRadarDraft;
  setPerception?: Maybe<TrendRadarDraft>;
  setSharingOptions?: Maybe<TrendradarSharingOptions>;
  setSharingOptionsLogo?: Maybe<TrendRadarDraft>;
  unpublish?: Maybe<TrendRadarDraft>;
  update: TrendRadarDraft;
};


export type TrendRadarMutationsCopyArgs = {
  input: CopyTrendRadarInput;
};


export type TrendRadarMutationsDeleteOverrideArgs = {
  macrotrendId: Scalars['ID'];
};


export type TrendRadarMutationsDeletePanelArgs = {
  panelId: Scalars['ID'];
};


export type TrendRadarMutationsOverrideEvaluationArgs = {
  input: OverrideEvaluationInput;
};


export type TrendRadarMutationsPanelArgs = {
  id: Scalars['ID'];
};


export type TrendRadarMutationsPublishArgs = {
  description?: InputMaybe<Scalars['String']>;
};


export type TrendRadarMutationsSetEvaluationEnabledArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
};


export type TrendRadarMutationsSetPerceptionArgs = {
  input: SetPerceptionInput;
};


export type TrendRadarMutationsSetSharingOptionsArgs = {
  input: SetSharingOptionsInput;
};


export type TrendRadarMutationsSetSharingOptionsLogoArgs = {
  logo: Scalars['FileUpload'];
};


export type TrendRadarMutationsUpdateArgs = {
  input: UpdateTrendRadarInput;
};

export type TrendRadarPanel = {
  __typename?: 'TrendRadarPanel';
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  internalEvaluationOption?: Maybe<InternalEvaluationOption>;
  macrotrends: Array<MacrotrendInterface>;
  publicEvaluationOption?: Maybe<PublicEvaluationOption>;
  title: Scalars['String'];
};

export type TrendRadarPanelEvaluation = {
  __typename?: 'TrendRadarPanelEvaluation';
  averageEvaluation?: Maybe<Evaluation>;
  panel: TrendRadarPanel;
};

export type TrendRadarPanelMutations = {
  __typename?: 'TrendRadarPanelMutations';
  internalEvaluationOption: InternalEvaluationOptionMutations;
  publicEvaluationOption: PublicEvaluationOptionMutations;
  setEnabled: TrendRadarPanel;
  update: TrendRadarPanel;
  updateMacrotrends: TrendRadarPanel;
};


export type TrendRadarPanelMutationsSetEnabledArgs = {
  enabled: Scalars['Boolean'];
};


export type TrendRadarPanelMutationsUpdateArgs = {
  input: UpdateTrendRadarPanelInput;
};


export type TrendRadarPanelMutationsUpdateMacrotrendsArgs = {
  macrotrendIds: Array<Scalars['ID']>;
};

export type TrendRadarParticipation = NodeInterface & {
  __typename?: 'TrendRadarParticipation';
  criteriaSet: CriteriaSet;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  evaluationEnabled: Scalars['Boolean'];
  evaluations?: Maybe<Array<MacrotrendEvaluation>>;
  id: Scalars['ID'];
  image: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrendRadarParticipationSort = {
  direction: SortOrder;
  field: TrendRadarParticipationSortField;
};

export enum TrendRadarParticipationSortField {
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

export type TrendRadarSort = {
  direction: SortOrder;
  field: TrendRadarSortField;
};

export enum TrendRadarSortField {
  PublishedTrendRadar = 'publishedTrendRadar',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

export type TrendReferences = {
  __typename?: 'TrendReferences';
  companyMacrotrend?: Maybe<CompanyMacrotrend>;
  companyMegatrend?: Maybe<CompanyMegatrend>;
  macrotrend?: Maybe<Macrotrend>;
  megatrend?: Maybe<Megatrend>;
  microtrend?: Maybe<Microtrend>;
  reducedMacrotrend?: Maybe<ReducedMacrotrend>;
  reducedMicrotrend?: Maybe<ReducedMicrotrend>;
};

export type TrendSummary = NodeInterface & {
  __typename?: 'TrendSummary';
  author: InsightAuthor;
  date: Scalars['Date'];
  id: Scalars['ID'];
  image: Scalars['String'];
  microtrends?: Maybe<Array<MicrotrendInterface>>;
  pdf: Scalars['String'];
  ppt: Scalars['String'];
  title: Scalars['String'];
};


export type TrendSummaryImageArgs = {
  gravity?: InputMaybe<ImageGravity>;
  height?: InputMaybe<Scalars['Int']>;
  resize?: InputMaybe<ImageResizeMethod>;
  width?: InputMaybe<Scalars['Int']>;
};

export type Trendcall = NodeInterface & {
  __typename?: 'Trendcall';
  author: InsightAuthor;
  date: Scalars['Date'];
  description: Scalars['String'];
  id: Scalars['ID'];
  image: Scalars['String'];
  title: Scalars['String'];
  video: Scalars['String'];
};


export type TrendcallImageArgs = {
  gravity?: InputMaybe<ImageGravity>;
  height?: InputMaybe<Scalars['Int']>;
  resize?: InputMaybe<ImageResizeMethod>;
  width?: InputMaybe<Scalars['Int']>;
};

export type TrendingTopic = NodeInterface & {
  __typename?: 'TrendingTopic';
  author: InsightAuthor;
  date: Scalars['Date'];
  description: Scalars['String'];
  id: Scalars['ID'];
  image: Scalars['String'];
  industries?: Maybe<Array<Industry>>;
  macrotrends?: Maybe<Array<Macrotrend>>;
  microtrends?: Maybe<Array<MicrotrendInterface>>;
  title: Scalars['String'];
  trendcall?: Maybe<Trendcall>;
};


export type TrendingTopicImageArgs = {
  gravity?: InputMaybe<ImageGravity>;
  height?: InputMaybe<Scalars['Int']>;
  resize?: InputMaybe<ImageResizeMethod>;
  width?: InputMaybe<Scalars['Int']>;
};

export type TrendradarSearchFacet = {
  __typename?: 'TrendradarSearchFacet';
  node: TrendRadar;
};

export type TrendradarSharingOptions = {
  __typename?: 'TrendradarSharingOptions';
  embedding: EmbeddingTrendradarSharingOption;
  image?: Maybe<Scalars['String']>;
  publicView: PublicViewTrendradarSharingOption;
};

export type UnpinMicrotrendInput = {
  macrotrendId: Scalars['ID'];
  microtrendId: Scalars['ID'];
  removeCompanyMicrotrendMacrotrendContext?: InputMaybe<Scalars['Boolean']>;
};

export type UnsubscribeFromMacrotrendInput = {
  macrotrendId: Scalars['ID'];
};

export type UpdateCnOInput = {
  challenges: Scalars['String'];
  id: Scalars['ID'];
  locale: Locale;
  opportunities: Scalars['String'];
  title: Scalars['String'];
};

export type UpdateCommentInput = {
  body?: InputMaybe<Scalars['String']>;
};

export type UpdateCompanyMicrotrendInput = {
  comment?: InputMaybe<Scalars['String']>;
  countryIds?: InputMaybe<Array<Scalars['ID']>>;
  id: Scalars['ID'];
  image?: InputMaybe<Scalars['FileUpload']>;
  industryIds?: InputMaybe<Array<Scalars['ID']>>;
  initiators?: InputMaybe<Array<Scalars['String']>>;
  innovationTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  macrotrendIds?: InputMaybe<Array<Scalars['ID']>>;
  translations?: InputMaybe<Array<CompanyMicrotrendTranslationInput>>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateFeedbackIntroTextInput = {
  translations: Array<FeedbackIntroTranslationInput>;
};

export type UpdateInnovationProjectInput = {
  description: Scalars['String'];
  environment: Scalars['String'];
  id: Scalars['ID'];
  image?: InputMaybe<Scalars['FileUpload']>;
  innovationFieldIds?: InputMaybe<Array<Scalars['ID']>>;
  macrotrendIds: Array<Scalars['ID']>;
  objective: Scalars['String'];
  participantIds: Array<Scalars['ID']>;
  publishingState: PublishingState;
  state: InnovationProjectState;
  title: Scalars['String'];
  trendRadarIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateMicrotrendUseCaseInput = {
  id: Scalars['ID'];
  text: Scalars['String'];
  title: Scalars['String'];
};

export type UpdatePostInput = {
  body: Scalars['String'];
  title: Scalars['String'];
};

export type UpdateProfileInput = {
  featureUpdatesDisabled?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  jobPosition?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Locale>;
  phone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateSearchAgentInput = {
  id: Scalars['ID'];
  search: SearchInput;
  title: Scalars['String'];
};

export type UpdateTrendRadarInput = {
  criteriaSetId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  managerIds?: InputMaybe<Array<Scalars['ID']>>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateTrendRadarPanelInput = {
  title: Scalars['String'];
};

export type UpdateUserSettingsInput = {
  notificationInterval?: InputMaybe<NotificationInterval>;
};

export type UploadAvatarInput = {
  file: Scalars['FileUpload'];
};

export type UsageCounts = {
  __typename?: 'UsageCounts';
  innovationFields: Scalars['Int'];
  innovationProjects: Scalars['Int'];
  trendRadars: Scalars['Int'];
};

export type User = NodeInterface & {
  __typename?: 'User';
  adminActsAsUser?: Maybe<Scalars['Boolean']>;
  avatar: Scalars['String'];
  company?: Maybe<Company>;
  email?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  featureUpdates?: Maybe<Scalars['Int']>;
  featureUpdatesDisabled: Scalars['Boolean'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  insightsUpdates?: Maybe<Scalars['Int']>;
  jobPosition?: Maybe<Scalars['String']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastName?: Maybe<Scalars['String']>;
  locale?: Maybe<Locale>;
  locked?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Roles>>;
  salutation?: Maybe<Scalars['String']>;
  showIntroductionVideo: Scalars['Boolean'];
  title?: Maybe<Scalars['String']>;
};

export type UserInterfaceInformation = {
  __typename?: 'UserInterfaceInformation';
  showAutomaticUniverseUpdate: Scalars['Boolean'];
  showUniverseUpdate: Scalars['Boolean'];
};

export type Workspace = NodeInterface & {
  __typename?: 'Workspace';
  company?: Maybe<Company>;
  containsTrend: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deprecatedMacrotrends: Array<Macrotrend>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
  participants?: Maybe<PaginatedUsers>;
  participating: Scalars['Boolean'];
  private: Scalars['Boolean'];
  searchAgents?: Maybe<PaginatedSearchAgents>;
  searchAgentsTrendCounts?: Maybe<SearchAgentTrendCounts>;
  title?: Maybe<Scalars['String']>;
  trends?: Maybe<PaginatedWorkspaceTrends>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSettings?: Maybe<WorkspaceUserSettings>;
  xlsxExportUrl: Scalars['String'];
};


export type WorkspaceContainsTrendArgs = {
  id: Scalars['ID'];
};


export type WorkspaceImageArgs = {
  gravity?: InputMaybe<ImageGravity>;
  height?: InputMaybe<Scalars['Int']>;
  resize?: InputMaybe<ImageResizeMethod>;
  width?: InputMaybe<Scalars['Int']>;
};


export type WorkspaceParticipantsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type WorkspaceSearchAgentsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type WorkspaceTrendsArgs = {
  filter?: InputMaybe<WorkspaceTrendFilter>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<WorkspaceTrendSort>;
  type?: InputMaybe<WorkspaceTrendType>;
};


export type WorkspaceXlsxExportUrlArgs = {
  filter?: InputMaybe<WorkspaceTrendFilter>;
  sort?: InputMaybe<WorkspaceExportSort>;
};

export type WorkspaceExportInput = {
  filter?: InputMaybe<WorkspaceTrendFilter>;
  format: ExportFormat;
  id: Scalars['ID'];
  sort: WorkspaceExportSort;
  template?: InputMaybe<Scalars['String']>;
};

export type WorkspaceExportSort = {
  macrotrend: WorkspaceMacrotrendSort;
  microtrend: WorkspaceMicrotrendSort;
};

export type WorkspaceInput = {
  description?: InputMaybe<Scalars['String']>;
  participantIds?: InputMaybe<Array<Scalars['ID']>>;
  private?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type WorkspaceMacrotrendSort = {
  direction: SortOrder;
  field: WorkspaceMacrotrendSortField;
};

export enum WorkspaceMacrotrendSortField {
  CreatedAt = 'createdAt',
  Position = 'position',
  VotingResult = 'votingResult'
}

export type WorkspaceMicrotrendSort = {
  direction: SortOrder;
  field: WorkspaceMicrotrendSortField;
};

export enum WorkspaceMicrotrendSortField {
  CreatedAt = 'createdAt',
  Position = 'position',
  PublishedAt = 'publishedAt',
  VotingResult = 'votingResult'
}

export type WorkspaceMutations = {
  __typename?: 'WorkspaceMutations';
  acceptSearchAgentTrends: Workspace;
  copy: Workspace;
  createTrendRadar: Scalars['ID'];
  delete: Scalars['Boolean'];
  join: Workspace;
  leave: Scalars['Boolean'];
  rejectMicrotrend: Workspace;
  rejectSearchAgentTrends: Workspace;
  removeNodes: Workspace;
  removeSearchAgent: Workspace;
  setWorkspaceTrendPosition: Workspace;
  unvote: WorkspaceTrend;
  update: Workspace;
  updateUserSettings: WorkspaceUserSettings;
  vote: WorkspaceTrend;
};


export type WorkspaceMutationsAcceptSearchAgentTrendsArgs = {
  input: SearchAgentBatchVoteInput;
};


export type WorkspaceMutationsCopyArgs = {
  title: Scalars['String'];
};


export type WorkspaceMutationsRejectMicrotrendArgs = {
  id: Scalars['ID'];
};


export type WorkspaceMutationsRejectSearchAgentTrendsArgs = {
  input: SearchAgentBatchVoteInput;
};


export type WorkspaceMutationsRemoveNodesArgs = {
  input: RemoveNodesInput;
};


export type WorkspaceMutationsRemoveSearchAgentArgs = {
  id: Scalars['ID'];
};


export type WorkspaceMutationsSetWorkspaceTrendPositionArgs = {
  input: WorkspaceTrendPositionInput;
};


export type WorkspaceMutationsUnvoteArgs = {
  trendId: Scalars['ID'];
};


export type WorkspaceMutationsUpdateArgs = {
  input: WorkspaceInput;
};


export type WorkspaceMutationsUpdateUserSettingsArgs = {
  input: UpdateUserSettingsInput;
};


export type WorkspaceMutationsVoteArgs = {
  input?: InputMaybe<WorkspaceVoteInput>;
};

export type WorkspaceSort = {
  direction: SortOrder;
  field: WorkspaceSortFields;
};

export enum WorkspaceSortFields {
  CreatedAt = 'createdAt',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

export type WorkspaceTrend = {
  __typename?: 'WorkspaceTrend';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  position?: Maybe<Scalars['Int']>;
  trend?: Maybe<NodeInterface>;
  userVote?: Maybe<WorkspaceVoteType>;
  votes: Scalars['Int'];
  workspace: Workspace;
};

export type WorkspaceTrendFilter = {
  macrotrend?: InputMaybe<MacrotrendFilter>;
  microtrend?: InputMaybe<MicrotrendFilter>;
};

export type WorkspaceTrendPositionInput = {
  position: Scalars['Int'];
  workspaceTrendId: Scalars['ID'];
};

export type WorkspaceTrendSort = {
  direction: SortOrder;
  field: WorkspaceTrendSortField;
};

export enum WorkspaceTrendSortField {
  CreatedAt = 'createdAt',
  Position = 'position',
  PublishedAt = 'publishedAt',
  VotingResult = 'votingResult'
}

export enum WorkspaceTrendType {
  Macrotrend = 'macrotrend',
  Microtrend = 'microtrend'
}

export type WorkspaceUserSettings = {
  __typename?: 'WorkspaceUserSettings';
  notificationInterval: NotificationInterval;
};

export type WorkspaceVoteInput = {
  trendId: Scalars['ID'];
  vote: WorkspaceVoteType;
};

export enum WorkspaceVoteType {
  Downvote = 'Downvote',
  Upvote = 'Upvote'
}

export type ChallengesAndOpportunitiesQueryVariables = Exact<{
  input: AiChallengesAndOpportunitiesInput;
}>;


export type ChallengesAndOpportunitiesQuery = { __typename?: 'Query', ai: { __typename?: 'AiQuery', challengesAndOpportunities: { __typename?: 'ChallengesAndOpportunitiesResult', challenges: string, opportunities: string } } };

export type ExplainTrendQueryVariables = Exact<{
  input: ExplainTrendInput;
}>;


export type ExplainTrendQuery = { __typename?: 'Query', ai: { __typename?: 'AiQuery', explainTrend: string } };

export type CommentPartsFragment = { __typename?: 'Comment', id: string, body?: string | null, createdAt?: any | null, updatedAt?: any | null, owner: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, avatar: string, enabled?: boolean | null } };

export type CreateCommentMutationVariables = Exact<{
  id: Scalars['ID'];
  input: CommentInput;
}>;


export type CreateCommentMutation = { __typename?: 'Mutation', post?: { __typename?: 'PostMutations', comment?: { __typename?: 'Comment', id: string, body?: string | null, createdAt?: any | null, updatedAt?: any | null, owner: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, avatar: string, email?: string | null, enabled?: boolean | null }, post?: { __typename?: 'Post', id: string, comments?: Array<{ __typename?: 'Comment', id: string, body?: string | null } | null> | null } | null } | null } | null };

export type DeleteCommentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCommentMutation = { __typename?: 'Mutation', comment?: { __typename?: 'CommentMutations', delete?: boolean | null } | null };

export type UpdateCommentMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateCommentInput;
}>;


export type UpdateCommentMutation = { __typename?: 'Mutation', comment?: { __typename?: 'CommentMutations', update?: { __typename?: 'Comment', id: string, body?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null };

export type CreateCompanyMicrotrendMutationVariables = Exact<{
  input: CreateCompanyMicrotrendInput;
}>;


export type CreateCompanyMicrotrendMutation = { __typename?: 'Mutation', createCompanyMicrotrend?: { __typename?: 'CompanyMicrotrend', id: string } | null };

export type DeleteCompanyMicrotrendMutationVariables = Exact<{
  input: DeleteCompanyMicrotrendInput;
}>;


export type DeleteCompanyMicrotrendMutation = { __typename?: 'Mutation', deleteCompanyMicrotrend: boolean };

export type OnsiteUpdateCompanyMicrotrendMutationVariables = Exact<{
  input: UpdateCompanyMicrotrendInput;
  locale?: InputMaybe<Locale>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type OnsiteUpdateCompanyMicrotrendMutation = { __typename?: 'Mutation', updateCompanyMicrotrend: { __typename?: 'CompanyMicrotrend', id: string, innovationTypes?: Array<{ __typename?: 'InnovationType', id: string, translations?: Array<{ __typename?: 'InnovationTypeTranslation', locale?: Locale | null, title?: string | null } | null> | null }> | null, industries: Array<{ __typename?: 'Industry', id: string, translations?: Array<{ __typename?: 'IndustryTranslation', locale?: Locale | null, title?: string | null } | null> | null }>, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null }> } };

export type UpdateCompanyMicrotrendMutationVariables = Exact<{
  input: UpdateCompanyMicrotrendInput;
  locale?: InputMaybe<Locale>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateCompanyMicrotrendMutation = { __typename?: 'Mutation', updateCompanyMicrotrend: { __typename?: 'CompanyMicrotrend', id: string, url?: string | null, images?: Array<string | null> | null, comment: string, countries?: Array<{ __typename?: 'Country', id: string }> | null, innovationTypes?: Array<{ __typename?: 'InnovationType', id: string, translations?: Array<{ __typename?: 'InnovationTypeTranslation', locale?: Locale | null, title?: string | null } | null> | null }> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, industries: Array<{ __typename?: 'Industry', id: string, translations?: Array<{ __typename?: 'IndustryTranslation', locale?: Locale | null, title?: string | null } | null> | null }>, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null }>, initiators?: Array<{ __typename?: 'Initiator', id: string, title?: string | null }> | null } };

export type MicrotrendQueryVariables = Exact<{
  id: Scalars['ID'];
  locale?: InputMaybe<Locale>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type MicrotrendQuery = { __typename?: 'Query', microtrend?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend', id: string, url?: string | null, images?: Array<string | null> | null, comment: string, countries?: Array<{ __typename?: 'Country', id: string }> | null, innovationTypes?: Array<{ __typename?: 'InnovationType', id: string }> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, industries: Array<{ __typename?: 'Industry', id: string, translations?: Array<{ __typename?: 'IndustryTranslation', title?: string | null } | null> | null }>, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null }>, initiators?: Array<{ __typename?: 'Initiator', id: string, title?: string | null }> | null, pins?: Array<{ __typename?: 'MicrotrendPin', id: string, macrotrend: { __typename?: 'CompanyMacrotrend', id: string } | { __typename?: 'Macrotrend', id: string } | { __typename?: 'ReducedMacrotrend', id: string } }> | null } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null };

export type LoadCriteriaSetsQueryVariables = Exact<{
  locale?: InputMaybe<Locale>;
}>;


export type LoadCriteriaSetsQuery = { __typename?: 'Query', criteriaSets?: Array<{ __typename?: 'CriteriaSet', id: string, translations: Array<{ __typename?: 'CriteriaSetTranslation', locale: Locale, title: string }> }> | null };

export type TotalCountQueryVariables = Exact<{
  type?: InputMaybe<ActivityFeedType>;
}>;


export type TotalCountQuery = { __typename?: 'Query', totalCount?: { __typename?: 'ActivityFeedItemConnection', totalCount?: number | null } | null };

export type ActivityFeedQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<ActivityFeedType>;
  locale?: InputMaybe<Locale>;
}>;


export type ActivityFeedQuery = { __typename?: 'Query', activityFeed?: { __typename?: 'ActivityFeedItemConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename?: 'ActivityFeedItemEdge', cursor?: string | null, node?: { __typename?: 'ActivityFeedItem', createdAt?: any | null, user?: { __typename?: 'User', avatar: string, enabled?: boolean | null } | null, translations?: Array<{ __typename?: 'ActivityFeedItemTranslation', locale?: Locale | null, text?: string | null, attachment?: { __typename?: 'ActivityFeedItemTranslationAttachment', image?: string | null, description?: string | null } | null }> | null } | null } | null> | null } | null };

export type ExportWorkspaceMutationVariables = Exact<{
  input: WorkspaceExportInput;
}>;


export type ExportWorkspaceMutation = { __typename?: 'Mutation', export: { __typename?: 'Export', id: string, url?: string | null, status?: ExportStatus | null } };

export type ExportMutationVariables = Exact<{
  input: ExportInput;
}>;


export type ExportMutation = { __typename?: 'Mutation', export: { __typename?: 'Export', id: string, url?: string | null, status?: ExportStatus | null } };

export type PollQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PollQuery = { __typename?: 'Query', node?: { __typename?: 'Comment', id: string } | { __typename?: 'Company', id: string } | { __typename?: 'CompanyMacrotrend', id: string } | { __typename?: 'CompanyMegatrend', id: string } | { __typename?: 'CompanyMicrotrend', id: string } | { __typename?: 'Country', id: string } | { __typename?: 'CriteriaSet', id: string } | { __typename?: 'Export', status?: ExportStatus | null, url?: string | null, id: string } | { __typename?: 'Industry', id: string } | { __typename?: 'Initiator', id: string } | { __typename?: 'InnovationField', id: string } | { __typename?: 'InnovationProject', id: string } | { __typename?: 'InnovationType', id: string } | { __typename?: 'Insider', id: string } | { __typename?: 'Macrotrend', id: string } | { __typename?: 'Megatrend', id: string } | { __typename?: 'Microtrend', id: string } | { __typename?: 'Post', id: string } | { __typename?: 'PublishedTrendRadar', id: string } | { __typename?: 'ReducedMacrotrend', id: string } | { __typename?: 'ReducedMicrotrend', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'SearchAgent', id: string } | { __typename?: 'TrendRadarDraft', id: string } | { __typename?: 'TrendRadarParticipation', id: string } | { __typename?: 'TrendSummary', id: string } | { __typename?: 'Trendcall', id: string } | { __typename?: 'TrendingTopic', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Workspace', id: string } | null };

export type UsersQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, avatar: string, email?: string | null, enabled?: boolean | null }> };

export type IndustryListQueryVariables = Exact<{
  locale?: InputMaybe<Locale>;
}>;


export type IndustryListQuery = { __typename?: 'Query', industries: Array<{ __typename?: 'Industry', id: string, translations?: Array<{ __typename?: 'IndustryTranslation', locale?: Locale | null, title?: string | null } | null> | null }> };

export type InnovationFieldPartsFragment = { __typename?: 'InnovationField', id: string, title: string, description?: string | null, technologicalOpportunities?: string | null, marketOpportunities?: string | null, capabilities?: string | null, image?: string | null, updatedAt?: any | null, publishingState?: InnovationFieldPublishingState | null };

export type InnovationFieldViewPartsFragment = { __typename?: 'InnovationField', id: string, title: string, description?: string | null, technologicalOpportunities?: string | null, marketOpportunities?: string | null, capabilities?: string | null, image?: string | null, updatedAt?: any | null, publishingState?: InnovationFieldPublishingState | null, contactPerson?: { __typename?: 'User', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, lastLogin?: any | null, phone?: string | null, email?: string | null, avatar: string, roles?: Array<Roles> | null, locale?: Locale | null, enabled?: boolean | null, adminActsAsUser?: boolean | null, showIntroductionVideo: boolean, insightsUpdates?: number | null, featureUpdates?: number | null, featureUpdatesDisabled: boolean, company?: { __typename?: 'Company', id: string, automaticUniverseUpdate: boolean, color?: string | null, locales?: Array<Locale> | null, features?: Array<Feature> | null, maxUsers?: number | null, product?: CompanyProduct | null, testAccount?: boolean | null, accountType: AccountType, title?: string | null, exportTemplates?: Array<{ __typename?: 'ExportTemplate', id: string, title: string, exportTypes?: Array<ExportType> | null }> | null } | null } | null, megatrends: Array<{ __typename?: 'CompanyMegatrend', id: string, color?: string | null, active?: boolean | null, image?: string | null, publicUrl?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, active?: boolean | null, image?: string | null, publicUrl?: string | null, successor?: { __typename?: 'Megatrend', id: string } | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null }>, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', active?: boolean | null, publicUrl?: string | null, id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', active?: boolean | null, publicUrl?: string | null, deprecated: boolean, id: string, image?: string | null, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null }>, trendRadars: { __typename?: 'PaginatedTrendRadars', nodes: Array<{ __typename?: 'PublishedTrendRadar', id: string, title: string, image: string } | { __typename?: 'TrendRadarDraft', id: string, title: string, image: string }> }, innovationProjects: { __typename?: 'PaginatedInnovationProjects', nodes: Array<{ __typename?: 'InnovationProject', id: string, title: string, image?: string | null, state: InnovationProjectState, publishingState: PublishingState }> } };

export type AddNodesToInnovationFieldsMutationVariables = Exact<{
  input: AddNodesToInnovationFieldsInput;
  locale: Locale;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type AddNodesToInnovationFieldsMutation = { __typename?: 'Mutation', addNodesToInnovationFields: Array<{ __typename?: 'InnovationField', id: string, title: string, description?: string | null, technologicalOpportunities?: string | null, marketOpportunities?: string | null, capabilities?: string | null, image?: string | null, updatedAt?: any | null, publishingState?: InnovationFieldPublishingState | null, megatrends: Array<{ __typename?: 'CompanyMegatrend', id: string, color?: string | null, active?: boolean | null, image?: string | null, publicUrl?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, active?: boolean | null, image?: string | null, publicUrl?: string | null, successor?: { __typename?: 'Megatrend', id: string } | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null }>, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null }> }> };

export type CreateInnovationFieldMutationVariables = Exact<{
  input: InnovationFieldInput;
}>;


export type CreateInnovationFieldMutation = { __typename?: 'Mutation', createInnovationField?: { __typename?: 'InnovationField', id: string, title: string, description?: string | null, technologicalOpportunities?: string | null, marketOpportunities?: string | null, capabilities?: string | null, image?: string | null, updatedAt?: any | null, publishingState?: InnovationFieldPublishingState | null, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string } | { __typename?: 'Macrotrend', id: string } | { __typename?: 'ReducedMacrotrend', id: string }>, contactPerson?: { __typename?: 'User', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, lastLogin?: any | null, phone?: string | null, email?: string | null, avatar: string, roles?: Array<Roles> | null, locale?: Locale | null, enabled?: boolean | null, adminActsAsUser?: boolean | null, showIntroductionVideo: boolean, insightsUpdates?: number | null, featureUpdates?: number | null, featureUpdatesDisabled: boolean, company?: { __typename?: 'Company', id: string, automaticUniverseUpdate: boolean, color?: string | null, locales?: Array<Locale> | null, features?: Array<Feature> | null, maxUsers?: number | null, product?: CompanyProduct | null, testAccount?: boolean | null, accountType: AccountType, title?: string | null, exportTemplates?: Array<{ __typename?: 'ExportTemplate', id: string, title: string, exportTypes?: Array<ExportType> | null }> | null } | null } | null } | null };

export type DeleteInnovationFieldMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteInnovationFieldMutation = { __typename?: 'Mutation', innovationField?: { __typename?: 'InnovationFieldMutations', delete?: boolean | null } | null };

export type UpdatePublicInnovationFieldsMutationVariables = Exact<{
  input: PublicInnovationFieldsStateInput;
}>;


export type UpdatePublicInnovationFieldsMutation = { __typename?: 'Mutation', updatePublicInnovationFieldsState: boolean };

export type UpdateInnovationFieldMutationVariables = Exact<{
  id: Scalars['ID'];
  input: InnovationFieldInput;
  locale: Locale;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateInnovationFieldMutation = { __typename?: 'Mutation', innovationField?: { __typename?: 'InnovationFieldMutations', update?: { __typename?: 'InnovationField', id: string, title: string, description?: string | null, technologicalOpportunities?: string | null, marketOpportunities?: string | null, capabilities?: string | null, image?: string | null, updatedAt?: any | null, publishingState?: InnovationFieldPublishingState | null, contactPerson?: { __typename?: 'User', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, lastLogin?: any | null, phone?: string | null, email?: string | null, avatar: string, roles?: Array<Roles> | null, locale?: Locale | null, enabled?: boolean | null, adminActsAsUser?: boolean | null, showIntroductionVideo: boolean, insightsUpdates?: number | null, featureUpdates?: number | null, featureUpdatesDisabled: boolean, company?: { __typename?: 'Company', id: string, automaticUniverseUpdate: boolean, color?: string | null, locales?: Array<Locale> | null, features?: Array<Feature> | null, maxUsers?: number | null, product?: CompanyProduct | null, testAccount?: boolean | null, accountType: AccountType, title?: string | null, exportTemplates?: Array<{ __typename?: 'ExportTemplate', id: string, title: string, exportTypes?: Array<ExportType> | null }> | null } | null } | null, megatrends: Array<{ __typename?: 'CompanyMegatrend', id: string, color?: string | null, active?: boolean | null, image?: string | null, publicUrl?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, active?: boolean | null, image?: string | null, publicUrl?: string | null, successor?: { __typename?: 'Megatrend', id: string } | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null }>, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', active?: boolean | null, publicUrl?: string | null, id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', active?: boolean | null, publicUrl?: string | null, deprecated: boolean, id: string, image?: string | null, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null }>, trendRadars: { __typename?: 'PaginatedTrendRadars', nodes: Array<{ __typename?: 'PublishedTrendRadar', id: string, title: string, image: string } | { __typename?: 'TrendRadarDraft', id: string, title: string, image: string }> }, innovationProjects: { __typename?: 'PaginatedInnovationProjects', nodes: Array<{ __typename?: 'InnovationProject', id: string, title: string, image?: string | null, state: InnovationProjectState, publishingState: PublishingState }> } } | null } | null };

export type InnovationFieldsQueryVariables = Exact<{
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
}>;


export type InnovationFieldsQuery = { __typename?: 'Query', innovationFields?: { __typename?: 'PaginatedInnovationFields', nodes: Array<{ __typename?: 'InnovationField', id: string, title: string }> } | null };

export type InnovationFieldQueryVariables = Exact<{
  id: Scalars['ID'];
  locale: Locale;
}>;


export type InnovationFieldQuery = { __typename?: 'Query', innovationField?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField', id: string, title: string, description?: string | null, technologicalOpportunities?: string | null, marketOpportunities?: string | null, capabilities?: string | null, image?: string | null, updatedAt?: any | null, publishingState?: InnovationFieldPublishingState | null, contactPerson?: { __typename?: 'User', id: string } | null, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null }>, innovationProjects: { __typename?: 'PaginatedInnovationProjects', nodes: Array<{ __typename?: 'InnovationProject', id: string, title: string }> }, trendRadars: { __typename?: 'PaginatedTrendRadars', nodes: Array<{ __typename?: 'PublishedTrendRadar', id: string, title: string } | { __typename?: 'TrendRadarDraft', id: string, title: string }> } } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null };

export type InnovationFieldsGalleryQueryVariables = Exact<{
  filter?: InputMaybe<InnovationFieldFilterInput>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
}>;


export type InnovationFieldsGalleryQuery = { __typename?: 'Query', innovationFields?: { __typename?: 'PaginatedInnovationFields', innovationProjectsPublic: boolean, privateTrendRadars: Array<string>, nodes: Array<{ __typename?: 'InnovationField', id: string, title: string, description?: string | null, technologicalOpportunities?: string | null, marketOpportunities?: string | null, capabilities?: string | null, image?: string | null, updatedAt?: any | null, publishingState?: InnovationFieldPublishingState | null, deprecatedMacrotrends: Array<{ __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null }>, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string } | { __typename?: 'Macrotrend', id: string } | { __typename?: 'ReducedMacrotrend', id: string }> }>, facets: { __typename?: 'InnovationFieldFacets', innovationProjects: Array<{ __typename?: 'InnovationProject', id: string, title: string }>, trendRadars: Array<{ __typename?: 'PublishedTrendRadar', id: string, title: string } | { __typename?: 'TrendRadarDraft', id: string, title: string }> }, pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null };

export type InnovationFieldsListQueryVariables = Exact<{
  filter?: InputMaybe<InnovationFieldFilterInput>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  sort?: InputMaybe<InnovationFieldsSort>;
  locale?: InputMaybe<Locale>;
}>;


export type InnovationFieldsListQuery = { __typename?: 'Query', innovationFields?: { __typename?: 'PaginatedInnovationFields', innovationProjectsPublic: boolean, privateTrendRadars: Array<string>, nodes: Array<{ __typename?: 'InnovationField', id: string, title: string, description?: string | null, technologicalOpportunities?: string | null, marketOpportunities?: string | null, capabilities?: string | null, image?: string | null, updatedAt?: any | null, publishingState?: InnovationFieldPublishingState | null, innovationProjects: { __typename?: 'PaginatedInnovationProjects', nodes: Array<{ __typename?: 'InnovationProject', id: string, title: string }> }, deprecatedMacrotrends: Array<{ __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null }>, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null }>, megatrends: Array<{ __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null }>, trendRadars: { __typename?: 'PaginatedTrendRadars', nodes: Array<{ __typename?: 'PublishedTrendRadar', id: string, title: string } | { __typename?: 'TrendRadarDraft', id: string, title: string }> } }>, facets: { __typename?: 'InnovationFieldFacets', innovationProjects: Array<{ __typename?: 'InnovationProject', id: string, title: string }>, trendRadars: Array<{ __typename?: 'PublishedTrendRadar', id: string, title: string } | { __typename?: 'TrendRadarDraft', id: string, title: string }> }, pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null };

export type InnovationFieldsOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type InnovationFieldsOverviewQuery = { __typename?: 'Query', innovationFields?: { __typename?: 'PaginatedInnovationFields', nodes: Array<{ __typename?: 'InnovationField', id: string, title: string, description?: string | null, image?: string | null }> } | null };

export type PublicInnovationFieldsUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type PublicInnovationFieldsUrlQuery = { __typename?: 'Query', publicInnovationFieldsUrl?: string | null };

export type InnovationFieldViewQueryVariables = Exact<{
  id: Scalars['ID'];
  locale: Locale;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type InnovationFieldViewQuery = { __typename?: 'Query', innovationField?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField', id: string, title: string, description?: string | null, technologicalOpportunities?: string | null, marketOpportunities?: string | null, capabilities?: string | null, image?: string | null, updatedAt?: any | null, publishingState?: InnovationFieldPublishingState | null, contactPerson?: { __typename?: 'User', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, lastLogin?: any | null, phone?: string | null, email?: string | null, avatar: string, roles?: Array<Roles> | null, locale?: Locale | null, enabled?: boolean | null, adminActsAsUser?: boolean | null, showIntroductionVideo: boolean, insightsUpdates?: number | null, featureUpdates?: number | null, featureUpdatesDisabled: boolean, company?: { __typename?: 'Company', id: string, automaticUniverseUpdate: boolean, color?: string | null, locales?: Array<Locale> | null, features?: Array<Feature> | null, maxUsers?: number | null, product?: CompanyProduct | null, testAccount?: boolean | null, accountType: AccountType, title?: string | null, exportTemplates?: Array<{ __typename?: 'ExportTemplate', id: string, title: string, exportTypes?: Array<ExportType> | null }> | null } | null } | null, megatrends: Array<{ __typename?: 'CompanyMegatrend', id: string, color?: string | null, active?: boolean | null, image?: string | null, publicUrl?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, active?: boolean | null, image?: string | null, publicUrl?: string | null, successor?: { __typename?: 'Megatrend', id: string } | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null }>, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', active?: boolean | null, publicUrl?: string | null, id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', active?: boolean | null, publicUrl?: string | null, deprecated: boolean, id: string, image?: string | null, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null }>, trendRadars: { __typename?: 'PaginatedTrendRadars', nodes: Array<{ __typename?: 'PublishedTrendRadar', id: string, title: string, image: string } | { __typename?: 'TrendRadarDraft', id: string, title: string, image: string }> }, innovationProjects: { __typename?: 'PaginatedInnovationProjects', nodes: Array<{ __typename?: 'InnovationProject', id: string, title: string, image?: string | null, state: InnovationProjectState, publishingState: PublishingState }> } } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null };

export type InnovationProjectPartsFragment = { __typename?: 'InnovationProject', id: string, title: string, image?: string | null, description: string, objective: string, environment: string, state: InnovationProjectState, publishingState: PublishingState, updatedAt?: any | null };

export type CreateInnovationProjectMutationVariables = Exact<{
  input: CreateInnovationProjectInput;
  locale: Locale;
}>;


export type CreateInnovationProjectMutation = { __typename?: 'Mutation', createInnovationProject: { __typename?: 'InnovationProject', id: string, title: string, image?: string | null, description: string, objective: string, environment: string, state: InnovationProjectState, publishingState: PublishingState, updatedAt?: any | null, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null }>, megatrends: Array<{ __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null } | null> | null }>, innovationFields: Array<{ __typename?: 'InnovationField', id: string, title: string, image?: string | null }>, trendRadars: Array<{ __typename?: 'PublishedTrendRadar', id: string, title: string }>, participants: Array<{ __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, avatar: string }> } };

export type DeleteInnovationProjectMutationVariables = Exact<{
  input: DeleteInnovationProjectInput;
}>;


export type DeleteInnovationProjectMutation = { __typename?: 'Mutation', deleteInnovationProject: boolean };

export type ProposeInnovationProjectMutationVariables = Exact<{
  input: ProposeInnovationProjectInput;
}>;


export type ProposeInnovationProjectMutation = { __typename?: 'Mutation', proposeInnovationProject: boolean };

export type UpdatePublicInnovationProjectsMutationVariables = Exact<{
  input: PublicInnovationProjectsStateInput;
}>;


export type UpdatePublicInnovationProjectsMutation = { __typename?: 'Mutation', updatePublicInnovationProjectsState: boolean };

export type UpdateInnovationProjectMutationVariables = Exact<{
  input: UpdateInnovationProjectInput;
  locale: Locale;
}>;


export type UpdateInnovationProjectMutation = { __typename?: 'Mutation', updateInnovationProject: { __typename?: 'InnovationProject', id: string, title: string, image?: string | null, description: string, objective: string, environment: string, state: InnovationProjectState, publishingState: PublishingState, updatedAt?: any | null, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null }>, megatrends: Array<{ __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null } | null> | null }>, innovationFields: Array<{ __typename?: 'InnovationField', id: string, title: string, image?: string | null }>, trendRadars: Array<{ __typename?: 'PublishedTrendRadar', id: string, title: string }>, participants: Array<{ __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, avatar: string }> } };

export type InnovationProjectsQueryVariables = Exact<{
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
}>;


export type InnovationProjectsQuery = { __typename?: 'Query', innovationProjects?: { __typename?: 'PaginatedInnovationProjects', nodes: Array<{ __typename?: 'InnovationProject', id: string, title: string }> } | null };

export type InnovationProjectQueryVariables = Exact<{
  id: Scalars['ID'];
  locale: Locale;
}>;


export type InnovationProjectQuery = { __typename?: 'Query', innovationProject?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject', id: string, title: string, image?: string | null, description: string, objective: string, environment: string, state: InnovationProjectState, publishingState: PublishingState, updatedAt?: any | null, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null }>, innovationFields: Array<{ __typename?: 'InnovationField', id: string, title: string }>, trendRadars: Array<{ __typename?: 'PublishedTrendRadar', id: string, title: string }>, participants: Array<{ __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null }> } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null };

export type InnovationProjectsGalleryQueryVariables = Exact<{
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  filter?: InputMaybe<InnovationProjectFilterInput>;
}>;


export type InnovationProjectsGalleryQuery = { __typename?: 'Query', innovationProjects?: { __typename?: 'PaginatedInnovationProjects', privateTrendRadars: Array<string>, nodes: Array<{ __typename?: 'InnovationProject', id: string, title: string, image?: string | null, description: string, objective: string, environment: string, state: InnovationProjectState, publishingState: PublishingState, updatedAt?: any | null, deprecatedMacrotrends: Array<{ __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null }> }>, pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number }, facets: { __typename?: 'InnovationProjectFacets', states: Array<{ __typename?: 'InnovationProjectStateFacet', state: InnovationProjectState, count: number }>, trendRadars: Array<{ __typename?: 'NodeSearchFacet', count: number, node: { __typename?: 'Comment', id: string } | { __typename?: 'Company', id: string } | { __typename?: 'CompanyMacrotrend', id: string } | { __typename?: 'CompanyMegatrend', id: string } | { __typename?: 'CompanyMicrotrend', id: string } | { __typename?: 'Country', id: string } | { __typename?: 'CriteriaSet', id: string } | { __typename?: 'Export', id: string } | { __typename?: 'Industry', id: string } | { __typename?: 'Initiator', id: string } | { __typename?: 'InnovationField', id: string } | { __typename?: 'InnovationProject', id: string } | { __typename?: 'InnovationType', id: string } | { __typename?: 'Insider', id: string } | { __typename?: 'Macrotrend', id: string } | { __typename?: 'Megatrend', id: string } | { __typename?: 'Microtrend', id: string } | { __typename?: 'Post', id: string } | { __typename?: 'PublishedTrendRadar', title: string, id: string } | { __typename?: 'ReducedMacrotrend', id: string } | { __typename?: 'ReducedMicrotrend', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'SearchAgent', id: string } | { __typename?: 'TrendRadarDraft', id: string } | { __typename?: 'TrendRadarParticipation', id: string } | { __typename?: 'TrendSummary', id: string } | { __typename?: 'Trendcall', id: string } | { __typename?: 'TrendingTopic', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Workspace', id: string } }>, innovationFields: Array<{ __typename?: 'NodeSearchFacet', node: { __typename?: 'Comment', id: string } | { __typename?: 'Company', id: string } | { __typename?: 'CompanyMacrotrend', id: string } | { __typename?: 'CompanyMegatrend', id: string } | { __typename?: 'CompanyMicrotrend', id: string } | { __typename?: 'Country', id: string } | { __typename?: 'CriteriaSet', id: string } | { __typename?: 'Export', id: string } | { __typename?: 'Industry', id: string } | { __typename?: 'Initiator', id: string } | { __typename?: 'InnovationField', title: string, id: string } | { __typename?: 'InnovationProject', id: string } | { __typename?: 'InnovationType', id: string } | { __typename?: 'Insider', id: string } | { __typename?: 'Macrotrend', id: string } | { __typename?: 'Megatrend', id: string } | { __typename?: 'Microtrend', id: string } | { __typename?: 'Post', id: string } | { __typename?: 'PublishedTrendRadar', id: string } | { __typename?: 'ReducedMacrotrend', id: string } | { __typename?: 'ReducedMicrotrend', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'SearchAgent', id: string } | { __typename?: 'TrendRadarDraft', id: string } | { __typename?: 'TrendRadarParticipation', id: string } | { __typename?: 'TrendSummary', id: string } | { __typename?: 'Trendcall', id: string } | { __typename?: 'TrendingTopic', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Workspace', id: string } }> } } | null };

export type InnovationProjectsListQueryVariables = Exact<{
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  sort?: InputMaybe<InnovationProjectSort>;
  filter?: InputMaybe<InnovationProjectFilterInput>;
  locale?: InputMaybe<Locale>;
}>;


export type InnovationProjectsListQuery = { __typename?: 'Query', innovationProjects?: { __typename?: 'PaginatedInnovationProjects', privateTrendRadars: Array<string>, nodes: Array<{ __typename?: 'InnovationProject', image?: string | null, state: InnovationProjectState, publishingState: PublishingState, id: string, title: string, description: string, objective: string, environment: string, updatedAt?: any | null, deprecatedMacrotrends: Array<{ __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null }>, trendRadars: Array<{ __typename?: 'PublishedTrendRadar', id: string, title: string }>, innovationFields: Array<{ __typename?: 'InnovationField', id: string, title: string }>, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null, locale?: Locale | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null, locale?: Locale | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null, locale?: Locale | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null }>, megatrends: Array<{ __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null, locale?: Locale | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null, locale?: Locale | null } | null> | null }> }>, pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number }, facets: { __typename?: 'InnovationProjectFacets', states: Array<{ __typename?: 'InnovationProjectStateFacet', state: InnovationProjectState, count: number }>, trendRadars: Array<{ __typename?: 'NodeSearchFacet', count: number, node: { __typename?: 'Comment', id: string } | { __typename?: 'Company', id: string } | { __typename?: 'CompanyMacrotrend', id: string } | { __typename?: 'CompanyMegatrend', id: string } | { __typename?: 'CompanyMicrotrend', id: string } | { __typename?: 'Country', id: string } | { __typename?: 'CriteriaSet', id: string } | { __typename?: 'Export', id: string } | { __typename?: 'Industry', id: string } | { __typename?: 'Initiator', id: string } | { __typename?: 'InnovationField', id: string } | { __typename?: 'InnovationProject', id: string } | { __typename?: 'InnovationType', id: string } | { __typename?: 'Insider', id: string } | { __typename?: 'Macrotrend', id: string } | { __typename?: 'Megatrend', id: string } | { __typename?: 'Microtrend', id: string } | { __typename?: 'Post', id: string } | { __typename?: 'PublishedTrendRadar', title: string, id: string } | { __typename?: 'ReducedMacrotrend', id: string } | { __typename?: 'ReducedMicrotrend', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'SearchAgent', id: string } | { __typename?: 'TrendRadarDraft', id: string } | { __typename?: 'TrendRadarParticipation', id: string } | { __typename?: 'TrendSummary', id: string } | { __typename?: 'Trendcall', id: string } | { __typename?: 'TrendingTopic', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Workspace', id: string } }>, innovationFields: Array<{ __typename?: 'NodeSearchFacet', node: { __typename?: 'Comment', id: string } | { __typename?: 'Company', id: string } | { __typename?: 'CompanyMacrotrend', id: string } | { __typename?: 'CompanyMegatrend', id: string } | { __typename?: 'CompanyMicrotrend', id: string } | { __typename?: 'Country', id: string } | { __typename?: 'CriteriaSet', id: string } | { __typename?: 'Export', id: string } | { __typename?: 'Industry', id: string } | { __typename?: 'Initiator', id: string } | { __typename?: 'InnovationField', title: string, id: string } | { __typename?: 'InnovationProject', id: string } | { __typename?: 'InnovationType', id: string } | { __typename?: 'Insider', id: string } | { __typename?: 'Macrotrend', id: string } | { __typename?: 'Megatrend', id: string } | { __typename?: 'Microtrend', id: string } | { __typename?: 'Post', id: string } | { __typename?: 'PublishedTrendRadar', id: string } | { __typename?: 'ReducedMacrotrend', id: string } | { __typename?: 'ReducedMicrotrend', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'SearchAgent', id: string } | { __typename?: 'TrendRadarDraft', id: string } | { __typename?: 'TrendRadarParticipation', id: string } | { __typename?: 'TrendSummary', id: string } | { __typename?: 'Trendcall', id: string } | { __typename?: 'TrendingTopic', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Workspace', id: string } }> } } | null };

export type PublicInnovationProjectsUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type PublicInnovationProjectsUrlQuery = { __typename?: 'Query', publicInnovationProjectsUrl?: string | null };

export type InnovationProjectViewQueryVariables = Exact<{
  id: Scalars['ID'];
  locale: Locale;
}>;


export type InnovationProjectViewQuery = { __typename?: 'Query', innovationProject?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject', id: string, title: string, image?: string | null, description: string, objective: string, environment: string, state: InnovationProjectState, publishingState: PublishingState, updatedAt?: any | null, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Macrotrend', translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null }>, megatrends: Array<{ __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null } | null> | null }>, innovationFields: Array<{ __typename?: 'InnovationField', id: string, title: string, image?: string | null }>, trendRadars: Array<{ __typename?: 'PublishedTrendRadar', id: string, title: string, image: string }>, participants: Array<{ __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, avatar: string }> } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null };

export type InsightsQueryVariables = Exact<{ [key: string]: never; }>;


export type InsightsQuery = { __typename?: 'Query', tc?: { __typename?: 'PaginatedInsights', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, tt?: { __typename?: 'PaginatedInsights', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, ts?: { __typename?: 'PaginatedInsights', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null };

export type InsightsListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  type: InsightsType;
  sort?: InputMaybe<InsightsSort>;
}>;


export type InsightsListQuery = { __typename?: 'Query', insights?: { __typename?: 'PaginatedInsights', nodes: Array<{ __typename?: 'TrendSummary', id: string, date: any, title: string, image: string, author: { __typename?: 'InsightAuthor', id: string, title: string, name: string, image: string } } | { __typename?: 'Trendcall', id: string, date: any, title: string, description: string, image: string, video: string, author: { __typename?: 'InsightAuthor', id: string, title: string, name: string, image: string } } | { __typename?: 'TrendingTopic', id: string, date: any, title: string, description: string, image: string, author: { __typename?: 'InsightAuthor', id: string, title: string, name: string, image: string } }>, pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null };

export type InsightQueryVariables = Exact<{
  id: Scalars['ID'];
  locale: Locale;
}>;


export type InsightQuery = { __typename?: 'Query', insight?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary', id: string, title: string, pdf: string, ppt: string, date: any, image: string, author: { __typename?: 'InsightAuthor', id: string, title: string, name: string, image: string }, microtrends?: Array<{ __typename?: 'CompanyMicrotrend', id: string, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Microtrend', id: string, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'ReducedMicrotrend', id: string, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null }> | null } | { __typename?: 'Trendcall', id: string, date: any, title: string, description: string, image: string, video: string, author: { __typename?: 'InsightAuthor', id: string, title: string, name: string, image: string } } | { __typename?: 'TrendingTopic', id: string, date: any, title: string, description: string, image: string, author: { __typename?: 'InsightAuthor', id: string, title: string, name: string, image: string }, trendcall?: { __typename?: 'Trendcall', id: string, title: string, video: string } | null, microtrends?: Array<{ __typename?: 'CompanyMicrotrend', id: string, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Microtrend', id: string, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'ReducedMicrotrend', id: string, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null }> | null, macrotrends?: Array<{ __typename?: 'Macrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null }> | null, industries?: Array<{ __typename?: 'Industry', id: string, translations?: Array<{ __typename?: 'IndustryTranslation', title?: string | null } | null> | null }> | null } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null };

export type InternalEvaluationOptionPartsFragment = { __typename?: 'InternalEvaluationOption', id: string, enabled: boolean, myParticipationId?: string | null, participationCounter: { __typename?: 'ParticipationCounter', completed: number, incomplete: number, total: number }, participants: Array<{ __typename?: 'Participant', state: ParticipationState, user: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, avatar: string } }> };

export type DeleteParticipationsMutationVariables = Exact<{
  trendRadarId: Scalars['ID'];
  panelId: Scalars['ID'];
}>;


export type DeleteParticipationsMutation = { __typename?: 'Mutation', trendRadar?: { __typename?: 'TrendRadarMutations', panel: { __typename?: 'TrendRadarPanelMutations', internalEvaluationOption: { __typename?: 'InternalEvaluationOptionMutations', deleteParticipations: { __typename?: 'InternalEvaluationOption', id: string, enabled: boolean, myParticipationId?: string | null, participationCounter: { __typename?: 'ParticipationCounter', completed: number, incomplete: number, total: number }, participants: Array<{ __typename?: 'Participant', state: ParticipationState, user: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, avatar: string } }> } } } } | null };

export type InviteInternalEvaluationUsersMutationVariables = Exact<{
  trendRadarId: Scalars['ID'];
  panelId: Scalars['ID'];
  input: InviteUsersInput;
}>;


export type InviteInternalEvaluationUsersMutation = { __typename?: 'Mutation', trendRadar?: { __typename?: 'TrendRadarMutations', panel: { __typename?: 'TrendRadarPanelMutations', internalEvaluationOption: { __typename?: 'InternalEvaluationOptionMutations', inviteUsers: { __typename?: 'InternalEvaluationOption', id: string, enabled: boolean, myParticipationId?: string | null, participationCounter: { __typename?: 'ParticipationCounter', completed: number, incomplete: number, total: number }, participants: Array<{ __typename?: 'Participant', state: ParticipationState, user: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, avatar: string } }> } } } } | null };

export type SendMessageToInternalEvaluationParticipantsMutationVariables = Exact<{
  trendRadarId: Scalars['ID'];
  panelId: Scalars['ID'];
  input: SendMessageInput;
}>;


export type SendMessageToInternalEvaluationParticipantsMutation = { __typename?: 'Mutation', trendRadar?: { __typename?: 'TrendRadarMutations', panel: { __typename?: 'TrendRadarPanelMutations', internalEvaluationOption: { __typename?: 'InternalEvaluationOptionMutations', sendMessage: boolean } } } | null };

export type SetInternalEvaluationOptionEnabledMutationVariables = Exact<{
  trendRadarId: Scalars['ID'];
  panelId: Scalars['ID'];
  enabled: Scalars['Boolean'];
}>;


export type SetInternalEvaluationOptionEnabledMutation = { __typename?: 'Mutation', trendRadar?: { __typename?: 'TrendRadarMutations', panel: { __typename?: 'TrendRadarPanelMutations', internalEvaluationOption: { __typename?: 'InternalEvaluationOptionMutations', setEnabled: { __typename?: 'InternalEvaluationOption', id: string, enabled: boolean } } } } | null };

export type UninviteInternalEvaluationUserMutationVariables = Exact<{
  trendRadarId: Scalars['ID'];
  panelId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type UninviteInternalEvaluationUserMutation = { __typename?: 'Mutation', trendRadar?: { __typename?: 'TrendRadarMutations', panel: { __typename?: 'TrendRadarPanelMutations', internalEvaluationOption: { __typename?: 'InternalEvaluationOptionMutations', uninviteUser: { __typename?: 'InternalEvaluationOption', id: string, enabled: boolean, myParticipationId?: string | null, participationCounter: { __typename?: 'ParticipationCounter', completed: number, incomplete: number, total: number }, participants: Array<{ __typename?: 'Participant', state: ParticipationState, user: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, avatar: string } }> } } } } | null };

export type CompanyMacrotrendPartsFragment = { __typename?: 'CompanyMacrotrend', active?: boolean | null, publicUrl?: string | null, id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null };

type MacrotrendInterfaceParts_CompanyMacrotrend_Fragment = { __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null };

type MacrotrendInterfaceParts_Macrotrend_Fragment = { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null };

type MacrotrendInterfaceParts_ReducedMacrotrend_Fragment = { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null };

export type MacrotrendInterfacePartsFragment = MacrotrendInterfaceParts_CompanyMacrotrend_Fragment | MacrotrendInterfaceParts_Macrotrend_Fragment | MacrotrendInterfaceParts_ReducedMacrotrend_Fragment;

type MacrotrendTranslationParts_CompanyMacrotrendTranslation_Fragment = { __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null };

type MacrotrendTranslationParts_MacrotrendTranslation_Fragment = { __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null };

export type MacrotrendTranslationPartsFragment = MacrotrendTranslationParts_CompanyMacrotrendTranslation_Fragment | MacrotrendTranslationParts_MacrotrendTranslation_Fragment;

export type ReducedMacrotrendPartsFragment = { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null };

export type TrendoneMacrotrendPartsFragment = { __typename?: 'Macrotrend', active?: boolean | null, publicUrl?: string | null, deprecated: boolean, id: string, image?: string | null, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null };

export type BecomeInsiderOfMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BecomeInsiderOfMutation = { __typename?: 'Mutation', me?: { __typename?: 'MeMutations', becomeInsiderOf?: { __typename?: 'CompanyMacrotrend', id: string, insider?: Array<{ __typename?: 'Insider', user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, avatar: string, jobPosition?: string | null, enabled?: boolean | null } }> | null } | { __typename?: 'Macrotrend', id: string, insider?: Array<{ __typename?: 'Insider', user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, avatar: string, jobPosition?: string | null, enabled?: boolean | null } }> | null } | { __typename?: 'ReducedMacrotrend' } | null } | null };

export type CreateCnOMutationVariables = Exact<{
  id: Scalars['ID'];
  locale: Locale;
  input: CreateCnOInput;
}>;


export type CreateCnOMutation = { __typename?: 'Mutation', macrotrend: { __typename?: 'MacrotrendMutation', createCnO: { __typename?: 'ChallengesAndOpportunities', id: string, type: ChallengesAndOpportunitiesType, author?: string | null, createdOn?: any | null, deletable: boolean, editable: boolean, translations: Array<{ __typename?: 'ChallengesAndOpportunitiesTranslation', locale: Locale, title: string, challenges: string, opportunities: string }> } } };

export type DeleteCnOMutationVariables = Exact<{
  id: Scalars['ID'];
  input: DeleteCnOInput;
}>;


export type DeleteCnOMutation = { __typename?: 'Mutation', macrotrend: { __typename?: 'MacrotrendMutation', deleteCnO: boolean } };

export type PinMicrotrendsMutationVariables = Exact<{
  input: PinMicrotrendsInput;
}>;


export type PinMicrotrendsMutation = { __typename?: 'Mutation', pinMicrotrends: boolean };

export type StopBeingInsiderOfMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type StopBeingInsiderOfMutation = { __typename?: 'Mutation', me?: { __typename?: 'MeMutations', stopBeingInsiderOf?: { __typename?: 'CompanyMacrotrend', id: string, insider?: Array<{ __typename?: 'Insider', user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, avatar: string, jobPosition?: string | null, enabled?: boolean | null } }> | null } | { __typename?: 'Macrotrend', id: string, insider?: Array<{ __typename?: 'Insider', user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, avatar: string, jobPosition?: string | null, enabled?: boolean | null } }> | null } | { __typename?: 'ReducedMacrotrend' } | null } | null };

export type SubscribeToMacrotrendMutationVariables = Exact<{
  macrotrendId: Scalars['ID'];
}>;


export type SubscribeToMacrotrendMutation = { __typename?: 'Mutation', macrotrendSubscription?: { __typename?: 'CompanyMacrotrend', hasSubscription?: boolean | null, id: string } | { __typename?: 'Macrotrend', hasSubscription?: boolean | null, id: string } | { __typename?: 'ReducedMacrotrend', id: string } | null };

export type UnpinMicrotrendMutationVariables = Exact<{
  input: UnpinMicrotrendInput;
}>;


export type UnpinMicrotrendMutation = { __typename?: 'Mutation', unpinMicrotrend: boolean };

export type UnsubscribeFromMacrotrendMutationVariables = Exact<{
  macrotrendId: Scalars['ID'];
}>;


export type UnsubscribeFromMacrotrendMutation = { __typename?: 'Mutation', macrotrendSubscription?: { __typename?: 'CompanyMacrotrend', hasSubscription?: boolean | null, id: string } | { __typename?: 'Macrotrend', hasSubscription?: boolean | null, id: string } | { __typename?: 'ReducedMacrotrend', id: string } | null };

export type UpdateCnOMutationVariables = Exact<{
  id: Scalars['ID'];
  locale: Locale;
  input: UpdateCnOInput;
}>;


export type UpdateCnOMutation = { __typename?: 'Mutation', macrotrend: { __typename?: 'MacrotrendMutation', updateCnO: { __typename?: 'ChallengesAndOpportunities', id: string, type: ChallengesAndOpportunitiesType, author?: string | null, createdOn?: any | null, deletable: boolean, editable: boolean, translations: Array<{ __typename?: 'ChallengesAndOpportunitiesTranslation', locale: Locale, title: string, challenges: string, opportunities: string }> } } };

export type AddMacrotrendToWorkspaceQueryQueryVariables = Exact<{
  id: Scalars['ID'];
  locale: Locale;
  sort?: InputMaybe<WorkspaceSort>;
}>;


export type AddMacrotrendToWorkspaceQueryQuery = { __typename?: 'Query', trend?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null } | null> | null } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null, workspaces: Array<{ __typename?: 'Workspace', id: string, title?: string | null, containsTrend: boolean }> };

export type AddMacrotrendQueryQueryVariables = Exact<{
  id: Scalars['ID'];
  locale: Locale;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type AddMacrotrendQueryQuery = { __typename?: 'Query', macrotrend?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null, innovationFields?: { __typename?: 'PaginatedInnovationFields', nodes: Array<{ __typename?: 'InnovationField', id: string, title: string, description?: string | null, technologicalOpportunities?: string | null, marketOpportunities?: string | null, capabilities?: string | null, image?: string | null, updatedAt?: any | null, publishingState?: InnovationFieldPublishingState | null, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string } | { __typename?: 'Macrotrend', id: string } | { __typename?: 'ReducedMacrotrend', id: string }> }>, pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null };

export type MacrotrendEvaluationsQueryVariables = Exact<{
  id: Scalars['ID'];
  locale?: InputMaybe<Locale>;
}>;


export type MacrotrendEvaluationsQuery = { __typename?: 'Query', evaluations?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend', id: string, evaluations?: Array<{ __typename?: 'TrendRadarMacrotrendEvaluation', id: string, perception?: string | null, trendRadar: { __typename?: 'PublishedTrendRadar', id: string, title: string, draftId: string, managers: Array<{ __typename?: 'User', id: string }> }, evaluation: { __typename?: 'Evaluation', id: string, recommendedAction: RecommendedActionValues, readinessAssessment?: ReadinessAssessmentValues | null, values?: Array<{ __typename?: 'EvaluationValue', value?: number | null, criteria: { __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> } }> | null } }> | null } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend', id: string, evaluations?: Array<{ __typename?: 'TrendRadarMacrotrendEvaluation', id: string, perception?: string | null, trendRadar: { __typename?: 'PublishedTrendRadar', id: string, title: string, draftId: string, managers: Array<{ __typename?: 'User', id: string }> }, evaluation: { __typename?: 'Evaluation', id: string, recommendedAction: RecommendedActionValues, readinessAssessment?: ReadinessAssessmentValues | null, values?: Array<{ __typename?: 'EvaluationValue', value?: number | null, criteria: { __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> } }> | null } }> | null } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null };

export type IntroducedMacrotrendsQueryVariables = Exact<{
  locale: Locale;
}>;


export type IntroducedMacrotrendsQuery = { __typename?: 'Query', introducedMacrotrends: Array<{ __typename?: 'Macrotrend', id: string, image?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null, updateInfo?: string | null } | null> | null }> };

export type MacrotrendsQueryVariables = Exact<{
  locale: Locale;
}>;


export type MacrotrendsQuery = { __typename?: 'Query', macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null }> };

export type MergedMacrotrendsQueryVariables = Exact<{
  locale: Locale;
}>;


export type MergedMacrotrendsQuery = { __typename?: 'Query', mergedMacrotrends: Array<{ __typename?: 'MergedMacrotrend', successor: { __typename?: 'Macrotrend', id: string, image?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null, updateInfo?: string | null } | null> | null }, predecessor: { __typename?: 'Macrotrend', id: string, image?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null } }> };

export type PinnedMicrotrendsQueryVariables = Exact<{
  id: Scalars['ID'];
  locale: Locale;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type PinnedMicrotrendsQuery = { __typename?: 'Query', macrotrend?: { __typename?: 'Comment', id: string } | { __typename?: 'Company', id: string } | { __typename?: 'CompanyMacrotrend', id: string, pins?: Array<{ __typename?: 'MicrotrendPin', pinnedBy?: { __typename?: 'User', id: string } | null, microtrend: { __typename?: 'CompanyMicrotrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, author?: { __typename?: 'User', id: string, avatar: string, firstName?: string | null, lastName?: string | null, email?: string | null } | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'Microtrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'ReducedMicrotrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } }> | null } | { __typename?: 'CompanyMegatrend', id: string } | { __typename?: 'CompanyMicrotrend', id: string } | { __typename?: 'Country', id: string } | { __typename?: 'CriteriaSet', id: string } | { __typename?: 'Export', id: string } | { __typename?: 'Industry', id: string } | { __typename?: 'Initiator', id: string } | { __typename?: 'InnovationField', id: string } | { __typename?: 'InnovationProject', id: string } | { __typename?: 'InnovationType', id: string } | { __typename?: 'Insider', id: string } | { __typename?: 'Macrotrend', id: string, pins?: Array<{ __typename?: 'MicrotrendPin', pinnedBy?: { __typename?: 'User', id: string } | null, microtrend: { __typename?: 'CompanyMicrotrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, author?: { __typename?: 'User', id: string, avatar: string, firstName?: string | null, lastName?: string | null, email?: string | null } | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'Microtrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'ReducedMicrotrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } }> | null } | { __typename?: 'Megatrend', id: string } | { __typename?: 'Microtrend', id: string } | { __typename?: 'Post', id: string } | { __typename?: 'PublishedTrendRadar', id: string } | { __typename?: 'ReducedMacrotrend', id: string } | { __typename?: 'ReducedMicrotrend', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'SearchAgent', id: string } | { __typename?: 'TrendRadarDraft', id: string } | { __typename?: 'TrendRadarParticipation', id: string } | { __typename?: 'TrendSummary', id: string } | { __typename?: 'Trendcall', id: string } | { __typename?: 'TrendingTopic', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Workspace', id: string } | null };

export type RelatedMicrotrendsQueryVariables = Exact<{
  id: Scalars['ID'];
  locale: Locale;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type RelatedMicrotrendsQuery = { __typename?: 'Query', macrotrend?: { __typename?: 'Comment', id: string } | { __typename?: 'Company', id: string } | { __typename?: 'CompanyMacrotrend', id: string, relatedMicrotrends?: { __typename?: 'PaginatedMicrotrends', nodes: Array<{ __typename?: 'CompanyMicrotrend', url?: string | null, videos?: Array<string | null> | null, comment: string, id: string, identifiedAt?: any | null, images?: Array<string | null> | null, initiators?: Array<{ __typename?: 'Initiator', id: string, title?: string | null }> | null, author?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, avatar: string, jobPosition?: string | null, email?: string | null } | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'Microtrend', url?: string | null, publicUrl?: string | null, videos?: Array<string | null> | null, id: string, identifiedAt?: any | null, images?: Array<string | null> | null, initiators?: Array<{ __typename?: 'Initiator', id: string, title?: string | null }> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'ReducedMicrotrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null }>, pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null } | { __typename?: 'CompanyMegatrend', id: string } | { __typename?: 'CompanyMicrotrend', id: string } | { __typename?: 'Country', id: string } | { __typename?: 'CriteriaSet', id: string } | { __typename?: 'Export', id: string } | { __typename?: 'Industry', id: string } | { __typename?: 'Initiator', id: string } | { __typename?: 'InnovationField', id: string } | { __typename?: 'InnovationProject', id: string } | { __typename?: 'InnovationType', id: string } | { __typename?: 'Insider', id: string } | { __typename?: 'Macrotrend', id: string, relatedMicrotrends?: { __typename?: 'PaginatedMicrotrends', nodes: Array<{ __typename?: 'CompanyMicrotrend', url?: string | null, videos?: Array<string | null> | null, comment: string, id: string, identifiedAt?: any | null, images?: Array<string | null> | null, initiators?: Array<{ __typename?: 'Initiator', id: string, title?: string | null }> | null, author?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, avatar: string, jobPosition?: string | null, email?: string | null } | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'Microtrend', url?: string | null, publicUrl?: string | null, videos?: Array<string | null> | null, id: string, identifiedAt?: any | null, images?: Array<string | null> | null, initiators?: Array<{ __typename?: 'Initiator', id: string, title?: string | null }> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'ReducedMicrotrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null }>, pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null } | { __typename?: 'Megatrend', id: string } | { __typename?: 'Microtrend', id: string } | { __typename?: 'Post', id: string } | { __typename?: 'PublishedTrendRadar', id: string } | { __typename?: 'ReducedMacrotrend', id: string } | { __typename?: 'ReducedMicrotrend', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'SearchAgent', id: string } | { __typename?: 'TrendRadarDraft', id: string } | { __typename?: 'TrendRadarParticipation', id: string } | { __typename?: 'TrendSummary', id: string } | { __typename?: 'Trendcall', id: string } | { __typename?: 'TrendingTopic', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Workspace', id: string } | null };

export type ReplacedMacrotrendsQueryVariables = Exact<{
  locale: Locale;
}>;


export type ReplacedMacrotrendsQuery = { __typename?: 'Query', replacedMacrotrends: Array<{ __typename?: 'ReplacedMacrotrend', successor: { __typename?: 'Macrotrend', id: string, image?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null, updateInfo?: string | null } | null> | null }, predecessor: { __typename?: 'Macrotrend', id: string, image?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null } }> };

export type RevisedMacrotrendsQueryVariables = Exact<{
  locale: Locale;
}>;


export type RevisedMacrotrendsQuery = { __typename?: 'Query', revisedMacrotrends: Array<{ __typename?: 'Macrotrend', id: string, image?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null, updateInfo?: string | null } | null> | null }> };

export type MacrotrendSearchQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchFiltersInput>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  locale: Locale;
  sort?: InputMaybe<MacrotrendsSort>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type MacrotrendSearchQuery = { __typename?: 'Query', search?: { __typename?: 'Search', macrotrends?: { __typename?: 'PaginatedMacrotrends', pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number }, nodes: Array<{ __typename?: 'CompanyMacrotrend', id: string, image?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, active?: boolean | null, image?: string | null, publicUrl?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, active?: boolean | null, image?: string | null, publicUrl?: string | null, successor?: { __typename?: 'Megatrend', id: string } | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', id: string, image?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, active?: boolean | null, image?: string | null, publicUrl?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, active?: boolean | null, image?: string | null, publicUrl?: string | null, successor?: { __typename?: 'Megatrend', id: string } | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, active?: boolean | null, image?: string | null, publicUrl?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, active?: boolean | null, image?: string | null, publicUrl?: string | null, successor?: { __typename?: 'Megatrend', id: string } | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | null }> } | null } | null };

export type MacrotrendTrendradarDetailQueryVariables = Exact<{
  id: Scalars['ID'];
  locale: Locale;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type MacrotrendTrendradarDetailQuery = { __typename?: 'Query', macrotrend?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend', active?: boolean | null, publicUrl?: string | null, id: string, image?: string | null, color?: string | null, evaluations?: Array<{ __typename?: 'TrendRadarMacrotrendEvaluation', trendRadar: { __typename?: 'PublishedTrendRadar', id: string }, evaluation: { __typename?: 'Evaluation', id: string, recommendedAction: RecommendedActionValues, readinessAssessment?: ReadinessAssessmentValues | null, values?: Array<{ __typename?: 'EvaluationValue', value?: number | null, criteria: { __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> } }> | null } }> | null, innovationFields?: { __typename?: 'PaginatedInnovationFields', nodes: Array<{ __typename?: 'InnovationField', id: string, title: string, description?: string | null, technologicalOpportunities?: string | null, marketOpportunities?: string | null, capabilities?: string | null, image?: string | null, updatedAt?: any | null, publishingState?: InnovationFieldPublishingState | null, trendRadars: { __typename?: 'PaginatedTrendRadars', nodes: Array<{ __typename?: 'PublishedTrendRadar', id: string } | { __typename?: 'TrendRadarDraft', id: string }> } }>, pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null, insider?: Array<{ __typename?: 'Insider', user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, avatar: string, enabled?: boolean | null, jobPosition?: string | null } }> | null, extendedSources?: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, chances?: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, risks?: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend', active?: boolean | null, publicUrl?: string | null, deprecated: boolean, id: string, image?: string | null, color?: string | null, evaluations?: Array<{ __typename?: 'TrendRadarMacrotrendEvaluation', trendRadar: { __typename?: 'PublishedTrendRadar', id: string }, evaluation: { __typename?: 'Evaluation', id: string, recommendedAction: RecommendedActionValues, readinessAssessment?: ReadinessAssessmentValues | null, values?: Array<{ __typename?: 'EvaluationValue', value?: number | null, criteria: { __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> } }> | null } }> | null, innovationFields?: { __typename?: 'PaginatedInnovationFields', nodes: Array<{ __typename?: 'InnovationField', id: string, title: string, description?: string | null, technologicalOpportunities?: string | null, marketOpportunities?: string | null, capabilities?: string | null, image?: string | null, updatedAt?: any | null, publishingState?: InnovationFieldPublishingState | null, trendRadars: { __typename?: 'PaginatedTrendRadars', nodes: Array<{ __typename?: 'PublishedTrendRadar', id: string } | { __typename?: 'TrendRadarDraft', id: string }> } }>, pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null, insider?: Array<{ __typename?: 'Insider', user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, avatar: string, enabled?: boolean | null, jobPosition?: string | null } }> | null, extendedSources?: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, chances?: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, risks?: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, evaluations?: Array<{ __typename?: 'TrendRadarMacrotrendEvaluation', trendRadar: { __typename?: 'PublishedTrendRadar', id: string }, evaluation: { __typename?: 'Evaluation', id: string, recommendedAction: RecommendedActionValues, readinessAssessment?: ReadinessAssessmentValues | null, values?: Array<{ __typename?: 'EvaluationValue', value?: number | null, criteria: { __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> } }> | null } }> | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null };

export type MacrotrendDetailViewQueryVariables = Exact<{
  id: Scalars['ID'];
  locale: Locale;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type MacrotrendDetailViewQuery = { __typename?: 'Query', macrotrend?: { __typename?: 'Comment', id: string } | { __typename?: 'Company', id: string } | { __typename?: 'CompanyMacrotrend', hasSubscription?: boolean | null, id: string, active?: boolean | null, publicUrl?: string | null, image?: string | null, color?: string | null, challengesAndOpportunities: Array<{ __typename?: 'ChallengesAndOpportunities', id: string, author?: string | null, createdOn?: any | null, deletable: boolean, editable: boolean, translations: Array<{ __typename?: 'ChallengesAndOpportunitiesTranslation', locale: Locale, title: string, challenges: string, opportunities: string }> }>, drivers: Array<{ __typename?: 'Driver', translations?: Array<{ __typename?: 'DriverTranslation', locale?: Locale | null, title?: string | null, description?: string | null }> | null }>, evaluations?: Array<{ __typename?: 'TrendRadarMacrotrendEvaluation', id: string }> | null, insider?: Array<{ __typename?: 'Insider', user: { __typename?: 'User', id: string, enabled?: boolean | null, firstName?: string | null, lastName?: string | null, email?: string | null, avatar: string, jobPosition?: string | null } }> | null, relatedMicrotrends?: { __typename?: 'PaginatedMicrotrends', pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null, relatedMacrotrends?: { __typename?: 'PaginatedMacrotrends', nodes: Array<{ __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null }> } | null, innovationFields?: { __typename?: 'PaginatedInnovationFields', nodes: Array<{ __typename?: 'InnovationField', id: string, title: string, image?: string | null }>, pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null, innovationProjects: { __typename?: 'PaginatedInnovationProjects', nodes: Array<{ __typename?: 'InnovationProject', id: string, title: string, image?: string | null, state: InnovationProjectState }> }, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null }> } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null }> } | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'CompanyMegatrend', id: string } | { __typename?: 'CompanyMicrotrend', id: string } | { __typename?: 'Country', id: string } | { __typename?: 'CriteriaSet', id: string } | { __typename?: 'Export', id: string } | { __typename?: 'Industry', id: string } | { __typename?: 'Initiator', id: string } | { __typename?: 'InnovationField', id: string } | { __typename?: 'InnovationProject', id: string } | { __typename?: 'InnovationType', id: string } | { __typename?: 'Insider', id: string } | { __typename?: 'Macrotrend', hasSubscription?: boolean | null, id: string, active?: boolean | null, publicUrl?: string | null, deprecated: boolean, image?: string | null, color?: string | null, challengesAndOpportunities: Array<{ __typename?: 'ChallengesAndOpportunities', id: string, author?: string | null, createdOn?: any | null, deletable: boolean, editable: boolean, translations: Array<{ __typename?: 'ChallengesAndOpportunitiesTranslation', locale: Locale, title: string, challenges: string, opportunities: string }> }>, drivers: Array<{ __typename?: 'Driver', translations?: Array<{ __typename?: 'DriverTranslation', locale?: Locale | null, title?: string | null, description?: string | null }> | null }>, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, evaluations?: Array<{ __typename?: 'TrendRadarMacrotrendEvaluation', id: string }> | null, insider?: Array<{ __typename?: 'Insider', user: { __typename?: 'User', id: string, enabled?: boolean | null, firstName?: string | null, lastName?: string | null, email?: string | null, avatar: string, jobPosition?: string | null } }> | null, relatedMicrotrends?: { __typename?: 'PaginatedMicrotrends', pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null, relatedMacrotrends?: { __typename?: 'PaginatedMacrotrends', nodes: Array<{ __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null }> } | null, innovationFields?: { __typename?: 'PaginatedInnovationFields', nodes: Array<{ __typename?: 'InnovationField', id: string, title: string, image?: string | null }>, pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null, innovationProjects: { __typename?: 'PaginatedInnovationProjects', nodes: Array<{ __typename?: 'InnovationProject', id: string, title: string, image?: string | null, state: InnovationProjectState }> }, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null }> } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null }> } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string } | { __typename?: 'Microtrend', id: string } | { __typename?: 'Post', id: string } | { __typename?: 'PublishedTrendRadar', id: string } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMicrotrend', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'SearchAgent', id: string } | { __typename?: 'TrendRadarDraft', id: string } | { __typename?: 'TrendRadarParticipation', id: string } | { __typename?: 'TrendSummary', id: string } | { __typename?: 'Trendcall', id: string } | { __typename?: 'TrendingTopic', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Workspace', id: string } | null };

type MegatrendParts_CompanyMegatrend_Fragment = { __typename?: 'CompanyMegatrend', id: string, color?: string | null, active?: boolean | null, image?: string | null, publicUrl?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null };

type MegatrendParts_Megatrend_Fragment = { __typename?: 'Megatrend', id: string, color?: string | null, active?: boolean | null, image?: string | null, publicUrl?: string | null, successor?: { __typename?: 'Megatrend', id: string } | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null };

export type MegatrendPartsFragment = MegatrendParts_CompanyMegatrend_Fragment | MegatrendParts_Megatrend_Fragment;

type MegatrendTranslationParts_CompanyMegatrendTranslation_Fragment = { __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null };

type MegatrendTranslationParts_MegatrendTranslation_Fragment = { __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null };

export type MegatrendTranslationPartsFragment = MegatrendTranslationParts_CompanyMegatrendTranslation_Fragment | MegatrendTranslationParts_MegatrendTranslation_Fragment;

export type IntroducedMegatrendsQueryVariables = Exact<{
  locale: Locale;
}>;


export type IntroducedMegatrendsQuery = { __typename?: 'Query', introducedMegatrends: Array<{ __typename?: 'Megatrend', id: string, image?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null, updateInfo?: string | null } | null> | null }> };

export type MegatrendRelatedMicrotrendsQueryVariables = Exact<{
  id: Scalars['ID'];
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  locale: Locale;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type MegatrendRelatedMicrotrendsQuery = { __typename?: 'Query', megatrend?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend', id: string, relatedMicrotrends?: { __typename?: 'PaginatedMicrotrends', nodes: Array<{ __typename?: 'CompanyMicrotrend', url?: string | null, videos?: Array<string | null> | null, comment: string, id: string, identifiedAt?: any | null, images?: Array<string | null> | null, initiators?: Array<{ __typename?: 'Initiator', id: string, title?: string | null }> | null, author?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, avatar: string, jobPosition?: string | null, email?: string | null } | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'Microtrend', url?: string | null, publicUrl?: string | null, videos?: Array<string | null> | null, id: string, identifiedAt?: any | null, images?: Array<string | null> | null, initiators?: Array<{ __typename?: 'Initiator', id: string, title?: string | null }> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'ReducedMicrotrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null }>, pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend', id: string, relatedMicrotrends?: { __typename?: 'PaginatedMicrotrends', nodes: Array<{ __typename?: 'CompanyMicrotrend', url?: string | null, videos?: Array<string | null> | null, comment: string, id: string, identifiedAt?: any | null, images?: Array<string | null> | null, initiators?: Array<{ __typename?: 'Initiator', id: string, title?: string | null }> | null, author?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, avatar: string, jobPosition?: string | null, email?: string | null } | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'Microtrend', url?: string | null, publicUrl?: string | null, videos?: Array<string | null> | null, id: string, identifiedAt?: any | null, images?: Array<string | null> | null, initiators?: Array<{ __typename?: 'Initiator', id: string, title?: string | null }> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'ReducedMicrotrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null }>, pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null };

export type RevisedMegatrendsQueryVariables = Exact<{
  locale: Locale;
}>;


export type RevisedMegatrendsQuery = { __typename?: 'Query', revisedMegatrends: Array<{ __typename?: 'Megatrend', id: string, image?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null, updateInfo?: string | null } | null> | null }> };

export type MegatrendSearchQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchFiltersInput>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  locale: Locale;
  sort?: InputMaybe<MegatrendsSort>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type MegatrendSearchQuery = { __typename?: 'Query', search?: { __typename?: 'Search', megatrends?: { __typename?: 'PaginatedMegatrends', pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number }, nodes: Array<{ __typename?: 'CompanyMegatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null }> } | null } | null };

export type MegatrendDetailQueryVariables = Exact<{
  id: Scalars['ID'];
  locale: Locale;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type MegatrendDetailQuery = { __typename?: 'Query', megatrend?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend', id: string, color?: string | null, active?: boolean | null, image?: string | null, publicUrl?: string | null, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null }>, relatedMicrotrends?: { __typename?: 'PaginatedMicrotrends', pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend', id: string, color?: string | null, active?: boolean | null, image?: string | null, publicUrl?: string | null, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null }>, relatedMicrotrends?: { __typename?: 'PaginatedMicrotrends', pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null, successor?: { __typename?: 'Megatrend', id: string } | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null };

export type CreateUseCaseMutationVariables = Exact<{
  input: CreateMicrotrendUseCaseInput;
}>;


export type CreateUseCaseMutation = { __typename?: 'Mutation', microtrendUseCase: { __typename?: 'MicrotrendUseCaseMutation', createUseCase: { __typename?: 'MicrotrendUseCase', id: string, title: string, text: string, author: string, createdOn: any, editable: boolean, deletable: boolean } } };

export type DeleteUseCaseMutationVariables = Exact<{
  input: DeleteMicrotrendUseCaseInput;
}>;


export type DeleteUseCaseMutation = { __typename?: 'Mutation', microtrendUseCase: { __typename?: 'MicrotrendUseCaseMutation', deleteUseCase: boolean } };

export type UpdateUseCaseMutationVariables = Exact<{
  input: UpdateMicrotrendUseCaseInput;
}>;


export type UpdateUseCaseMutation = { __typename?: 'Mutation', microtrendUseCase: { __typename?: 'MicrotrendUseCaseMutation', updateUseCase: { __typename?: 'MicrotrendUseCase', id: string, title: string, text: string, author: string, createdOn: any, editable: boolean, deletable: boolean } } };

export type UseCasesQueryVariables = Exact<{
  id: Scalars['ID'];
  locale: Locale;
}>;


export type UseCasesQuery = { __typename?: 'Query', node?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend', id: string, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string, title: string, text: string, author: string, createdOn: any, editable: boolean, deletable: boolean }> } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend', id: string, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string, title: string, text: string, author: string, createdOn: any, editable: boolean, deletable: boolean }> } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend', id: string, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string, title: string, text: string, author: string, createdOn: any, editable: boolean, deletable: boolean }> } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null };

export type CompanyMicrotrendPartsFragment = { __typename?: 'CompanyMicrotrend', url?: string | null, videos?: Array<string | null> | null, comment: string, id: string, identifiedAt?: any | null, images?: Array<string | null> | null, initiators?: Array<{ __typename?: 'Initiator', id: string, title?: string | null }> | null, author?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, avatar: string, jobPosition?: string | null, email?: string | null } | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> };

type MicrotrendInterfaceParts_CompanyMicrotrend_Fragment = { __typename?: 'CompanyMicrotrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> };

type MicrotrendInterfaceParts_Microtrend_Fragment = { __typename?: 'Microtrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> };

type MicrotrendInterfaceParts_ReducedMicrotrend_Fragment = { __typename?: 'ReducedMicrotrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> };

export type MicrotrendInterfacePartsFragment = MicrotrendInterfaceParts_CompanyMicrotrend_Fragment | MicrotrendInterfaceParts_Microtrend_Fragment | MicrotrendInterfaceParts_ReducedMicrotrend_Fragment;

export type MicrotrendTranslationPartsFragment = { __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null };

export type ReducedMicrotrendPartsFragment = { __typename?: 'ReducedMicrotrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null };

export type TrendoneMicrotrendPartsFragment = { __typename?: 'Microtrend', url?: string | null, publicUrl?: string | null, videos?: Array<string | null> | null, id: string, identifiedAt?: any | null, images?: Array<string | null> | null, initiators?: Array<{ __typename?: 'Initiator', id: string, title?: string | null }> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> };

export type AddMicrotrendQueryQueryVariables = Exact<{
  id: Scalars['ID'];
  locale: Locale;
  sort?: InputMaybe<WorkspaceSort>;
}>;


export type AddMicrotrendQueryQuery = { __typename?: 'Query', trend?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend', id: string, translations?: Array<{ __typename?: 'MicrotrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend', id: string, translations?: Array<{ __typename?: 'MicrotrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend', id: string, translations?: Array<{ __typename?: 'MicrotrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null, workspaces: Array<{ __typename?: 'Workspace', id: string, title?: string | null, containsTrend: boolean }> };

export type CountriesQueryVariables = Exact<{
  locale: Locale;
}>;


export type CountriesQuery = { __typename?: 'Query', countries?: { __typename?: 'PaginatedCountries', pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number }, nodes: Array<{ __typename?: 'Country', id: string, translations?: Array<{ __typename?: 'CountryTranslation', locale?: Locale | null, title?: string | null } | null> | null }> } | null };

export type MicrotrendsGalleryQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchFiltersInput>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  locale: Locale;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type MicrotrendsGalleryQuery = { __typename?: 'Query', search?: { __typename?: 'Search', microtrends?: { __typename?: 'PaginatedMicrotrends', pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number }, nodes: Array<{ __typename?: 'CompanyMicrotrend', url?: string | null, videos?: Array<string | null> | null, comment: string, id: string, identifiedAt?: any | null, images?: Array<string | null> | null, initiators?: Array<{ __typename?: 'Initiator', id: string, title?: string | null }> | null, author?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, avatar: string, jobPosition?: string | null, email?: string | null } | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'Microtrend', url?: string | null, publicUrl?: string | null, videos?: Array<string | null> | null, id: string, identifiedAt?: any | null, images?: Array<string | null> | null, initiators?: Array<{ __typename?: 'Initiator', id: string, title?: string | null }> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'ReducedMicrotrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null }> } | null } | null };

export type IndustriesQueryVariables = Exact<{
  locale: Locale;
}>;


export type IndustriesQuery = { __typename?: 'Query', industries: Array<{ __typename?: 'Industry', id: string, translations?: Array<{ __typename?: 'IndustryTranslation', locale?: Locale | null, title?: string | null } | null> | null }> };

export type InitiatorsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']>;
}>;


export type InitiatorsQuery = { __typename?: 'Query', initiators?: { __typename?: 'PaginatedInitiators', nodes: Array<{ __typename?: 'Initiator', id: string, title?: string | null }> } | null };

export type InnovationTypesQueryVariables = Exact<{
  locale: Locale;
}>;


export type InnovationTypesQuery = { __typename?: 'Query', innovationTypes?: { __typename?: 'PaginatedInnovationTypes', nodes: Array<{ __typename?: 'InnovationType', id: string, translations?: Array<{ __typename?: 'InnovationTypeTranslation', locale?: Locale | null, title?: string | null } | null> | null }> } | null };

export type MicrotrendsListQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchFiltersInput>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  locale: Locale;
  sort?: InputMaybe<MicrotrendsSort>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type MicrotrendsListQuery = { __typename?: 'Query', search?: { __typename?: 'Search', microtrends?: { __typename?: 'PaginatedMicrotrends', pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number }, nodes: Array<{ __typename?: 'CompanyMicrotrend', url?: string | null, videos?: Array<string | null> | null, comment: string, id: string, identifiedAt?: any | null, images?: Array<string | null> | null, innovationTypes?: Array<{ __typename?: 'InnovationType', id: string, translations?: Array<{ __typename?: 'InnovationTypeTranslation', locale?: Locale | null, title?: string | null } | null> | null }> | null, countries?: Array<{ __typename?: 'Country', code: string, translations?: Array<{ __typename?: 'CountryTranslation', locale?: Locale | null, title?: string | null } | null> | null }> | null, industries: Array<{ __typename?: 'Industry', id: string, translations?: Array<{ __typename?: 'IndustryTranslation', locale?: Locale | null, title?: string | null } | null> | null }>, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null }>, megatrends: Array<{ __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null } | null> | null }>, initiators?: Array<{ __typename?: 'Initiator', id: string, title?: string | null }> | null, author?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, avatar: string, jobPosition?: string | null, email?: string | null } | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'Microtrend', url?: string | null, publicUrl?: string | null, videos?: Array<string | null> | null, id: string, identifiedAt?: any | null, images?: Array<string | null> | null, innovationTypes?: Array<{ __typename?: 'InnovationType', id: string, translations?: Array<{ __typename?: 'InnovationTypeTranslation', locale?: Locale | null, title?: string | null } | null> | null }> | null, countries?: Array<{ __typename?: 'Country', code: string, translations?: Array<{ __typename?: 'CountryTranslation', locale?: Locale | null, title?: string | null } | null> | null }> | null, industries: Array<{ __typename?: 'Industry', id: string, translations?: Array<{ __typename?: 'IndustryTranslation', locale?: Locale | null, title?: string | null } | null> | null }>, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null }>, megatrends: Array<{ __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null } | null> | null }>, initiators?: Array<{ __typename?: 'Initiator', id: string, title?: string | null }> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'ReducedMicrotrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null }> } | null } | null };

export type MicrotrendPinQueryVariables = Exact<{
  id: Scalars['ID'];
  locale: Locale;
}>;


export type MicrotrendPinQuery = { __typename?: 'Query', microtrend?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend', id: string, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null, pins?: Array<{ __typename?: 'MicrotrendPin', id: string, macrotrend: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null } }> | null } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend', id: string, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null, pins?: Array<{ __typename?: 'MicrotrendPin', id: string, macrotrend: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null } }> | null } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null };

export type ScrapedInfosQueryVariables = Exact<{
  url: Scalars['String'];
}>;


export type ScrapedInfosQuery = { __typename?: 'Query', scrapedInfos?: { __typename?: 'ScrapedInfos', url?: string | null, language?: string | null, title?: string | null, description?: string | null, image?: string | null } | null };

export type MicrotrendDetailQueryVariables = Exact<{
  id: Scalars['ID'];
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  locale: Locale;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type MicrotrendDetailQuery = { __typename?: 'Query', microtrend?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend', publicUrl?: string | null, url?: string | null, videos?: Array<string | null> | null, comment: string, id: string, identifiedAt?: any | null, images?: Array<string | null> | null, pins?: Array<{ __typename?: 'MicrotrendPin', id: string, macrotrend: { __typename?: 'CompanyMacrotrend', id: string } | { __typename?: 'Macrotrend', id: string } | { __typename?: 'ReducedMacrotrend', id: string } }> | null, megatrends: Array<{ __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null }>, innovationTypes?: Array<{ __typename?: 'InnovationType', id: string, translations?: Array<{ __typename?: 'InnovationTypeTranslation', locale?: Locale | null, title?: string | null } | null> | null }> | null, industries: Array<{ __typename?: 'Industry', id: string, translations?: Array<{ __typename?: 'IndustryTranslation', title?: string | null } | null> | null }>, countries?: Array<{ __typename?: 'Country', id: string, code: string, translations?: Array<{ __typename?: 'CountryTranslation', locale?: Locale | null, title?: string | null } | null> | null }> | null, relatedMicrotrends?: { __typename?: 'PaginatedMicrotrends', nodes: Array<{ __typename?: 'CompanyMicrotrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'Microtrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'ReducedMicrotrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> }> } | null, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null }>, initiators?: Array<{ __typename?: 'Initiator', id: string, title?: string | null }> | null, author?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, avatar: string, jobPosition?: string | null, email?: string | null } | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend', publicUrl?: string | null, url?: string | null, videos?: Array<string | null> | null, id: string, identifiedAt?: any | null, images?: Array<string | null> | null, megatrends: Array<{ __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null }>, innovationTypes?: Array<{ __typename?: 'InnovationType', id: string, translations?: Array<{ __typename?: 'InnovationTypeTranslation', locale?: Locale | null, title?: string | null } | null> | null }> | null, industries: Array<{ __typename?: 'Industry', id: string, translations?: Array<{ __typename?: 'IndustryTranslation', title?: string | null } | null> | null }>, countries?: Array<{ __typename?: 'Country', id: string, code: string, translations?: Array<{ __typename?: 'CountryTranslation', locale?: Locale | null, title?: string | null } | null> | null }> | null, relatedMicrotrends?: { __typename?: 'PaginatedMicrotrends', nodes: Array<{ __typename?: 'CompanyMicrotrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'Microtrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'ReducedMicrotrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> }> } | null, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null }>, initiators?: Array<{ __typename?: 'Initiator', id: string, title?: string | null }> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null };

export type EvaluateMacrotrendMutationVariables = Exact<{
  input: EvaluateMacrotrendInput;
  locale?: InputMaybe<Locale>;
}>;


export type EvaluateMacrotrendMutation = { __typename?: 'Mutation', evaluateMacrotrend: { __typename?: 'TrendRadarParticipation', id: string, title: string, description?: string | null, evaluations?: Array<{ __typename?: 'MacrotrendEvaluation', id: string, macrotrend: { __typename?: 'CompanyMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null } | null> | null } | null }, evaluation?: { __typename?: 'Evaluation', id: string, recommendedAction: RecommendedActionValues, readinessAssessment?: ReadinessAssessmentValues | null, values?: Array<{ __typename?: 'EvaluationValue', value?: number | null, criteria: { __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> } }> | null } | null }> | null } };

export type DiscussionUserPartsFragment = { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, enabled?: boolean | null, avatar: string };

export type PostCountPartsFragment = { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } };

export type PostPartsFragment = { __typename?: 'Post', id: string, category: PostCategory, title: string, body: string, createdAt?: any | null, updatedAt?: any | null, url?: string | null };

export type DeletePostMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePostMutation = { __typename?: 'Mutation', post?: { __typename?: 'PostMutations', delete?: boolean | null } | null };

export type CreatePostInnovationProjectMutationVariables = Exact<{
  input: CreatePostInput;
}>;


export type CreatePostInnovationProjectMutation = { __typename?: 'Mutation', createPost: { __typename?: 'Post', id: string, title: string, body: string, createdAt?: any | null, updatedAt?: any | null, node: { __typename?: 'Comment', id: string } | { __typename?: 'Company', id: string } | { __typename?: 'CompanyMacrotrend', id: string } | { __typename?: 'CompanyMegatrend', id: string } | { __typename?: 'CompanyMicrotrend', id: string } | { __typename?: 'Country', id: string } | { __typename?: 'CriteriaSet', id: string } | { __typename?: 'Export', id: string } | { __typename?: 'Industry', id: string } | { __typename?: 'Initiator', id: string } | { __typename?: 'InnovationField', id: string } | { __typename?: 'InnovationProject', id: string } | { __typename?: 'InnovationType', id: string } | { __typename?: 'Insider', id: string } | { __typename?: 'Macrotrend', id: string } | { __typename?: 'Megatrend', id: string } | { __typename?: 'Microtrend', id: string } | { __typename?: 'Post', id: string } | { __typename?: 'PublishedTrendRadar', id: string } | { __typename?: 'ReducedMacrotrend', id: string } | { __typename?: 'ReducedMicrotrend', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'SearchAgent', id: string } | { __typename?: 'TrendRadarDraft', id: string } | { __typename?: 'TrendRadarParticipation', id: string } | { __typename?: 'TrendSummary', id: string } | { __typename?: 'Trendcall', id: string } | { __typename?: 'TrendingTopic', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Workspace', id: string }, owner: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, avatar: string, enabled?: boolean | null } } };

export type UpdatePostMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdatePostInput;
}>;


export type UpdatePostMutation = { __typename?: 'Mutation', post?: { __typename?: 'PostMutations', update?: { __typename?: 'Post', id: string, title: string, body: string, createdAt?: any | null, updatedAt?: any | null, owner: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, avatar: string, enabled?: boolean | null } } | null } | null };

export type CreatePostsMutationVariables = Exact<{
  input: CreatePostsInput;
}>;


export type CreatePostsMutation = { __typename?: 'Mutation', createPosts: Array<{ __typename?: 'Post', id: string, title: string, body: string, createdAt?: any | null, updatedAt?: any | null, node: { __typename?: 'Comment', id: string } | { __typename?: 'Company', id: string } | { __typename?: 'CompanyMacrotrend', id: string } | { __typename?: 'CompanyMegatrend', id: string } | { __typename?: 'CompanyMicrotrend', id: string } | { __typename?: 'Country', id: string } | { __typename?: 'CriteriaSet', id: string } | { __typename?: 'Export', id: string } | { __typename?: 'Industry', id: string } | { __typename?: 'Initiator', id: string } | { __typename?: 'InnovationField', id: string } | { __typename?: 'InnovationProject', id: string } | { __typename?: 'InnovationType', id: string } | { __typename?: 'Insider', id: string } | { __typename?: 'Macrotrend', id: string } | { __typename?: 'Megatrend', id: string } | { __typename?: 'Microtrend', id: string } | { __typename?: 'Post', id: string } | { __typename?: 'PublishedTrendRadar', id: string } | { __typename?: 'ReducedMacrotrend', id: string } | { __typename?: 'ReducedMicrotrend', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'SearchAgent', id: string } | { __typename?: 'TrendRadarDraft', id: string } | { __typename?: 'TrendRadarParticipation', id: string } | { __typename?: 'TrendSummary', id: string } | { __typename?: 'Trendcall', id: string } | { __typename?: 'TrendingTopic', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Workspace', id: string }, owner: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, avatar: string, enabled?: boolean | null } }> };

export type CreatePostMutationVariables = Exact<{
  input: CreatePostInput;
}>;


export type CreatePostMutation = { __typename?: 'Mutation', createPost: { __typename?: 'Post', id: string, title: string, body: string, createdAt?: any | null, updatedAt?: any | null, node: { __typename?: 'Comment', id: string } | { __typename?: 'Company', id: string } | { __typename?: 'CompanyMacrotrend', id: string } | { __typename?: 'CompanyMegatrend', id: string } | { __typename?: 'CompanyMicrotrend', id: string } | { __typename?: 'Country', id: string } | { __typename?: 'CriteriaSet', id: string } | { __typename?: 'Export', id: string } | { __typename?: 'Industry', id: string } | { __typename?: 'Initiator', id: string } | { __typename?: 'InnovationField', id: string } | { __typename?: 'InnovationProject', id: string } | { __typename?: 'InnovationType', id: string } | { __typename?: 'Insider', id: string } | { __typename?: 'Macrotrend', id: string } | { __typename?: 'Megatrend', id: string } | { __typename?: 'Microtrend', id: string } | { __typename?: 'Post', id: string } | { __typename?: 'PublishedTrendRadar', id: string } | { __typename?: 'ReducedMacrotrend', id: string } | { __typename?: 'ReducedMicrotrend', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'SearchAgent', id: string } | { __typename?: 'TrendRadarDraft', id: string } | { __typename?: 'TrendRadarParticipation', id: string } | { __typename?: 'TrendSummary', id: string } | { __typename?: 'Trendcall', id: string } | { __typename?: 'TrendingTopic', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Workspace', id: string }, owner: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, avatar: string, enabled?: boolean | null } } };

export type InnovationFieldPostsQueryVariables = Exact<{
  id: Scalars['ID'];
  locale: Locale;
  category: PostCategory;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
}>;


export type InnovationFieldPostsQuery = { __typename?: 'Query', node?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField', id: string, posts: { __typename?: 'PaginatedPosts', nodes: Array<{ __typename?: 'Post', id: string, category: PostCategory, title: string, body: string, createdAt?: any | null, updatedAt?: any | null, url?: string | null, node: { __typename?: 'Comment', id: string } | { __typename?: 'Company', id: string } | { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'CompanyMegatrend', id: string } | { __typename?: 'CompanyMicrotrend', id: string } | { __typename?: 'Country', id: string } | { __typename?: 'CriteriaSet', id: string } | { __typename?: 'Export', id: string } | { __typename?: 'Industry', id: string } | { __typename?: 'Initiator', id: string } | { __typename?: 'InnovationField', id: string } | { __typename?: 'InnovationProject', id: string } | { __typename?: 'InnovationType', id: string } | { __typename?: 'Insider', id: string } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'Megatrend', id: string } | { __typename?: 'Microtrend', id: string } | { __typename?: 'Post', id: string } | { __typename?: 'PublishedTrendRadar', id: string } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'ReducedMicrotrend', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'SearchAgent', id: string } | { __typename?: 'TrendRadarDraft', id: string } | { __typename?: 'TrendRadarParticipation', id: string } | { __typename?: 'TrendSummary', id: string } | { __typename?: 'Trendcall', id: string } | { __typename?: 'TrendingTopic', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Workspace', id: string }, owner: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, enabled?: boolean | null, avatar: string }, comments?: Array<{ __typename?: 'Comment', id: string, body?: string | null, createdAt?: any | null, updatedAt?: any | null, owner: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, avatar: string, enabled?: boolean | null } } | null> | null }>, pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } }, extendedSources: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } }, chances: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } }, risks: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null };

export type InnovationProjectPostsQueryVariables = Exact<{
  id: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
}>;


export type InnovationProjectPostsQuery = { __typename?: 'Query', node?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject', id: string, posts: { __typename?: 'PaginatedPosts', nodes: Array<{ __typename?: 'Post', id: string, category: PostCategory, title: string, body: string, createdAt?: any | null, updatedAt?: any | null, url?: string | null, owner: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, enabled?: boolean | null, avatar: string }, comments?: Array<{ __typename?: 'Comment', id: string, body?: string | null, createdAt?: any | null, updatedAt?: any | null, owner: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, avatar: string, enabled?: boolean | null } } | null> | null, node: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject', id: string, title: string } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } }>, pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } }, updates: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null };

export type MacrotrendPostsQueryVariables = Exact<{
  id: Scalars['ID'];
  category: PostCategory;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Locale>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type MacrotrendPostsQuery = { __typename?: 'Query', macrotrend?: { __typename?: 'Comment', id: string } | { __typename?: 'Company', id: string } | { __typename?: 'CompanyMacrotrend', id: string, color?: string | null, posts?: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number }, nodes: Array<{ __typename?: 'Post', id: string, category: PostCategory, title: string, body: string, createdAt?: any | null, updatedAt?: any | null, url?: string | null, node: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' }, owner: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, enabled?: boolean | null, avatar: string }, comments?: Array<{ __typename?: 'Comment', id: string, body?: string | null, createdAt?: any | null, updatedAt?: any | null, owner: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, avatar: string, enabled?: boolean | null } } | null> | null }> } | null, extendedSources?: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, chances?: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, risks?: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null } | { __typename?: 'CompanyMegatrend', id: string } | { __typename?: 'CompanyMicrotrend', id: string } | { __typename?: 'Country', id: string } | { __typename?: 'CriteriaSet', id: string } | { __typename?: 'Export', id: string } | { __typename?: 'Industry', id: string } | { __typename?: 'Initiator', id: string } | { __typename?: 'InnovationField', id: string } | { __typename?: 'InnovationProject', id: string } | { __typename?: 'InnovationType', id: string } | { __typename?: 'Insider', id: string } | { __typename?: 'Macrotrend', id: string, color?: string | null, posts?: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number }, nodes: Array<{ __typename?: 'Post', id: string, category: PostCategory, title: string, body: string, createdAt?: any | null, updatedAt?: any | null, url?: string | null, node: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' }, owner: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, enabled?: boolean | null, avatar: string }, comments?: Array<{ __typename?: 'Comment', id: string, body?: string | null, createdAt?: any | null, updatedAt?: any | null, owner: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, avatar: string, enabled?: boolean | null } } | null> | null }> } | null, extendedSources?: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, chances?: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, risks?: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null } | { __typename?: 'Megatrend', id: string } | { __typename?: 'Microtrend', id: string } | { __typename?: 'Post', id: string } | { __typename?: 'PublishedTrendRadar', id: string } | { __typename?: 'ReducedMacrotrend', id: string } | { __typename?: 'ReducedMicrotrend', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'SearchAgent', id: string } | { __typename?: 'TrendRadarDraft', id: string } | { __typename?: 'TrendRadarParticipation', id: string } | { __typename?: 'TrendSummary', id: string } | { __typename?: 'Trendcall', id: string } | { __typename?: 'TrendingTopic', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Workspace', id: string } | null };

export type MegatrendPostsQueryVariables = Exact<{
  id: Scalars['ID'];
  locale: Locale;
  category: PostCategory;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
}>;


export type MegatrendPostsQuery = { __typename?: 'Query', node?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend', id: string, posts?: { __typename?: 'PaginatedPosts', nodes: Array<{ __typename?: 'Post', id: string, category: PostCategory, title: string, body: string, createdAt?: any | null, updatedAt?: any | null, url?: string | null, node: { __typename?: 'Comment', id: string } | { __typename?: 'Company', id: string } | { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'CompanyMegatrend', id: string } | { __typename?: 'CompanyMicrotrend', id: string } | { __typename?: 'Country', id: string } | { __typename?: 'CriteriaSet', id: string } | { __typename?: 'Export', id: string } | { __typename?: 'Industry', id: string } | { __typename?: 'Initiator', id: string } | { __typename?: 'InnovationField', id: string } | { __typename?: 'InnovationProject', id: string } | { __typename?: 'InnovationType', id: string } | { __typename?: 'Insider', id: string } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'Megatrend', id: string } | { __typename?: 'Microtrend', id: string } | { __typename?: 'Post', id: string } | { __typename?: 'PublishedTrendRadar', id: string } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'ReducedMicrotrend', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'SearchAgent', id: string } | { __typename?: 'TrendRadarDraft', id: string } | { __typename?: 'TrendRadarParticipation', id: string } | { __typename?: 'TrendSummary', id: string } | { __typename?: 'Trendcall', id: string } | { __typename?: 'TrendingTopic', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Workspace', id: string }, owner: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, enabled?: boolean | null, avatar: string }, comments?: Array<{ __typename?: 'Comment', id: string, body?: string | null, createdAt?: any | null, updatedAt?: any | null, owner: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, avatar: string, enabled?: boolean | null } } | null> | null }>, pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null, extendedSources?: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, chances?: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, risks?: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend', id: string, posts?: { __typename?: 'PaginatedPosts', nodes: Array<{ __typename?: 'Post', id: string, category: PostCategory, title: string, body: string, createdAt?: any | null, updatedAt?: any | null, url?: string | null, node: { __typename?: 'Comment', id: string } | { __typename?: 'Company', id: string } | { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'CompanyMegatrend', id: string } | { __typename?: 'CompanyMicrotrend', id: string } | { __typename?: 'Country', id: string } | { __typename?: 'CriteriaSet', id: string } | { __typename?: 'Export', id: string } | { __typename?: 'Industry', id: string } | { __typename?: 'Initiator', id: string } | { __typename?: 'InnovationField', id: string } | { __typename?: 'InnovationProject', id: string } | { __typename?: 'InnovationType', id: string } | { __typename?: 'Insider', id: string } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'Megatrend', id: string } | { __typename?: 'Microtrend', id: string } | { __typename?: 'Post', id: string } | { __typename?: 'PublishedTrendRadar', id: string } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'ReducedMicrotrend', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'SearchAgent', id: string } | { __typename?: 'TrendRadarDraft', id: string } | { __typename?: 'TrendRadarParticipation', id: string } | { __typename?: 'TrendSummary', id: string } | { __typename?: 'Trendcall', id: string } | { __typename?: 'TrendingTopic', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Workspace', id: string }, owner: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, enabled?: boolean | null, avatar: string }, comments?: Array<{ __typename?: 'Comment', id: string, body?: string | null, createdAt?: any | null, updatedAt?: any | null, owner: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, avatar: string, enabled?: boolean | null } } | null> | null }>, pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null, extendedSources?: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, chances?: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, risks?: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null };

export type TrendradarPostsQueryVariables = Exact<{
  id: Scalars['ID'];
  locale: Locale;
  action: RecommendedActionValues;
  category: PostCategory;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
}>;


export type TrendradarPostsQuery = { __typename?: 'Query', node?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar', id: string, title: string, posts?: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number }, nodes: Array<{ __typename?: 'Post', id: string, category: PostCategory, title: string, body: string, createdAt?: any | null, updatedAt?: any | null, url?: string | null, owner: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, enabled?: boolean | null, avatar: string }, comments?: Array<{ __typename?: 'Comment', id: string, body?: string | null, createdAt?: any | null, updatedAt?: any | null, owner: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, avatar: string, enabled?: boolean | null } } | null> | null, node: { __typename?: 'Comment', id: string } | { __typename?: 'Company', id: string } | { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'CompanyMegatrend', id: string } | { __typename?: 'CompanyMicrotrend', id: string } | { __typename?: 'Country', id: string } | { __typename?: 'CriteriaSet', id: string } | { __typename?: 'Export', id: string } | { __typename?: 'Industry', id: string } | { __typename?: 'Initiator', id: string } | { __typename?: 'InnovationField', id: string } | { __typename?: 'InnovationProject', id: string } | { __typename?: 'InnovationType', id: string } | { __typename?: 'Insider', id: string } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'Megatrend', id: string } | { __typename?: 'Microtrend', id: string } | { __typename?: 'Post', id: string } | { __typename?: 'PublishedTrendRadar', id: string } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'ReducedMicrotrend', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'SearchAgent', id: string } | { __typename?: 'TrendRadarDraft', id: string } | { __typename?: 'TrendRadarParticipation', id: string } | { __typename?: 'TrendSummary', id: string } | { __typename?: 'Trendcall', id: string } | { __typename?: 'TrendingTopic', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Workspace', id: string } }> } | null } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null };

export type PublicEvaluationOptionPartsFragment = { __typename?: 'PublicEvaluationOption', id: string, enabled: boolean, feedbackEnabled: boolean, image?: string | null, participationCounter: { __typename?: 'ParticipationCounter', completed: number, incomplete: number, total: number }, translations: Array<{ __typename?: 'PublicEvaluationIntroTranslation', locale: Locale, title: string, description: string, feedbackIntro: string }> };

export type DeletePublicEvaluationLogoMutationVariables = Exact<{
  trendRadarId: Scalars['ID'];
  panelId: Scalars['ID'];
}>;


export type DeletePublicEvaluationLogoMutation = { __typename?: 'Mutation', trendRadar?: { __typename?: 'TrendRadarMutations', panel: { __typename?: 'TrendRadarPanelMutations', publicEvaluationOption: { __typename?: 'PublicEvaluationOptionMutations', deletePublicEvaluationLogo: { __typename?: 'PublicEvaluationOption', id: string, enabled: boolean, feedbackEnabled: boolean, image?: string | null, participationCounter: { __typename?: 'ParticipationCounter', completed: number, incomplete: number, total: number }, translations: Array<{ __typename?: 'PublicEvaluationIntroTranslation', locale: Locale, title: string, description: string, feedbackIntro: string }> } } } } | null };

export type DeletePanelPublicParticipationsMutationVariables = Exact<{
  trendRadarId: Scalars['ID'];
  panelId: Scalars['ID'];
}>;


export type DeletePanelPublicParticipationsMutation = { __typename?: 'Mutation', trendRadar?: { __typename?: 'TrendRadarMutations', panel: { __typename?: 'TrendRadarPanelMutations', publicEvaluationOption: { __typename?: 'PublicEvaluationOptionMutations', deleteParticipations: { __typename?: 'PublicEvaluationOption', id: string, enabled: boolean, feedbackEnabled: boolean, image?: string | null, participationCounter: { __typename?: 'ParticipationCounter', completed: number, incomplete: number, total: number }, translations: Array<{ __typename?: 'PublicEvaluationIntroTranslation', locale: Locale, title: string, description: string, feedbackIntro: string }> } } } } | null };

export type SetPanelPublicEvaluationOptionEnabledMutationVariables = Exact<{
  trendRadarId: Scalars['ID'];
  panelId: Scalars['ID'];
  enabled: Scalars['Boolean'];
}>;


export type SetPanelPublicEvaluationOptionEnabledMutation = { __typename?: 'Mutation', trendRadar?: { __typename?: 'TrendRadarMutations', panel: { __typename?: 'TrendRadarPanelMutations', publicEvaluationOption: { __typename?: 'PublicEvaluationOptionMutations', setEnabled: { __typename?: 'PublicEvaluationOption', id: string, enabled: boolean } } } } | null };

export type SetPanelPublicEvaluationOptionFeedbackEnabledMutationVariables = Exact<{
  trendRadarId: Scalars['ID'];
  panelId: Scalars['ID'];
  enabled: Scalars['Boolean'];
}>;


export type SetPanelPublicEvaluationOptionFeedbackEnabledMutation = { __typename?: 'Mutation', trendRadar?: { __typename?: 'TrendRadarMutations', panel: { __typename?: 'TrendRadarPanelMutations', publicEvaluationOption: { __typename?: 'PublicEvaluationOptionMutations', setFeedbackEnabled: { __typename?: 'PublicEvaluationOption', id: string, enabled: boolean, feedbackEnabled: boolean, image?: string | null, participationCounter: { __typename?: 'ParticipationCounter', completed: number, incomplete: number, total: number }, translations: Array<{ __typename?: 'PublicEvaluationIntroTranslation', locale: Locale, title: string, description: string, feedbackIntro: string }> } } } } | null };

export type UpdateFeedbackIntroTextMutationVariables = Exact<{
  trendRadarId: Scalars['ID'];
  panelId: Scalars['ID'];
  input: UpdateFeedbackIntroTextInput;
}>;


export type UpdateFeedbackIntroTextMutation = { __typename?: 'Mutation', trendRadar?: { __typename?: 'TrendRadarMutations', panel: { __typename?: 'TrendRadarPanelMutations', publicEvaluationOption: { __typename?: 'PublicEvaluationOptionMutations', updateFeedbackIntroText: { __typename?: 'PublicEvaluationOption', id: string, enabled: boolean, feedbackEnabled: boolean, image?: string | null, participationCounter: { __typename?: 'ParticipationCounter', completed: number, incomplete: number, total: number }, translations: Array<{ __typename?: 'PublicEvaluationIntroTranslation', locale: Locale, title: string, description: string, feedbackIntro: string }> } } } } | null };

export type UpdatePanelPublicEvaluationIntroTranslationsMutationVariables = Exact<{
  trendRadarId: Scalars['ID'];
  panelId: Scalars['ID'];
  input: PublicEvaluationOptionIntroTranslationsInput;
}>;


export type UpdatePanelPublicEvaluationIntroTranslationsMutation = { __typename?: 'Mutation', trendRadar?: { __typename?: 'TrendRadarMutations', panel: { __typename?: 'TrendRadarPanelMutations', publicEvaluationOption: { __typename?: 'PublicEvaluationOptionMutations', updateIntroTranslations: { __typename?: 'PublicEvaluationOption', id: string, enabled: boolean, feedbackEnabled: boolean, image?: string | null, participationCounter: { __typename?: 'ParticipationCounter', completed: number, incomplete: number, total: number }, translations: Array<{ __typename?: 'PublicEvaluationIntroTranslation', locale: Locale, title: string, description: string, feedbackIntro: string }> } } } } | null };

export type UpdatePublicEvaluationLogoMutationVariables = Exact<{
  trendRadarId: Scalars['ID'];
  panelId: Scalars['ID'];
  logo: Scalars['FileUpload'];
}>;


export type UpdatePublicEvaluationLogoMutation = { __typename?: 'Mutation', trendRadar?: { __typename?: 'TrendRadarMutations', panel: { __typename?: 'TrendRadarPanelMutations', publicEvaluationOption: { __typename?: 'PublicEvaluationOptionMutations', updatePublicEvaluationLogo: { __typename?: 'PublicEvaluationOption', id: string, enabled: boolean, feedbackEnabled: boolean, image?: string | null, participationCounter: { __typename?: 'ParticipationCounter', completed: number, incomplete: number, total: number }, translations: Array<{ __typename?: 'PublicEvaluationIntroTranslation', locale: Locale, title: string, description: string, feedbackIntro: string }> } } } } | null };

export type SearchAgentPartsFragment = { __typename?: 'SearchAgent', id: string, title: string, search?: { __typename?: 'SearchParameters', query?: string | null, filter?: { __typename?: 'SearchFilters', macrotrends?: Array<string> | null, megatrends?: Array<string> | null, industries?: Array<string> | null, regions?: Array<string> | null, countries?: Array<string> | null, innovationType?: Array<string> | null, sdgs?: Array<string> | null } | null } | null, facets?: { __typename?: 'SearchFacets', macrotrends: Array<{ __typename?: 'MacrotrendSearchFacet', node: { __typename?: 'CompanyMacrotrend', id: string, image?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null, description?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, successor?: { __typename?: 'CompanyMacrotrend', translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Macrotrend', translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null, description?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null, description?: string | null } | null> | null } | null } }>, megatrends: Array<{ __typename?: 'MegatrendSearchFacet', node: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null, description?: string | null } | null> | null } }>, industries: Array<{ __typename?: 'IndustrySearchFacet', node: { __typename?: 'Industry', id: string, translations?: Array<{ __typename?: 'IndustryTranslation', title?: string | null } | null> | null } }>, regions: Array<{ __typename?: 'RegionSearchFacet', node: { __typename?: 'Region', id: string, code: string, translations?: Array<{ __typename?: 'RegionTranslation', title?: string | null } | null> | null } }>, countries: Array<{ __typename?: 'CountrySearchFacet', node: { __typename?: 'Country', id: string, code: string, translations?: Array<{ __typename?: 'CountryTranslation', title?: string | null } | null> | null, region?: { __typename?: 'Region', id: string, code: string, translations?: Array<{ __typename?: 'RegionTranslation', title?: string | null } | null> | null } | null } }>, innovationType: Array<{ __typename?: 'InnovationTypeSearchFacet', node: { __typename?: 'InnovationType', id: string, translations?: Array<{ __typename?: 'InnovationTypeTranslation', title?: string | null } | null> | null } }>, sdgs: Array<{ __typename?: 'SdgSearchFacet', node: { __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', title: string }> } }> } | null, trendCounts: { __typename?: 'SearchAgentWorkspaceTrendCounts', new: number, unvoted: number, accepted: number, rejected: number } };

export type CreateSearchAgentMutationVariables = Exact<{
  input: CreateSearchAgentInput;
}>;


export type CreateSearchAgentMutation = { __typename?: 'Mutation', createSearchAgent?: { __typename?: 'SearchAgent', id: string, title: string, workspaces?: Array<{ __typename?: 'Workspace', id: string, title?: string | null } | null> | null } | null };

export type DeleteSearchAgentMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
  searchAgentId: Scalars['ID'];
}>;


export type DeleteSearchAgentMutation = { __typename?: 'Mutation', workspace?: { __typename?: 'WorkspaceMutations', removeSearchAgent: { __typename?: 'Workspace', id: string } } | null };

export type UpdateSearchAgentMutationVariables = Exact<{
  input: UpdateSearchAgentInput;
  locale?: InputMaybe<Locale>;
  workspaceId: Scalars['ID'];
}>;


export type UpdateSearchAgentMutation = { __typename?: 'Mutation', updateSearchAgent?: { __typename?: 'SearchAgent', id: string, title: string, search?: { __typename?: 'SearchParameters', query?: string | null, filter?: { __typename?: 'SearchFilters', macrotrends?: Array<string> | null, megatrends?: Array<string> | null, industries?: Array<string> | null, regions?: Array<string> | null, countries?: Array<string> | null, innovationType?: Array<string> | null, sdgs?: Array<string> | null } | null } | null, facets?: { __typename?: 'SearchFacets', macrotrends: Array<{ __typename?: 'MacrotrendSearchFacet', node: { __typename?: 'CompanyMacrotrend', id: string, image?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null, description?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, successor?: { __typename?: 'CompanyMacrotrend', translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Macrotrend', translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null, description?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null, description?: string | null } | null> | null } | null } }>, megatrends: Array<{ __typename?: 'MegatrendSearchFacet', node: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null, description?: string | null } | null> | null } }>, industries: Array<{ __typename?: 'IndustrySearchFacet', node: { __typename?: 'Industry', id: string, translations?: Array<{ __typename?: 'IndustryTranslation', title?: string | null } | null> | null } }>, regions: Array<{ __typename?: 'RegionSearchFacet', node: { __typename?: 'Region', id: string, code: string, translations?: Array<{ __typename?: 'RegionTranslation', title?: string | null } | null> | null } }>, countries: Array<{ __typename?: 'CountrySearchFacet', node: { __typename?: 'Country', id: string, code: string, translations?: Array<{ __typename?: 'CountryTranslation', title?: string | null } | null> | null, region?: { __typename?: 'Region', id: string, code: string, translations?: Array<{ __typename?: 'RegionTranslation', title?: string | null } | null> | null } | null } }>, innovationType: Array<{ __typename?: 'InnovationTypeSearchFacet', node: { __typename?: 'InnovationType', id: string, translations?: Array<{ __typename?: 'InnovationTypeTranslation', title?: string | null } | null> | null } }>, sdgs: Array<{ __typename?: 'SdgSearchFacet', node: { __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', title: string }> } }> } | null, trendCounts: { __typename?: 'SearchAgentWorkspaceTrendCounts', new: number, unvoted: number, accepted: number, rejected: number } } | null };

export type DetailsQueryVariables = Exact<{
  id: Scalars['ID'];
  workspaceId: Scalars['ID'];
  locale?: InputMaybe<Locale>;
}>;


export type DetailsQuery = { __typename?: 'Query', searchAgent?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent', id: string, title: string, search?: { __typename?: 'SearchParameters', query?: string | null, filter?: { __typename?: 'SearchFilters', macrotrends?: Array<string> | null, megatrends?: Array<string> | null, industries?: Array<string> | null, regions?: Array<string> | null, countries?: Array<string> | null, innovationType?: Array<string> | null, sdgs?: Array<string> | null } | null } | null, facets?: { __typename?: 'SearchFacets', macrotrends: Array<{ __typename?: 'MacrotrendSearchFacet', node: { __typename?: 'CompanyMacrotrend', id: string, image?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null, description?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, successor?: { __typename?: 'CompanyMacrotrend', translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Macrotrend', translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null, description?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null, description?: string | null } | null> | null } | null } }>, megatrends: Array<{ __typename?: 'MegatrendSearchFacet', node: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null, description?: string | null } | null> | null } }>, industries: Array<{ __typename?: 'IndustrySearchFacet', node: { __typename?: 'Industry', id: string, translations?: Array<{ __typename?: 'IndustryTranslation', title?: string | null } | null> | null } }>, regions: Array<{ __typename?: 'RegionSearchFacet', node: { __typename?: 'Region', id: string, code: string, translations?: Array<{ __typename?: 'RegionTranslation', title?: string | null } | null> | null } }>, countries: Array<{ __typename?: 'CountrySearchFacet', node: { __typename?: 'Country', id: string, code: string, translations?: Array<{ __typename?: 'CountryTranslation', title?: string | null } | null> | null, region?: { __typename?: 'Region', id: string, code: string, translations?: Array<{ __typename?: 'RegionTranslation', title?: string | null } | null> | null } | null } }>, innovationType: Array<{ __typename?: 'InnovationTypeSearchFacet', node: { __typename?: 'InnovationType', id: string, translations?: Array<{ __typename?: 'InnovationTypeTranslation', title?: string | null } | null> | null } }>, sdgs: Array<{ __typename?: 'SdgSearchFacet', node: { __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', title: string }> } }> } | null, trendCounts: { __typename?: 'SearchAgentWorkspaceTrendCounts', new: number, unvoted: number, accepted: number, rejected: number } } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null };

export type MicrotrendQueryComfortQueryVariables = Exact<{
  id: Scalars['ID'];
  workspaceId: Scalars['ID'];
  type?: InputMaybe<SearchAgentTrendType>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  locale: Locale;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type MicrotrendQueryComfortQuery = { __typename?: 'Query', searchAgent?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent', id: string, title: string, trendCounts: { __typename?: 'SearchAgentWorkspaceTrendCounts', new: number, unvoted: number, accepted: number, rejected: number }, trends?: { __typename?: 'PaginatedSearchAgentMicrotrend', pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number }, nodes?: Array<{ __typename?: 'SearchAgentMicrotrend', new?: boolean | null, microtrend?: { __typename?: 'CompanyMicrotrend', url?: string | null, videos?: Array<string | null> | null, comment: string, id: string, identifiedAt?: any | null, images?: Array<string | null> | null, innovationTypes?: Array<{ __typename?: 'InnovationType', id: string, translations?: Array<{ __typename?: 'InnovationTypeTranslation', locale?: Locale | null, title?: string | null } | null> | null }> | null, industries: Array<{ __typename?: 'Industry', id: string, translations?: Array<{ __typename?: 'IndustryTranslation', title?: string | null } | null> | null }>, countries?: Array<{ __typename?: 'Country', id: string, code: string, translations?: Array<{ __typename?: 'CountryTranslation', locale?: Locale | null, title?: string | null } | null> | null }> | null, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null }>, megatrends: Array<{ __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null }>, relatedMicrotrends?: { __typename?: 'PaginatedMicrotrends', nodes: Array<{ __typename?: 'CompanyMicrotrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'Microtrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'ReducedMicrotrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> }> } | null, initiators?: Array<{ __typename?: 'Initiator', id: string, title?: string | null }> | null, author?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, avatar: string, jobPosition?: string | null, email?: string | null } | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'Microtrend', url?: string | null, publicUrl?: string | null, videos?: Array<string | null> | null, id: string, identifiedAt?: any | null, images?: Array<string | null> | null, innovationTypes?: Array<{ __typename?: 'InnovationType', id: string, translations?: Array<{ __typename?: 'InnovationTypeTranslation', locale?: Locale | null, title?: string | null } | null> | null }> | null, industries: Array<{ __typename?: 'Industry', id: string, translations?: Array<{ __typename?: 'IndustryTranslation', title?: string | null } | null> | null }>, countries?: Array<{ __typename?: 'Country', id: string, code: string, translations?: Array<{ __typename?: 'CountryTranslation', locale?: Locale | null, title?: string | null } | null> | null }> | null, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null }>, megatrends: Array<{ __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null }>, relatedMicrotrends?: { __typename?: 'PaginatedMicrotrends', nodes: Array<{ __typename?: 'CompanyMicrotrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'Microtrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'ReducedMicrotrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> }> } | null, initiators?: Array<{ __typename?: 'Initiator', id: string, title?: string | null }> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'ReducedMicrotrend' } | null } | null> | null } | null } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null };

export type MicrotrendsTotalCountQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchFiltersInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
}>;


export type MicrotrendsTotalCountQuery = { __typename?: 'Query', search?: { __typename?: 'Search', microtrends?: { __typename?: 'PaginatedMicrotrends', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null } | null };

export type MicrotrendQueryQueryVariables = Exact<{
  id: Scalars['ID'];
  workspaceId: Scalars['ID'];
  type?: InputMaybe<SearchAgentTrendType>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Locale>;
}>;


export type MicrotrendQueryQuery = { __typename?: 'Query', node?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent', id: string, title: string, trendCounts: { __typename?: 'SearchAgentWorkspaceTrendCounts', new: number, unvoted: number, accepted: number, rejected: number }, trends?: { __typename?: 'PaginatedSearchAgentMicrotrend', pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number }, nodes?: Array<{ __typename?: 'SearchAgentMicrotrend', new?: boolean | null, microtrend?: { __typename?: 'CompanyMicrotrend', id: string, images?: Array<string | null> | null, identifiedAt?: any | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', title?: string | null, description?: string | null, locale?: Locale | null } | null> | null } | { __typename?: 'Microtrend', id: string, images?: Array<string | null> | null, identifiedAt?: any | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', title?: string | null, description?: string | null, locale?: Locale | null } | null> | null } | { __typename?: 'ReducedMicrotrend', id: string, images?: Array<string | null> | null, identifiedAt?: any | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', title?: string | null, description?: string | null, locale?: Locale | null } | null> | null } | null } | null> | null } | null } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null };

export type CountryPartsFragment = { __typename?: 'Country', id: string, code: string, translations?: Array<{ __typename?: 'CountryTranslation', locale?: Locale | null, title?: string | null } | null> | null };

export type CountryTranslationPartsFragment = { __typename?: 'CountryTranslation', locale?: Locale | null, title?: string | null };

export type IndustryPartsFragment = { __typename?: 'Industry', id: string, translations?: Array<{ __typename?: 'IndustryTranslation', title?: string | null } | null> | null };

export type InnovationTypePartsFragment = { __typename?: 'InnovationType', id: string, translations?: Array<{ __typename?: 'InnovationTypeTranslation', locale?: Locale | null, title?: string | null } | null> | null };

export type InnovationTypeTranslationPartsFragment = { __typename?: 'InnovationTypeTranslation', locale?: Locale | null, title?: string | null };

export type RegionPartsFragment = { __typename?: 'Region', id: string, code: string, translations?: Array<{ __typename?: 'RegionTranslation', locale?: Locale | null, title?: string | null } | null> | null };

export type RegionTranslationPartsFragment = { __typename?: 'RegionTranslation', locale?: Locale | null, title?: string | null };

type TrendradarParts_PublishedTrendRadar_Fragment = { __typename?: 'PublishedTrendRadar', id: string, title: string };

type TrendradarParts_TrendRadarDraft_Fragment = { __typename?: 'TrendRadarDraft', id: string, title: string };

export type TrendradarPartsFragment = TrendradarParts_PublishedTrendRadar_Fragment | TrendradarParts_TrendRadarDraft_Fragment;

export type SearchCountTestSearchQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchFiltersInput>;
}>;


export type SearchCountTestSearchQuery = { __typename?: 'Query', cnt?: { __typename?: 'DirectSearch', microtrends?: { __typename?: 'PaginatedMicrotrends', pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null, macrotrends?: { __typename?: 'PaginatedMacrotrends', pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null, megatrends?: { __typename?: 'PaginatedMegatrends', pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null } | null };

export type MacrotrendTestSearchQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchFiltersInput>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  locale: Locale;
  sort?: InputMaybe<MacrotrendsSort>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type MacrotrendTestSearchQuery = { __typename?: 'Query', search?: { __typename?: 'DirectSearch', macrotrends?: { __typename?: 'PaginatedMacrotrends', pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number }, nodes: Array<{ __typename?: 'CompanyMacrotrend', id: string, image?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, active?: boolean | null, image?: string | null, publicUrl?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, active?: boolean | null, image?: string | null, publicUrl?: string | null, successor?: { __typename?: 'Megatrend', id: string } | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', id: string, image?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, active?: boolean | null, image?: string | null, publicUrl?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, active?: boolean | null, image?: string | null, publicUrl?: string | null, successor?: { __typename?: 'Megatrend', id: string } | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, active?: boolean | null, image?: string | null, publicUrl?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, active?: boolean | null, image?: string | null, publicUrl?: string | null, successor?: { __typename?: 'Megatrend', id: string } | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | null }> } | null } | null };

export type MegatrendsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchFiltersInput>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  locale: Locale;
  sort?: InputMaybe<MegatrendsSort>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type MegatrendsQuery = { __typename?: 'Query', search?: { __typename?: 'DirectSearch', megatrends?: { __typename?: 'PaginatedMegatrends', pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number }, nodes: Array<{ __typename?: 'CompanyMegatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null }> } | null } | null };

export type MicrotrendsGalleryTestSearchQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchFiltersInput>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  locale: Locale;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type MicrotrendsGalleryTestSearchQuery = { __typename?: 'Query', search?: { __typename?: 'DirectSearch', microtrends?: { __typename?: 'PaginatedMicrotrends', pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number }, nodes: Array<{ __typename?: 'CompanyMicrotrend', url?: string | null, id: string, images?: Array<string | null> | null, identifiedAt?: any | null, author?: { __typename?: 'User', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, lastLogin?: any | null, phone?: string | null, email?: string | null, avatar: string, roles?: Array<Roles> | null, locale?: Locale | null, enabled?: boolean | null, adminActsAsUser?: boolean | null, showIntroductionVideo: boolean, insightsUpdates?: number | null, featureUpdates?: number | null, featureUpdatesDisabled: boolean, company?: { __typename?: 'Company', id: string, automaticUniverseUpdate: boolean, color?: string | null, locales?: Array<Locale> | null, features?: Array<Feature> | null, maxUsers?: number | null, product?: CompanyProduct | null, testAccount?: boolean | null, accountType: AccountType, title?: string | null, exportTemplates?: Array<{ __typename?: 'ExportTemplate', id: string, title: string, exportTypes?: Array<ExportType> | null }> | null } | null } | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Microtrend', url?: string | null, id: string, images?: Array<string | null> | null, identifiedAt?: any | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'ReducedMicrotrend', id: string, images?: Array<string | null> | null, identifiedAt?: any | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null }> } | null } | null };

export type MicrotrendsListTestSearchQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchFiltersInput>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  locale: Locale;
  sort?: InputMaybe<MicrotrendsSort>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type MicrotrendsListTestSearchQuery = { __typename?: 'Query', search?: { __typename?: 'DirectSearch', microtrends?: { __typename?: 'PaginatedMicrotrends', pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number }, nodes: Array<{ __typename?: 'CompanyMicrotrend', url?: string | null, videos?: Array<string | null> | null, id: string, images?: Array<string | null> | null, identifiedAt?: any | null, author?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, initiators?: Array<{ __typename?: 'Initiator', id: string, title?: string | null }> | null, innovationTypes?: Array<{ __typename?: 'InnovationType', id: string, translations?: Array<{ __typename?: 'InnovationTypeTranslation', locale?: Locale | null, title?: string | null } | null> | null }> | null, countries?: Array<{ __typename?: 'Country', code: string, translations?: Array<{ __typename?: 'CountryTranslation', locale?: Locale | null, title?: string | null } | null> | null }> | null, industries: Array<{ __typename?: 'Industry', id: string, translations?: Array<{ __typename?: 'IndustryTranslation', locale?: Locale | null, title?: string | null } | null> | null }>, megatrends: Array<{ __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null } | null> | null }>, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null }>, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Microtrend', url?: string | null, videos?: Array<string | null> | null, id: string, images?: Array<string | null> | null, identifiedAt?: any | null, initiators?: Array<{ __typename?: 'Initiator', id: string, title?: string | null }> | null, innovationTypes?: Array<{ __typename?: 'InnovationType', id: string, translations?: Array<{ __typename?: 'InnovationTypeTranslation', locale?: Locale | null, title?: string | null } | null> | null }> | null, countries?: Array<{ __typename?: 'Country', code: string, translations?: Array<{ __typename?: 'CountryTranslation', locale?: Locale | null, title?: string | null } | null> | null }> | null, industries: Array<{ __typename?: 'Industry', id: string, translations?: Array<{ __typename?: 'IndustryTranslation', locale?: Locale | null, title?: string | null } | null> | null }>, megatrends: Array<{ __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null } | null> | null }>, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null }>, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'ReducedMicrotrend', id: string, images?: Array<string | null> | null, identifiedAt?: any | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null }> } | null } | null };

export type TrendFinderFacetsTestQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  locale: Locale;
}>;


export type TrendFinderFacetsTestQuery = { __typename?: 'Query', search?: { __typename?: 'DirectSearch', microtrends?: { __typename?: 'PaginatedMicrotrends', facets?: { __typename?: 'SearchFacets', macrotrends: Array<{ __typename?: 'MacrotrendSearchFacet', node: { __typename?: 'CompanyMacrotrend', id: string, image?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null, description?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', id: string, image?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null, description?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null, description?: string | null } | null> | null } | null } }>, megatrends: Array<{ __typename?: 'MegatrendSearchFacet', node: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null, description?: string | null } | null> | null } }>, industries: Array<{ __typename?: 'IndustrySearchFacet', node: { __typename?: 'Industry', id: string, translations?: Array<{ __typename?: 'IndustryTranslation', title?: string | null } | null> | null } }>, regions: Array<{ __typename?: 'RegionSearchFacet', node: { __typename?: 'Region', id: string, code: string, translations?: Array<{ __typename?: 'RegionTranslation', locale?: Locale | null, title?: string | null } | null> | null } }>, countries: Array<{ __typename?: 'CountrySearchFacet', node: { __typename?: 'Country', id: string, code: string, region?: { __typename?: 'Region', id: string, code: string, translations?: Array<{ __typename?: 'RegionTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'CountryTranslation', locale?: Locale | null, title?: string | null } | null> | null } }>, innovationType: Array<{ __typename?: 'InnovationTypeSearchFacet', node: { __typename?: 'InnovationType', id: string, translations?: Array<{ __typename?: 'InnovationTypeTranslation', locale?: Locale | null, title?: string | null } | null> | null } }>, trendradars: Array<{ __typename?: 'TrendradarSearchFacet', node: { __typename?: 'PublishedTrendRadar', id: string, title: string } | { __typename?: 'TrendRadarDraft', id: string, title: string } }> } | null } | null } | null };

export type SearchCountQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchFiltersInput>;
}>;


export type SearchCountQuery = { __typename?: 'Query', cnt?: { __typename?: 'Search', microtrends?: { __typename?: 'PaginatedMicrotrends', pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null, macrotrends?: { __typename?: 'PaginatedMacrotrends', pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null, megatrends?: { __typename?: 'PaginatedMegatrends', pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null } | null };

export type FacetsByIdQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  locale: Locale;
}>;


export type FacetsByIdQuery = { __typename?: 'Query', nodes?: Array<{ __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend', id: string, image?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null } | null> | null } | null } | { __typename?: 'CompanyMegatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null } | null> | null, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null }> } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country', id: string, code: string, region?: { __typename?: 'Region', id: string } | null, translations?: Array<{ __typename?: 'CountryTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry', id: string, translations?: Array<{ __typename?: 'IndustryTranslation', title?: string | null } | null> | null } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType', id: string, translations?: Array<{ __typename?: 'InnovationTypeTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend', id: string, image?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null } | null> | null } | null } | { __typename?: 'Megatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null } | null> | null, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null }> } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar', id: string, title: string } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, image?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region', id: string, code: string, countries?: { __typename?: 'PaginatedCountries', nodes: Array<{ __typename?: 'Country', id: string, translations?: Array<{ __typename?: 'CountryTranslation', title?: string | null } | null> | null }> } | null, translations?: Array<{ __typename?: 'RegionTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft', id: string, title: string } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null> | null };

export type FacetsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  locale: Locale;
}>;


export type FacetsQuery = { __typename?: 'Query', search?: { __typename?: 'Search', microtrends?: { __typename?: 'PaginatedMicrotrends', facets?: { __typename?: 'SearchFacets', macrotrends: Array<{ __typename?: 'MacrotrendSearchFacet', node: { __typename?: 'CompanyMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', id: string } | { __typename?: 'Macrotrend', id: string } | { __typename?: 'ReducedMacrotrend', id: string } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null } | null> | null } | null } }>, megatrends: Array<{ __typename?: 'MegatrendSearchFacet', node: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null } | null> | null } }>, industries: Array<{ __typename?: 'IndustrySearchFacet', node: { __typename?: 'Industry', id: string, translations?: Array<{ __typename?: 'IndustryTranslation', title?: string | null } | null> | null } }>, regions: Array<{ __typename?: 'RegionSearchFacet', node: { __typename?: 'Region', id: string, code: string, translations?: Array<{ __typename?: 'RegionTranslation', locale?: Locale | null, title?: string | null } | null> | null } }>, countries: Array<{ __typename?: 'CountrySearchFacet', node: { __typename?: 'Country', id: string, code: string, region?: { __typename?: 'Region', id: string, code: string, translations?: Array<{ __typename?: 'RegionTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'CountryTranslation', locale?: Locale | null, title?: string | null } | null> | null } }>, innovationType: Array<{ __typename?: 'InnovationTypeSearchFacet', node: { __typename?: 'InnovationType', id: string, translations?: Array<{ __typename?: 'InnovationTypeTranslation', locale?: Locale | null, title?: string | null } | null> | null } }>, sdgs: Array<{ __typename?: 'SdgSearchFacet', node: { __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', title: string }> } }> } | null } | null } | null };

export type TrendFacetsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  locale: Locale;
}>;


export type TrendFacetsQuery = { __typename?: 'Query', trendtree?: { __typename?: 'Search', microtrends?: { __typename?: 'PaginatedMicrotrends', facets?: { __typename?: 'SearchFacets', macrotrends: Array<{ __typename?: 'MacrotrendSearchFacet', node: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null } | { __typename?: 'Megatrend', id: string, color?: string | null } | null } }>, megatrends: Array<{ __typename?: 'MegatrendSearchFacet', node: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null } | null> | null } }> } | null } | null } | null };

export type FacetsSearchQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  locale: Locale;
}>;


export type FacetsSearchQuery = { __typename?: 'Query', search?: { __typename?: 'Search', microtrends?: { __typename?: 'PaginatedMicrotrends', facets?: { __typename?: 'SearchFacets', macrotrends: Array<{ __typename?: 'MacrotrendSearchFacet', node: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null } | null> | null } | null } }>, megatrends: Array<{ __typename?: 'MegatrendSearchFacet', node: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null } | null> | null } }>, industries: Array<{ __typename?: 'IndustrySearchFacet', node: { __typename?: 'Industry', id: string, translations?: Array<{ __typename?: 'IndustryTranslation', title?: string | null } | null> | null } }>, regions: Array<{ __typename?: 'RegionSearchFacet', node: { __typename?: 'Region', id: string, code: string, translations?: Array<{ __typename?: 'RegionTranslation', locale?: Locale | null, title?: string | null } | null> | null } }>, countries: Array<{ __typename?: 'CountrySearchFacet', node: { __typename?: 'Country', id: string, code: string, region?: { __typename?: 'Region', id: string, code: string, translations?: Array<{ __typename?: 'RegionTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'CountryTranslation', locale?: Locale | null, title?: string | null } | null> | null } }>, innovationType: Array<{ __typename?: 'InnovationTypeSearchFacet', node: { __typename?: 'InnovationType', id: string, translations?: Array<{ __typename?: 'InnovationTypeTranslation', locale?: Locale | null, title?: string | null } | null> | null } }>, trendradars: Array<{ __typename?: 'TrendradarSearchFacet', node: { __typename?: 'PublishedTrendRadar', id: string, title: string } | { __typename?: 'TrendRadarDraft', id: string, title: string } }>, sdgs: Array<{ __typename?: 'SdgSearchFacet', node: { __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', title: string }> } }> } | null } | null } | null };

export type TrendRadarDraftCriteriaPartsFragment = { __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> };

export type TrendRadarDraftEvaluationPartsFragment = { __typename?: 'Evaluation', id: string, recommendedAction: RecommendedActionValues, readinessAssessment?: ReadinessAssessmentValues | null, values?: Array<{ __typename?: 'EvaluationValue', value?: number | null, criteria: { __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> } }> | null };

export type TrendRadarDraftPartsFragment = { __typename?: 'TrendRadarDraft', id: string, title: string, description?: string | null, published: boolean, publishable: boolean, hasUnpublishedChanges: boolean, evaluationEnabled: boolean, criteriaSetChangeable: boolean, managers: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, avatar: string }>, sharingOptions: { __typename?: 'TrendradarSharingOptions', image?: string | null, embedding: { __typename?: 'EmbeddingTrendradarSharingOption', id?: string | null, enabled: boolean }, publicView: { __typename?: 'PublicViewTrendradarSharingOption', id?: string | null, enabled: boolean } }, panels: Array<{ __typename?: 'TrendRadarPanel', id: string, title: string, enabled: boolean, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null }>, internalEvaluationOption?: { __typename?: 'InternalEvaluationOption', id: string, enabled: boolean, myParticipationId?: string | null, participationCounter: { __typename?: 'ParticipationCounter', completed: number, incomplete: number, total: number }, participants: Array<{ __typename?: 'Participant', state: ParticipationState, user: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, avatar: string } }> } | null, publicEvaluationOption?: { __typename?: 'PublicEvaluationOption', id: string, enabled: boolean, feedbackEnabled: boolean, image?: string | null, participationCounter: { __typename?: 'ParticipationCounter', completed: number, incomplete: number, total: number }, translations: Array<{ __typename?: 'PublicEvaluationIntroTranslation', locale: Locale, title: string, description: string, feedbackIntro: string }>, feedbackTranslations: Array<{ __typename?: 'PublicEvaluationFeedbackIntroTranslation', locale: Locale, text: string }> } | null }>, evaluations?: Array<{ __typename?: 'ManagedMacrotrendEvaluation', id: string, evaluationCount?: number | null, perception?: string | null, macrotrend: { __typename?: 'CompanyMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null }, overrideEvaluation?: { __typename?: 'Evaluation', id: string, recommendedAction: RecommendedActionValues, readinessAssessment?: ReadinessAssessmentValues | null, values?: Array<{ __typename?: 'EvaluationValue', value?: number | null, criteria: { __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> } }> | null } | null, averageEvaluation?: { __typename?: 'Evaluation', id: string, recommendedAction: RecommendedActionValues, readinessAssessment?: ReadinessAssessmentValues | null, values?: Array<{ __typename?: 'EvaluationValue', value?: number | null, criteria: { __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> } }> | null } | null, panelEvaluations: Array<{ __typename?: 'TrendRadarPanelEvaluation', panel: { __typename?: 'TrendRadarPanel', id: string, title: string }, averageEvaluation?: { __typename?: 'Evaluation', id: string, recommendedAction: RecommendedActionValues, readinessAssessment?: ReadinessAssessmentValues | null, values?: Array<{ __typename?: 'EvaluationValue', value?: number | null, criteria: { __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> } }> | null } | null }> }> | null, criteriaSet: { __typename?: 'CriteriaSet', id: string, translations: Array<{ __typename?: 'CriteriaSetTranslation', locale: Locale, title: string, recommendedAction?: { __typename?: 'RecommendedActionContent', actTitle: string, prepareTitle: string, watchTitle: string, outOfScopeTitle: string } | null }>, criterias: Array<{ __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> }> }, innovationFields?: { __typename?: 'PaginatedInnovationFields', nodes: Array<{ __typename?: 'InnovationField', id: string, title: string, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string } | { __typename?: 'Macrotrend', id: string } | { __typename?: 'ReducedMacrotrend', id: string }> }>, pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, innovationProjects: { __typename?: 'PaginatedInnovationProjects', nodes: Array<{ __typename?: 'InnovationProject', id: string, title: string, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string } | { __typename?: 'Macrotrend', id: string } | { __typename?: 'ReducedMacrotrend', id: string }> }>, pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } }, constraints: { __typename?: 'TrendRadarDraftConstraints', internalParticipantsMinimum: number }, deprecatedMacrotrends: Array<{ __typename?: 'DeprecatedMacrotrends', panel: { __typename?: 'TrendRadarPanel', id: string, title: string }, macrotrends?: Array<{ __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null }> | null }> };

export type TrendRadarDraftUserPartsFragment = { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, avatar: string };

export type CopyTrendradarDraftMutationVariables = Exact<{
  id: Scalars['ID'];
  input: CopyTrendRadarInput;
}>;


export type CopyTrendradarDraftMutation = { __typename?: 'Mutation', trendRadar?: { __typename?: 'TrendRadarMutations', copy: { __typename?: 'TrendRadarDraft', id: string, title: string } } | null };

export type CreatePanelMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CreatePanelMutation = { __typename?: 'Mutation', trendRadar?: { __typename?: 'TrendRadarMutations', createPanel: { __typename?: 'TrendRadarDraft', id: string, panels: Array<{ __typename?: 'TrendRadarPanel', id: string, title: string, enabled: boolean, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null }>, internalEvaluationOption?: { __typename?: 'InternalEvaluationOption', id: string, enabled: boolean, myParticipationId?: string | null, participationCounter: { __typename?: 'ParticipationCounter', completed: number, incomplete: number, total: number }, participants: Array<{ __typename?: 'Participant', state: ParticipationState, user: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, avatar: string } }> } | null, publicEvaluationOption?: { __typename?: 'PublicEvaluationOption', id: string, enabled: boolean, feedbackEnabled: boolean, image?: string | null, participationCounter: { __typename?: 'ParticipationCounter', completed: number, incomplete: number, total: number }, translations: Array<{ __typename?: 'PublicEvaluationIntroTranslation', locale: Locale, title: string, description: string, feedbackIntro: string }>, feedbackTranslations: Array<{ __typename?: 'PublicEvaluationFeedbackIntroTranslation', locale: Locale, text: string }> } | null }> } } | null };

export type CreateTrendRadarDraftMutationVariables = Exact<{
  input: CreateTrendRadarInput;
}>;


export type CreateTrendRadarDraftMutation = { __typename?: 'Mutation', createTrendRadar?: { __typename?: 'TrendRadarDraft', id: string } | null };

export type DeletePanelMutationVariables = Exact<{
  id: Scalars['ID'];
  panelId: Scalars['ID'];
}>;


export type DeletePanelMutation = { __typename?: 'Mutation', trendRadar?: { __typename?: 'TrendRadarMutations', deletePanel: { __typename?: 'TrendRadarDraft', id: string, criteriaSetChangeable: boolean, publishable: boolean, hasUnpublishedChanges: boolean, panels: Array<{ __typename?: 'TrendRadarPanel', id: string, title: string, enabled: boolean, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null }>, internalEvaluationOption?: { __typename?: 'InternalEvaluationOption', id: string, enabled: boolean, myParticipationId?: string | null, participationCounter: { __typename?: 'ParticipationCounter', completed: number, incomplete: number, total: number }, participants: Array<{ __typename?: 'Participant', state: ParticipationState, user: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, avatar: string } }> } | null, publicEvaluationOption?: { __typename?: 'PublicEvaluationOption', id: string, enabled: boolean, feedbackEnabled: boolean, image?: string | null, participationCounter: { __typename?: 'ParticipationCounter', completed: number, incomplete: number, total: number }, translations: Array<{ __typename?: 'PublicEvaluationIntroTranslation', locale: Locale, title: string, description: string, feedbackIntro: string }>, feedbackTranslations: Array<{ __typename?: 'PublicEvaluationFeedbackIntroTranslation', locale: Locale, text: string }> } | null }> } } | null };

export type DeleteSharingOptionsLogoMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteSharingOptionsLogoMutation = { __typename?: 'Mutation', trendRadar?: { __typename?: 'TrendRadarMutations', deleteSharingOptionsLogo?: { __typename?: 'TrendRadarDraft', id: string, sharingOptions: { __typename?: 'TrendradarSharingOptions', image?: string | null, embedding: { __typename?: 'EmbeddingTrendradarSharingOption', id?: string | null, enabled: boolean }, publicView: { __typename?: 'PublicViewTrendradarSharingOption', id?: string | null, enabled: boolean } } } | null } | null };

export type DeleteTrendRadarDraftMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTrendRadarDraftMutation = { __typename?: 'Mutation', trendRadar?: { __typename?: 'TrendRadarMutations', delete?: boolean | null } | null };

export type PublishTrendRadarDraftMutationVariables = Exact<{
  id: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
}>;


export type PublishTrendRadarDraftMutation = { __typename?: 'Mutation', trendRadar?: { __typename?: 'TrendRadarMutations', publish?: { __typename?: 'TrendRadarDraft', id: string, published: boolean, publishable: boolean, criteriaSetChangeable: boolean, publishedId?: string | null } | null } | null };

export type SetTrendRadarDraftEvaluationEnabledMutationVariables = Exact<{
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
}>;


export type SetTrendRadarDraftEvaluationEnabledMutation = { __typename?: 'Mutation', trendRadar?: { __typename?: 'TrendRadarMutations', setEvaluationEnabled: { __typename?: 'TrendRadarDraft', id: string, evaluationEnabled: boolean } } | null };

export type SetSharingOptionsLogoMutationVariables = Exact<{
  id: Scalars['ID'];
  logo: Scalars['FileUpload'];
}>;


export type SetSharingOptionsLogoMutation = { __typename?: 'Mutation', trendRadar?: { __typename?: 'TrendRadarMutations', setSharingOptionsLogo?: { __typename?: 'TrendRadarDraft', id: string, sharingOptions: { __typename?: 'TrendradarSharingOptions', image?: string | null, embedding: { __typename?: 'EmbeddingTrendradarSharingOption', id?: string | null, enabled: boolean }, publicView: { __typename?: 'PublicViewTrendradarSharingOption', id?: string | null, enabled: boolean } } } | null } | null };

export type SetSharingOptionsMutationVariables = Exact<{
  id: Scalars['ID'];
  input: SetSharingOptionsInput;
}>;


export type SetSharingOptionsMutation = { __typename?: 'Mutation', trendRadar?: { __typename?: 'TrendRadarMutations', setSharingOptions?: { __typename?: 'TrendradarSharingOptions', embedding: { __typename?: 'EmbeddingTrendradarSharingOption', id?: string | null, enabled: boolean }, publicView: { __typename?: 'PublicViewTrendradarSharingOption', id?: string | null, enabled: boolean } } | null } | null };

export type UnpublishTrendRadarDraftMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UnpublishTrendRadarDraftMutation = { __typename?: 'Mutation', trendRadar?: { __typename?: 'TrendRadarMutations', unpublish?: { __typename?: 'TrendRadarDraft', id: string, published: boolean, publishable: boolean, publishedId?: string | null, criteriaSetChangeable: boolean } | null } | null };

export type UpdateTrendRadarDraftMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateTrendRadarInput;
  locale: Locale;
}>;


export type UpdateTrendRadarDraftMutation = { __typename?: 'Mutation', trendRadar?: { __typename?: 'TrendRadarMutations', update: { __typename?: 'TrendRadarDraft', id: string, title: string, description?: string | null, published: boolean, publishable: boolean, hasUnpublishedChanges: boolean, evaluationEnabled: boolean, criteriaSetChangeable: boolean, managers: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, avatar: string }>, sharingOptions: { __typename?: 'TrendradarSharingOptions', image?: string | null, embedding: { __typename?: 'EmbeddingTrendradarSharingOption', id?: string | null, enabled: boolean }, publicView: { __typename?: 'PublicViewTrendradarSharingOption', id?: string | null, enabled: boolean } }, panels: Array<{ __typename?: 'TrendRadarPanel', id: string, title: string, enabled: boolean, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null }>, internalEvaluationOption?: { __typename?: 'InternalEvaluationOption', id: string, enabled: boolean, myParticipationId?: string | null, participationCounter: { __typename?: 'ParticipationCounter', completed: number, incomplete: number, total: number }, participants: Array<{ __typename?: 'Participant', state: ParticipationState, user: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, avatar: string } }> } | null, publicEvaluationOption?: { __typename?: 'PublicEvaluationOption', id: string, enabled: boolean, feedbackEnabled: boolean, image?: string | null, participationCounter: { __typename?: 'ParticipationCounter', completed: number, incomplete: number, total: number }, translations: Array<{ __typename?: 'PublicEvaluationIntroTranslation', locale: Locale, title: string, description: string, feedbackIntro: string }>, feedbackTranslations: Array<{ __typename?: 'PublicEvaluationFeedbackIntroTranslation', locale: Locale, text: string }> } | null }>, evaluations?: Array<{ __typename?: 'ManagedMacrotrendEvaluation', id: string, evaluationCount?: number | null, perception?: string | null, macrotrend: { __typename?: 'CompanyMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null }, overrideEvaluation?: { __typename?: 'Evaluation', id: string, recommendedAction: RecommendedActionValues, readinessAssessment?: ReadinessAssessmentValues | null, values?: Array<{ __typename?: 'EvaluationValue', value?: number | null, criteria: { __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> } }> | null } | null, averageEvaluation?: { __typename?: 'Evaluation', id: string, recommendedAction: RecommendedActionValues, readinessAssessment?: ReadinessAssessmentValues | null, values?: Array<{ __typename?: 'EvaluationValue', value?: number | null, criteria: { __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> } }> | null } | null, panelEvaluations: Array<{ __typename?: 'TrendRadarPanelEvaluation', panel: { __typename?: 'TrendRadarPanel', id: string, title: string }, averageEvaluation?: { __typename?: 'Evaluation', id: string, recommendedAction: RecommendedActionValues, readinessAssessment?: ReadinessAssessmentValues | null, values?: Array<{ __typename?: 'EvaluationValue', value?: number | null, criteria: { __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> } }> | null } | null }> }> | null, criteriaSet: { __typename?: 'CriteriaSet', id: string, translations: Array<{ __typename?: 'CriteriaSetTranslation', locale: Locale, title: string, recommendedAction?: { __typename?: 'RecommendedActionContent', actTitle: string, prepareTitle: string, watchTitle: string, outOfScopeTitle: string } | null }>, criterias: Array<{ __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> }> }, innovationFields?: { __typename?: 'PaginatedInnovationFields', nodes: Array<{ __typename?: 'InnovationField', id: string, title: string, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string } | { __typename?: 'Macrotrend', id: string } | { __typename?: 'ReducedMacrotrend', id: string }> }>, pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, innovationProjects: { __typename?: 'PaginatedInnovationProjects', nodes: Array<{ __typename?: 'InnovationProject', id: string, title: string, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string } | { __typename?: 'Macrotrend', id: string } | { __typename?: 'ReducedMacrotrend', id: string }> }>, pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } }, constraints: { __typename?: 'TrendRadarDraftConstraints', internalParticipantsMinimum: number }, deprecatedMacrotrends: Array<{ __typename?: 'DeprecatedMacrotrends', panel: { __typename?: 'TrendRadarPanel', id: string, title: string }, macrotrends?: Array<{ __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null }> | null }> } } | null };

export type LoadRecommendedActionPreviewQueryVariables = Exact<{
  input: RecommendedActionPreviewInput;
}>;


export type LoadRecommendedActionPreviewQuery = { __typename?: 'Query', recommendedActionPreview: RecommendedActionValues };

export type LoadTrendRadarDraftEvaluationsQueryVariables = Exact<{
  id: Scalars['ID'];
  locale: Locale;
}>;


export type LoadTrendRadarDraftEvaluationsQuery = { __typename?: 'Query', trendradar?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft', id: string, evaluations?: Array<{ __typename?: 'ManagedMacrotrendEvaluation', id: string, evaluationCount?: number | null, perception?: string | null, macrotrend: { __typename?: 'CompanyMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null }, overrideEvaluation?: { __typename?: 'Evaluation', id: string, recommendedAction: RecommendedActionValues, readinessAssessment?: ReadinessAssessmentValues | null, values?: Array<{ __typename?: 'EvaluationValue', value?: number | null, criteria: { __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> } }> | null } | null, averageEvaluation?: { __typename?: 'Evaluation', id: string, recommendedAction: RecommendedActionValues, readinessAssessment?: ReadinessAssessmentValues | null, values?: Array<{ __typename?: 'EvaluationValue', value?: number | null, criteria: { __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> } }> | null } | null, panelEvaluations: Array<{ __typename?: 'TrendRadarPanelEvaluation', panel: { __typename?: 'TrendRadarPanel', id: string, title: string }, averageEvaluation?: { __typename?: 'Evaluation', id: string, recommendedAction: RecommendedActionValues, readinessAssessment?: ReadinessAssessmentValues | null, values?: Array<{ __typename?: 'EvaluationValue', value?: number | null, criteria: { __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> } }> | null } | null }> }> | null } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null };

export type LoadTrendRadarDraftFlagsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LoadTrendRadarDraftFlagsQuery = { __typename?: 'Query', trendradar?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft', id: string, publishable: boolean, hasUnpublishedChanges: boolean, criteriaSetChangeable: boolean } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null };

export type LoadTrendRadarDraftQueryVariables = Exact<{
  id: Scalars['ID'];
  locale: Locale;
}>;


export type LoadTrendRadarDraftQuery = { __typename?: 'Query', trendradar?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft', id: string, title: string, description?: string | null, published: boolean, publishable: boolean, hasUnpublishedChanges: boolean, evaluationEnabled: boolean, criteriaSetChangeable: boolean, managers: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, avatar: string }>, sharingOptions: { __typename?: 'TrendradarSharingOptions', image?: string | null, embedding: { __typename?: 'EmbeddingTrendradarSharingOption', id?: string | null, enabled: boolean }, publicView: { __typename?: 'PublicViewTrendradarSharingOption', id?: string | null, enabled: boolean } }, panels: Array<{ __typename?: 'TrendRadarPanel', id: string, title: string, enabled: boolean, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null }>, internalEvaluationOption?: { __typename?: 'InternalEvaluationOption', id: string, enabled: boolean, myParticipationId?: string | null, participationCounter: { __typename?: 'ParticipationCounter', completed: number, incomplete: number, total: number }, participants: Array<{ __typename?: 'Participant', state: ParticipationState, user: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, avatar: string } }> } | null, publicEvaluationOption?: { __typename?: 'PublicEvaluationOption', id: string, enabled: boolean, feedbackEnabled: boolean, image?: string | null, participationCounter: { __typename?: 'ParticipationCounter', completed: number, incomplete: number, total: number }, translations: Array<{ __typename?: 'PublicEvaluationIntroTranslation', locale: Locale, title: string, description: string, feedbackIntro: string }>, feedbackTranslations: Array<{ __typename?: 'PublicEvaluationFeedbackIntroTranslation', locale: Locale, text: string }> } | null }>, evaluations?: Array<{ __typename?: 'ManagedMacrotrendEvaluation', id: string, evaluationCount?: number | null, perception?: string | null, macrotrend: { __typename?: 'CompanyMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null }, overrideEvaluation?: { __typename?: 'Evaluation', id: string, recommendedAction: RecommendedActionValues, readinessAssessment?: ReadinessAssessmentValues | null, values?: Array<{ __typename?: 'EvaluationValue', value?: number | null, criteria: { __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> } }> | null } | null, averageEvaluation?: { __typename?: 'Evaluation', id: string, recommendedAction: RecommendedActionValues, readinessAssessment?: ReadinessAssessmentValues | null, values?: Array<{ __typename?: 'EvaluationValue', value?: number | null, criteria: { __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> } }> | null } | null, panelEvaluations: Array<{ __typename?: 'TrendRadarPanelEvaluation', panel: { __typename?: 'TrendRadarPanel', id: string, title: string }, averageEvaluation?: { __typename?: 'Evaluation', id: string, recommendedAction: RecommendedActionValues, readinessAssessment?: ReadinessAssessmentValues | null, values?: Array<{ __typename?: 'EvaluationValue', value?: number | null, criteria: { __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> } }> | null } | null }> }> | null, criteriaSet: { __typename?: 'CriteriaSet', id: string, translations: Array<{ __typename?: 'CriteriaSetTranslation', locale: Locale, title: string, recommendedAction?: { __typename?: 'RecommendedActionContent', actTitle: string, prepareTitle: string, watchTitle: string, outOfScopeTitle: string } | null }>, criterias: Array<{ __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> }> }, innovationFields?: { __typename?: 'PaginatedInnovationFields', nodes: Array<{ __typename?: 'InnovationField', id: string, title: string, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string } | { __typename?: 'Macrotrend', id: string } | { __typename?: 'ReducedMacrotrend', id: string }> }>, pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, innovationProjects: { __typename?: 'PaginatedInnovationProjects', nodes: Array<{ __typename?: 'InnovationProject', id: string, title: string, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string } | { __typename?: 'Macrotrend', id: string } | { __typename?: 'ReducedMacrotrend', id: string }> }>, pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } }, constraints: { __typename?: 'TrendRadarDraftConstraints', internalParticipantsMinimum: number }, deprecatedMacrotrends: Array<{ __typename?: 'DeprecatedMacrotrends', panel: { __typename?: 'TrendRadarPanel', id: string, title: string }, macrotrends?: Array<{ __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null }> | null }> } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null };

export type TrendRadarPanelPartsFragment = { __typename?: 'TrendRadarPanel', id: string, title: string, enabled: boolean, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null }>, internalEvaluationOption?: { __typename?: 'InternalEvaluationOption', id: string, enabled: boolean, myParticipationId?: string | null, participationCounter: { __typename?: 'ParticipationCounter', completed: number, incomplete: number, total: number }, participants: Array<{ __typename?: 'Participant', state: ParticipationState, user: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, avatar: string } }> } | null, publicEvaluationOption?: { __typename?: 'PublicEvaluationOption', id: string, enabled: boolean, feedbackEnabled: boolean, image?: string | null, participationCounter: { __typename?: 'ParticipationCounter', completed: number, incomplete: number, total: number }, translations: Array<{ __typename?: 'PublicEvaluationIntroTranslation', locale: Locale, title: string, description: string, feedbackIntro: string }>, feedbackTranslations: Array<{ __typename?: 'PublicEvaluationFeedbackIntroTranslation', locale: Locale, text: string }> } | null };

export type SetTrendRadarPanelEnabledMutationVariables = Exact<{
  trendRadarId: Scalars['ID'];
  panelId: Scalars['ID'];
  enabled: Scalars['Boolean'];
}>;


export type SetTrendRadarPanelEnabledMutation = { __typename?: 'Mutation', trendRadar?: { __typename?: 'TrendRadarMutations', panel: { __typename?: 'TrendRadarPanelMutations', setEnabled: { __typename?: 'TrendRadarPanel', id: string, title: string, enabled: boolean, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null }>, internalEvaluationOption?: { __typename?: 'InternalEvaluationOption', id: string, enabled: boolean, myParticipationId?: string | null, participationCounter: { __typename?: 'ParticipationCounter', completed: number, incomplete: number, total: number }, participants: Array<{ __typename?: 'Participant', state: ParticipationState, user: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, avatar: string } }> } | null, publicEvaluationOption?: { __typename?: 'PublicEvaluationOption', id: string, enabled: boolean, feedbackEnabled: boolean, image?: string | null, participationCounter: { __typename?: 'ParticipationCounter', completed: number, incomplete: number, total: number }, translations: Array<{ __typename?: 'PublicEvaluationIntroTranslation', locale: Locale, title: string, description: string, feedbackIntro: string }>, feedbackTranslations: Array<{ __typename?: 'PublicEvaluationFeedbackIntroTranslation', locale: Locale, text: string }> } | null } } } | null };

export type UpdateMacrotrendsMutationVariables = Exact<{
  trendRadarId: Scalars['ID'];
  panelId: Scalars['ID'];
  macrotrendIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type UpdateMacrotrendsMutation = { __typename?: 'Mutation', trendRadar?: { __typename?: 'TrendRadarMutations', panel: { __typename?: 'TrendRadarPanelMutations', updateMacrotrends: { __typename?: 'TrendRadarPanel', id: string, title: string, enabled: boolean, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null }>, internalEvaluationOption?: { __typename?: 'InternalEvaluationOption', id: string, enabled: boolean, myParticipationId?: string | null, participationCounter: { __typename?: 'ParticipationCounter', completed: number, incomplete: number, total: number }, participants: Array<{ __typename?: 'Participant', state: ParticipationState, user: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, avatar: string } }> } | null, publicEvaluationOption?: { __typename?: 'PublicEvaluationOption', id: string, enabled: boolean, feedbackEnabled: boolean, image?: string | null, participationCounter: { __typename?: 'ParticipationCounter', completed: number, incomplete: number, total: number }, translations: Array<{ __typename?: 'PublicEvaluationIntroTranslation', locale: Locale, title: string, description: string, feedbackIntro: string }>, feedbackTranslations: Array<{ __typename?: 'PublicEvaluationFeedbackIntroTranslation', locale: Locale, text: string }> } | null } } } | null };

export type UpdatePanelMutationVariables = Exact<{
  trendRadarId: Scalars['ID'];
  panelId: Scalars['ID'];
  input: UpdateTrendRadarPanelInput;
}>;


export type UpdatePanelMutation = { __typename?: 'Mutation', trendRadar?: { __typename?: 'TrendRadarMutations', panel: { __typename?: 'TrendRadarPanelMutations', update: { __typename?: 'TrendRadarPanel', id: string, title: string, enabled: boolean, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null }>, internalEvaluationOption?: { __typename?: 'InternalEvaluationOption', id: string, enabled: boolean, myParticipationId?: string | null, participationCounter: { __typename?: 'ParticipationCounter', completed: number, incomplete: number, total: number }, participants: Array<{ __typename?: 'Participant', state: ParticipationState, user: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, avatar: string } }> } | null, publicEvaluationOption?: { __typename?: 'PublicEvaluationOption', id: string, enabled: boolean, feedbackEnabled: boolean, image?: string | null, participationCounter: { __typename?: 'ParticipationCounter', completed: number, incomplete: number, total: number }, translations: Array<{ __typename?: 'PublicEvaluationIntroTranslation', locale: Locale, title: string, description: string, feedbackIntro: string }>, feedbackTranslations: Array<{ __typename?: 'PublicEvaluationFeedbackIntroTranslation', locale: Locale, text: string }> } | null } } } | null };

export type CriteriaPartsFragment = { __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> };

type DeprecatedMacrotrendsParts_PublishedTrendRadar_Fragment = { __typename?: 'PublishedTrendRadar', deprecatedMacrotrends: Array<{ __typename?: 'DeprecatedMacrotrends', panel: { __typename?: 'TrendRadarPanel', id: string, title: string }, macrotrends?: Array<{ __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null }> | null }> };

type DeprecatedMacrotrendsParts_TrendRadarDraft_Fragment = { __typename?: 'TrendRadarDraft', deprecatedMacrotrends: Array<{ __typename?: 'DeprecatedMacrotrends', panel: { __typename?: 'TrendRadarPanel', id: string, title: string }, macrotrends?: Array<{ __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null }> | null }> };

export type DeprecatedMacrotrendsPartsFragment = DeprecatedMacrotrendsParts_PublishedTrendRadar_Fragment | DeprecatedMacrotrendsParts_TrendRadarDraft_Fragment;

export type TrendradarEvaluationPartsFragment = { __typename?: 'Evaluation', id: string, recommendedAction: RecommendedActionValues, readinessAssessment?: ReadinessAssessmentValues | null, values?: Array<{ __typename?: 'EvaluationValue', value?: number | null, criteria: { __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> } }> | null };

type TrendradarMacrotrendParts_CompanyMacrotrend_Fragment = { __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null };

type TrendradarMacrotrendParts_Macrotrend_Fragment = { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null };

type TrendradarMacrotrendParts_ReducedMacrotrend_Fragment = { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null };

export type TrendradarMacrotrendPartsFragment = TrendradarMacrotrendParts_CompanyMacrotrend_Fragment | TrendradarMacrotrendParts_Macrotrend_Fragment | TrendradarMacrotrendParts_ReducedMacrotrend_Fragment;

export type TrendradarUserPartsFragment = { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobPosition?: string | null, avatar: string };

export type CreateTrendRadarMutationVariables = Exact<{
  input: CreateTrendRadarInput;
  locale?: InputMaybe<Locale>;
}>;


export type CreateTrendRadarMutation = { __typename?: 'Mutation', createTrendRadar?: { __typename?: 'TrendRadarDraft', id: string, publishedId?: string | null, title: string, description?: string | null, published: boolean, publishable: boolean, hasUnpublishedChanges: boolean, criteriaSetChangeable: boolean, managers: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobPosition?: string | null, avatar: string }>, criteriaSet: { __typename?: 'CriteriaSet', id: string, criterias: Array<{ __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> }> } } | null };

export type DeleteOverrideMutationVariables = Exact<{
  id: Scalars['ID'];
  macrotrendId: Scalars['ID'];
  locale: Locale;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type DeleteOverrideMutation = { __typename?: 'Mutation', trendRadar?: { __typename?: 'TrendRadarMutations', deleteOverride?: { __typename?: 'TrendRadarDraft', id: string, publishedId?: string | null, title: string, description?: string | null, image: string, published: boolean, publishable: boolean, hasUnpublishedChanges: boolean, evaluationEnabled: boolean, criteriaSet: { __typename?: 'CriteriaSet', id: string, criterias: Array<{ __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> }> }, evaluations?: Array<{ __typename?: 'ManagedMacrotrendEvaluation', id: string, evaluationCount?: number | null, perception?: string | null, macrotrend: { __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null }, overrideEvaluation?: { __typename?: 'Evaluation', id: string, recommendedAction: RecommendedActionValues, readinessAssessment?: ReadinessAssessmentValues | null, values?: Array<{ __typename?: 'EvaluationValue', value?: number | null, criteria: { __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> } }> | null } | null, averageEvaluation?: { __typename?: 'Evaluation', id: string, recommendedAction: RecommendedActionValues, readinessAssessment?: ReadinessAssessmentValues | null, values?: Array<{ __typename?: 'EvaluationValue', value?: number | null, criteria: { __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> } }> | null } | null }> | null } | null } | null };

export type RepublishTrendradarMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RepublishTrendradarMutation = { __typename?: 'Mutation', trendRadar?: { __typename?: 'TrendRadarMutations', republish?: { __typename?: 'TrendRadarDraft', id: string, publishedId?: string | null, title: string, description?: string | null, image: string, published: boolean, publishable: boolean, hasUnpublishedChanges: boolean, evaluationEnabled: boolean } | null } | null };

export type OverrideEvaluationMutationVariables = Exact<{
  id: Scalars['ID'];
  input: OverrideEvaluationInput;
  locale: Locale;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type OverrideEvaluationMutation = { __typename?: 'Mutation', trendRadar?: { __typename?: 'TrendRadarMutations', overrideEvaluation?: { __typename?: 'TrendRadarDraft', id: string, publishedId?: string | null, title: string, description?: string | null, image: string, published: boolean, publishable: boolean, hasUnpublishedChanges: boolean, evaluationEnabled: boolean, criteriaSet: { __typename?: 'CriteriaSet', id: string, criterias: Array<{ __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> }> }, evaluations?: Array<{ __typename?: 'ManagedMacrotrendEvaluation', id: string, evaluationCount?: number | null, perception?: string | null, macrotrend: { __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null }, overrideEvaluation?: { __typename?: 'Evaluation', id: string, recommendedAction: RecommendedActionValues, readinessAssessment?: ReadinessAssessmentValues | null, values?: Array<{ __typename?: 'EvaluationValue', value?: number | null, criteria: { __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> } }> | null } | null, averageEvaluation?: { __typename?: 'Evaluation', id: string, recommendedAction: RecommendedActionValues, readinessAssessment?: ReadinessAssessmentValues | null, values?: Array<{ __typename?: 'EvaluationValue', value?: number | null, criteria: { __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> } }> | null } | null }> | null } | null } | null };

export type SetPercptionMutationVariables = Exact<{
  id: Scalars['ID'];
  input: SetPerceptionInput;
  locale: Locale;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type SetPercptionMutation = { __typename?: 'Mutation', trendRadar?: { __typename?: 'TrendRadarMutations', setPerception?: { __typename?: 'TrendRadarDraft', id: string, publishedId?: string | null, image: string, published: boolean, publishable: boolean, hasUnpublishedChanges: boolean, evaluations?: Array<{ __typename?: 'ManagedMacrotrendEvaluation', id: string, evaluationCount?: number | null, perception?: string | null, macrotrend: { __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null }, overrideEvaluation?: { __typename?: 'Evaluation', id: string, recommendedAction: RecommendedActionValues, readinessAssessment?: ReadinessAssessmentValues | null, values?: Array<{ __typename?: 'EvaluationValue', value?: number | null, criteria: { __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> } }> | null } | null, averageEvaluation?: { __typename?: 'Evaluation', id: string, recommendedAction: RecommendedActionValues, readinessAssessment?: ReadinessAssessmentValues | null, values?: Array<{ __typename?: 'EvaluationValue', value?: number | null, criteria: { __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> } }> | null } | null }> | null } | null } | null };

export type TrendradarsQueryVariables = Exact<{
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
}>;


export type TrendradarsQuery = { __typename?: 'Query', trendradars?: { __typename?: 'PaginatedTrendRadars', nodes: Array<{ __typename?: 'PublishedTrendRadar', id: string, title: string } | { __typename?: 'TrendRadarDraft', id: string, title: string }> } | null };

export type CountRadarsQueryVariables = Exact<{ [key: string]: never; }>;


export type CountRadarsQuery = { __typename?: 'Query', trendradars?: { __typename?: 'PaginatedTrendRadars', pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null, participations?: { __typename?: 'PaginatedTrendRadarParticipations', pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null };

export type LoadTrendradarsGalleryQueryVariables = Exact<{
  locale?: InputMaybe<Locale>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
}>;


export type LoadTrendradarsGalleryQuery = { __typename?: 'Query', trendradars?: { __typename?: 'PaginatedTrendRadars', nodes: Array<{ __typename?: 'PublishedTrendRadar', id: string, title: string, image: string, managers: Array<{ __typename?: 'User', id: string }>, deprecatedMacrotrends: Array<{ __typename?: 'DeprecatedMacrotrends', panel: { __typename?: 'TrendRadarPanel', id: string, title: string }, macrotrends?: Array<{ __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null }> | null }> } | { __typename?: 'TrendRadarDraft', id: string, title: string, image: string, managers: Array<{ __typename?: 'User', id: string }>, deprecatedMacrotrends: Array<{ __typename?: 'DeprecatedMacrotrends', panel: { __typename?: 'TrendRadarPanel', id: string, title: string }, macrotrends?: Array<{ __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null }> | null }> }> } | null };

export type InnovationFieldDetailQueryVariables = Exact<{
  id: Scalars['ID'];
  locale: Locale;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type InnovationFieldDetailQuery = { __typename?: 'Query', innovationField?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField', id: string, title: string, description?: string | null, technologicalOpportunities?: string | null, marketOpportunities?: string | null, capabilities?: string | null, image?: string | null, updatedAt?: any | null, publishingState?: InnovationFieldPublishingState | null, contactPerson?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, avatar: string, jobPosition?: string | null } | null, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null }> } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null };

export type TrendRadarInnovationFieldsQueryVariables = Exact<{
  id: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
}>;


export type TrendRadarInnovationFieldsQuery = { __typename?: 'Query', node?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar', id: string, innovationFields?: { __typename?: 'PaginatedInnovationFields', nodes: Array<{ __typename?: 'InnovationField', id: string, title: string, description?: string | null, image?: string | null, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string } | { __typename?: 'Macrotrend', id: string } | { __typename?: 'ReducedMacrotrend', id: string }> }> } | null } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null };

export type InnovationProjectDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
  locale: Locale;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type InnovationProjectDetailsQuery = { __typename?: 'Query', innovationProject?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject', id: string, title: string, image?: string | null, description: string, objective: string, environment: string, state: InnovationProjectState, publishingState: PublishingState, updatedAt?: any | null, participants: Array<{ __typename?: 'User', id: string, avatar: string, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, email?: string | null }>, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null }> } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null };

export type TrendRadarInnovationProjectsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TrendRadarInnovationProjectsQuery = { __typename?: 'Query', node?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar', id: string, innovationProjects: { __typename?: 'PaginatedInnovationProjects', nodes: Array<{ __typename?: 'InnovationProject', id: string, title: string, image?: string | null, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string } | { __typename?: 'Macrotrend', id: string } | { __typename?: 'ReducedMacrotrend', id: string }> }> } } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null };

export type LoadTrendradarsListQueryVariables = Exact<{
  locale?: InputMaybe<Locale>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  sort?: InputMaybe<TrendRadarSort>;
}>;


export type LoadTrendradarsListQuery = { __typename?: 'Query', trendradars?: { __typename?: 'PaginatedTrendRadars', nodes: Array<{ __typename?: 'PublishedTrendRadar', id: string, title: string, image: string, updatedAt?: any | null, managers: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null }>, innovationFields?: { __typename?: 'PaginatedInnovationFields', nodes: Array<{ __typename?: 'InnovationField', id: string, title: string }> } | null, innovationProjects: { __typename?: 'PaginatedInnovationProjects', nodes: Array<{ __typename?: 'InnovationProject', id: string, title: string }> }, deprecatedMacrotrends: Array<{ __typename?: 'DeprecatedMacrotrends', panel: { __typename?: 'TrendRadarPanel', id: string, title: string }, macrotrends?: Array<{ __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null }> | null }> } | { __typename?: 'TrendRadarDraft', id: string, title: string, image: string, updatedAt?: any | null, managers: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null }>, innovationFields?: { __typename?: 'PaginatedInnovationFields', nodes: Array<{ __typename?: 'InnovationField', id: string, title: string }> } | null, innovationProjects: { __typename?: 'PaginatedInnovationProjects', nodes: Array<{ __typename?: 'InnovationProject', id: string, title: string }> }, deprecatedMacrotrends: Array<{ __typename?: 'DeprecatedMacrotrends', panel: { __typename?: 'TrendRadarPanel', id: string, title: string }, macrotrends?: Array<{ __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null }> | null }> }> } | null };

export type LoadParticipationQueryVariables = Exact<{
  id: Scalars['ID'];
  locale: Locale;
}>;


export type LoadParticipationQuery = { __typename?: 'Query', participation?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation', id: string, title: string, description?: string | null, evaluationEnabled: boolean, updatedAt?: any | null, criteriaSet: { __typename?: 'CriteriaSet', criterias: Array<{ __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> }> }, evaluations?: Array<{ __typename?: 'MacrotrendEvaluation', id: string, perception?: string | null, macrotrend: { __typename?: 'CompanyMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null } | null> | null } | null } | { __typename?: 'Macrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMacrotrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', title?: string | null } | null> | null } | null }, evaluation?: { __typename?: 'Evaluation', id: string, recommendedAction: RecommendedActionValues, readinessAssessment?: ReadinessAssessmentValues | null, values?: Array<{ __typename?: 'EvaluationValue', value?: number | null, criteria: { __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> } }> | null } | null }> | null } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null };

export type LoadParticipationsQueryVariables = Exact<{
  sort?: InputMaybe<TrendRadarParticipationSort>;
}>;


export type LoadParticipationsQuery = { __typename?: 'Query', trendRadarParticipations?: { __typename?: 'PaginatedTrendRadarParticipations', nodes: Array<{ __typename?: 'TrendRadarParticipation', id: string, title: string, image: string, updatedAt?: any | null }> } | null };

export type LoadPublishedQueryVariables = Exact<{
  id: Scalars['ID'];
  locale?: InputMaybe<Locale>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type LoadPublishedQuery = { __typename?: 'Query', trendradar?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar', id: string, draftId: string, title: string, description?: string | null, image: string, updatedAt?: any | null, managers: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobPosition?: string | null, avatar: string }>, criteriaSet: { __typename?: 'CriteriaSet', id: string, criterias: Array<{ __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> }>, translations: Array<{ __typename?: 'CriteriaSetTranslation', locale: Locale, title: string, readinessAssessment?: { __typename?: 'ReadinessAssessmentContent', learn?: string | null, preserve?: string | null, make?: string | null, buy?: string | null } | null, recommendedAction?: { __typename?: 'RecommendedActionContent', actTitle: string, actDescription: string, prepareTitle: string, prepareDescription: string, watchTitle: string, watchDescription: string, outOfScopeTitle: string, outOfScopeDescription: string } | null }> }, evaluations: Array<{ __typename?: 'MacrotrendEvaluation', id: string, perception?: string | null, macrotrend: { __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null }, evaluation?: { __typename?: 'Evaluation', id: string, recommendedAction: RecommendedActionValues, readinessAssessment?: ReadinessAssessmentValues | null, values?: Array<{ __typename?: 'EvaluationValue', value?: number | null, criteria: { __typename?: 'Criteria', id: string, type: CriteriaType, min: number, max: number, marks: number, nullable: boolean, adsorb: boolean, scale: Scale, translations: Array<{ __typename?: 'CriteriaTranslation', locale: string, title: string, description?: string | null, labels: Array<string> }> } }> | null } | null }>, innovationFields?: { __typename?: 'PaginatedInnovationFields', nodes: Array<{ __typename?: 'InnovationField', id: string, title: string, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string } | { __typename?: 'Macrotrend', id: string } | { __typename?: 'ReducedMacrotrend', id: string }> }>, pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, innovationProjects: { __typename?: 'PaginatedInnovationProjects', nodes: Array<{ __typename?: 'InnovationProject', id: string, title: string, macrotrends: Array<{ __typename?: 'CompanyMacrotrend', id: string } | { __typename?: 'Macrotrend', id: string } | { __typename?: 'ReducedMacrotrend', id: string }> }>, pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } }, extendedSourcesACT?: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, extendedSourcesPREPARE?: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, extendedSourcesWATCH?: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, chancesACT?: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, chancesPREPARE?: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, chancesWATCH?: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, risksACT?: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, risksPREPARE?: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, risksWATCH?: { __typename?: 'PaginatedPosts', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, deprecatedMacrotrends: Array<{ __typename?: 'DeprecatedMacrotrends', panel: { __typename?: 'TrendRadarPanel', id: string, title: string }, macrotrends?: Array<{ __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null }> | null }> } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null };

export type LoadWorkspacesForSelectQueryVariables = Exact<{
  locale?: InputMaybe<Locale>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type LoadWorkspacesForSelectQuery = { __typename?: 'Query', updateableWorkspaces: Array<{ __typename?: 'Workspace', id: string, title?: string | null, trends?: { __typename?: 'PaginatedWorkspaceTrends', nodes: Array<{ __typename?: 'WorkspaceTrend', trend?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null }> } | null }> };

export type SendFeedbackMutationVariables = Exact<{
  input: SendFeedbackInput;
}>;


export type SendFeedbackMutation = { __typename?: 'Mutation', sendFeedback: boolean };

export type UiQueryVariables = Exact<{ [key: string]: never; }>;


export type UiQuery = { __typename?: 'Query', ui: { __typename?: 'UserInterfaceInformation', showUniverseUpdate: boolean, showAutomaticUniverseUpdate: boolean } };

export type UserPartsFragment = { __typename?: 'User', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, lastLogin?: any | null, phone?: string | null, email?: string | null, avatar: string, roles?: Array<Roles> | null, locale?: Locale | null, enabled?: boolean | null, adminActsAsUser?: boolean | null, showIntroductionVideo: boolean, insightsUpdates?: number | null, featureUpdates?: number | null, featureUpdatesDisabled: boolean, company?: { __typename?: 'Company', id: string, automaticUniverseUpdate: boolean, color?: string | null, locales?: Array<Locale> | null, features?: Array<Feature> | null, maxUsers?: number | null, product?: CompanyProduct | null, testAccount?: boolean | null, accountType: AccountType, title?: string | null, exportTemplates?: Array<{ __typename?: 'ExportTemplate', id: string, title: string, exportTypes?: Array<ExportType> | null }> | null } | null };

export type DeleteAvatarMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAvatarMutation = { __typename?: 'Mutation', me?: { __typename?: 'MeMutations', deleteAvatar: { __typename?: 'User', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, lastLogin?: any | null, phone?: string | null, email?: string | null, avatar: string, roles?: Array<Roles> | null, locale?: Locale | null, enabled?: boolean | null, adminActsAsUser?: boolean | null, showIntroductionVideo: boolean, insightsUpdates?: number | null, featureUpdates?: number | null, featureUpdatesDisabled: boolean, company?: { __typename?: 'Company', id: string, automaticUniverseUpdate: boolean, color?: string | null, locales?: Array<Locale> | null, features?: Array<Feature> | null, maxUsers?: number | null, product?: CompanyProduct | null, testAccount?: boolean | null, accountType: AccountType, title?: string | null, exportTemplates?: Array<{ __typename?: 'ExportTemplate', id: string, title: string, exportTypes?: Array<ExportType> | null }> | null } | null } } | null };

export type UploadAvatarMutationVariables = Exact<{
  input: UploadAvatarInput;
}>;


export type UploadAvatarMutation = { __typename?: 'Mutation', me?: { __typename?: 'MeMutations', uploadAvatar: { __typename?: 'User', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, lastLogin?: any | null, phone?: string | null, email?: string | null, avatar: string, roles?: Array<Roles> | null, locale?: Locale | null, enabled?: boolean | null, adminActsAsUser?: boolean | null, showIntroductionVideo: boolean, insightsUpdates?: number | null, featureUpdates?: number | null, featureUpdatesDisabled: boolean, company?: { __typename?: 'Company', id: string, automaticUniverseUpdate: boolean, color?: string | null, locales?: Array<Locale> | null, features?: Array<Feature> | null, maxUsers?: number | null, product?: CompanyProduct | null, testAccount?: boolean | null, accountType: AccountType, title?: string | null, exportTemplates?: Array<{ __typename?: 'ExportTemplate', id: string, title: string, exportTypes?: Array<ExportType> | null }> | null } | null } } | null };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type ChangePasswordMutationVariables = Exact<{
  input: ChangePasswordInput;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', me?: { __typename?: 'MeMutations', changePassword: { __typename?: 'User', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, lastLogin?: any | null, phone?: string | null, email?: string | null, avatar: string, roles?: Array<Roles> | null, locale?: Locale | null, enabled?: boolean | null, adminActsAsUser?: boolean | null, showIntroductionVideo: boolean, insightsUpdates?: number | null, featureUpdates?: number | null, featureUpdatesDisabled: boolean, company?: { __typename?: 'Company', id: string, automaticUniverseUpdate: boolean, color?: string | null, locales?: Array<Locale> | null, features?: Array<Feature> | null, maxUsers?: number | null, product?: CompanyProduct | null, testAccount?: boolean | null, accountType: AccountType, title?: string | null, exportTemplates?: Array<{ __typename?: 'ExportTemplate', id: string, title: string, exportTypes?: Array<ExportType> | null }> | null } | null } } | null };

export type UpdateProfileMutationVariables = Exact<{
  input: UpdateProfileInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', me?: { __typename?: 'MeMutations', updateProfile: { __typename?: 'User', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, lastLogin?: any | null, phone?: string | null, email?: string | null, avatar: string, roles?: Array<Roles> | null, locale?: Locale | null, enabled?: boolean | null, adminActsAsUser?: boolean | null, showIntroductionVideo: boolean, insightsUpdates?: number | null, featureUpdates?: number | null, featureUpdatesDisabled: boolean, company?: { __typename?: 'Company', id: string, automaticUniverseUpdate: boolean, color?: string | null, locales?: Array<Locale> | null, features?: Array<Feature> | null, maxUsers?: number | null, product?: CompanyProduct | null, testAccount?: boolean | null, accountType: AccountType, title?: string | null, exportTemplates?: Array<{ __typename?: 'ExportTemplate', id: string, title: string, exportTypes?: Array<ExportType> | null }> | null } | null } } | null };

export type SetInsightsUpdatesSeenMutationVariables = Exact<{ [key: string]: never; }>;


export type SetInsightsUpdatesSeenMutation = { __typename?: 'Mutation', me?: { __typename?: 'MeMutations', setInsightsUpdatesSeen: { __typename?: 'User', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, lastLogin?: any | null, phone?: string | null, email?: string | null, avatar: string, roles?: Array<Roles> | null, locale?: Locale | null, enabled?: boolean | null, adminActsAsUser?: boolean | null, showIntroductionVideo: boolean, insightsUpdates?: number | null, featureUpdates?: number | null, featureUpdatesDisabled: boolean, company?: { __typename?: 'Company', id: string, automaticUniverseUpdate: boolean, color?: string | null, locales?: Array<Locale> | null, features?: Array<Feature> | null, maxUsers?: number | null, product?: CompanyProduct | null, testAccount?: boolean | null, accountType: AccountType, title?: string | null, exportTemplates?: Array<{ __typename?: 'ExportTemplate', id: string, title: string, exportTypes?: Array<ExportType> | null }> | null } | null } } | null };

export type SetLastFeatureUpdateMutationVariables = Exact<{ [key: string]: never; }>;


export type SetLastFeatureUpdateMutation = { __typename?: 'Mutation', me?: { __typename?: 'MeMutations', setLastFeatureUpdate: { __typename?: 'User', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, lastLogin?: any | null, phone?: string | null, email?: string | null, avatar: string, roles?: Array<Roles> | null, locale?: Locale | null, enabled?: boolean | null, adminActsAsUser?: boolean | null, showIntroductionVideo: boolean, insightsUpdates?: number | null, featureUpdates?: number | null, featureUpdatesDisabled: boolean, company?: { __typename?: 'Company', id: string, automaticUniverseUpdate: boolean, color?: string | null, locales?: Array<Locale> | null, features?: Array<Feature> | null, maxUsers?: number | null, product?: CompanyProduct | null, testAccount?: boolean | null, accountType: AccountType, title?: string | null, exportTemplates?: Array<{ __typename?: 'ExportTemplate', id: string, title: string, exportTypes?: Array<ExportType> | null }> | null } | null } } | null };

export type SetSeenIntroductionVideoMutationVariables = Exact<{ [key: string]: never; }>;


export type SetSeenIntroductionVideoMutation = { __typename?: 'Mutation', me?: { __typename?: 'MeMutations', setSeenIntroductionVideo: { __typename?: 'User', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, lastLogin?: any | null, phone?: string | null, email?: string | null, avatar: string, roles?: Array<Roles> | null, locale?: Locale | null, enabled?: boolean | null, adminActsAsUser?: boolean | null, showIntroductionVideo: boolean, insightsUpdates?: number | null, featureUpdates?: number | null, featureUpdatesDisabled: boolean, company?: { __typename?: 'Company', id: string, automaticUniverseUpdate: boolean, color?: string | null, locales?: Array<Locale> | null, features?: Array<Feature> | null, maxUsers?: number | null, product?: CompanyProduct | null, testAccount?: boolean | null, accountType: AccountType, title?: string | null, exportTemplates?: Array<{ __typename?: 'ExportTemplate', id: string, title: string, exportTypes?: Array<ExportType> | null }> | null } | null } } | null };

export type ProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, lastLogin?: any | null, phone?: string | null, email?: string | null, avatar: string, roles?: Array<Roles> | null, locale?: Locale | null, enabled?: boolean | null, adminActsAsUser?: boolean | null, showIntroductionVideo: boolean, insightsUpdates?: number | null, featureUpdates?: number | null, featureUpdatesDisabled: boolean, company?: { __typename?: 'Company', id: string, automaticUniverseUpdate: boolean, color?: string | null, locales?: Array<Locale> | null, features?: Array<Feature> | null, maxUsers?: number | null, product?: CompanyProduct | null, testAccount?: boolean | null, accountType: AccountType, title?: string | null, exportTemplates?: Array<{ __typename?: 'ExportTemplate', id: string, title: string, exportTypes?: Array<ExportType> | null }> | null } | null } | null };

export type UserSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type UserSelectQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, avatar: string, roles?: Array<Roles> | null }> };

export type TrendsPartsFragment = { __typename?: 'Workspace', id: string, trends?: { __typename?: 'PaginatedWorkspaceTrends', pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number }, nodes: Array<{ __typename?: 'WorkspaceTrend', position?: number | null, votes: number, userVote?: WorkspaceVoteType | null, trend?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, author?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, avatar: string } | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMicrotrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null }> } | null };

export type WorkspaceUserPartsFragment = { __typename?: 'User', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, lastLogin?: any | null, phone?: string | null, email?: string | null, enabled?: boolean | null, avatar: string };

export type WorkspacePartsFragment = { __typename?: 'Workspace', id: string, title?: string | null, private: boolean, searchAgents?: { __typename?: 'PaginatedSearchAgents', nodes: Array<{ __typename?: 'SearchAgent', id: string, title: string, trendCounts: { __typename?: 'SearchAgentWorkspaceTrendCounts', new: number, unvoted: number, accepted: number, rejected: number }, trends?: { __typename?: 'PaginatedSearchAgentMicrotrend', nodes?: Array<{ __typename?: 'SearchAgentMicrotrend', new?: boolean | null, microtrend?: { __typename?: 'CompanyMicrotrend', id: string, images?: Array<string | null> | null, identifiedAt?: any | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', title?: string | null, description?: string | null } | null> | null } | { __typename?: 'Microtrend', id: string, images?: Array<string | null> | null, identifiedAt?: any | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', title?: string | null, description?: string | null } | null> | null } | { __typename?: 'ReducedMicrotrend', id: string, images?: Array<string | null> | null, identifiedAt?: any | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', title?: string | null, description?: string | null } | null> | null } | null } | null> | null } | null }> } | null, microtrend?: { __typename?: 'PaginatedWorkspaceTrends', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, macrotrend?: { __typename?: 'PaginatedWorkspaceTrends', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, trends?: { __typename?: 'PaginatedWorkspaceTrends', pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number }, nodes: Array<{ __typename?: 'WorkspaceTrend', trend?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMicrotrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null }> } | null };

export type WorkspaceViewPartsFragment = { __typename?: 'Workspace', id: string, title?: string | null, description?: string | null, image?: string | null, private: boolean, participating: boolean, ownerId?: string | null, xlsxExportUrl: string, userSettings?: { __typename?: 'WorkspaceUserSettings', notificationInterval: NotificationInterval } | null, participants?: { __typename?: 'PaginatedUsers', nodes: Array<{ __typename?: 'User', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, lastLogin?: any | null, phone?: string | null, email?: string | null, enabled?: boolean | null, avatar: string }> } | null, microtrend?: { __typename?: 'PaginatedWorkspaceTrends', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, macrotrend?: { __typename?: 'PaginatedWorkspaceTrends', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, trends?: { __typename?: 'PaginatedWorkspaceTrends', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number }, nodes: Array<{ __typename?: 'WorkspaceTrend', trend?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend', id: string, image?: string | null } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend', id: string, images?: Array<string | null> | null } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend', id: string, image?: string | null } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend', id: string, images?: Array<string | null> | null } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null } | { __typename?: 'ReducedMicrotrend', id: string, images?: Array<string | null> | null } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null }> } | null };

export type AcceptAllMicroTrendsMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
  searchAgentId: Scalars['ID'];
  searchAgentTrendType: SearchAgentTrendType;
  pageSize: Scalars['Int'];
}>;


export type AcceptAllMicroTrendsMutation = { __typename?: 'Mutation', workspace?: { __typename?: 'WorkspaceMutations', acceptSearchAgentTrends: { __typename?: 'Workspace', id: string, title?: string | null, description?: string | null, image?: string | null, private: boolean, participating: boolean, ownerId?: string | null, xlsxExportUrl: string, userSettings?: { __typename?: 'WorkspaceUserSettings', notificationInterval: NotificationInterval } | null, participants?: { __typename?: 'PaginatedUsers', nodes: Array<{ __typename?: 'User', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, lastLogin?: any | null, phone?: string | null, email?: string | null, enabled?: boolean | null, avatar: string }> } | null, microtrend?: { __typename?: 'PaginatedWorkspaceTrends', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, macrotrend?: { __typename?: 'PaginatedWorkspaceTrends', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, trends?: { __typename?: 'PaginatedWorkspaceTrends', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number }, nodes: Array<{ __typename?: 'WorkspaceTrend', trend?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend', id: string, image?: string | null } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend', id: string, images?: Array<string | null> | null } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend', id: string, image?: string | null } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend', id: string, images?: Array<string | null> | null } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null } | { __typename?: 'ReducedMicrotrend', id: string, images?: Array<string | null> | null } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null }> } | null } } | null };

export type AcceptMicrotrendMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
  workspaceIds: Array<Scalars['ID']> | Scalars['ID'];
  nodeIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type AcceptMicrotrendMutation = { __typename?: 'Mutation', addNodesToWorkspaces: Array<{ __typename?: 'Workspace', id: string, title?: string | null, searchAgents?: { __typename?: 'PaginatedSearchAgents', nodes: Array<{ __typename?: 'SearchAgent', id: string, trendCounts: { __typename?: 'SearchAgentWorkspaceTrendCounts', new: number, unvoted: number, accepted: number, rejected: number } }> } | null }> };

export type AddNodesToWorkspacesMutationVariables = Exact<{
  nodeIds: Array<Scalars['ID']> | Scalars['ID'];
  workspaceIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type AddNodesToWorkspacesMutation = { __typename?: 'Mutation', addNodesToWorkspaces: Array<{ __typename?: 'Workspace', id: string, title?: string | null }> };

export type CopyWorkspaceMutationVariables = Exact<{
  id: Scalars['ID'];
  title: Scalars['String'];
}>;


export type CopyWorkspaceMutation = { __typename?: 'Mutation', workspace?: { __typename?: 'WorkspaceMutations', copy: { __typename?: 'Workspace', id: string, title?: string | null, description?: string | null, participants?: { __typename?: 'PaginatedUsers', nodes: Array<{ __typename?: 'User', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, lastLogin?: any | null, phone?: string | null, email?: string | null, enabled?: boolean | null, avatar: string }> } | null } } | null };

export type CreateTrendradarMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CreateTrendradarMutation = { __typename?: 'Mutation', workspace?: { __typename?: 'WorkspaceMutations', createTrendRadar: string } | null };

export type CreateWorkspaceMutationVariables = Exact<{
  input: WorkspaceInput;
}>;


export type CreateWorkspaceMutation = { __typename?: 'Mutation', createWorkspace?: { __typename?: 'Workspace', id: string, title?: string | null, description?: string | null, participants?: { __typename?: 'PaginatedUsers', nodes: Array<{ __typename?: 'User', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, lastLogin?: any | null, phone?: string | null, email?: string | null, enabled?: boolean | null, avatar: string }> } | null } | null };

export type DeleteWorkspaceMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteWorkspaceMutation = { __typename?: 'Mutation', workspace?: { __typename?: 'WorkspaceMutations', delete: boolean } | null };

export type JoinWorkspaceMutationVariables = Exact<{
  id: Scalars['ID'];
  pageSize?: InputMaybe<Scalars['Int']>;
}>;


export type JoinWorkspaceMutation = { __typename?: 'Mutation', workspace?: { __typename?: 'WorkspaceMutations', join: { __typename?: 'Workspace', id: string, participating: boolean, participants?: { __typename?: 'PaginatedUsers', nodes: Array<{ __typename?: 'User', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, lastLogin?: any | null, phone?: string | null, email?: string | null, enabled?: boolean | null, avatar: string }>, pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null } } | null };

export type LeaveWorkspaceMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LeaveWorkspaceMutation = { __typename?: 'Mutation', workspace?: { __typename?: 'WorkspaceMutations', leave: boolean } | null };

export type RejectAllMicroTrendsMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
  searchAgentId: Scalars['ID'];
  searchAgentTrendType: SearchAgentTrendType;
  pageSize: Scalars['Int'];
}>;


export type RejectAllMicroTrendsMutation = { __typename?: 'Mutation', workspace?: { __typename?: 'WorkspaceMutations', rejectSearchAgentTrends: { __typename?: 'Workspace', id: string, title?: string | null, description?: string | null, image?: string | null, private: boolean, participating: boolean, ownerId?: string | null, xlsxExportUrl: string, userSettings?: { __typename?: 'WorkspaceUserSettings', notificationInterval: NotificationInterval } | null, participants?: { __typename?: 'PaginatedUsers', nodes: Array<{ __typename?: 'User', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, lastLogin?: any | null, phone?: string | null, email?: string | null, enabled?: boolean | null, avatar: string }> } | null, microtrend?: { __typename?: 'PaginatedWorkspaceTrends', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, macrotrend?: { __typename?: 'PaginatedWorkspaceTrends', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, trends?: { __typename?: 'PaginatedWorkspaceTrends', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number }, nodes: Array<{ __typename?: 'WorkspaceTrend', trend?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend', id: string, image?: string | null } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend', id: string, images?: Array<string | null> | null } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend', id: string, image?: string | null } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend', id: string, images?: Array<string | null> | null } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null } | { __typename?: 'ReducedMicrotrend', id: string, images?: Array<string | null> | null } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null }> } | null } } | null };

export type RejectMicrotrendMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
  microtrendId: Scalars['ID'];
}>;


export type RejectMicrotrendMutation = { __typename?: 'Mutation', workspace?: { __typename?: 'WorkspaceMutations', rejectMicrotrend: { __typename?: 'Workspace', id: string, title?: string | null, searchAgents?: { __typename?: 'PaginatedSearchAgents', nodes: Array<{ __typename?: 'SearchAgent', id: string, trendCounts: { __typename?: 'SearchAgentWorkspaceTrendCounts', new: number, unvoted: number, accepted: number, rejected: number } }> } | null } } | null };

export type RemoveMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
  nodeIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RemoveMutation = { __typename?: 'Mutation', workspace?: { __typename?: 'WorkspaceMutations', removeNodes: { __typename?: 'Workspace', id: string } } | null };

export type UpdateWorkspaceTrendPositionMutationVariables = Exact<{
  id: Scalars['ID'];
  input: WorkspaceTrendPositionInput;
}>;


export type UpdateWorkspaceTrendPositionMutation = { __typename?: 'Mutation', workspace?: { __typename?: 'WorkspaceMutations', setWorkspaceTrendPosition: { __typename?: 'Workspace', id: string } } | null };

export type WorkspaceUnvoteMutationVariables = Exact<{
  id: Scalars['ID'];
  trendId: Scalars['ID'];
}>;


export type WorkspaceUnvoteMutation = { __typename?: 'Mutation', workspace?: { __typename?: 'WorkspaceMutations', unvote: { __typename?: 'WorkspaceTrend', votes: number, userVote?: WorkspaceVoteType | null } } | null };

export type UpdateWorkspaceMutationVariables = Exact<{
  id: Scalars['ID'];
  input: WorkspaceInput;
  pageSize?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateWorkspaceMutation = { __typename?: 'Mutation', workspace?: { __typename?: 'WorkspaceMutations', update: { __typename?: 'Workspace', id: string, title?: string | null, description?: string | null, image?: string | null, private: boolean, participating: boolean, ownerId?: string | null, xlsxExportUrl: string, userSettings?: { __typename?: 'WorkspaceUserSettings', notificationInterval: NotificationInterval } | null, participants?: { __typename?: 'PaginatedUsers', nodes: Array<{ __typename?: 'User', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, lastLogin?: any | null, phone?: string | null, email?: string | null, enabled?: boolean | null, avatar: string }> } | null, microtrend?: { __typename?: 'PaginatedWorkspaceTrends', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, macrotrend?: { __typename?: 'PaginatedWorkspaceTrends', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, trends?: { __typename?: 'PaginatedWorkspaceTrends', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number }, nodes: Array<{ __typename?: 'WorkspaceTrend', trend?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend', id: string, image?: string | null } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend', id: string, images?: Array<string | null> | null } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend', id: string, image?: string | null } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend', id: string, images?: Array<string | null> | null } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null } | { __typename?: 'ReducedMicrotrend', id: string, images?: Array<string | null> | null } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null }> } | null } } | null };

export type UpdateUserSettingsMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateUserSettingsInput;
}>;


export type UpdateUserSettingsMutation = { __typename?: 'Mutation', workspace?: { __typename?: 'WorkspaceMutations', updateUserSettings: { __typename?: 'WorkspaceUserSettings', notificationInterval: NotificationInterval } } | null };

export type WorkspaceVoteMutationVariables = Exact<{
  id: Scalars['ID'];
  input: WorkspaceVoteInput;
}>;


export type WorkspaceVoteMutation = { __typename?: 'Mutation', workspace?: { __typename?: 'WorkspaceMutations', vote: { __typename?: 'WorkspaceTrend', votes: number, userVote?: WorkspaceVoteType | null } } | null };

export type DetailsShortQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DetailsShortQuery = { __typename?: 'Query', workspace?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace', id: string, title?: string | null, description?: string | null, participating: boolean, private: boolean, searchAgentsTrendCounts?: { __typename?: 'SearchAgentTrendCounts', new: number, unvoted: number } | null, trends?: { __typename?: 'PaginatedWorkspaceTrends', nodes: Array<{ __typename?: 'WorkspaceTrend', trend?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend', id: string, image?: string | null } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend', id: string, images?: Array<string | null> | null } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend', id: string, image?: string | null } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend', id: string, images?: Array<string | null> | null } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null } | { __typename?: 'ReducedMicrotrend', id: string, images?: Array<string | null> | null } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null }>, pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, searchAgents?: { __typename?: 'PaginatedSearchAgents', nodes: Array<{ __typename?: 'SearchAgent', id: string, title: string, trendCounts: { __typename?: 'SearchAgentWorkspaceTrendCounts', new: number, unvoted: number, accepted: number, rejected: number } }> } | null } | null };

export type WorkspaceEditQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type WorkspaceEditQuery = { __typename?: 'Query', node?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace', id: string, title?: string | null, description?: string | null, private: boolean, participants?: { __typename?: 'PaginatedUsers', nodes: Array<{ __typename?: 'User', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, lastLogin?: any | null, phone?: string | null, email?: string | null, enabled?: boolean | null, avatar: string }> } | null } | null };

export type ExportUrlQueryVariables = Exact<{
  id: Scalars['ID'];
  sort?: InputMaybe<WorkspaceExportSort>;
  filter?: InputMaybe<WorkspaceTrendFilter>;
}>;


export type ExportUrlQuery = { __typename?: 'Query', workspaceXlsxExportUrl?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace', id: string, xlsxExportUrl: string } | null };

export type WorkspacesGalleryQueryVariables = Exact<{
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  type?: InputMaybe<WorkspaceTrendType>;
}>;


export type WorkspacesGalleryQuery = { __typename?: 'Query', workspaces?: { __typename?: 'PaginatedWorkspaces', nodes: Array<{ __typename?: 'Workspace', id: string, title?: string | null, description?: string | null, updatedAt?: any | null, private: boolean, participating: boolean, ownerId?: string | null, deprecatedMacrotrends: Array<{ __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null }>, participants?: { __typename?: 'PaginatedUsers', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number }, nodes: Array<{ __typename?: 'User', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, lastLogin?: any | null, phone?: string | null, email?: string | null, enabled?: boolean | null, avatar: string }> } | null, trends?: { __typename?: 'PaginatedWorkspaceTrends', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number }, nodes: Array<{ __typename?: 'WorkspaceTrend', trend?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend', id: string, image?: string | null } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend', id: string, images?: Array<string | null> | null } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend', id: string, image?: string | null } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend', id: string, images?: Array<string | null> | null } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null } | { __typename?: 'ReducedMicrotrend', id: string, images?: Array<string | null> | null } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null }> } | null, searchAgentsTrendCounts?: { __typename?: 'SearchAgentTrendCounts', new: number, unvoted: number } | null }>, pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null };

export type WorkspacesListQueryVariables = Exact<{
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  type?: InputMaybe<WorkspaceTrendType>;
  sort?: InputMaybe<WorkspaceSort>;
}>;


export type WorkspacesListQuery = { __typename?: 'Query', workspaces?: { __typename?: 'PaginatedWorkspaces', nodes: Array<{ __typename?: 'Workspace', id: string, title?: string | null, description?: string | null, updatedAt?: any | null, private: boolean, participating: boolean, deprecatedMacrotrends: Array<{ __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', title?: string | null } | null> | null }>, participants?: { __typename?: 'PaginatedUsers', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number }, nodes: Array<{ __typename?: 'User', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, lastLogin?: any | null, phone?: string | null, email?: string | null, enabled?: boolean | null, avatar: string }> } | null, trends?: { __typename?: 'PaginatedWorkspaceTrends', nodes: Array<{ __typename?: 'WorkspaceTrend', trend?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend', id: string, image?: string | null } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend', id: string, images?: Array<string | null> | null } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend', id: string, image?: string | null } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend', id: string, images?: Array<string | null> | null } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null } | { __typename?: 'ReducedMicrotrend', id: string, images?: Array<string | null> | null } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null }>, pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, searchAgentsTrendCounts?: { __typename?: 'SearchAgentTrendCounts', new: number, unvoted: number } | null }>, pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null };

export type WorkspacesOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkspacesOverviewQuery = { __typename?: 'Query', workspaces?: { __typename?: 'PaginatedWorkspaces', nodes: Array<{ __typename?: 'Workspace', id: string, title?: string | null, private: boolean, participating: boolean, searchAgentsTrendCounts?: { __typename?: 'SearchAgentTrendCounts', new: number, unvoted: number } | null, participants?: { __typename?: 'PaginatedUsers', nodes: Array<{ __typename?: 'User', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, lastLogin?: any | null, phone?: string | null, email?: string | null, enabled?: boolean | null, avatar: string }>, pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null }> } | null };

export type SearchAgentsQueryVariables = Exact<{
  id: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
}>;


export type SearchAgentsQuery = { __typename?: 'Query', node?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace', id: string, title?: string | null, description?: string | null, searchAgents?: { __typename?: 'PaginatedSearchAgents', nodes: Array<{ __typename?: 'SearchAgent', id: string, title: string, hasDeprecatedMacrotrends: boolean, trendCounts: { __typename?: 'SearchAgentWorkspaceTrendCounts', new: number, unvoted: number, accepted: number, rejected: number } }>, pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null } | null };

export type WorkspaceTrendsQueryVariables = Exact<{
  id: Scalars['ID'];
  locale: Locale;
  type?: InputMaybe<WorkspaceTrendType>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<WorkspaceTrendSort>;
  filter?: InputMaybe<WorkspaceTrendFilter>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
}>;


export type WorkspaceTrendsQuery = { __typename?: 'Query', node?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace', id: string, microtrend?: { __typename?: 'PaginatedWorkspaceTrends', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, macrotrend?: { __typename?: 'PaginatedWorkspaceTrends', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, trends?: { __typename?: 'PaginatedWorkspaceTrends', pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number }, nodes: Array<{ __typename?: 'WorkspaceTrend', position?: number | null, votes: number, userVote?: WorkspaceVoteType | null, trend?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, author?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, avatar: string } | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend', deprecated: boolean, id: string, image?: string | null, color?: string | null, successor?: { __typename?: 'CompanyMacrotrend', id: string, translations?: Array<{ __typename?: 'CompanyMacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Macrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'ReducedMacrotrend', id: string, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null, color?: string | null, translations?: Array<{ __typename?: 'MacrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, megatrend?: { __typename?: 'CompanyMegatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'CompanyMegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | { __typename?: 'Megatrend', id: string, color?: string | null, translations?: Array<{ __typename?: 'MegatrendTranslation', locale?: Locale | null, title?: string | null } | null> | null } | null } | { __typename?: 'ReducedMicrotrend', id: string, identifiedAt?: any | null, images?: Array<string | null> | null, translations?: Array<{ __typename?: 'MicrotrendTranslation', locale?: Locale | null, title?: string | null, description?: string | null } | null> | null, useCases: Array<{ __typename?: 'MicrotrendUseCase', id: string }>, sdgs: Array<{ __typename?: 'SDG', id: string, translations: Array<{ __typename?: 'SDGTranslation', locale: Locale, title: string, description: string }> }> } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null }> } | null } | null };

export type WorkspaceViewQueryVariables = Exact<{
  id: Scalars['ID'];
  pageSize?: InputMaybe<Scalars['Int']>;
}>;


export type WorkspaceViewQuery = { __typename?: 'Query', workspace?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend' } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend' } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend' } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend' } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend' } | { __typename?: 'ReducedMicrotrend' } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace', id: string, title?: string | null, description?: string | null, image?: string | null, private: boolean, participating: boolean, ownerId?: string | null, xlsxExportUrl: string, userSettings?: { __typename?: 'WorkspaceUserSettings', notificationInterval: NotificationInterval } | null, participants?: { __typename?: 'PaginatedUsers', nodes: Array<{ __typename?: 'User', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, jobPosition?: string | null, lastLogin?: any | null, phone?: string | null, email?: string | null, enabled?: boolean | null, avatar: string }> } | null, microtrend?: { __typename?: 'PaginatedWorkspaceTrends', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, macrotrend?: { __typename?: 'PaginatedWorkspaceTrends', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number } } | null, trends?: { __typename?: 'PaginatedWorkspaceTrends', pageInfo: { __typename?: 'PaginatedPageInfo', totalCount: number }, nodes: Array<{ __typename?: 'WorkspaceTrend', trend?: { __typename?: 'Comment' } | { __typename?: 'Company' } | { __typename?: 'CompanyMacrotrend', id: string, image?: string | null } | { __typename?: 'CompanyMegatrend' } | { __typename?: 'CompanyMicrotrend', id: string, images?: Array<string | null> | null } | { __typename?: 'Country' } | { __typename?: 'CriteriaSet' } | { __typename?: 'Export' } | { __typename?: 'Industry' } | { __typename?: 'Initiator' } | { __typename?: 'InnovationField' } | { __typename?: 'InnovationProject' } | { __typename?: 'InnovationType' } | { __typename?: 'Insider' } | { __typename?: 'Macrotrend', id: string, image?: string | null } | { __typename?: 'Megatrend' } | { __typename?: 'Microtrend', id: string, images?: Array<string | null> | null } | { __typename?: 'Post' } | { __typename?: 'PublishedTrendRadar' } | { __typename?: 'ReducedMacrotrend', id: string, image?: string | null } | { __typename?: 'ReducedMicrotrend', id: string, images?: Array<string | null> | null } | { __typename?: 'Region' } | { __typename?: 'SearchAgent' } | { __typename?: 'TrendRadarDraft' } | { __typename?: 'TrendRadarParticipation' } | { __typename?: 'TrendSummary' } | { __typename?: 'Trendcall' } | { __typename?: 'TrendingTopic' } | { __typename?: 'User' } | { __typename?: 'Workspace' } | null }> } | null } | null };

export type WorkspacesQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkspacesQuery = { __typename?: 'Query', workspaces?: { __typename?: 'PaginatedWorkspaces', nodes: Array<{ __typename?: 'Workspace', id: string, title?: string | null, description?: string | null }>, pageInfo: { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number } } | null };

export type PaginatedPageInfoPartsFragment = { __typename?: 'PaginatedPageInfo', currentPage: number, totalPages: number, pageSize: number, totalCount: number };

export const CommentPartsFragmentDoc = gql`
    fragment CommentParts on Comment {
  id
  body
  createdAt
  updatedAt
  owner {
    id
    firstName
    lastName
    email
    avatar
    enabled
  }
}
    `;
export const InnovationFieldPartsFragmentDoc = gql`
    fragment InnovationFieldParts on InnovationField {
  id
  title
  description
  technologicalOpportunities
  marketOpportunities
  capabilities
  image
  updatedAt
  publishingState
}
    `;
export const UserPartsFragmentDoc = gql`
    fragment UserParts on User {
  id
  title
  firstName
  lastName
  jobPosition
  lastLogin
  phone
  email
  avatar
  roles
  locale
  enabled
  company {
    id
    automaticUniverseUpdate
    color
    exportTemplates {
      id
      title
      exportTypes
    }
    locales
    features
    maxUsers
    product
    testAccount
    accountType
    title
  }
  adminActsAsUser
  showIntroductionVideo
  insightsUpdates
  featureUpdates
  featureUpdatesDisabled
}
    `;
export const MegatrendTranslationPartsFragmentDoc = gql`
    fragment MegatrendTranslationParts on MegatrendTranslationInterface {
  locale
  title
  description
}
    `;
export const MegatrendPartsFragmentDoc = gql`
    fragment MegatrendParts on MegatrendInterface {
  id
  color
  active
  image(width: $width, height: $height)
  ... on Megatrend {
    successor {
      id
    }
  }
  translations(locale: $locale) {
    ...MegatrendTranslationParts
  }
  publicUrl(locale: $locale)
}
    ${MegatrendTranslationPartsFragmentDoc}`;
export const MacrotrendTranslationPartsFragmentDoc = gql`
    fragment MacrotrendTranslationParts on MacrotrendTranslationInterface {
  locale
  title
  description
}
    `;
export const MacrotrendInterfacePartsFragmentDoc = gql`
    fragment MacrotrendInterfaceParts on MacrotrendInterface {
  id
  image(width: $width, height: $height)
  color
  ... on Macrotrend {
    deprecated
    successor {
      id
      translations(locale: $locale) {
        locale
        title
      }
    }
  }
  translations(locale: $locale) {
    ...MacrotrendTranslationParts
  }
  megatrend {
    id
    color
    translations(locale: $locale) {
      locale
      title
    }
  }
}
    ${MacrotrendTranslationPartsFragmentDoc}`;
export const ReducedMacrotrendPartsFragmentDoc = gql`
    fragment ReducedMacrotrendParts on ReducedMacrotrend {
  ...MacrotrendInterfaceParts
}
    ${MacrotrendInterfacePartsFragmentDoc}`;
export const CompanyMacrotrendPartsFragmentDoc = gql`
    fragment CompanyMacrotrendParts on CompanyMacrotrend {
  ...MacrotrendInterfaceParts
  active
  publicUrl(locale: $locale)
}
    ${MacrotrendInterfacePartsFragmentDoc}`;
export const TrendoneMacrotrendPartsFragmentDoc = gql`
    fragment TrendoneMacrotrendParts on Macrotrend {
  ...MacrotrendInterfaceParts
  active
  publicUrl(locale: $locale)
}
    ${MacrotrendInterfacePartsFragmentDoc}`;
export const InnovationFieldViewPartsFragmentDoc = gql`
    fragment InnovationFieldViewParts on InnovationField {
  ...InnovationFieldParts
  contactPerson {
    ...UserParts
  }
  megatrends {
    ...MegatrendParts
  }
  macrotrends {
    ...ReducedMacrotrendParts
    ...CompanyMacrotrendParts
    ...TrendoneMacrotrendParts
  }
  trendRadars(page: 1, pageSize: 40) {
    nodes {
      id
      title
      image
    }
  }
  innovationProjects(page: 1, pageSize: 40, publishingState: published) {
    nodes {
      id
      title
      image
      state
      publishingState
    }
  }
}
    ${InnovationFieldPartsFragmentDoc}
${UserPartsFragmentDoc}
${MegatrendPartsFragmentDoc}
${ReducedMacrotrendPartsFragmentDoc}
${CompanyMacrotrendPartsFragmentDoc}
${TrendoneMacrotrendPartsFragmentDoc}`;
export const InnovationProjectPartsFragmentDoc = gql`
    fragment InnovationProjectParts on InnovationProject {
  id
  title
  image
  description
  objective
  environment
  state
  publishingState
  updatedAt
}
    `;
export const MicrotrendTranslationPartsFragmentDoc = gql`
    fragment MicrotrendTranslationParts on MicrotrendTranslation {
  locale
  title
  description
}
    `;
export const MicrotrendInterfacePartsFragmentDoc = gql`
    fragment MicrotrendInterfaceParts on MicrotrendInterface {
  id
  identifiedAt
  images(width: $width, height: $height)
  translations(locale: $locale) {
    ...MicrotrendTranslationParts
  }
  useCases(locale: $locale) {
    id
  }
  sdgs {
    id
    translations(locale: $locale) {
      locale
      title
      description
    }
  }
}
    ${MicrotrendTranslationPartsFragmentDoc}`;
export const CompanyMicrotrendPartsFragmentDoc = gql`
    fragment CompanyMicrotrendParts on CompanyMicrotrend {
  ...MicrotrendInterfaceParts
  url
  videos
  initiators {
    id
    title
  }
  comment
  author {
    id
    firstName
    lastName
    avatar
    jobPosition
    email
  }
}
    ${MicrotrendInterfacePartsFragmentDoc}`;
export const ReducedMicrotrendPartsFragmentDoc = gql`
    fragment ReducedMicrotrendParts on ReducedMicrotrend {
  id
  identifiedAt
  images(width: $width, height: $height)
  translations(locale: $locale) {
    ...MicrotrendTranslationParts
  }
}
    ${MicrotrendTranslationPartsFragmentDoc}`;
export const TrendoneMicrotrendPartsFragmentDoc = gql`
    fragment TrendoneMicrotrendParts on Microtrend {
  ...MicrotrendInterfaceParts
  url
  publicUrl
  videos
  initiators {
    id
    title
  }
}
    ${MicrotrendInterfacePartsFragmentDoc}`;
export const DiscussionUserPartsFragmentDoc = gql`
    fragment DiscussionUserParts on User {
  id
  firstName
  lastName
  email
  enabled
  avatar
}
    `;
export const PostCountPartsFragmentDoc = gql`
    fragment PostCountParts on PaginatedPosts {
  pageInfo {
    totalCount
  }
}
    `;
export const PostPartsFragmentDoc = gql`
    fragment PostParts on Post {
  id
  category
  title
  body
  createdAt
  updatedAt
  url
}
    `;
export const PublicEvaluationOptionPartsFragmentDoc = gql`
    fragment PublicEvaluationOptionParts on PublicEvaluationOption {
  id
  enabled
  feedbackEnabled
  image
  participationCounter {
    completed
    incomplete
    total
  }
  translations {
    locale
    title
    description
    feedbackIntro
  }
}
    `;
export const SearchAgentPartsFragmentDoc = gql`
    fragment SearchAgentParts on SearchAgent {
  id
  title
  search {
    query
    filter {
      macrotrends
      megatrends
      industries
      regions
      countries
      innovationType
      sdgs
    }
  }
  facets {
    macrotrends {
      node {
        id
        image
        ... on Macrotrend {
          deprecated
          successor {
            translations(locale: $locale) {
              title
            }
          }
        }
        translations(locale: $locale) {
          title
          description
        }
        megatrend {
          id
          color
          image
          translations(locale: $locale) {
            title
            description
          }
        }
      }
    }
    megatrends {
      node {
        id
        color
        image
        translations(locale: $locale) {
          title
          description
        }
      }
    }
    industries {
      node {
        id
        translations(locale: $locale) {
          title
        }
      }
    }
    regions {
      node {
        id
        code
        translations(locale: $locale) {
          title
        }
      }
    }
    countries {
      node {
        id
        code
        translations(locale: $locale) {
          title
        }
        region {
          id
          code
          translations(locale: $locale) {
            title
          }
        }
      }
    }
    innovationType {
      node {
        id
        translations(locale: $locale) {
          title
        }
      }
    }
    sdgs {
      node {
        id
        translations(locale: $locale) {
          title
        }
      }
    }
  }
  trendCounts(workspaceId: $workspaceId) {
    new
    unvoted
    accepted
    rejected
  }
}
    `;
export const CountryTranslationPartsFragmentDoc = gql`
    fragment CountryTranslationParts on CountryTranslation {
  locale
  title
}
    `;
export const CountryPartsFragmentDoc = gql`
    fragment CountryParts on Country {
  id
  code
  translations(locale: $locale) {
    ...CountryTranslationParts
  }
}
    ${CountryTranslationPartsFragmentDoc}`;
export const IndustryPartsFragmentDoc = gql`
    fragment IndustryParts on Industry {
  id
  translations(locale: $locale) {
    title
  }
}
    `;
export const InnovationTypeTranslationPartsFragmentDoc = gql`
    fragment InnovationTypeTranslationParts on InnovationTypeTranslation {
  locale
  title
}
    `;
export const InnovationTypePartsFragmentDoc = gql`
    fragment InnovationTypeParts on InnovationType {
  id
  translations(locale: $locale) {
    ...InnovationTypeTranslationParts
  }
}
    ${InnovationTypeTranslationPartsFragmentDoc}`;
export const RegionTranslationPartsFragmentDoc = gql`
    fragment RegionTranslationParts on RegionTranslation {
  locale
  title
}
    `;
export const RegionPartsFragmentDoc = gql`
    fragment RegionParts on Region {
  id
  code
  translations(locale: $locale) {
    ...RegionTranslationParts
  }
}
    ${RegionTranslationPartsFragmentDoc}`;
export const TrendradarPartsFragmentDoc = gql`
    fragment TrendradarParts on TrendRadar {
  id
  title
}
    `;
export const TrendRadarDraftUserPartsFragmentDoc = gql`
    fragment TrendRadarDraftUserParts on User {
  id
  firstName
  lastName
  email
  avatar
}
    `;
export const InternalEvaluationOptionPartsFragmentDoc = gql`
    fragment InternalEvaluationOptionParts on InternalEvaluationOption {
  id
  enabled
  myParticipationId
  participationCounter {
    completed
    incomplete
    total
  }
  participants {
    user {
      id
      email
      firstName
      lastName
      avatar
    }
    state
  }
}
    `;
export const TrendRadarPanelPartsFragmentDoc = gql`
    fragment TrendRadarPanelParts on TrendRadarPanel {
  id
  title
  enabled
  macrotrends {
    id
    color
    ... on Macrotrend {
      deprecated
    }
    translations {
      locale
      title
    }
  }
  internalEvaluationOption {
    ...InternalEvaluationOptionParts
  }
  publicEvaluationOption {
    id
    enabled
    feedbackEnabled
    image
    participationCounter {
      completed
      incomplete
      total
    }
    translations {
      locale
      title
      description
      feedbackIntro
    }
    feedbackTranslations {
      locale
      text
    }
  }
}
    ${InternalEvaluationOptionPartsFragmentDoc}`;
export const TrendRadarDraftCriteriaPartsFragmentDoc = gql`
    fragment TrendRadarDraftCriteriaParts on Criteria {
  id
  type
  min
  max
  marks
  nullable
  adsorb
  scale
  translations(locale: $locale) {
    locale
    title
    description
    labels
  }
}
    `;
export const TrendRadarDraftEvaluationPartsFragmentDoc = gql`
    fragment TrendRadarDraftEvaluationParts on Evaluation {
  id
  values {
    criteria {
      ...TrendRadarDraftCriteriaParts
    }
    value
  }
  recommendedAction
  readinessAssessment
}
    ${TrendRadarDraftCriteriaPartsFragmentDoc}`;
export const DeprecatedMacrotrendsPartsFragmentDoc = gql`
    fragment DeprecatedMacrotrendsParts on TrendRadar {
  deprecatedMacrotrends {
    panel {
      id
      title
    }
    macrotrends {
      id
      translations(locale: $locale) {
        title
      }
    }
  }
}
    `;
export const TrendRadarDraftPartsFragmentDoc = gql`
    fragment TrendRadarDraftParts on TrendRadarDraft {
  id
  title
  description
  published
  publishable
  hasUnpublishedChanges
  managers {
    ...TrendRadarDraftUserParts
  }
  sharingOptions {
    image
    embedding {
      id
      enabled
    }
    publicView {
      id
      enabled
    }
  }
  panels {
    ...TrendRadarPanelParts
  }
  evaluationEnabled
  evaluations {
    id
    evaluationCount
    perception
    macrotrend {
      id
      color
      translations(locale: $locale) {
        locale
        title
      }
      megatrend {
        id
        color
        translations(locale: $locale) {
          locale
          title
        }
      }
    }
    overrideEvaluation {
      ...TrendRadarDraftEvaluationParts
    }
    averageEvaluation {
      ...TrendRadarDraftEvaluationParts
    }
    panelEvaluations {
      panel {
        id
        title
      }
      averageEvaluation {
        ...TrendRadarDraftEvaluationParts
      }
    }
  }
  criteriaSetChangeable
  criteriaSet {
    id
    translations(locale: $locale) {
      locale
      title
      recommendedAction {
        actTitle
        prepareTitle
        watchTitle
        outOfScopeTitle
      }
    }
    criterias {
      ...TrendRadarDraftCriteriaParts
    }
  }
  ...DeprecatedMacrotrendsParts
  innovationFields(pageSize: 50) {
    nodes {
      id
      title
      macrotrends {
        id
      }
    }
    pageInfo {
      totalCount
    }
  }
  innovationProjects {
    nodes {
      id
      title
      macrotrends {
        id
      }
    }
    pageInfo {
      totalCount
    }
  }
  constraints {
    internalParticipantsMinimum
  }
}
    ${TrendRadarDraftUserPartsFragmentDoc}
${TrendRadarPanelPartsFragmentDoc}
${TrendRadarDraftEvaluationPartsFragmentDoc}
${TrendRadarDraftCriteriaPartsFragmentDoc}
${DeprecatedMacrotrendsPartsFragmentDoc}`;
export const CriteriaPartsFragmentDoc = gql`
    fragment CriteriaParts on Criteria {
  id
  type
  min
  max
  marks
  nullable
  adsorb
  scale
  translations(locale: $locale) {
    locale
    title
    description
    labels
  }
}
    `;
export const TrendradarEvaluationPartsFragmentDoc = gql`
    fragment TrendradarEvaluationParts on Evaluation {
  id
  values {
    criteria {
      ...CriteriaParts
    }
    value
  }
  recommendedAction
  readinessAssessment
}
    ${CriteriaPartsFragmentDoc}`;
export const TrendradarMacrotrendPartsFragmentDoc = gql`
    fragment TrendradarMacrotrendParts on MacrotrendInterface {
  ...MacrotrendInterfaceParts
  megatrend {
    id
    color
    translations(locale: $locale) {
      locale
      title
    }
  }
}
    ${MacrotrendInterfacePartsFragmentDoc}`;
export const TrendradarUserPartsFragmentDoc = gql`
    fragment TrendradarUserParts on User {
  id
  firstName
  lastName
  email
  jobPosition
  avatar
}
    `;
export const PaginatedPageInfoPartsFragmentDoc = gql`
    fragment PaginatedPageInfoParts on PaginatedPageInfo {
  currentPage
  totalPages
  pageSize
  totalCount
}
    `;
export const TrendsPartsFragmentDoc = gql`
    fragment TrendsParts on Workspace {
  id
  trends(
    type: $type
    page: $page
    pageSize: $pageSize
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      ...PaginatedPageInfoParts
    }
    nodes {
      position
      votes
      userVote
      trend {
        ...MicrotrendInterfaceParts
        ... on CompanyMicrotrend {
          author {
            id
            firstName
            lastName
            email
            avatar
          }
        }
        ...MacrotrendInterfaceParts
      }
    }
  }
}
    ${PaginatedPageInfoPartsFragmentDoc}
${MicrotrendInterfacePartsFragmentDoc}
${MacrotrendInterfacePartsFragmentDoc}`;
export const WorkspacePartsFragmentDoc = gql`
    fragment WorkspaceParts on Workspace {
  id
  title
  private
  searchAgents {
    nodes {
      id
      title
      trendCounts(workspaceId: $workspaceId) {
        new
        unvoted
        accepted
        rejected
      }
      trends(
        workspaceId: $workspaceId
        type: $searchAgentTrendType
        page: $page
        pageSize: $pageSize
      ) {
        nodes {
          microtrend {
            id
            images
            identifiedAt
            translations(locale: $locale) {
              title
              description
            }
          }
          new
        }
      }
    }
  }
  microtrend: trends(type: microtrend) {
    pageInfo {
      totalCount
    }
  }
  macrotrend: trends(type: macrotrend) {
    pageInfo {
      totalCount
    }
  }
  trends(
    type: $workspaceTrendType
    page: $page
    pageSize: $pageSize
    sort: {field: createdAt, direction: asc}
  ) {
    pageInfo {
      currentPage
      totalPages
      pageSize
      totalCount
    }
    nodes {
      trend {
        ...MacrotrendInterfaceParts
        ...MicrotrendInterfaceParts
      }
    }
  }
}
    ${MacrotrendInterfacePartsFragmentDoc}
${MicrotrendInterfacePartsFragmentDoc}`;
export const WorkspaceUserPartsFragmentDoc = gql`
    fragment WorkspaceUserParts on User {
  id
  title
  firstName
  lastName
  jobPosition
  lastLogin
  phone
  email
  enabled
  avatar
}
    `;
export const WorkspaceViewPartsFragmentDoc = gql`
    fragment WorkspaceViewParts on Workspace {
  id
  title
  description
  image
  private
  participating
  userSettings {
    notificationInterval
  }
  participants(page: null, pageSize: $pageSize) {
    nodes {
      ...WorkspaceUserParts
    }
  }
  microtrend: trends(type: microtrend) {
    pageInfo {
      totalCount
    }
  }
  macrotrend: trends(type: macrotrend) {
    pageInfo {
      totalCount
    }
  }
  trends(
    type: null
    page: 1
    pageSize: 4
    sort: {field: createdAt, direction: desc}
  ) {
    pageInfo {
      totalCount
    }
    nodes {
      trend {
        ... on MicrotrendInterface {
          id
          images(width: 620, height: 280, gravity: sm)
        }
        ... on MacrotrendInterface {
          id
          image(width: 620, height: 280, gravity: sm)
        }
      }
    }
  }
  ownerId
  xlsxExportUrl
}
    ${WorkspaceUserPartsFragmentDoc}`;
export const ChallengesAndOpportunitiesDocument = gql`
    query challengesAndOpportunities($input: AiChallengesAndOpportunitiesInput!) {
  ai {
    challengesAndOpportunities(input: $input) {
      challenges
      opportunities
    }
  }
}
    `;

/**
 * __useChallengesAndOpportunitiesQuery__
 *
 * To use a Smart Query within a Vue component, call `useChallengesAndOpportunitiesQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     challengesAndOpportunities: useChallengesAndOpportunitiesQuery({
 *       variables: {
 *         input: // value for 'input'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useChallengesAndOpportunitiesQuery = createSmartQueryOptionsFunction<
  ChallengesAndOpportunitiesQuery,
  ChallengesAndOpportunitiesQueryVariables,
  ApolloError
>(ChallengesAndOpportunitiesDocument);

export const ExplainTrendDocument = gql`
    query explainTrend($input: ExplainTrendInput!) {
  ai {
    explainTrend(input: $input)
  }
}
    `;

/**
 * __useExplainTrendQuery__
 *
 * To use a Smart Query within a Vue component, call `useExplainTrendQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     explainTrend: useExplainTrendQuery({
 *       variables: {
 *         input: // value for 'input'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useExplainTrendQuery = createSmartQueryOptionsFunction<
  ExplainTrendQuery,
  ExplainTrendQueryVariables,
  ApolloError
>(ExplainTrendDocument);

export const CreateCommentDocument = gql`
    mutation createComment($id: ID!, $input: CommentInput!) {
  post(id: $id) {
    comment(input: $input) {
      id
      body
      createdAt
      updatedAt
      owner {
        id
        firstName
        lastName
        avatar
        email
        enabled
      }
      post {
        id
        comments {
          id
          body
        }
      }
    }
  }
}
    `;

/**
 * __createCommentMutation__
 *
 * To run a mutation, you call `createCommentMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = createCommentMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export const createCommentMutation = createMutationFunction<
  CreateCommentMutation,
  CreateCommentMutationVariables,
  ApolloError
>(CreateCommentDocument);

export const DeleteCommentDocument = gql`
    mutation deleteComment($id: ID!) {
  comment(id: $id) {
    delete
  }
}
    `;

/**
 * __deleteCommentMutation__
 *
 * To run a mutation, you call `deleteCommentMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = deleteCommentMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export const deleteCommentMutation = createMutationFunction<
  DeleteCommentMutation,
  DeleteCommentMutationVariables,
  ApolloError
>(DeleteCommentDocument);

export const UpdateCommentDocument = gql`
    mutation updateComment($id: ID!, $input: UpdateCommentInput!) {
  comment(id: $id) {
    update(input: $input) {
      id
      body
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __updateCommentMutation__
 *
 * To run a mutation, you call `updateCommentMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = updateCommentMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export const updateCommentMutation = createMutationFunction<
  UpdateCommentMutation,
  UpdateCommentMutationVariables,
  ApolloError
>(UpdateCommentDocument);

export const CreateCompanyMicrotrendDocument = gql`
    mutation createCompanyMicrotrend($input: CreateCompanyMicrotrendInput!) {
  createCompanyMicrotrend(input: $input) {
    id
  }
}
    `;

/**
 * __createCompanyMicrotrendMutation__
 *
 * To run a mutation, you call `createCompanyMicrotrendMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = createCompanyMicrotrendMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export const createCompanyMicrotrendMutation = createMutationFunction<
  CreateCompanyMicrotrendMutation,
  CreateCompanyMicrotrendMutationVariables,
  ApolloError
>(CreateCompanyMicrotrendDocument);

export const DeleteCompanyMicrotrendDocument = gql`
    mutation deleteCompanyMicrotrend($input: DeleteCompanyMicrotrendInput!) {
  deleteCompanyMicrotrend(input: $input)
}
    `;

/**
 * __deleteCompanyMicrotrendMutation__
 *
 * To run a mutation, you call `deleteCompanyMicrotrendMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = deleteCompanyMicrotrendMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export const deleteCompanyMicrotrendMutation = createMutationFunction<
  DeleteCompanyMicrotrendMutation,
  DeleteCompanyMicrotrendMutationVariables,
  ApolloError
>(DeleteCompanyMicrotrendDocument);

export const OnsiteUpdateCompanyMicrotrendDocument = gql`
    mutation onsiteUpdateCompanyMicrotrend($input: UpdateCompanyMicrotrendInput!, $locale: Locale, $width: Int, $height: Int) {
  updateCompanyMicrotrend(input: $input) {
    id
    innovationTypes {
      id
      translations(locale: $locale) {
        locale
        title
      }
    }
    industries {
      id
      translations(locale: $locale) {
        locale
        title
      }
    }
    macrotrends {
      ...MacrotrendInterfaceParts
    }
  }
}
    ${MacrotrendInterfacePartsFragmentDoc}`;

/**
 * __onsiteUpdateCompanyMicrotrendMutation__
 *
 * To run a mutation, you call `onsiteUpdateCompanyMicrotrendMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = onsiteUpdateCompanyMicrotrendMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *     locale: // value for 'locale'
 *     width: // value for 'width'
 *     height: // value for 'height'
 *   },
 * });
 */
export const onsiteUpdateCompanyMicrotrendMutation = createMutationFunction<
  OnsiteUpdateCompanyMicrotrendMutation,
  OnsiteUpdateCompanyMicrotrendMutationVariables,
  ApolloError
>(OnsiteUpdateCompanyMicrotrendDocument);

export const UpdateCompanyMicrotrendDocument = gql`
    mutation updateCompanyMicrotrend($input: UpdateCompanyMicrotrendInput!, $locale: Locale, $width: Int, $height: Int) {
  updateCompanyMicrotrend(input: $input) {
    id
    url
    images
    comment
    countries {
      id
    }
    innovationTypes {
      id
      translations(locale: $locale) {
        locale
        title
      }
    }
    translations {
      locale
      title
      description
    }
    industries {
      id
      translations(locale: $locale) {
        locale
        title
      }
    }
    macrotrends {
      ...MacrotrendInterfaceParts
    }
    initiators {
      id
      title
    }
  }
}
    ${MacrotrendInterfacePartsFragmentDoc}`;

/**
 * __updateCompanyMicrotrendMutation__
 *
 * To run a mutation, you call `updateCompanyMicrotrendMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = updateCompanyMicrotrendMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *     locale: // value for 'locale'
 *     width: // value for 'width'
 *     height: // value for 'height'
 *   },
 * });
 */
export const updateCompanyMicrotrendMutation = createMutationFunction<
  UpdateCompanyMicrotrendMutation,
  UpdateCompanyMicrotrendMutationVariables,
  ApolloError
>(UpdateCompanyMicrotrendDocument);

export const MicrotrendDocument = gql`
    query microtrend($id: ID!, $locale: Locale, $width: Int, $height: Int) {
  microtrend: node(id: $id) {
    ... on CompanyMicrotrend {
      id
      url
      images
      comment
      countries {
        id
      }
      innovationTypes {
        id
      }
      translations {
        locale
        title
        description
      }
      industries {
        id
        translations(locale: $locale) {
          title
        }
      }
      macrotrends {
        ...MacrotrendInterfaceParts
      }
      initiators {
        id
        title
      }
      pins {
        id
        macrotrend {
          id
        }
      }
    }
  }
}
    ${MacrotrendInterfacePartsFragmentDoc}`;

/**
 * __useMicrotrendQuery__
 *
 * To use a Smart Query within a Vue component, call `useMicrotrendQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     microtrend: useMicrotrendQuery({
 *       variables: {
 *         id: // value for 'id'
 *         locale: // value for 'locale'
 *         width: // value for 'width'
 *         height: // value for 'height'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useMicrotrendQuery = createSmartQueryOptionsFunction<
  MicrotrendQuery,
  MicrotrendQueryVariables,
  ApolloError
>(MicrotrendDocument);

export const LoadCriteriaSetsDocument = gql`
    query LoadCriteriaSets($locale: Locale = null) {
  criteriaSets {
    id
    translations(locale: $locale) {
      locale
      title
    }
  }
}
    `;

/**
 * __useLoadCriteriaSetsQuery__
 *
 * To use a Smart Query within a Vue component, call `useLoadCriteriaSetsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     loadCriteriaSets: useLoadCriteriaSetsQuery({
 *       variables: {
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useLoadCriteriaSetsQuery = createSmartQueryOptionsFunction<
  LoadCriteriaSetsQuery,
  LoadCriteriaSetsQueryVariables,
  ApolloError
>(LoadCriteriaSetsDocument);

export const TotalCountDocument = gql`
    query TotalCount($type: ActivityFeedType) {
  totalCount: activityFeed(type: $type) {
    totalCount
  }
}
    `;

/**
 * __useTotalCountQuery__
 *
 * To use a Smart Query within a Vue component, call `useTotalCountQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     totalCount: useTotalCountQuery({
 *       variables: {
 *         type: // value for 'type'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useTotalCountQuery = createSmartQueryOptionsFunction<
  TotalCountQuery,
  TotalCountQueryVariables,
  ApolloError
>(TotalCountDocument);

export const ActivityFeedDocument = gql`
    query ActivityFeed($after: String, $first: Int, $before: String, $last: Int, $type: ActivityFeedType, $locale: Locale) {
  activityFeed(
    after: $after
    first: $first
    before: $before
    last: $last
    type: $type
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        user {
          avatar
          enabled
        }
        translations(locale: $locale) {
          locale
          text
          attachment {
            image
            description
          }
        }
        createdAt
      }
    }
  }
}
    `;

/**
 * __useActivityFeedQuery__
 *
 * To use a Smart Query within a Vue component, call `useActivityFeedQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     activityFeed: useActivityFeedQuery({
 *       variables: {
 *         after: // value for 'after'
 *         first: // value for 'first'
 *         before: // value for 'before'
 *         last: // value for 'last'
 *         type: // value for 'type'
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useActivityFeedQuery = createSmartQueryOptionsFunction<
  ActivityFeedQuery,
  ActivityFeedQueryVariables,
  ApolloError
>(ActivityFeedDocument);

export const ExportWorkspaceDocument = gql`
    mutation exportWorkspace($input: WorkspaceExportInput!) {
  export: exportWorkspace(input: $input) {
    id
    url
    status
  }
}
    `;

/**
 * __exportWorkspaceMutation__
 *
 * To run a mutation, you call `exportWorkspaceMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = exportWorkspaceMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export const exportWorkspaceMutation = createMutationFunction<
  ExportWorkspaceMutation,
  ExportWorkspaceMutationVariables,
  ApolloError
>(ExportWorkspaceDocument);

export const ExportDocument = gql`
    mutation export($input: ExportInput!) {
  export(input: $input) {
    id
    url
    status
  }
}
    `;

/**
 * __exportMutation__
 *
 * To run a mutation, you call `exportMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = exportMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export const exportMutation = createMutationFunction<
  ExportMutation,
  ExportMutationVariables,
  ApolloError
>(ExportDocument);

export const PollDocument = gql`
    query poll($id: ID!) {
  node(id: $id) {
    id
    ... on Export {
      status
      url
    }
  }
}
    `;

/**
 * __usePollQuery__
 *
 * To use a Smart Query within a Vue component, call `usePollQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     poll: usePollQuery({
 *       variables: {
 *         id: // value for 'id'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const usePollQuery = createSmartQueryOptionsFunction<
  PollQuery,
  PollQueryVariables,
  ApolloError
>(PollDocument);

export const UsersDocument = gql`
    query users {
  users {
    id
    firstName
    lastName
    avatar
    email
    enabled
  }
}
    `;

/**
 * __useUsersQuery__
 *
 * To use a Smart Query within a Vue component, call `useUsersQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     users: useUsersQuery({
 *       variables: {},
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useUsersQuery = createSmartQueryOptionsFunction<
  UsersQuery,
  UsersQueryVariables,
  ApolloError
>(UsersDocument);

export const IndustryListDocument = gql`
    query industryList($locale: Locale) {
  industries {
    id
    translations(locale: $locale) {
      locale
      title
    }
  }
}
    `;

/**
 * __useIndustryListQuery__
 *
 * To use a Smart Query within a Vue component, call `useIndustryListQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     industryList: useIndustryListQuery({
 *       variables: {
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useIndustryListQuery = createSmartQueryOptionsFunction<
  IndustryListQuery,
  IndustryListQueryVariables,
  ApolloError
>(IndustryListDocument);

export const AddNodesToInnovationFieldsDocument = gql`
    mutation addNodesToInnovationFields($input: AddNodesToInnovationFieldsInput!, $locale: Locale!, $width: Int, $height: Int) {
  addNodesToInnovationFields(input: $input) {
    ...InnovationFieldParts
    megatrends {
      ...MegatrendParts
    }
    macrotrends {
      ...MacrotrendInterfaceParts
    }
  }
}
    ${InnovationFieldPartsFragmentDoc}
${MegatrendPartsFragmentDoc}
${MacrotrendInterfacePartsFragmentDoc}`;

/**
 * __addNodesToInnovationFieldsMutation__
 *
 * To run a mutation, you call `addNodesToInnovationFieldsMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = addNodesToInnovationFieldsMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *     locale: // value for 'locale'
 *     width: // value for 'width'
 *     height: // value for 'height'
 *   },
 * });
 */
export const addNodesToInnovationFieldsMutation = createMutationFunction<
  AddNodesToInnovationFieldsMutation,
  AddNodesToInnovationFieldsMutationVariables,
  ApolloError
>(AddNodesToInnovationFieldsDocument);

export const CreateInnovationFieldDocument = gql`
    mutation createInnovationField($input: InnovationFieldInput!) {
  createInnovationField(input: $input) {
    ...InnovationFieldParts
    macrotrends {
      id
    }
    contactPerson {
      ...UserParts
    }
  }
}
    ${InnovationFieldPartsFragmentDoc}
${UserPartsFragmentDoc}`;

/**
 * __createInnovationFieldMutation__
 *
 * To run a mutation, you call `createInnovationFieldMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = createInnovationFieldMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export const createInnovationFieldMutation = createMutationFunction<
  CreateInnovationFieldMutation,
  CreateInnovationFieldMutationVariables,
  ApolloError
>(CreateInnovationFieldDocument);

export const DeleteInnovationFieldDocument = gql`
    mutation deleteInnovationField($id: ID!) {
  innovationField(id: $id) {
    delete
  }
}
    `;

/**
 * __deleteInnovationFieldMutation__
 *
 * To run a mutation, you call `deleteInnovationFieldMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = deleteInnovationFieldMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export const deleteInnovationFieldMutation = createMutationFunction<
  DeleteInnovationFieldMutation,
  DeleteInnovationFieldMutationVariables,
  ApolloError
>(DeleteInnovationFieldDocument);

export const UpdatePublicInnovationFieldsDocument = gql`
    mutation updatePublicInnovationFields($input: PublicInnovationFieldsStateInput!) {
  updatePublicInnovationFieldsState(input: $input)
}
    `;

/**
 * __updatePublicInnovationFieldsMutation__
 *
 * To run a mutation, you call `updatePublicInnovationFieldsMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = updatePublicInnovationFieldsMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export const updatePublicInnovationFieldsMutation = createMutationFunction<
  UpdatePublicInnovationFieldsMutation,
  UpdatePublicInnovationFieldsMutationVariables,
  ApolloError
>(UpdatePublicInnovationFieldsDocument);

export const UpdateInnovationFieldDocument = gql`
    mutation updateInnovationField($id: ID!, $input: InnovationFieldInput!, $locale: Locale!, $width: Int, $height: Int) {
  innovationField(id: $id) {
    update(input: $input) {
      ...InnovationFieldViewParts
    }
  }
}
    ${InnovationFieldViewPartsFragmentDoc}`;

/**
 * __updateInnovationFieldMutation__
 *
 * To run a mutation, you call `updateInnovationFieldMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = updateInnovationFieldMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *     locale: // value for 'locale'
 *     width: // value for 'width'
 *     height: // value for 'height'
 *   },
 * });
 */
export const updateInnovationFieldMutation = createMutationFunction<
  UpdateInnovationFieldMutation,
  UpdateInnovationFieldMutationVariables,
  ApolloError
>(UpdateInnovationFieldDocument);

export const InnovationFieldsDocument = gql`
    query InnovationFields($page: Int!, $pageSize: Int!) {
  innovationFields(page: $page, pageSize: $pageSize) {
    nodes {
      id
      title
    }
  }
}
    `;

/**
 * __useInnovationFieldsQuery__
 *
 * To use a Smart Query within a Vue component, call `useInnovationFieldsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     innovationFields: useInnovationFieldsQuery({
 *       variables: {
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useInnovationFieldsQuery = createSmartQueryOptionsFunction<
  InnovationFieldsQuery,
  InnovationFieldsQueryVariables,
  ApolloError
>(InnovationFieldsDocument);

export const InnovationFieldDocument = gql`
    query InnovationField($id: ID!, $locale: Locale!) {
  innovationField: node(id: $id) {
    ... on InnovationField {
      ...InnovationFieldParts
      contactPerson {
        id
      }
      macrotrends {
        id
        translations(locale: $locale) {
          title
        }
        megatrend {
          id
          color
        }
      }
      innovationProjects(page: 1, pageSize: 40) {
        nodes {
          id
          title
        }
      }
      trendRadars(page: 1, pageSize: 40) {
        nodes {
          id
          title
        }
      }
    }
  }
}
    ${InnovationFieldPartsFragmentDoc}`;

/**
 * __useInnovationFieldQuery__
 *
 * To use a Smart Query within a Vue component, call `useInnovationFieldQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     innovationField: useInnovationFieldQuery({
 *       variables: {
 *         id: // value for 'id'
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useInnovationFieldQuery = createSmartQueryOptionsFunction<
  InnovationFieldQuery,
  InnovationFieldQueryVariables,
  ApolloError
>(InnovationFieldDocument);

export const InnovationFieldsGalleryDocument = gql`
    query InnovationFieldsGallery($filter: InnovationFieldFilterInput, $page: Int!, $pageSize: Int!) {
  innovationFields(filter: $filter, page: $page, pageSize: $pageSize) {
    nodes {
      ...InnovationFieldParts
      deprecatedMacrotrends {
        id
        translations {
          title
        }
      }
      macrotrends {
        id
      }
    }
    facets {
      innovationProjects {
        id
        title
      }
      trendRadars {
        id
        title
      }
    }
    pageInfo {
      ...PaginatedPageInfoParts
    }
    innovationProjectsPublic
    privateTrendRadars
  }
}
    ${InnovationFieldPartsFragmentDoc}
${PaginatedPageInfoPartsFragmentDoc}`;

/**
 * __useInnovationFieldsGalleryQuery__
 *
 * To use a Smart Query within a Vue component, call `useInnovationFieldsGalleryQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     innovationFieldsGallery: useInnovationFieldsGalleryQuery({
 *       variables: {
 *         filter: // value for 'filter'
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useInnovationFieldsGalleryQuery = createSmartQueryOptionsFunction<
  InnovationFieldsGalleryQuery,
  InnovationFieldsGalleryQueryVariables,
  ApolloError
>(InnovationFieldsGalleryDocument);

export const InnovationFieldsListDocument = gql`
    query InnovationFieldsList($filter: InnovationFieldFilterInput, $page: Int!, $pageSize: Int!, $sort: InnovationFieldsSort, $locale: Locale) {
  innovationFields(filter: $filter, page: $page, sort: $sort, pageSize: $pageSize) {
    nodes {
      ...InnovationFieldParts
      innovationProjects {
        nodes {
          id
          title
        }
      }
      deprecatedMacrotrends {
        id
        translations {
          title
        }
      }
      macrotrends {
        id
        translations(locale: $locale) {
          locale
          title
        }
        megatrend {
          id
          color
        }
      }
      megatrends {
        id
        translations(locale: $locale) {
          locale
          title
        }
        color
      }
      trendRadars {
        nodes {
          id
          title
        }
      }
    }
    facets {
      innovationProjects {
        id
        title
      }
      trendRadars {
        id
        title
      }
    }
    pageInfo {
      ...PaginatedPageInfoParts
    }
    innovationProjectsPublic
    privateTrendRadars
  }
}
    ${InnovationFieldPartsFragmentDoc}
${PaginatedPageInfoPartsFragmentDoc}`;

/**
 * __useInnovationFieldsListQuery__
 *
 * To use a Smart Query within a Vue component, call `useInnovationFieldsListQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     innovationFieldsList: useInnovationFieldsListQuery({
 *       variables: {
 *         filter: // value for 'filter'
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *         sort: // value for 'sort'
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useInnovationFieldsListQuery = createSmartQueryOptionsFunction<
  InnovationFieldsListQuery,
  InnovationFieldsListQueryVariables,
  ApolloError
>(InnovationFieldsListDocument);

export const InnovationFieldsOverviewDocument = gql`
    query InnovationFieldsOverview {
  innovationFields(
    page: 1
    pageSize: 4
    sort: {field: createdAt, direction: desc}
  ) {
    nodes {
      id
      title
      description
      image(width: 50, height: 50, resize: fill)
    }
  }
}
    `;

/**
 * __useInnovationFieldsOverviewQuery__
 *
 * To use a Smart Query within a Vue component, call `useInnovationFieldsOverviewQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     innovationFieldsOverview: useInnovationFieldsOverviewQuery({
 *       variables: {},
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useInnovationFieldsOverviewQuery = createSmartQueryOptionsFunction<
  InnovationFieldsOverviewQuery,
  InnovationFieldsOverviewQueryVariables,
  ApolloError
>(InnovationFieldsOverviewDocument);

export const PublicInnovationFieldsUrlDocument = gql`
    query PublicInnovationFieldsUrl {
  publicInnovationFieldsUrl
}
    `;

/**
 * __usePublicInnovationFieldsUrlQuery__
 *
 * To use a Smart Query within a Vue component, call `usePublicInnovationFieldsUrlQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     publicInnovationFieldsUrl: usePublicInnovationFieldsUrlQuery({
 *       variables: {},
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const usePublicInnovationFieldsUrlQuery = createSmartQueryOptionsFunction<
  PublicInnovationFieldsUrlQuery,
  PublicInnovationFieldsUrlQueryVariables,
  ApolloError
>(PublicInnovationFieldsUrlDocument);

export const InnovationFieldViewDocument = gql`
    query InnovationFieldView($id: ID!, $locale: Locale!, $width: Int, $height: Int) {
  innovationField: node(id: $id) {
    ...InnovationFieldViewParts
  }
}
    ${InnovationFieldViewPartsFragmentDoc}`;

/**
 * __useInnovationFieldViewQuery__
 *
 * To use a Smart Query within a Vue component, call `useInnovationFieldViewQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     innovationFieldView: useInnovationFieldViewQuery({
 *       variables: {
 *         id: // value for 'id'
 *         locale: // value for 'locale'
 *         width: // value for 'width'
 *         height: // value for 'height'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useInnovationFieldViewQuery = createSmartQueryOptionsFunction<
  InnovationFieldViewQuery,
  InnovationFieldViewQueryVariables,
  ApolloError
>(InnovationFieldViewDocument);

export const CreateInnovationProjectDocument = gql`
    mutation createInnovationProject($input: CreateInnovationProjectInput!, $locale: Locale!) {
  createInnovationProject(input: $input) {
    ...InnovationProjectParts
    macrotrends {
      id
      translations(locale: $locale) {
        title
      }
      megatrend {
        id
        color
      }
    }
    megatrends {
      id
      translations(locale: $locale) {
        title
      }
      color
    }
    innovationFields {
      id
      title
      image
    }
    trendRadars {
      id
      title
    }
    participants {
      id
      email
      firstName
      lastName
      jobPosition
      avatar
    }
  }
}
    ${InnovationProjectPartsFragmentDoc}`;

/**
 * __createInnovationProjectMutation__
 *
 * To run a mutation, you call `createInnovationProjectMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = createInnovationProjectMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *     locale: // value for 'locale'
 *   },
 * });
 */
export const createInnovationProjectMutation = createMutationFunction<
  CreateInnovationProjectMutation,
  CreateInnovationProjectMutationVariables,
  ApolloError
>(CreateInnovationProjectDocument);

export const DeleteInnovationProjectDocument = gql`
    mutation deleteInnovationProject($input: DeleteInnovationProjectInput!) {
  deleteInnovationProject(input: $input)
}
    `;

/**
 * __deleteInnovationProjectMutation__
 *
 * To run a mutation, you call `deleteInnovationProjectMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = deleteInnovationProjectMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export const deleteInnovationProjectMutation = createMutationFunction<
  DeleteInnovationProjectMutation,
  DeleteInnovationProjectMutationVariables,
  ApolloError
>(DeleteInnovationProjectDocument);

export const ProposeInnovationProjectDocument = gql`
    mutation proposeInnovationProject($input: ProposeInnovationProjectInput!) {
  proposeInnovationProject(input: $input)
}
    `;

/**
 * __proposeInnovationProjectMutation__
 *
 * To run a mutation, you call `proposeInnovationProjectMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = proposeInnovationProjectMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export const proposeInnovationProjectMutation = createMutationFunction<
  ProposeInnovationProjectMutation,
  ProposeInnovationProjectMutationVariables,
  ApolloError
>(ProposeInnovationProjectDocument);

export const UpdatePublicInnovationProjectsDocument = gql`
    mutation updatePublicInnovationProjects($input: PublicInnovationProjectsStateInput!) {
  updatePublicInnovationProjectsState(input: $input)
}
    `;

/**
 * __updatePublicInnovationProjectsMutation__
 *
 * To run a mutation, you call `updatePublicInnovationProjectsMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = updatePublicInnovationProjectsMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export const updatePublicInnovationProjectsMutation = createMutationFunction<
  UpdatePublicInnovationProjectsMutation,
  UpdatePublicInnovationProjectsMutationVariables,
  ApolloError
>(UpdatePublicInnovationProjectsDocument);

export const UpdateInnovationProjectDocument = gql`
    mutation updateInnovationProject($input: UpdateInnovationProjectInput!, $locale: Locale!) {
  updateInnovationProject(input: $input) {
    ...InnovationProjectParts
    macrotrends {
      id
      translations(locale: $locale) {
        title
      }
      megatrend {
        id
        color
      }
    }
    megatrends {
      id
      translations(locale: $locale) {
        title
      }
      color
    }
    innovationFields {
      id
      title
      image
    }
    trendRadars {
      id
      title
    }
    participants {
      id
      email
      firstName
      lastName
      jobPosition
      avatar
    }
  }
}
    ${InnovationProjectPartsFragmentDoc}`;

/**
 * __updateInnovationProjectMutation__
 *
 * To run a mutation, you call `updateInnovationProjectMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = updateInnovationProjectMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *     locale: // value for 'locale'
 *   },
 * });
 */
export const updateInnovationProjectMutation = createMutationFunction<
  UpdateInnovationProjectMutation,
  UpdateInnovationProjectMutationVariables,
  ApolloError
>(UpdateInnovationProjectDocument);

export const InnovationProjectsDocument = gql`
    query InnovationProjects($page: Int!, $pageSize: Int!) {
  innovationProjects(page: $page, pageSize: $pageSize) {
    nodes {
      id
      title
    }
  }
}
    `;

/**
 * __useInnovationProjectsQuery__
 *
 * To use a Smart Query within a Vue component, call `useInnovationProjectsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     innovationProjects: useInnovationProjectsQuery({
 *       variables: {
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useInnovationProjectsQuery = createSmartQueryOptionsFunction<
  InnovationProjectsQuery,
  InnovationProjectsQueryVariables,
  ApolloError
>(InnovationProjectsDocument);

export const InnovationProjectDocument = gql`
    query InnovationProject($id: ID!, $locale: Locale!) {
  innovationProject: node(id: $id) {
    ... on InnovationProject {
      ...InnovationProjectParts
      macrotrends {
        id
        translations(locale: $locale) {
          title
        }
        megatrend {
          id
          color
        }
      }
      innovationFields {
        id
        title
      }
      trendRadars {
        id
        title
      }
      participants {
        id
        email
        firstName
        lastName
        jobPosition
      }
    }
  }
}
    ${InnovationProjectPartsFragmentDoc}`;

/**
 * __useInnovationProjectQuery__
 *
 * To use a Smart Query within a Vue component, call `useInnovationProjectQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     innovationProject: useInnovationProjectQuery({
 *       variables: {
 *         id: // value for 'id'
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useInnovationProjectQuery = createSmartQueryOptionsFunction<
  InnovationProjectQuery,
  InnovationProjectQueryVariables,
  ApolloError
>(InnovationProjectDocument);

export const InnovationProjectsGalleryDocument = gql`
    query InnovationProjectsGallery($page: Int!, $pageSize: Int!, $filter: InnovationProjectFilterInput) {
  innovationProjects(page: $page, pageSize: $pageSize, filter: $filter) {
    nodes {
      ...InnovationProjectParts
      deprecatedMacrotrends {
        id
        translations {
          title
        }
      }
    }
    pageInfo {
      ...PaginatedPageInfoParts
    }
    facets {
      states {
        state
        count
      }
      trendRadars {
        node {
          id
          ... on PublishedTrendRadar {
            title
          }
        }
        count
      }
      innovationFields {
        node {
          id
          ... on InnovationField {
            title
          }
        }
      }
    }
    privateTrendRadars
  }
}
    ${InnovationProjectPartsFragmentDoc}
${PaginatedPageInfoPartsFragmentDoc}`;

/**
 * __useInnovationProjectsGalleryQuery__
 *
 * To use a Smart Query within a Vue component, call `useInnovationProjectsGalleryQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     innovationProjectsGallery: useInnovationProjectsGalleryQuery({
 *       variables: {
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *         filter: // value for 'filter'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useInnovationProjectsGalleryQuery = createSmartQueryOptionsFunction<
  InnovationProjectsGalleryQuery,
  InnovationProjectsGalleryQueryVariables,
  ApolloError
>(InnovationProjectsGalleryDocument);

export const InnovationProjectsListDocument = gql`
    query InnovationProjectsList($page: Int!, $pageSize: Int!, $sort: InnovationProjectSort, $filter: InnovationProjectFilterInput, $locale: Locale) {
  innovationProjects(
    page: $page
    pageSize: $pageSize
    sort: $sort
    filter: $filter
  ) {
    nodes {
      ...InnovationProjectParts
      deprecatedMacrotrends {
        id
        translations {
          title
        }
      }
      image
      state
      publishingState
      trendRadars {
        id
        title
      }
      innovationFields {
        id
        title
      }
      macrotrends {
        id
        translations(locale: $locale) {
          title
          locale
        }
        megatrend {
          id
          color
        }
      }
      megatrends {
        id
        translations(locale: $locale) {
          title
          locale
        }
        color
      }
    }
    pageInfo {
      ...PaginatedPageInfoParts
    }
    facets {
      states {
        state
        count
      }
      trendRadars {
        node {
          id
          ... on PublishedTrendRadar {
            title
          }
        }
        count
      }
      innovationFields {
        node {
          id
          ... on InnovationField {
            title
          }
        }
      }
    }
    privateTrendRadars
  }
}
    ${InnovationProjectPartsFragmentDoc}
${PaginatedPageInfoPartsFragmentDoc}`;

/**
 * __useInnovationProjectsListQuery__
 *
 * To use a Smart Query within a Vue component, call `useInnovationProjectsListQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     innovationProjectsList: useInnovationProjectsListQuery({
 *       variables: {
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *         sort: // value for 'sort'
 *         filter: // value for 'filter'
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useInnovationProjectsListQuery = createSmartQueryOptionsFunction<
  InnovationProjectsListQuery,
  InnovationProjectsListQueryVariables,
  ApolloError
>(InnovationProjectsListDocument);

export const PublicInnovationProjectsUrlDocument = gql`
    query PublicInnovationProjectsUrl {
  publicInnovationProjectsUrl
}
    `;

/**
 * __usePublicInnovationProjectsUrlQuery__
 *
 * To use a Smart Query within a Vue component, call `usePublicInnovationProjectsUrlQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     publicInnovationProjectsUrl: usePublicInnovationProjectsUrlQuery({
 *       variables: {},
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const usePublicInnovationProjectsUrlQuery = createSmartQueryOptionsFunction<
  PublicInnovationProjectsUrlQuery,
  PublicInnovationProjectsUrlQueryVariables,
  ApolloError
>(PublicInnovationProjectsUrlDocument);

export const InnovationProjectViewDocument = gql`
    query InnovationProjectView($id: ID!, $locale: Locale!) {
  innovationProject: node(id: $id) {
    ... on InnovationProject {
      ...InnovationProjectParts
      macrotrends {
        id
        color
        ... on Macrotrend {
          deprecated
          successor {
            translations(locale: $locale) {
              title
            }
          }
        }
        translations(locale: $locale) {
          title
        }
        megatrend {
          id
          color
        }
      }
      megatrends {
        id
        translations(locale: $locale) {
          title
        }
        color
      }
      innovationFields {
        id
        title
        image
      }
      trendRadars {
        id
        title
        image
      }
      participants {
        id
        email
        firstName
        lastName
        jobPosition
        avatar
      }
    }
  }
}
    ${InnovationProjectPartsFragmentDoc}`;

/**
 * __useInnovationProjectViewQuery__
 *
 * To use a Smart Query within a Vue component, call `useInnovationProjectViewQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     innovationProjectView: useInnovationProjectViewQuery({
 *       variables: {
 *         id: // value for 'id'
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useInnovationProjectViewQuery = createSmartQueryOptionsFunction<
  InnovationProjectViewQuery,
  InnovationProjectViewQueryVariables,
  ApolloError
>(InnovationProjectViewDocument);

export const InsightsDocument = gql`
    query Insights {
  tc: insights(page: 1, pageSize: 1, type: TRENDCALL) {
    pageInfo {
      totalCount
    }
  }
  tt: insights(page: 1, pageSize: 1, type: TRENDING_TOPIC) {
    pageInfo {
      totalCount
    }
  }
  ts: insights(page: 1, pageSize: 1, type: TREND_SUMMARY) {
    pageInfo {
      totalCount
    }
  }
}
    `;

/**
 * __useInsightsQuery__
 *
 * To use a Smart Query within a Vue component, call `useInsightsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     insights: useInsightsQuery({
 *       variables: {},
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useInsightsQuery = createSmartQueryOptionsFunction<
  InsightsQuery,
  InsightsQueryVariables,
  ApolloError
>(InsightsDocument);

export const InsightsListDocument = gql`
    query InsightsList($page: Int, $pageSize: Int, $type: InsightsType!, $sort: InsightsSort) {
  insights(page: $page, pageSize: $pageSize, type: $type, sort: $sort) {
    nodes {
      ... on Trendcall {
        id
        author {
          id
          title
          name
          image
        }
        date
        title
        description
        image
        video
      }
      ... on TrendingTopic {
        id
        author {
          id
          title
          name
          image
        }
        date
        title
        description
        image
      }
      ... on TrendSummary {
        id
        author {
          id
          title
          name
          image
        }
        date
        title
        image
      }
    }
    pageInfo {
      currentPage
      totalPages
      pageSize
      totalCount
    }
  }
}
    `;

/**
 * __useInsightsListQuery__
 *
 * To use a Smart Query within a Vue component, call `useInsightsListQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     insightsList: useInsightsListQuery({
 *       variables: {
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *         type: // value for 'type'
 *         sort: // value for 'sort'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useInsightsListQuery = createSmartQueryOptionsFunction<
  InsightsListQuery,
  InsightsListQueryVariables,
  ApolloError
>(InsightsListDocument);

export const InsightDocument = gql`
    query Insight($id: ID!, $locale: Locale!) {
  insight: node(id: $id) {
    ... on Trendcall {
      id
      author {
        id
        title
        name
        image
      }
      date
      title
      description
      image
      video
    }
    ... on TrendingTopic {
      id
      author {
        id
        title
        name
        image
      }
      date
      title
      description
      image
      trendcall {
        id
        title
        video
      }
      microtrends {
        id
        images
        translations(locale: $locale) {
          locale
          title
          description
        }
      }
      macrotrends {
        id
        color
        translations(locale: $locale) {
          title
        }
        megatrend {
          id
          color
        }
      }
      industries {
        id
        translations(locale: $locale) {
          title
        }
      }
    }
    ... on TrendSummary {
      id
      author {
        id
        title
        name
        image
      }
      title
      pdf
      ppt
      date
      image
      microtrends {
        id
        images
        translations(locale: $locale) {
          locale
          title
          description
        }
      }
    }
  }
}
    `;

/**
 * __useInsightQuery__
 *
 * To use a Smart Query within a Vue component, call `useInsightQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     insight: useInsightQuery({
 *       variables: {
 *         id: // value for 'id'
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useInsightQuery = createSmartQueryOptionsFunction<
  InsightQuery,
  InsightQueryVariables,
  ApolloError
>(InsightDocument);

export const DeleteParticipationsDocument = gql`
    mutation deleteParticipations($trendRadarId: ID!, $panelId: ID!) {
  trendRadar(id: $trendRadarId) {
    panel(id: $panelId) {
      internalEvaluationOption {
        deleteParticipations {
          ...InternalEvaluationOptionParts
        }
      }
    }
  }
}
    ${InternalEvaluationOptionPartsFragmentDoc}`;

/**
 * __deleteParticipationsMutation__
 *
 * To run a mutation, you call `deleteParticipationsMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = deleteParticipationsMutation(this, {
 *   variables: {
 *     trendRadarId: // value for 'trendRadarId'
 *     panelId: // value for 'panelId'
 *   },
 * });
 */
export const deleteParticipationsMutation = createMutationFunction<
  DeleteParticipationsMutation,
  DeleteParticipationsMutationVariables,
  ApolloError
>(DeleteParticipationsDocument);

export const InviteInternalEvaluationUsersDocument = gql`
    mutation inviteInternalEvaluationUsers($trendRadarId: ID!, $panelId: ID!, $input: InviteUsersInput!) {
  trendRadar(id: $trendRadarId) {
    panel(id: $panelId) {
      internalEvaluationOption {
        inviteUsers(input: $input) {
          ...InternalEvaluationOptionParts
        }
      }
    }
  }
}
    ${InternalEvaluationOptionPartsFragmentDoc}`;

/**
 * __inviteInternalEvaluationUsersMutation__
 *
 * To run a mutation, you call `inviteInternalEvaluationUsersMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = inviteInternalEvaluationUsersMutation(this, {
 *   variables: {
 *     trendRadarId: // value for 'trendRadarId'
 *     panelId: // value for 'panelId'
 *     input: // value for 'input'
 *   },
 * });
 */
export const inviteInternalEvaluationUsersMutation = createMutationFunction<
  InviteInternalEvaluationUsersMutation,
  InviteInternalEvaluationUsersMutationVariables,
  ApolloError
>(InviteInternalEvaluationUsersDocument);

export const SendMessageToInternalEvaluationParticipantsDocument = gql`
    mutation sendMessageToInternalEvaluationParticipants($trendRadarId: ID!, $panelId: ID!, $input: SendMessageInput!) {
  trendRadar(id: $trendRadarId) {
    panel(id: $panelId) {
      internalEvaluationOption {
        sendMessage(input: $input)
      }
    }
  }
}
    `;

/**
 * __sendMessageToInternalEvaluationParticipantsMutation__
 *
 * To run a mutation, you call `sendMessageToInternalEvaluationParticipantsMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = sendMessageToInternalEvaluationParticipantsMutation(this, {
 *   variables: {
 *     trendRadarId: // value for 'trendRadarId'
 *     panelId: // value for 'panelId'
 *     input: // value for 'input'
 *   },
 * });
 */
export const sendMessageToInternalEvaluationParticipantsMutation = createMutationFunction<
  SendMessageToInternalEvaluationParticipantsMutation,
  SendMessageToInternalEvaluationParticipantsMutationVariables,
  ApolloError
>(SendMessageToInternalEvaluationParticipantsDocument);

export const SetInternalEvaluationOptionEnabledDocument = gql`
    mutation setInternalEvaluationOptionEnabled($trendRadarId: ID!, $panelId: ID!, $enabled: Boolean!) {
  trendRadar(id: $trendRadarId) {
    panel(id: $panelId) {
      internalEvaluationOption {
        setEnabled(enabled: $enabled) {
          id
          enabled
        }
      }
    }
  }
}
    `;

/**
 * __setInternalEvaluationOptionEnabledMutation__
 *
 * To run a mutation, you call `setInternalEvaluationOptionEnabledMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = setInternalEvaluationOptionEnabledMutation(this, {
 *   variables: {
 *     trendRadarId: // value for 'trendRadarId'
 *     panelId: // value for 'panelId'
 *     enabled: // value for 'enabled'
 *   },
 * });
 */
export const setInternalEvaluationOptionEnabledMutation = createMutationFunction<
  SetInternalEvaluationOptionEnabledMutation,
  SetInternalEvaluationOptionEnabledMutationVariables,
  ApolloError
>(SetInternalEvaluationOptionEnabledDocument);

export const UninviteInternalEvaluationUserDocument = gql`
    mutation uninviteInternalEvaluationUser($trendRadarId: ID!, $panelId: ID!, $userId: ID!) {
  trendRadar(id: $trendRadarId) {
    panel(id: $panelId) {
      internalEvaluationOption {
        uninviteUser(userId: $userId) {
          ...InternalEvaluationOptionParts
        }
      }
    }
  }
}
    ${InternalEvaluationOptionPartsFragmentDoc}`;

/**
 * __uninviteInternalEvaluationUserMutation__
 *
 * To run a mutation, you call `uninviteInternalEvaluationUserMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = uninviteInternalEvaluationUserMutation(this, {
 *   variables: {
 *     trendRadarId: // value for 'trendRadarId'
 *     panelId: // value for 'panelId'
 *     userId: // value for 'userId'
 *   },
 * });
 */
export const uninviteInternalEvaluationUserMutation = createMutationFunction<
  UninviteInternalEvaluationUserMutation,
  UninviteInternalEvaluationUserMutationVariables,
  ApolloError
>(UninviteInternalEvaluationUserDocument);

export const BecomeInsiderOfDocument = gql`
    mutation becomeInsiderOf($id: ID!) {
  me {
    becomeInsiderOf(id: $id) {
      ... on Macrotrend {
        id
        insider {
          user {
            id
            firstName
            lastName
            email
            avatar
            jobPosition
            enabled
          }
        }
      }
      ... on CompanyMacrotrend {
        id
        insider {
          user {
            id
            firstName
            lastName
            email
            avatar
            jobPosition
            enabled
          }
        }
      }
    }
  }
}
    `;

/**
 * __becomeInsiderOfMutation__
 *
 * To run a mutation, you call `becomeInsiderOfMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = becomeInsiderOfMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export const becomeInsiderOfMutation = createMutationFunction<
  BecomeInsiderOfMutation,
  BecomeInsiderOfMutationVariables,
  ApolloError
>(BecomeInsiderOfDocument);

export const CreateCnODocument = gql`
    mutation CreateCnO($id: ID!, $locale: Locale!, $input: CreateCnOInput!) {
  macrotrend(id: $id) {
    createCnO(input: $input) {
      id
      type
      translations(locale: $locale) {
        locale
        title
        challenges
        opportunities
      }
      author
      createdOn
      deletable
      editable
    }
  }
}
    `;

/**
 * __createCnOMutation__
 *
 * To run a mutation, you call `createCnOMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = createCnOMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *     locale: // value for 'locale'
 *     input: // value for 'input'
 *   },
 * });
 */
export const createCnOMutation = createMutationFunction<
  CreateCnOMutation,
  CreateCnOMutationVariables,
  ApolloError
>(CreateCnODocument);

export const DeleteCnODocument = gql`
    mutation DeleteCnO($id: ID!, $input: DeleteCnOInput!) {
  macrotrend(id: $id) {
    deleteCnO(input: $input)
  }
}
    `;

/**
 * __deleteCnOMutation__
 *
 * To run a mutation, you call `deleteCnOMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = deleteCnOMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export const deleteCnOMutation = createMutationFunction<
  DeleteCnOMutation,
  DeleteCnOMutationVariables,
  ApolloError
>(DeleteCnODocument);

export const PinMicrotrendsDocument = gql`
    mutation pinMicrotrends($input: PinMicrotrendsInput!) {
  pinMicrotrends(input: $input)
}
    `;

/**
 * __pinMicrotrendsMutation__
 *
 * To run a mutation, you call `pinMicrotrendsMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = pinMicrotrendsMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export const pinMicrotrendsMutation = createMutationFunction<
  PinMicrotrendsMutation,
  PinMicrotrendsMutationVariables,
  ApolloError
>(PinMicrotrendsDocument);

export const StopBeingInsiderOfDocument = gql`
    mutation stopBeingInsiderOf($id: ID!) {
  me {
    stopBeingInsiderOf(id: $id) {
      ... on Macrotrend {
        id
        insider {
          user {
            id
            firstName
            lastName
            email
            avatar
            jobPosition
            enabled
          }
        }
      }
      ... on CompanyMacrotrend {
        id
        insider {
          user {
            id
            firstName
            lastName
            email
            avatar
            jobPosition
            enabled
          }
        }
      }
    }
  }
}
    `;

/**
 * __stopBeingInsiderOfMutation__
 *
 * To run a mutation, you call `stopBeingInsiderOfMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = stopBeingInsiderOfMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export const stopBeingInsiderOfMutation = createMutationFunction<
  StopBeingInsiderOfMutation,
  StopBeingInsiderOfMutationVariables,
  ApolloError
>(StopBeingInsiderOfDocument);

export const SubscribeToMacrotrendDocument = gql`
    mutation subscribeToMacrotrend($macrotrendId: ID!) {
  macrotrendSubscription: subscribeToMacrotrend(
    input: {macrotrendId: $macrotrendId}
  ) {
    id
    ... on CompanyMacrotrend {
      hasSubscription
    }
    ... on Macrotrend {
      hasSubscription
    }
  }
}
    `;

/**
 * __subscribeToMacrotrendMutation__
 *
 * To run a mutation, you call `subscribeToMacrotrendMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = subscribeToMacrotrendMutation(this, {
 *   variables: {
 *     macrotrendId: // value for 'macrotrendId'
 *   },
 * });
 */
export const subscribeToMacrotrendMutation = createMutationFunction<
  SubscribeToMacrotrendMutation,
  SubscribeToMacrotrendMutationVariables,
  ApolloError
>(SubscribeToMacrotrendDocument);

export const UnpinMicrotrendDocument = gql`
    mutation unpinMicrotrend($input: UnpinMicrotrendInput!) {
  unpinMicrotrend(input: $input)
}
    `;

/**
 * __unpinMicrotrendMutation__
 *
 * To run a mutation, you call `unpinMicrotrendMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = unpinMicrotrendMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export const unpinMicrotrendMutation = createMutationFunction<
  UnpinMicrotrendMutation,
  UnpinMicrotrendMutationVariables,
  ApolloError
>(UnpinMicrotrendDocument);

export const UnsubscribeFromMacrotrendDocument = gql`
    mutation unsubscribeFromMacrotrend($macrotrendId: ID!) {
  macrotrendSubscription: unsubscribeFromMacrotrend(
    input: {macrotrendId: $macrotrendId}
  ) {
    id
    ... on Macrotrend {
      hasSubscription
    }
    ... on CompanyMacrotrend {
      hasSubscription
    }
  }
}
    `;

/**
 * __unsubscribeFromMacrotrendMutation__
 *
 * To run a mutation, you call `unsubscribeFromMacrotrendMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = unsubscribeFromMacrotrendMutation(this, {
 *   variables: {
 *     macrotrendId: // value for 'macrotrendId'
 *   },
 * });
 */
export const unsubscribeFromMacrotrendMutation = createMutationFunction<
  UnsubscribeFromMacrotrendMutation,
  UnsubscribeFromMacrotrendMutationVariables,
  ApolloError
>(UnsubscribeFromMacrotrendDocument);

export const UpdateCnODocument = gql`
    mutation UpdateCnO($id: ID!, $locale: Locale!, $input: UpdateCnOInput!) {
  macrotrend(id: $id) {
    updateCnO(input: $input) {
      id
      type
      translations(locale: $locale) {
        locale
        title
        challenges
        opportunities
      }
      author
      createdOn
      deletable
      editable
    }
  }
}
    `;

/**
 * __updateCnOMutation__
 *
 * To run a mutation, you call `updateCnOMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = updateCnOMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *     locale: // value for 'locale'
 *     input: // value for 'input'
 *   },
 * });
 */
export const updateCnOMutation = createMutationFunction<
  UpdateCnOMutation,
  UpdateCnOMutationVariables,
  ApolloError
>(UpdateCnODocument);

export const AddMacrotrendToWorkspaceQueryDocument = gql`
    query AddMacrotrendToWorkspaceQuery($id: ID!, $locale: Locale!, $sort: WorkspaceSort) {
  trend: node(id: $id) {
    ... on MacrotrendInterface {
      id
      translations(locale: $locale) {
        title
      }
    }
  }
  workspaces: updateableWorkspaces(sort: $sort) {
    id
    title
    containsTrend(id: $id)
  }
}
    `;

/**
 * __useAddMacrotrendToWorkspaceQueryQuery__
 *
 * To use a Smart Query within a Vue component, call `useAddMacrotrendToWorkspaceQueryQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     addMacrotrendToWorkspaceQuery: useAddMacrotrendToWorkspaceQueryQuery({
 *       variables: {
 *         id: // value for 'id'
 *         locale: // value for 'locale'
 *         sort: // value for 'sort'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useAddMacrotrendToWorkspaceQueryQuery = createSmartQueryOptionsFunction<
  AddMacrotrendToWorkspaceQueryQuery,
  AddMacrotrendToWorkspaceQueryQueryVariables,
  ApolloError
>(AddMacrotrendToWorkspaceQueryDocument);

export const AddMacrotrendQueryDocument = gql`
    query AddMacrotrendQuery($id: ID!, $locale: Locale!, $width: Int, $height: Int) {
  macrotrend: node(id: $id) {
    ... on MacrotrendInterface {
      ...MacrotrendInterfaceParts
    }
  }
  innovationFields(page: 1, pageSize: 250) {
    nodes {
      ...InnovationFieldParts
      macrotrends {
        id
      }
    }
    pageInfo {
      ...PaginatedPageInfoParts
    }
  }
}
    ${MacrotrendInterfacePartsFragmentDoc}
${InnovationFieldPartsFragmentDoc}
${PaginatedPageInfoPartsFragmentDoc}`;

/**
 * __useAddMacrotrendQueryQuery__
 *
 * To use a Smart Query within a Vue component, call `useAddMacrotrendQueryQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     addMacrotrendQuery: useAddMacrotrendQueryQuery({
 *       variables: {
 *         id: // value for 'id'
 *         locale: // value for 'locale'
 *         width: // value for 'width'
 *         height: // value for 'height'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useAddMacrotrendQueryQuery = createSmartQueryOptionsFunction<
  AddMacrotrendQueryQuery,
  AddMacrotrendQueryQueryVariables,
  ApolloError
>(AddMacrotrendQueryDocument);

export const MacrotrendEvaluationsDocument = gql`
    query MacrotrendEvaluations($id: ID!, $locale: Locale) {
  evaluations: node(id: $id) {
    ... on Macrotrend {
      id
      evaluations {
        id
        trendRadar {
          id
          title
          draftId
          managers {
            id
          }
        }
        evaluation {
          id
          values {
            criteria {
              ...CriteriaParts
            }
            value
          }
          recommendedAction
          readinessAssessment
        }
        perception
      }
    }
    ... on CompanyMacrotrend {
      id
      evaluations {
        id
        trendRadar {
          id
          title
          draftId
          managers {
            id
          }
        }
        evaluation {
          id
          values {
            criteria {
              ...CriteriaParts
            }
            value
          }
          recommendedAction
          readinessAssessment
        }
        perception
      }
    }
  }
}
    ${CriteriaPartsFragmentDoc}`;

/**
 * __useMacrotrendEvaluationsQuery__
 *
 * To use a Smart Query within a Vue component, call `useMacrotrendEvaluationsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     macrotrendEvaluations: useMacrotrendEvaluationsQuery({
 *       variables: {
 *         id: // value for 'id'
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useMacrotrendEvaluationsQuery = createSmartQueryOptionsFunction<
  MacrotrendEvaluationsQuery,
  MacrotrendEvaluationsQueryVariables,
  ApolloError
>(MacrotrendEvaluationsDocument);

export const IntroducedMacrotrendsDocument = gql`
    query introducedMacrotrends($locale: Locale!) {
  introducedMacrotrends {
    id
    image(width: 600, height: 300, resize: crop, gravity: ce)
    translations(locale: $locale) {
      title
      updateInfo
    }
  }
}
    `;

/**
 * __useIntroducedMacrotrendsQuery__
 *
 * To use a Smart Query within a Vue component, call `useIntroducedMacrotrendsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     introducedMacrotrends: useIntroducedMacrotrendsQuery({
 *       variables: {
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useIntroducedMacrotrendsQuery = createSmartQueryOptionsFunction<
  IntroducedMacrotrendsQuery,
  IntroducedMacrotrendsQueryVariables,
  ApolloError
>(IntroducedMacrotrendsDocument);

export const MacrotrendsDocument = gql`
    query macrotrends($locale: Locale!) {
  macrotrends {
    id
    megatrend {
      id
      color
    }
    translations(locale: $locale) {
      title
    }
    ... on Macrotrend {
      deprecated
    }
  }
}
    `;

/**
 * __useMacrotrendsQuery__
 *
 * To use a Smart Query within a Vue component, call `useMacrotrendsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     macrotrends: useMacrotrendsQuery({
 *       variables: {
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useMacrotrendsQuery = createSmartQueryOptionsFunction<
  MacrotrendsQuery,
  MacrotrendsQueryVariables,
  ApolloError
>(MacrotrendsDocument);

export const MergedMacrotrendsDocument = gql`
    query mergedMacrotrends($locale: Locale!) {
  mergedMacrotrends {
    successor {
      id
      image(width: 600, height: 300, resize: crop, gravity: ce)
      translations(locale: $locale) {
        title
        updateInfo
      }
    }
    predecessor {
      id
      image(width: 600, height: 300, resize: crop, gravity: ce)
      translations(locale: $locale) {
        title
      }
    }
  }
}
    `;

/**
 * __useMergedMacrotrendsQuery__
 *
 * To use a Smart Query within a Vue component, call `useMergedMacrotrendsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     mergedMacrotrends: useMergedMacrotrendsQuery({
 *       variables: {
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useMergedMacrotrendsQuery = createSmartQueryOptionsFunction<
  MergedMacrotrendsQuery,
  MergedMacrotrendsQueryVariables,
  ApolloError
>(MergedMacrotrendsDocument);

export const PinnedMicrotrendsDocument = gql`
    query PinnedMicrotrends($id: ID!, $locale: Locale!, $width: Int, $height: Int) {
  macrotrend: node(id: $id) {
    id
    ... on CompanyMacrotrend {
      pins {
        pinnedBy {
          id
        }
        microtrend {
          ...MicrotrendInterfaceParts
          ... on CompanyMicrotrend {
            author {
              id
              avatar
              firstName
              lastName
              email
            }
          }
        }
      }
    }
    ... on Macrotrend {
      pins {
        pinnedBy {
          id
        }
        microtrend {
          ...MicrotrendInterfaceParts
          ... on CompanyMicrotrend {
            author {
              id
              avatar
              firstName
              lastName
              email
            }
          }
        }
      }
    }
  }
}
    ${MicrotrendInterfacePartsFragmentDoc}`;

/**
 * __usePinnedMicrotrendsQuery__
 *
 * To use a Smart Query within a Vue component, call `usePinnedMicrotrendsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     pinnedMicrotrends: usePinnedMicrotrendsQuery({
 *       variables: {
 *         id: // value for 'id'
 *         locale: // value for 'locale'
 *         width: // value for 'width'
 *         height: // value for 'height'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const usePinnedMicrotrendsQuery = createSmartQueryOptionsFunction<
  PinnedMicrotrendsQuery,
  PinnedMicrotrendsQueryVariables,
  ApolloError
>(PinnedMicrotrendsDocument);

export const RelatedMicrotrendsDocument = gql`
    query RelatedMicrotrends($id: ID!, $locale: Locale!, $page: Int, $pageSize: Int, $width: Int, $height: Int) {
  macrotrend: node(id: $id) {
    id
    ... on CompanyMacrotrend {
      relatedMicrotrends(page: $page, pageSize: $pageSize) {
        nodes {
          ...ReducedMicrotrendParts
          ...TrendoneMicrotrendParts
          ...CompanyMicrotrendParts
        }
        pageInfo {
          ...PaginatedPageInfoParts
        }
      }
    }
    ... on Macrotrend {
      relatedMicrotrends(page: $page, pageSize: $pageSize) {
        nodes {
          ...ReducedMicrotrendParts
          ...TrendoneMicrotrendParts
          ...CompanyMicrotrendParts
        }
        pageInfo {
          ...PaginatedPageInfoParts
        }
      }
    }
  }
}
    ${ReducedMicrotrendPartsFragmentDoc}
${TrendoneMicrotrendPartsFragmentDoc}
${CompanyMicrotrendPartsFragmentDoc}
${PaginatedPageInfoPartsFragmentDoc}`;

/**
 * __useRelatedMicrotrendsQuery__
 *
 * To use a Smart Query within a Vue component, call `useRelatedMicrotrendsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     relatedMicrotrends: useRelatedMicrotrendsQuery({
 *       variables: {
 *         id: // value for 'id'
 *         locale: // value for 'locale'
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *         width: // value for 'width'
 *         height: // value for 'height'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useRelatedMicrotrendsQuery = createSmartQueryOptionsFunction<
  RelatedMicrotrendsQuery,
  RelatedMicrotrendsQueryVariables,
  ApolloError
>(RelatedMicrotrendsDocument);

export const ReplacedMacrotrendsDocument = gql`
    query replacedMacrotrends($locale: Locale!) {
  replacedMacrotrends {
    successor {
      id
      image(width: 600, height: 300, resize: crop, gravity: ce)
      translations(locale: $locale) {
        title
        updateInfo
      }
    }
    predecessor {
      id
      image(width: 600, height: 300, resize: crop, gravity: ce)
      translations(locale: $locale) {
        title
      }
    }
  }
}
    `;

/**
 * __useReplacedMacrotrendsQuery__
 *
 * To use a Smart Query within a Vue component, call `useReplacedMacrotrendsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     replacedMacrotrends: useReplacedMacrotrendsQuery({
 *       variables: {
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useReplacedMacrotrendsQuery = createSmartQueryOptionsFunction<
  ReplacedMacrotrendsQuery,
  ReplacedMacrotrendsQueryVariables,
  ApolloError
>(ReplacedMacrotrendsDocument);

export const RevisedMacrotrendsDocument = gql`
    query revisedMacrotrends($locale: Locale!) {
  revisedMacrotrends {
    id
    image(width: 600, height: 300, resize: crop, gravity: ce)
    translations(locale: $locale) {
      title
      updateInfo
    }
  }
}
    `;

/**
 * __useRevisedMacrotrendsQuery__
 *
 * To use a Smart Query within a Vue component, call `useRevisedMacrotrendsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     revisedMacrotrends: useRevisedMacrotrendsQuery({
 *       variables: {
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useRevisedMacrotrendsQuery = createSmartQueryOptionsFunction<
  RevisedMacrotrendsQuery,
  RevisedMacrotrendsQueryVariables,
  ApolloError
>(RevisedMacrotrendsDocument);

export const MacrotrendSearchDocument = gql`
    query MacrotrendSearch($query: String, $filter: SearchFiltersInput, $page: Int!, $pageSize: Int!, $locale: Locale!, $sort: MacrotrendsSort, $width: Int, $height: Int) {
  search: search(query: $query, filter: $filter) {
    macrotrends(page: $page, pageSize: $pageSize, sort: $sort) {
      pageInfo {
        ...PaginatedPageInfoParts
      }
      nodes {
        id
        image(width: $width, height: $height, resize: fit)
        translations(locale: $locale) {
          ...MacrotrendTranslationParts
        }
        megatrend {
          ...MegatrendParts
        }
      }
    }
  }
}
    ${PaginatedPageInfoPartsFragmentDoc}
${MacrotrendTranslationPartsFragmentDoc}
${MegatrendPartsFragmentDoc}`;

/**
 * __useMacrotrendSearchQuery__
 *
 * To use a Smart Query within a Vue component, call `useMacrotrendSearchQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     macrotrendSearch: useMacrotrendSearchQuery({
 *       variables: {
 *         query: // value for 'query'
 *         filter: // value for 'filter'
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *         locale: // value for 'locale'
 *         sort: // value for 'sort'
 *         width: // value for 'width'
 *         height: // value for 'height'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useMacrotrendSearchQuery = createSmartQueryOptionsFunction<
  MacrotrendSearchQuery,
  MacrotrendSearchQueryVariables,
  ApolloError
>(MacrotrendSearchDocument);

export const MacrotrendTrendradarDetailDocument = gql`
    query MacrotrendTrendradarDetail($id: ID!, $locale: Locale!, $page: Int, $pageSize: Int, $width: Int, $height: Int) {
  macrotrend: node(id: $id) {
    ... on ReducedMacrotrend {
      ...ReducedMacrotrendParts
      evaluations {
        trendRadar {
          id
        }
        evaluation {
          id
          values {
            criteria {
              ...CriteriaParts
            }
            value
          }
          recommendedAction
          readinessAssessment
        }
      }
    }
    ... on CompanyMacrotrend {
      ...CompanyMacrotrendParts
      evaluations {
        trendRadar {
          id
        }
        evaluation {
          id
          values {
            criteria {
              ...CriteriaParts
            }
            value
          }
          recommendedAction
          readinessAssessment
        }
      }
      innovationFields(page: $page, pageSize: $pageSize) {
        nodes {
          ...InnovationFieldParts
          trendRadars {
            nodes {
              id
            }
          }
        }
        pageInfo {
          ...PaginatedPageInfoParts
        }
      }
      insider {
        user {
          id
          firstName
          lastName
          email
          avatar
          enabled
          jobPosition
        }
      }
      extendedSources: posts(category: extendedSources) {
        ...PostCountParts
      }
      chances: posts(category: chances) {
        ...PostCountParts
      }
      risks: posts(category: risks) {
        ...PostCountParts
      }
    }
    ... on Macrotrend {
      ...TrendoneMacrotrendParts
      evaluations {
        trendRadar {
          id
        }
        evaluation {
          id
          values {
            criteria {
              ...CriteriaParts
            }
            value
          }
          recommendedAction
          readinessAssessment
        }
      }
      innovationFields(page: $page, pageSize: $pageSize) {
        nodes {
          ...InnovationFieldParts
          trendRadars {
            nodes {
              id
            }
          }
        }
        pageInfo {
          ...PaginatedPageInfoParts
        }
      }
      insider {
        user {
          id
          firstName
          lastName
          email
          avatar
          enabled
          jobPosition
        }
      }
      extendedSources: posts(category: extendedSources) {
        ...PostCountParts
      }
      chances: posts(category: chances) {
        ...PostCountParts
      }
      risks: posts(category: risks) {
        ...PostCountParts
      }
    }
  }
}
    ${ReducedMacrotrendPartsFragmentDoc}
${CriteriaPartsFragmentDoc}
${CompanyMacrotrendPartsFragmentDoc}
${InnovationFieldPartsFragmentDoc}
${PaginatedPageInfoPartsFragmentDoc}
${PostCountPartsFragmentDoc}
${TrendoneMacrotrendPartsFragmentDoc}`;

/**
 * __useMacrotrendTrendradarDetailQuery__
 *
 * To use a Smart Query within a Vue component, call `useMacrotrendTrendradarDetailQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     macrotrendTrendradarDetail: useMacrotrendTrendradarDetailQuery({
 *       variables: {
 *         id: // value for 'id'
 *         locale: // value for 'locale'
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *         width: // value for 'width'
 *         height: // value for 'height'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useMacrotrendTrendradarDetailQuery = createSmartQueryOptionsFunction<
  MacrotrendTrendradarDetailQuery,
  MacrotrendTrendradarDetailQueryVariables,
  ApolloError
>(MacrotrendTrendradarDetailDocument);

export const MacrotrendDetailViewDocument = gql`
    query MacrotrendDetailView($id: ID!, $locale: Locale!, $width: Int, $height: Int) {
  macrotrend: node(id: $id) {
    id
    ...ReducedMacrotrendParts
    ... on Macrotrend {
      ...TrendoneMacrotrendParts
      challengesAndOpportunities {
        id
        translations(locale: $locale) {
          locale
          title
          challenges
          opportunities
        }
        author
        createdOn
        deletable
        editable
      }
      drivers {
        translations(locale: $locale) {
          locale
          title
          description
        }
      }
      successor {
        id
      }
      evaluations {
        id
      }
      hasSubscription
      insider {
        user {
          id
          enabled
          firstName
          lastName
          email
          avatar
          jobPosition
        }
      }
      relatedMicrotrends(page: 1, pageSize: 1) {
        pageInfo {
          ...PaginatedPageInfoParts
        }
      }
      relatedMacrotrends(page: 1, pageSize: 40) {
        nodes {
          ...MacrotrendInterfaceParts
        }
      }
      innovationFields(page: 1, pageSize: 40) {
        nodes {
          id
          title
          image(width: 264, height: 200, resize: fill, gravity: sm)
        }
        pageInfo {
          ...PaginatedPageInfoParts
        }
      }
      innovationProjects(page: 1, pageSize: 40) {
        nodes {
          id
          title
          image(width: 264, height: 200, resize: fill, gravity: sm)
          state
        }
      }
      megatrend {
        id
        color
        translations(locale: $locale) {
          locale
          title
        }
        macrotrends {
          ...MacrotrendInterfaceParts
        }
      }
    }
    ... on CompanyMacrotrend {
      ...CompanyMacrotrendParts
      challengesAndOpportunities {
        id
        translations(locale: $locale) {
          locale
          title
          challenges
          opportunities
        }
        author
        createdOn
        deletable
        editable
      }
      drivers {
        translations(locale: $locale) {
          locale
          title
          description
        }
      }
      evaluations {
        id
      }
      hasSubscription
      insider {
        user {
          id
          enabled
          firstName
          lastName
          email
          avatar
          jobPosition
        }
      }
      relatedMicrotrends(page: 1, pageSize: 1) {
        pageInfo {
          ...PaginatedPageInfoParts
        }
      }
      relatedMacrotrends(page: 1, pageSize: 40) {
        nodes {
          ...MacrotrendInterfaceParts
        }
      }
      innovationFields(page: 1, pageSize: 40) {
        nodes {
          id
          title
          image(width: 264, height: 200, resize: fill, gravity: sm)
        }
        pageInfo {
          ...PaginatedPageInfoParts
        }
      }
      innovationProjects(page: 1, pageSize: 40) {
        nodes {
          id
          title
          image(width: 264, height: 200, resize: fill, gravity: sm)
          state
        }
      }
      megatrend {
        id
        color
        translations(locale: $locale) {
          locale
          title
        }
        macrotrends {
          ...MacrotrendInterfaceParts
        }
      }
    }
  }
}
    ${ReducedMacrotrendPartsFragmentDoc}
${TrendoneMacrotrendPartsFragmentDoc}
${PaginatedPageInfoPartsFragmentDoc}
${MacrotrendInterfacePartsFragmentDoc}
${CompanyMacrotrendPartsFragmentDoc}`;

/**
 * __useMacrotrendDetailViewQuery__
 *
 * To use a Smart Query within a Vue component, call `useMacrotrendDetailViewQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     macrotrendDetailView: useMacrotrendDetailViewQuery({
 *       variables: {
 *         id: // value for 'id'
 *         locale: // value for 'locale'
 *         width: // value for 'width'
 *         height: // value for 'height'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useMacrotrendDetailViewQuery = createSmartQueryOptionsFunction<
  MacrotrendDetailViewQuery,
  MacrotrendDetailViewQueryVariables,
  ApolloError
>(MacrotrendDetailViewDocument);

export const IntroducedMegatrendsDocument = gql`
    query introducedMegatrends($locale: Locale!) {
  introducedMegatrends {
    id
    image(width: 600, height: 300, resize: crop, gravity: ce)
    translations(locale: $locale) {
      title
      updateInfo
    }
  }
}
    `;

/**
 * __useIntroducedMegatrendsQuery__
 *
 * To use a Smart Query within a Vue component, call `useIntroducedMegatrendsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     introducedMegatrends: useIntroducedMegatrendsQuery({
 *       variables: {
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useIntroducedMegatrendsQuery = createSmartQueryOptionsFunction<
  IntroducedMegatrendsQuery,
  IntroducedMegatrendsQueryVariables,
  ApolloError
>(IntroducedMegatrendsDocument);

export const MegatrendRelatedMicrotrendsDocument = gql`
    query MegatrendRelatedMicrotrends($id: ID!, $page: Int!, $pageSize: Int!, $locale: Locale!, $width: Int, $height: Int) {
  megatrend: node(id: $id) {
    ... on MegatrendInterface {
      id
      relatedMicrotrends(page: $page, pageSize: $pageSize) {
        nodes {
          ...TrendoneMicrotrendParts
          ...CompanyMicrotrendParts
          ...ReducedMicrotrendParts
        }
        pageInfo {
          ...PaginatedPageInfoParts
        }
      }
    }
  }
}
    ${TrendoneMicrotrendPartsFragmentDoc}
${CompanyMicrotrendPartsFragmentDoc}
${ReducedMicrotrendPartsFragmentDoc}
${PaginatedPageInfoPartsFragmentDoc}`;

/**
 * __useMegatrendRelatedMicrotrendsQuery__
 *
 * To use a Smart Query within a Vue component, call `useMegatrendRelatedMicrotrendsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     megatrendRelatedMicrotrends: useMegatrendRelatedMicrotrendsQuery({
 *       variables: {
 *         id: // value for 'id'
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *         locale: // value for 'locale'
 *         width: // value for 'width'
 *         height: // value for 'height'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useMegatrendRelatedMicrotrendsQuery = createSmartQueryOptionsFunction<
  MegatrendRelatedMicrotrendsQuery,
  MegatrendRelatedMicrotrendsQueryVariables,
  ApolloError
>(MegatrendRelatedMicrotrendsDocument);

export const RevisedMegatrendsDocument = gql`
    query revisedMegatrends($locale: Locale!) {
  revisedMegatrends {
    id
    image(width: 600, height: 300, resize: crop, gravity: ce)
    translations(locale: $locale) {
      title
      updateInfo
    }
  }
}
    `;

/**
 * __useRevisedMegatrendsQuery__
 *
 * To use a Smart Query within a Vue component, call `useRevisedMegatrendsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     revisedMegatrends: useRevisedMegatrendsQuery({
 *       variables: {
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useRevisedMegatrendsQuery = createSmartQueryOptionsFunction<
  RevisedMegatrendsQuery,
  RevisedMegatrendsQueryVariables,
  ApolloError
>(RevisedMegatrendsDocument);

export const MegatrendSearchDocument = gql`
    query MegatrendSearch($query: String, $filter: SearchFiltersInput, $page: Int!, $pageSize: Int!, $locale: Locale!, $sort: MegatrendsSort, $width: Int, $height: Int) {
  search: search(query: $query, filter: $filter) {
    megatrends(page: $page, pageSize: $pageSize, sort: $sort) {
      pageInfo {
        ...PaginatedPageInfoParts
      }
      nodes {
        id
        color
        image(width: $width, height: $height, resize: fit)
        translations(locale: $locale) {
          ...MegatrendTranslationParts
        }
      }
    }
  }
}
    ${PaginatedPageInfoPartsFragmentDoc}
${MegatrendTranslationPartsFragmentDoc}`;

/**
 * __useMegatrendSearchQuery__
 *
 * To use a Smart Query within a Vue component, call `useMegatrendSearchQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     megatrendSearch: useMegatrendSearchQuery({
 *       variables: {
 *         query: // value for 'query'
 *         filter: // value for 'filter'
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *         locale: // value for 'locale'
 *         sort: // value for 'sort'
 *         width: // value for 'width'
 *         height: // value for 'height'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useMegatrendSearchQuery = createSmartQueryOptionsFunction<
  MegatrendSearchQuery,
  MegatrendSearchQueryVariables,
  ApolloError
>(MegatrendSearchDocument);

export const MegatrendDetailDocument = gql`
    query MegatrendDetail($id: ID!, $locale: Locale!, $width: Int, $height: Int) {
  megatrend: node(id: $id) {
    ... on MegatrendInterface {
      ...MegatrendParts
      macrotrends {
        ...MacrotrendInterfaceParts
      }
      relatedMicrotrends(page: 1, pageSize: 1) {
        pageInfo {
          ...PaginatedPageInfoParts
        }
      }
    }
  }
}
    ${MegatrendPartsFragmentDoc}
${MacrotrendInterfacePartsFragmentDoc}
${PaginatedPageInfoPartsFragmentDoc}`;

/**
 * __useMegatrendDetailQuery__
 *
 * To use a Smart Query within a Vue component, call `useMegatrendDetailQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     megatrendDetail: useMegatrendDetailQuery({
 *       variables: {
 *         id: // value for 'id'
 *         locale: // value for 'locale'
 *         width: // value for 'width'
 *         height: // value for 'height'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useMegatrendDetailQuery = createSmartQueryOptionsFunction<
  MegatrendDetailQuery,
  MegatrendDetailQueryVariables,
  ApolloError
>(MegatrendDetailDocument);

export const CreateUseCaseDocument = gql`
    mutation createUseCase($input: CreateMicrotrendUseCaseInput!) {
  microtrendUseCase {
    createUseCase(input: $input) {
      id
      title
      text
      author
      createdOn
      editable
      deletable
    }
  }
}
    `;

/**
 * __createUseCaseMutation__
 *
 * To run a mutation, you call `createUseCaseMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = createUseCaseMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export const createUseCaseMutation = createMutationFunction<
  CreateUseCaseMutation,
  CreateUseCaseMutationVariables,
  ApolloError
>(CreateUseCaseDocument);

export const DeleteUseCaseDocument = gql`
    mutation deleteUseCase($input: DeleteMicrotrendUseCaseInput!) {
  microtrendUseCase {
    deleteUseCase(input: $input)
  }
}
    `;

/**
 * __deleteUseCaseMutation__
 *
 * To run a mutation, you call `deleteUseCaseMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = deleteUseCaseMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export const deleteUseCaseMutation = createMutationFunction<
  DeleteUseCaseMutation,
  DeleteUseCaseMutationVariables,
  ApolloError
>(DeleteUseCaseDocument);

export const UpdateUseCaseDocument = gql`
    mutation updateUseCase($input: UpdateMicrotrendUseCaseInput!) {
  microtrendUseCase {
    updateUseCase(input: $input) {
      id
      title
      text
      author
      createdOn
      editable
      deletable
    }
  }
}
    `;

/**
 * __updateUseCaseMutation__
 *
 * To run a mutation, you call `updateUseCaseMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = updateUseCaseMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export const updateUseCaseMutation = createMutationFunction<
  UpdateUseCaseMutation,
  UpdateUseCaseMutationVariables,
  ApolloError
>(UpdateUseCaseDocument);

export const UseCasesDocument = gql`
    query useCases($id: ID!, $locale: Locale!) {
  node(id: $id) {
    ... on MicrotrendInterface {
      id
      useCases(locale: $locale) {
        id
        title
        text
        author
        createdOn
        editable
        deletable
      }
    }
  }
}
    `;

/**
 * __useUseCasesQuery__
 *
 * To use a Smart Query within a Vue component, call `useUseCasesQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     useCases: useUseCasesQuery({
 *       variables: {
 *         id: // value for 'id'
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useUseCasesQuery = createSmartQueryOptionsFunction<
  UseCasesQuery,
  UseCasesQueryVariables,
  ApolloError
>(UseCasesDocument);

export const AddMicrotrendQueryDocument = gql`
    query AddMicrotrendQuery($id: ID!, $locale: Locale!, $sort: WorkspaceSort) {
  trend: node(id: $id) {
    ... on MicrotrendInterface {
      id
      translations(locale: $locale) {
        title
      }
    }
  }
  workspaces: updateableWorkspaces(sort: $sort) {
    id
    title
    containsTrend(id: $id)
  }
}
    `;

/**
 * __useAddMicrotrendQueryQuery__
 *
 * To use a Smart Query within a Vue component, call `useAddMicrotrendQueryQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     addMicrotrendQuery: useAddMicrotrendQueryQuery({
 *       variables: {
 *         id: // value for 'id'
 *         locale: // value for 'locale'
 *         sort: // value for 'sort'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useAddMicrotrendQueryQuery = createSmartQueryOptionsFunction<
  AddMicrotrendQueryQuery,
  AddMicrotrendQueryQueryVariables,
  ApolloError
>(AddMicrotrendQueryDocument);

export const CountriesDocument = gql`
    query countries($locale: Locale!) {
  countries(page: 1, pageSize: 300, locale: $locale) {
    pageInfo {
      ...PaginatedPageInfoParts
    }
    nodes {
      id
      translations(locale: $locale) {
        locale
        title
      }
    }
  }
}
    ${PaginatedPageInfoPartsFragmentDoc}`;

/**
 * __useCountriesQuery__
 *
 * To use a Smart Query within a Vue component, call `useCountriesQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     countries: useCountriesQuery({
 *       variables: {
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useCountriesQuery = createSmartQueryOptionsFunction<
  CountriesQuery,
  CountriesQueryVariables,
  ApolloError
>(CountriesDocument);

export const MicrotrendsGalleryDocument = gql`
    query MicrotrendsGallery($query: String, $filter: SearchFiltersInput, $page: Int!, $pageSize: Int!, $locale: Locale!, $width: Int, $height: Int) {
  search: search(query: $query, filter: $filter) {
    microtrends(
      sort: {field: identifiedAt, direction: desc}
      page: $page
      pageSize: $pageSize
    ) {
      pageInfo {
        ...PaginatedPageInfoParts
      }
      nodes {
        ...ReducedMicrotrendParts
        ...CompanyMicrotrendParts
        ...TrendoneMicrotrendParts
      }
    }
  }
}
    ${PaginatedPageInfoPartsFragmentDoc}
${ReducedMicrotrendPartsFragmentDoc}
${CompanyMicrotrendPartsFragmentDoc}
${TrendoneMicrotrendPartsFragmentDoc}`;

/**
 * __useMicrotrendsGalleryQuery__
 *
 * To use a Smart Query within a Vue component, call `useMicrotrendsGalleryQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     microtrendsGallery: useMicrotrendsGalleryQuery({
 *       variables: {
 *         query: // value for 'query'
 *         filter: // value for 'filter'
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *         locale: // value for 'locale'
 *         width: // value for 'width'
 *         height: // value for 'height'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useMicrotrendsGalleryQuery = createSmartQueryOptionsFunction<
  MicrotrendsGalleryQuery,
  MicrotrendsGalleryQueryVariables,
  ApolloError
>(MicrotrendsGalleryDocument);

export const IndustriesDocument = gql`
    query industries($locale: Locale!) {
  industries {
    id
    translations(locale: $locale) {
      locale
      title
    }
  }
}
    `;

/**
 * __useIndustriesQuery__
 *
 * To use a Smart Query within a Vue component, call `useIndustriesQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     industries: useIndustriesQuery({
 *       variables: {
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useIndustriesQuery = createSmartQueryOptionsFunction<
  IndustriesQuery,
  IndustriesQueryVariables,
  ApolloError
>(IndustriesDocument);

export const InitiatorsDocument = gql`
    query initiators($filter: String) {
  initiators(page: 1, pageSize: 25, filter: $filter) {
    nodes {
      id
      title
    }
  }
}
    `;

/**
 * __useInitiatorsQuery__
 *
 * To use a Smart Query within a Vue component, call `useInitiatorsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     initiators: useInitiatorsQuery({
 *       variables: {
 *         filter: // value for 'filter'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useInitiatorsQuery = createSmartQueryOptionsFunction<
  InitiatorsQuery,
  InitiatorsQueryVariables,
  ApolloError
>(InitiatorsDocument);

export const InnovationTypesDocument = gql`
    query innovationTypes($locale: Locale!) {
  innovationTypes {
    nodes {
      id
      translations(locale: $locale) {
        locale
        title
      }
    }
  }
}
    `;

/**
 * __useInnovationTypesQuery__
 *
 * To use a Smart Query within a Vue component, call `useInnovationTypesQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     innovationTypes: useInnovationTypesQuery({
 *       variables: {
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useInnovationTypesQuery = createSmartQueryOptionsFunction<
  InnovationTypesQuery,
  InnovationTypesQueryVariables,
  ApolloError
>(InnovationTypesDocument);

export const MicrotrendsListDocument = gql`
    query MicrotrendsList($query: String, $filter: SearchFiltersInput, $page: Int!, $pageSize: Int!, $locale: Locale!, $sort: MicrotrendsSort, $width: Int, $height: Int) {
  search: search(query: $query, filter: $filter) {
    microtrends(page: $page, pageSize: $pageSize, sort: $sort) {
      pageInfo {
        ...PaginatedPageInfoParts
      }
      nodes {
        ...ReducedMicrotrendParts
        ... on CompanyMicrotrend {
          ...CompanyMicrotrendParts
          innovationTypes {
            id
            translations(locale: $locale) {
              locale
              title
            }
          }
          countries {
            code
            translations(locale: $locale) {
              locale
              title
            }
          }
          industries {
            id
            translations(locale: $locale) {
              locale
              title
            }
          }
          macrotrends {
            id
            color
            translations(locale: $locale) {
              title
            }
          }
          megatrends {
            id
            color
            translations(locale: $locale) {
              title
            }
          }
        }
        ... on Microtrend {
          ...TrendoneMicrotrendParts
          innovationTypes {
            id
            translations(locale: $locale) {
              locale
              title
            }
          }
          countries {
            code
            translations(locale: $locale) {
              locale
              title
            }
          }
          industries {
            id
            translations(locale: $locale) {
              locale
              title
            }
          }
          macrotrends {
            id
            color
            translations(locale: $locale) {
              title
            }
          }
          megatrends {
            id
            color
            translations(locale: $locale) {
              title
            }
          }
        }
      }
    }
  }
}
    ${PaginatedPageInfoPartsFragmentDoc}
${ReducedMicrotrendPartsFragmentDoc}
${CompanyMicrotrendPartsFragmentDoc}
${TrendoneMicrotrendPartsFragmentDoc}`;

/**
 * __useMicrotrendsListQuery__
 *
 * To use a Smart Query within a Vue component, call `useMicrotrendsListQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     microtrendsList: useMicrotrendsListQuery({
 *       variables: {
 *         query: // value for 'query'
 *         filter: // value for 'filter'
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *         locale: // value for 'locale'
 *         sort: // value for 'sort'
 *         width: // value for 'width'
 *         height: // value for 'height'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useMicrotrendsListQuery = createSmartQueryOptionsFunction<
  MicrotrendsListQuery,
  MicrotrendsListQueryVariables,
  ApolloError
>(MicrotrendsListDocument);

export const MicrotrendPinDocument = gql`
    query MicrotrendPin($id: ID!, $locale: Locale!) {
  microtrend: node(id: $id) {
    ... on Microtrend {
      id
      translations(locale: $locale) {
        locale
        title
      }
      pins {
        id
        macrotrend {
          id
          translations(locale: $locale) {
            title
          }
        }
      }
    }
    ... on CompanyMicrotrend {
      id
      translations(locale: $locale) {
        locale
        title
      }
      pins {
        id
        macrotrend {
          id
          translations(locale: $locale) {
            title
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMicrotrendPinQuery__
 *
 * To use a Smart Query within a Vue component, call `useMicrotrendPinQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     microtrendPin: useMicrotrendPinQuery({
 *       variables: {
 *         id: // value for 'id'
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useMicrotrendPinQuery = createSmartQueryOptionsFunction<
  MicrotrendPinQuery,
  MicrotrendPinQueryVariables,
  ApolloError
>(MicrotrendPinDocument);

export const ScrapedInfosDocument = gql`
    query scrapedInfos($url: String!) {
  scrapedInfos(url: $url) {
    url
    language
    title
    description
    image
  }
}
    `;

/**
 * __useScrapedInfosQuery__
 *
 * To use a Smart Query within a Vue component, call `useScrapedInfosQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     scrapedInfos: useScrapedInfosQuery({
 *       variables: {
 *         url: // value for 'url'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useScrapedInfosQuery = createSmartQueryOptionsFunction<
  ScrapedInfosQuery,
  ScrapedInfosQueryVariables,
  ApolloError
>(ScrapedInfosDocument);

export const MicrotrendDetailDocument = gql`
    query MicrotrendDetail($id: ID!, $page: Int!, $pageSize: Int!, $locale: Locale!, $width: Int, $height: Int) {
  microtrend: node(id: $id) {
    ... on CompanyMicrotrend {
      ...CompanyMicrotrendParts
      publicUrl
      pins {
        id
        macrotrend {
          id
        }
      }
      megatrends {
        id
        color
        translations(locale: $locale) {
          ...MegatrendTranslationParts
        }
      }
      innovationTypes {
        ...InnovationTypeParts
      }
      industries {
        ...IndustryParts
      }
      countries {
        ...CountryParts
      }
      relatedMicrotrends(page: $page, pageSize: $pageSize) {
        nodes {
          ...MicrotrendInterfaceParts
        }
      }
      macrotrends {
        ...MacrotrendInterfaceParts
      }
    }
    ... on Microtrend {
      ...TrendoneMicrotrendParts
      publicUrl
      megatrends {
        id
        color
        translations(locale: $locale) {
          ...MegatrendTranslationParts
        }
      }
      innovationTypes {
        ...InnovationTypeParts
      }
      industries {
        ...IndustryParts
      }
      countries {
        ...CountryParts
      }
      relatedMicrotrends(page: $page, pageSize: $pageSize) {
        nodes {
          ...MicrotrendInterfaceParts
        }
      }
      macrotrends {
        ...MacrotrendInterfaceParts
      }
    }
    ... on ReducedMicrotrend {
      ...ReducedMicrotrendParts
    }
  }
}
    ${CompanyMicrotrendPartsFragmentDoc}
${MegatrendTranslationPartsFragmentDoc}
${InnovationTypePartsFragmentDoc}
${IndustryPartsFragmentDoc}
${CountryPartsFragmentDoc}
${MicrotrendInterfacePartsFragmentDoc}
${MacrotrendInterfacePartsFragmentDoc}
${TrendoneMicrotrendPartsFragmentDoc}
${ReducedMicrotrendPartsFragmentDoc}`;

/**
 * __useMicrotrendDetailQuery__
 *
 * To use a Smart Query within a Vue component, call `useMicrotrendDetailQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     microtrendDetail: useMicrotrendDetailQuery({
 *       variables: {
 *         id: // value for 'id'
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *         locale: // value for 'locale'
 *         width: // value for 'width'
 *         height: // value for 'height'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useMicrotrendDetailQuery = createSmartQueryOptionsFunction<
  MicrotrendDetailQuery,
  MicrotrendDetailQueryVariables,
  ApolloError
>(MicrotrendDetailDocument);

export const EvaluateMacrotrendDocument = gql`
    mutation evaluateMacrotrend($input: EvaluateMacrotrendInput!, $locale: Locale) {
  evaluateMacrotrend(input: $input) {
    id
    title
    description
    evaluations {
      id
      macrotrend {
        ... on MacrotrendInterface {
          id
          color
          translations(locale: $locale) {
            locale
            title
          }
          megatrend {
            id
            color
            translations(locale: $locale) {
              title
            }
          }
        }
      }
      evaluation {
        id
        values {
          criteria {
            ...CriteriaParts
          }
          value
        }
        recommendedAction
        readinessAssessment
      }
    }
  }
}
    ${CriteriaPartsFragmentDoc}`;

/**
 * __evaluateMacrotrendMutation__
 *
 * To run a mutation, you call `evaluateMacrotrendMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = evaluateMacrotrendMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *     locale: // value for 'locale'
 *   },
 * });
 */
export const evaluateMacrotrendMutation = createMutationFunction<
  EvaluateMacrotrendMutation,
  EvaluateMacrotrendMutationVariables,
  ApolloError
>(EvaluateMacrotrendDocument);

export const DeletePostDocument = gql`
    mutation deletePost($id: ID!) {
  post(id: $id) {
    delete
  }
}
    `;

/**
 * __deletePostMutation__
 *
 * To run a mutation, you call `deletePostMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = deletePostMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export const deletePostMutation = createMutationFunction<
  DeletePostMutation,
  DeletePostMutationVariables,
  ApolloError
>(DeletePostDocument);

export const CreatePostInnovationProjectDocument = gql`
    mutation createPostInnovationProject($input: CreatePostInput!) {
  createPost(input: $input) {
    id
    title
    body
    node {
      id
    }
    createdAt
    updatedAt
    owner {
      id
      email
      firstName
      lastName
      avatar
      enabled
    }
  }
}
    `;

/**
 * __createPostInnovationProjectMutation__
 *
 * To run a mutation, you call `createPostInnovationProjectMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = createPostInnovationProjectMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export const createPostInnovationProjectMutation = createMutationFunction<
  CreatePostInnovationProjectMutation,
  CreatePostInnovationProjectMutationVariables,
  ApolloError
>(CreatePostInnovationProjectDocument);

export const UpdatePostDocument = gql`
    mutation updatePost($id: ID!, $input: UpdatePostInput!) {
  post(id: $id) {
    update(input: $input) {
      id
      title
      body
      createdAt
      updatedAt
      owner {
        id
        email
        firstName
        lastName
        avatar
        enabled
      }
    }
  }
}
    `;

/**
 * __updatePostMutation__
 *
 * To run a mutation, you call `updatePostMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = updatePostMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export const updatePostMutation = createMutationFunction<
  UpdatePostMutation,
  UpdatePostMutationVariables,
  ApolloError
>(UpdatePostDocument);

export const CreatePostsDocument = gql`
    mutation createPosts($input: CreatePostsInput!) {
  createPosts(input: $input) {
    id
    title
    body
    createdAt
    updatedAt
    node {
      id
    }
    owner {
      id
      email
      firstName
      lastName
      avatar
      enabled
    }
  }
}
    `;

/**
 * __createPostsMutation__
 *
 * To run a mutation, you call `createPostsMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = createPostsMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export const createPostsMutation = createMutationFunction<
  CreatePostsMutation,
  CreatePostsMutationVariables,
  ApolloError
>(CreatePostsDocument);

export const CreatePostDocument = gql`
    mutation createPost($input: CreatePostInput!) {
  createPost(input: $input) {
    id
    title
    body
    createdAt
    updatedAt
    node {
      id
    }
    owner {
      id
      email
      firstName
      lastName
      avatar
      enabled
    }
  }
}
    `;

/**
 * __createPostMutation__
 *
 * To run a mutation, you call `createPostMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = createPostMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export const createPostMutation = createMutationFunction<
  CreatePostMutation,
  CreatePostMutationVariables,
  ApolloError
>(CreatePostDocument);

export const InnovationFieldPostsDocument = gql`
    query InnovationFieldPosts($id: ID!, $locale: Locale!, $category: PostCategory!, $page: Int, $pageSize: Int) {
  node(id: $id) {
    ... on InnovationField {
      id
      posts(category: $category, page: $page, pageSize: $pageSize) {
        nodes {
          ...PostParts
          node {
            id
            ... on MacrotrendInterface {
              translations(locale: $locale) {
                title
              }
              megatrend {
                id
                color
              }
            }
          }
          owner {
            ...DiscussionUserParts
          }
          comments {
            ...CommentParts
            owner {
              ...DiscussionUserParts
            }
          }
        }
        pageInfo {
          ...PaginatedPageInfoParts
        }
      }
      extendedSources: posts(category: extendedSources) {
        pageInfo {
          totalCount
        }
      }
      chances: posts(category: chances) {
        pageInfo {
          totalCount
        }
      }
      risks: posts(category: risks) {
        pageInfo {
          totalCount
        }
      }
    }
  }
}
    ${PostPartsFragmentDoc}
${DiscussionUserPartsFragmentDoc}
${CommentPartsFragmentDoc}
${PaginatedPageInfoPartsFragmentDoc}`;

/**
 * __useInnovationFieldPostsQuery__
 *
 * To use a Smart Query within a Vue component, call `useInnovationFieldPostsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     innovationFieldPosts: useInnovationFieldPostsQuery({
 *       variables: {
 *         id: // value for 'id'
 *         locale: // value for 'locale'
 *         category: // value for 'category'
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useInnovationFieldPostsQuery = createSmartQueryOptionsFunction<
  InnovationFieldPostsQuery,
  InnovationFieldPostsQueryVariables,
  ApolloError
>(InnovationFieldPostsDocument);

export const InnovationProjectPostsDocument = gql`
    query InnovationProjectPosts($id: ID!, $page: Int, $pageSize: Int) {
  node(id: $id) {
    ... on InnovationProject {
      id
      posts(category: updates, page: $page, pageSize: $pageSize) {
        nodes {
          ...PostParts
          owner {
            ...DiscussionUserParts
          }
          comments {
            ...CommentParts
            owner {
              ...DiscussionUserParts
            }
          }
          node {
            ... on InnovationProject {
              id
              title
            }
          }
        }
        pageInfo {
          ...PaginatedPageInfoParts
        }
      }
      updates: posts(category: updates) {
        pageInfo {
          totalCount
        }
      }
    }
  }
}
    ${PostPartsFragmentDoc}
${DiscussionUserPartsFragmentDoc}
${CommentPartsFragmentDoc}
${PaginatedPageInfoPartsFragmentDoc}`;

/**
 * __useInnovationProjectPostsQuery__
 *
 * To use a Smart Query within a Vue component, call `useInnovationProjectPostsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     innovationProjectPosts: useInnovationProjectPostsQuery({
 *       variables: {
 *         id: // value for 'id'
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useInnovationProjectPostsQuery = createSmartQueryOptionsFunction<
  InnovationProjectPostsQuery,
  InnovationProjectPostsQueryVariables,
  ApolloError
>(InnovationProjectPostsDocument);

export const MacrotrendPostsDocument = gql`
    query MacrotrendPosts($id: ID!, $category: PostCategory!, $page: Int, $pageSize: Int, $locale: Locale, $width: Int, $height: Int) {
  macrotrend: node(id: $id) {
    id
    ... on CompanyMacrotrend {
      id
      color
      posts(category: $category, page: $page, pageSize: $pageSize) {
        pageInfo {
          ...PaginatedPageInfoParts
        }
        nodes {
          ...PostParts
          node {
            ...MacrotrendInterfaceParts
          }
          owner {
            ...DiscussionUserParts
          }
          comments {
            ...CommentParts
            owner {
              ...DiscussionUserParts
            }
          }
        }
      }
      extendedSources: posts(category: extendedSources) {
        pageInfo {
          totalCount
        }
      }
      chances: posts(category: chances) {
        pageInfo {
          totalCount
        }
      }
      risks: posts(category: risks) {
        pageInfo {
          totalCount
        }
      }
    }
    ... on Macrotrend {
      id
      color
      posts(category: $category, page: $page, pageSize: $pageSize) {
        pageInfo {
          ...PaginatedPageInfoParts
        }
        nodes {
          ...PostParts
          node {
            ...MacrotrendInterfaceParts
          }
          owner {
            ...DiscussionUserParts
          }
          comments {
            ...CommentParts
            owner {
              ...DiscussionUserParts
            }
          }
        }
      }
      extendedSources: posts(category: extendedSources) {
        pageInfo {
          totalCount
        }
      }
      chances: posts(category: chances) {
        pageInfo {
          totalCount
        }
      }
      risks: posts(category: risks) {
        pageInfo {
          totalCount
        }
      }
    }
  }
}
    ${PaginatedPageInfoPartsFragmentDoc}
${PostPartsFragmentDoc}
${MacrotrendInterfacePartsFragmentDoc}
${DiscussionUserPartsFragmentDoc}
${CommentPartsFragmentDoc}`;

/**
 * __useMacrotrendPostsQuery__
 *
 * To use a Smart Query within a Vue component, call `useMacrotrendPostsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     macrotrendPosts: useMacrotrendPostsQuery({
 *       variables: {
 *         id: // value for 'id'
 *         category: // value for 'category'
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *         locale: // value for 'locale'
 *         width: // value for 'width'
 *         height: // value for 'height'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useMacrotrendPostsQuery = createSmartQueryOptionsFunction<
  MacrotrendPostsQuery,
  MacrotrendPostsQueryVariables,
  ApolloError
>(MacrotrendPostsDocument);

export const MegatrendPostsDocument = gql`
    query MegatrendPosts($id: ID!, $locale: Locale!, $category: PostCategory!, $page: Int, $pageSize: Int) {
  node(id: $id) {
    ... on MegatrendInterface {
      id
      posts(category: $category, page: $page, pageSize: $pageSize) {
        nodes {
          ...PostParts
          node {
            id
            ... on MacrotrendInterface {
              translations(locale: $locale) {
                title
              }
              megatrend {
                id
                color
              }
            }
          }
          owner {
            ...DiscussionUserParts
          }
          comments {
            ...CommentParts
            owner {
              ...DiscussionUserParts
            }
          }
        }
        pageInfo {
          ...PaginatedPageInfoParts
        }
      }
      extendedSources: posts(category: extendedSources) {
        pageInfo {
          totalCount
        }
      }
      chances: posts(category: chances) {
        pageInfo {
          totalCount
        }
      }
      risks: posts(category: risks) {
        pageInfo {
          totalCount
        }
      }
    }
  }
}
    ${PostPartsFragmentDoc}
${DiscussionUserPartsFragmentDoc}
${CommentPartsFragmentDoc}
${PaginatedPageInfoPartsFragmentDoc}`;

/**
 * __useMegatrendPostsQuery__
 *
 * To use a Smart Query within a Vue component, call `useMegatrendPostsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     megatrendPosts: useMegatrendPostsQuery({
 *       variables: {
 *         id: // value for 'id'
 *         locale: // value for 'locale'
 *         category: // value for 'category'
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useMegatrendPostsQuery = createSmartQueryOptionsFunction<
  MegatrendPostsQuery,
  MegatrendPostsQueryVariables,
  ApolloError
>(MegatrendPostsDocument);

export const TrendradarPostsDocument = gql`
    query TrendradarPosts($id: ID!, $locale: Locale!, $action: RecommendedActionValues!, $category: PostCategory!, $page: Int, $pageSize: Int) {
  node(id: $id) {
    ... on PublishedTrendRadar {
      id
      title
      posts(
        recommendedAction: $action
        category: $category
        page: $page
        pageSize: $pageSize
      ) {
        pageInfo {
          ...PaginatedPageInfoParts
        }
        nodes {
          ...PostParts
          owner {
            ...DiscussionUserParts
          }
          comments {
            ...CommentParts
            owner {
              ...DiscussionUserParts
            }
          }
          node {
            id
            ... on MacrotrendInterface {
              translations(locale: $locale) {
                title
              }
              megatrend {
                id
                color
              }
            }
          }
        }
      }
    }
  }
}
    ${PaginatedPageInfoPartsFragmentDoc}
${PostPartsFragmentDoc}
${DiscussionUserPartsFragmentDoc}
${CommentPartsFragmentDoc}`;

/**
 * __useTrendradarPostsQuery__
 *
 * To use a Smart Query within a Vue component, call `useTrendradarPostsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     trendradarPosts: useTrendradarPostsQuery({
 *       variables: {
 *         id: // value for 'id'
 *         locale: // value for 'locale'
 *         action: // value for 'action'
 *         category: // value for 'category'
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useTrendradarPostsQuery = createSmartQueryOptionsFunction<
  TrendradarPostsQuery,
  TrendradarPostsQueryVariables,
  ApolloError
>(TrendradarPostsDocument);

export const DeletePublicEvaluationLogoDocument = gql`
    mutation deletePublicEvaluationLogo($trendRadarId: ID!, $panelId: ID!) {
  trendRadar(id: $trendRadarId) {
    panel(id: $panelId) {
      publicEvaluationOption {
        deletePublicEvaluationLogo {
          ...PublicEvaluationOptionParts
        }
      }
    }
  }
}
    ${PublicEvaluationOptionPartsFragmentDoc}`;

/**
 * __deletePublicEvaluationLogoMutation__
 *
 * To run a mutation, you call `deletePublicEvaluationLogoMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = deletePublicEvaluationLogoMutation(this, {
 *   variables: {
 *     trendRadarId: // value for 'trendRadarId'
 *     panelId: // value for 'panelId'
 *   },
 * });
 */
export const deletePublicEvaluationLogoMutation = createMutationFunction<
  DeletePublicEvaluationLogoMutation,
  DeletePublicEvaluationLogoMutationVariables,
  ApolloError
>(DeletePublicEvaluationLogoDocument);

export const DeletePanelPublicParticipationsDocument = gql`
    mutation deletePanelPublicParticipations($trendRadarId: ID!, $panelId: ID!) {
  trendRadar(id: $trendRadarId) {
    panel(id: $panelId) {
      publicEvaluationOption {
        deleteParticipations {
          ...PublicEvaluationOptionParts
        }
      }
    }
  }
}
    ${PublicEvaluationOptionPartsFragmentDoc}`;

/**
 * __deletePanelPublicParticipationsMutation__
 *
 * To run a mutation, you call `deletePanelPublicParticipationsMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = deletePanelPublicParticipationsMutation(this, {
 *   variables: {
 *     trendRadarId: // value for 'trendRadarId'
 *     panelId: // value for 'panelId'
 *   },
 * });
 */
export const deletePanelPublicParticipationsMutation = createMutationFunction<
  DeletePanelPublicParticipationsMutation,
  DeletePanelPublicParticipationsMutationVariables,
  ApolloError
>(DeletePanelPublicParticipationsDocument);

export const SetPanelPublicEvaluationOptionEnabledDocument = gql`
    mutation setPanelPublicEvaluationOptionEnabled($trendRadarId: ID!, $panelId: ID!, $enabled: Boolean!) {
  trendRadar(id: $trendRadarId) {
    panel(id: $panelId) {
      publicEvaluationOption {
        setEnabled(enabled: $enabled) {
          id
          enabled
        }
      }
    }
  }
}
    `;

/**
 * __setPanelPublicEvaluationOptionEnabledMutation__
 *
 * To run a mutation, you call `setPanelPublicEvaluationOptionEnabledMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = setPanelPublicEvaluationOptionEnabledMutation(this, {
 *   variables: {
 *     trendRadarId: // value for 'trendRadarId'
 *     panelId: // value for 'panelId'
 *     enabled: // value for 'enabled'
 *   },
 * });
 */
export const setPanelPublicEvaluationOptionEnabledMutation = createMutationFunction<
  SetPanelPublicEvaluationOptionEnabledMutation,
  SetPanelPublicEvaluationOptionEnabledMutationVariables,
  ApolloError
>(SetPanelPublicEvaluationOptionEnabledDocument);

export const SetPanelPublicEvaluationOptionFeedbackEnabledDocument = gql`
    mutation setPanelPublicEvaluationOptionFeedbackEnabled($trendRadarId: ID!, $panelId: ID!, $enabled: Boolean!) {
  trendRadar(id: $trendRadarId) {
    panel(id: $panelId) {
      publicEvaluationOption {
        setFeedbackEnabled(enabled: $enabled) {
          ...PublicEvaluationOptionParts
        }
      }
    }
  }
}
    ${PublicEvaluationOptionPartsFragmentDoc}`;

/**
 * __setPanelPublicEvaluationOptionFeedbackEnabledMutation__
 *
 * To run a mutation, you call `setPanelPublicEvaluationOptionFeedbackEnabledMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = setPanelPublicEvaluationOptionFeedbackEnabledMutation(this, {
 *   variables: {
 *     trendRadarId: // value for 'trendRadarId'
 *     panelId: // value for 'panelId'
 *     enabled: // value for 'enabled'
 *   },
 * });
 */
export const setPanelPublicEvaluationOptionFeedbackEnabledMutation = createMutationFunction<
  SetPanelPublicEvaluationOptionFeedbackEnabledMutation,
  SetPanelPublicEvaluationOptionFeedbackEnabledMutationVariables,
  ApolloError
>(SetPanelPublicEvaluationOptionFeedbackEnabledDocument);

export const UpdateFeedbackIntroTextDocument = gql`
    mutation updateFeedbackIntroText($trendRadarId: ID!, $panelId: ID!, $input: UpdateFeedbackIntroTextInput!) {
  trendRadar(id: $trendRadarId) {
    panel(id: $panelId) {
      publicEvaluationOption {
        updateFeedbackIntroText(input: $input) {
          ...PublicEvaluationOptionParts
        }
      }
    }
  }
}
    ${PublicEvaluationOptionPartsFragmentDoc}`;

/**
 * __updateFeedbackIntroTextMutation__
 *
 * To run a mutation, you call `updateFeedbackIntroTextMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = updateFeedbackIntroTextMutation(this, {
 *   variables: {
 *     trendRadarId: // value for 'trendRadarId'
 *     panelId: // value for 'panelId'
 *     input: // value for 'input'
 *   },
 * });
 */
export const updateFeedbackIntroTextMutation = createMutationFunction<
  UpdateFeedbackIntroTextMutation,
  UpdateFeedbackIntroTextMutationVariables,
  ApolloError
>(UpdateFeedbackIntroTextDocument);

export const UpdatePanelPublicEvaluationIntroTranslationsDocument = gql`
    mutation updatePanelPublicEvaluationIntroTranslations($trendRadarId: ID!, $panelId: ID!, $input: PublicEvaluationOptionIntroTranslationsInput!) {
  trendRadar(id: $trendRadarId) {
    panel(id: $panelId) {
      publicEvaluationOption {
        updateIntroTranslations(input: $input) {
          ...PublicEvaluationOptionParts
        }
      }
    }
  }
}
    ${PublicEvaluationOptionPartsFragmentDoc}`;

/**
 * __updatePanelPublicEvaluationIntroTranslationsMutation__
 *
 * To run a mutation, you call `updatePanelPublicEvaluationIntroTranslationsMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = updatePanelPublicEvaluationIntroTranslationsMutation(this, {
 *   variables: {
 *     trendRadarId: // value for 'trendRadarId'
 *     panelId: // value for 'panelId'
 *     input: // value for 'input'
 *   },
 * });
 */
export const updatePanelPublicEvaluationIntroTranslationsMutation = createMutationFunction<
  UpdatePanelPublicEvaluationIntroTranslationsMutation,
  UpdatePanelPublicEvaluationIntroTranslationsMutationVariables,
  ApolloError
>(UpdatePanelPublicEvaluationIntroTranslationsDocument);

export const UpdatePublicEvaluationLogoDocument = gql`
    mutation updatePublicEvaluationLogo($trendRadarId: ID!, $panelId: ID!, $logo: FileUpload!) {
  trendRadar(id: $trendRadarId) {
    panel(id: $panelId) {
      publicEvaluationOption {
        updatePublicEvaluationLogo(logo: $logo) {
          ...PublicEvaluationOptionParts
        }
      }
    }
  }
}
    ${PublicEvaluationOptionPartsFragmentDoc}`;

/**
 * __updatePublicEvaluationLogoMutation__
 *
 * To run a mutation, you call `updatePublicEvaluationLogoMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = updatePublicEvaluationLogoMutation(this, {
 *   variables: {
 *     trendRadarId: // value for 'trendRadarId'
 *     panelId: // value for 'panelId'
 *     logo: // value for 'logo'
 *   },
 * });
 */
export const updatePublicEvaluationLogoMutation = createMutationFunction<
  UpdatePublicEvaluationLogoMutation,
  UpdatePublicEvaluationLogoMutationVariables,
  ApolloError
>(UpdatePublicEvaluationLogoDocument);

export const CreateSearchAgentDocument = gql`
    mutation CreateSearchAgent($input: CreateSearchAgentInput!) {
  createSearchAgent(input: $input) {
    id
    title
    workspaces {
      id
      title
    }
  }
}
    `;

/**
 * __createSearchAgentMutation__
 *
 * To run a mutation, you call `createSearchAgentMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = createSearchAgentMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export const createSearchAgentMutation = createMutationFunction<
  CreateSearchAgentMutation,
  CreateSearchAgentMutationVariables,
  ApolloError
>(CreateSearchAgentDocument);

export const DeleteSearchAgentDocument = gql`
    mutation deleteSearchAgent($workspaceId: ID!, $searchAgentId: ID!) {
  workspace(id: $workspaceId) {
    removeSearchAgent(id: $searchAgentId) {
      id
    }
  }
}
    `;

/**
 * __deleteSearchAgentMutation__
 *
 * To run a mutation, you call `deleteSearchAgentMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = deleteSearchAgentMutation(this, {
 *   variables: {
 *     workspaceId: // value for 'workspaceId'
 *     searchAgentId: // value for 'searchAgentId'
 *   },
 * });
 */
export const deleteSearchAgentMutation = createMutationFunction<
  DeleteSearchAgentMutation,
  DeleteSearchAgentMutationVariables,
  ApolloError
>(DeleteSearchAgentDocument);

export const UpdateSearchAgentDocument = gql`
    mutation UpdateSearchAgent($input: UpdateSearchAgentInput!, $locale: Locale, $workspaceId: ID!) {
  updateSearchAgent(input: $input) {
    ...SearchAgentParts
  }
}
    ${SearchAgentPartsFragmentDoc}`;

/**
 * __updateSearchAgentMutation__
 *
 * To run a mutation, you call `updateSearchAgentMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = updateSearchAgentMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *     locale: // value for 'locale'
 *     workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export const updateSearchAgentMutation = createMutationFunction<
  UpdateSearchAgentMutation,
  UpdateSearchAgentMutationVariables,
  ApolloError
>(UpdateSearchAgentDocument);

export const DetailsDocument = gql`
    query details($id: ID!, $workspaceId: ID!, $locale: Locale) {
  searchAgent: node(id: $id) {
    ...SearchAgentParts
  }
}
    ${SearchAgentPartsFragmentDoc}`;

/**
 * __useDetailsQuery__
 *
 * To use a Smart Query within a Vue component, call `useDetailsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     details: useDetailsQuery({
 *       variables: {
 *         id: // value for 'id'
 *         workspaceId: // value for 'workspaceId'
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useDetailsQuery = createSmartQueryOptionsFunction<
  DetailsQuery,
  DetailsQueryVariables,
  ApolloError
>(DetailsDocument);

export const MicrotrendQueryComfortDocument = gql`
    query MicrotrendQueryComfort($id: ID!, $workspaceId: ID!, $type: SearchAgentTrendType, $page: Int, $pageSize: Int, $locale: Locale!, $width: Int, $height: Int) {
  searchAgent: node(id: $id) {
    ... on SearchAgent {
      id
      title
      trendCounts(workspaceId: $workspaceId) {
        new
        unvoted
        accepted
        rejected
      }
      trends(type: $type, workspaceId: $workspaceId, page: $page, pageSize: $pageSize) {
        pageInfo {
          currentPage
          totalPages
          pageSize
          totalCount
        }
        nodes {
          microtrend {
            ... on CompanyMicrotrend {
              ...CompanyMicrotrendParts
              innovationTypes {
                ...InnovationTypeParts
              }
              industries {
                ...IndustryParts
              }
              countries {
                ...CountryParts
              }
              macrotrends {
                ...MacrotrendInterfaceParts
              }
              megatrends {
                id
                color
                translations(locale: $locale) {
                  ...MegatrendTranslationParts
                }
              }
              relatedMicrotrends(page: $page, pageSize: $pageSize) {
                nodes {
                  ...MicrotrendInterfaceParts
                }
              }
            }
            ... on Microtrend {
              ...TrendoneMicrotrendParts
              innovationTypes {
                ...InnovationTypeParts
              }
              industries {
                ...IndustryParts
              }
              countries {
                ...CountryParts
              }
              macrotrends {
                ...MacrotrendInterfaceParts
              }
              megatrends {
                id
                color
                translations(locale: $locale) {
                  ...MegatrendTranslationParts
                }
              }
              relatedMicrotrends(page: 1, pageSize: 24) {
                nodes {
                  ...MicrotrendInterfaceParts
                }
              }
            }
          }
          new
        }
      }
    }
  }
}
    ${CompanyMicrotrendPartsFragmentDoc}
${InnovationTypePartsFragmentDoc}
${IndustryPartsFragmentDoc}
${CountryPartsFragmentDoc}
${MacrotrendInterfacePartsFragmentDoc}
${MegatrendTranslationPartsFragmentDoc}
${MicrotrendInterfacePartsFragmentDoc}
${TrendoneMicrotrendPartsFragmentDoc}`;

/**
 * __useMicrotrendQueryComfortQuery__
 *
 * To use a Smart Query within a Vue component, call `useMicrotrendQueryComfortQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     microtrendQueryComfort: useMicrotrendQueryComfortQuery({
 *       variables: {
 *         id: // value for 'id'
 *         workspaceId: // value for 'workspaceId'
 *         type: // value for 'type'
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *         locale: // value for 'locale'
 *         width: // value for 'width'
 *         height: // value for 'height'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useMicrotrendQueryComfortQuery = createSmartQueryOptionsFunction<
  MicrotrendQueryComfortQuery,
  MicrotrendQueryComfortQueryVariables,
  ApolloError
>(MicrotrendQueryComfortDocument);

export const MicrotrendsTotalCountDocument = gql`
    query microtrendsTotalCount($query: String, $filter: SearchFiltersInput, $pageSize: Int) {
  search(query: $query, filter: $filter) {
    microtrends(pageSize: $pageSize) {
      pageInfo {
        totalCount
      }
    }
  }
}
    `;

/**
 * __useMicrotrendsTotalCountQuery__
 *
 * To use a Smart Query within a Vue component, call `useMicrotrendsTotalCountQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     microtrendsTotalCount: useMicrotrendsTotalCountQuery({
 *       variables: {
 *         query: // value for 'query'
 *         filter: // value for 'filter'
 *         pageSize: // value for 'pageSize'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useMicrotrendsTotalCountQuery = createSmartQueryOptionsFunction<
  MicrotrendsTotalCountQuery,
  MicrotrendsTotalCountQueryVariables,
  ApolloError
>(MicrotrendsTotalCountDocument);

export const MicrotrendQueryDocument = gql`
    query MicrotrendQuery($id: ID!, $workspaceId: ID!, $type: SearchAgentTrendType, $page: Int, $pageSize: Int, $locale: Locale) {
  node(id: $id) {
    ... on SearchAgent {
      id
      title
      trendCounts(workspaceId: $workspaceId) {
        new
        unvoted
        accepted
        rejected
      }
      trends(type: $type, workspaceId: $workspaceId, page: $page, pageSize: $pageSize) {
        pageInfo {
          currentPage
          totalPages
          pageSize
          totalCount
        }
        nodes {
          microtrend {
            id
            images
            identifiedAt
            translations(locale: $locale) {
              title
              description
              locale
            }
          }
          new
        }
      }
    }
  }
}
    `;

/**
 * __useMicrotrendQueryQuery__
 *
 * To use a Smart Query within a Vue component, call `useMicrotrendQueryQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     microtrendQuery: useMicrotrendQueryQuery({
 *       variables: {
 *         id: // value for 'id'
 *         workspaceId: // value for 'workspaceId'
 *         type: // value for 'type'
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useMicrotrendQueryQuery = createSmartQueryOptionsFunction<
  MicrotrendQueryQuery,
  MicrotrendQueryQueryVariables,
  ApolloError
>(MicrotrendQueryDocument);

export const SearchCountTestSearchDocument = gql`
    query SearchCountTestSearch($query: String, $filter: SearchFiltersInput) {
  cnt: directSearch(query: $query, filter: $filter) {
    microtrends {
      pageInfo {
        ...PaginatedPageInfoParts
      }
    }
    macrotrends {
      pageInfo {
        ...PaginatedPageInfoParts
      }
    }
    megatrends {
      pageInfo {
        ...PaginatedPageInfoParts
      }
    }
  }
}
    ${PaginatedPageInfoPartsFragmentDoc}`;

/**
 * __useSearchCountTestSearchQuery__
 *
 * To use a Smart Query within a Vue component, call `useSearchCountTestSearchQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     searchCountTestSearch: useSearchCountTestSearchQuery({
 *       variables: {
 *         query: // value for 'query'
 *         filter: // value for 'filter'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useSearchCountTestSearchQuery = createSmartQueryOptionsFunction<
  SearchCountTestSearchQuery,
  SearchCountTestSearchQueryVariables,
  ApolloError
>(SearchCountTestSearchDocument);

export const MacrotrendTestSearchDocument = gql`
    query MacrotrendTestSearch($query: String, $filter: SearchFiltersInput, $page: Int!, $pageSize: Int!, $locale: Locale!, $sort: MacrotrendsSort, $width: Int, $height: Int) {
  search: directSearch(query: $query, filter: $filter) {
    macrotrends(page: $page, pageSize: $pageSize, sort: $sort) {
      pageInfo {
        ...PaginatedPageInfoParts
      }
      nodes {
        id
        image(width: $width, height: $height, resize: fit)
        translations(locale: $locale) {
          ...MacrotrendTranslationParts
        }
        megatrend {
          ...MegatrendParts
        }
      }
    }
  }
}
    ${PaginatedPageInfoPartsFragmentDoc}
${MacrotrendTranslationPartsFragmentDoc}
${MegatrendPartsFragmentDoc}`;

/**
 * __useMacrotrendTestSearchQuery__
 *
 * To use a Smart Query within a Vue component, call `useMacrotrendTestSearchQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     macrotrendTestSearch: useMacrotrendTestSearchQuery({
 *       variables: {
 *         query: // value for 'query'
 *         filter: // value for 'filter'
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *         locale: // value for 'locale'
 *         sort: // value for 'sort'
 *         width: // value for 'width'
 *         height: // value for 'height'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useMacrotrendTestSearchQuery = createSmartQueryOptionsFunction<
  MacrotrendTestSearchQuery,
  MacrotrendTestSearchQueryVariables,
  ApolloError
>(MacrotrendTestSearchDocument);

export const MegatrendsDocument = gql`
    query Megatrends($query: String, $filter: SearchFiltersInput, $page: Int!, $pageSize: Int!, $locale: Locale!, $sort: MegatrendsSort, $width: Int, $height: Int) {
  search: directSearch(query: $query, filter: $filter) {
    megatrends(page: $page, pageSize: $pageSize, sort: $sort) {
      pageInfo {
        ...PaginatedPageInfoParts
      }
      nodes {
        id
        color
        image(width: $width, height: $height, resize: fit)
        translations(locale: $locale) {
          locale
          title
          description
        }
      }
    }
  }
}
    ${PaginatedPageInfoPartsFragmentDoc}`;

/**
 * __useMegatrendsQuery__
 *
 * To use a Smart Query within a Vue component, call `useMegatrendsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     megatrends: useMegatrendsQuery({
 *       variables: {
 *         query: // value for 'query'
 *         filter: // value for 'filter'
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *         locale: // value for 'locale'
 *         sort: // value for 'sort'
 *         width: // value for 'width'
 *         height: // value for 'height'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useMegatrendsQuery = createSmartQueryOptionsFunction<
  MegatrendsQuery,
  MegatrendsQueryVariables,
  ApolloError
>(MegatrendsDocument);

export const MicrotrendsGalleryTestSearchDocument = gql`
    query MicrotrendsGalleryTestSearch($query: String, $filter: SearchFiltersInput, $page: Int!, $pageSize: Int!, $locale: Locale!, $width: Int, $height: Int) {
  search: directSearch(query: $query, filter: $filter) {
    microtrends(
      sort: {field: identifiedAt, direction: desc}
      page: $page
      pageSize: $pageSize
    ) {
      pageInfo {
        ...PaginatedPageInfoParts
      }
      nodes {
        id
        images(width: $width, height: $height, resize: fill)
        identifiedAt
        translations(locale: $locale) {
          locale
          title
          description
        }
        ... on CompanyMicrotrend {
          url
          author {
            ...UserParts
          }
        }
        ... on Microtrend {
          url
        }
      }
    }
  }
}
    ${PaginatedPageInfoPartsFragmentDoc}
${UserPartsFragmentDoc}`;

/**
 * __useMicrotrendsGalleryTestSearchQuery__
 *
 * To use a Smart Query within a Vue component, call `useMicrotrendsGalleryTestSearchQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     microtrendsGalleryTestSearch: useMicrotrendsGalleryTestSearchQuery({
 *       variables: {
 *         query: // value for 'query'
 *         filter: // value for 'filter'
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *         locale: // value for 'locale'
 *         width: // value for 'width'
 *         height: // value for 'height'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useMicrotrendsGalleryTestSearchQuery = createSmartQueryOptionsFunction<
  MicrotrendsGalleryTestSearchQuery,
  MicrotrendsGalleryTestSearchQueryVariables,
  ApolloError
>(MicrotrendsGalleryTestSearchDocument);

export const MicrotrendsListTestSearchDocument = gql`
    query MicrotrendsListTestSearch($query: String, $filter: SearchFiltersInput, $page: Int!, $pageSize: Int!, $locale: Locale!, $sort: MicrotrendsSort, $width: Int, $height: Int) {
  search: directSearch(query: $query, filter: $filter) {
    microtrends(page: $page, pageSize: $pageSize, sort: $sort) {
      pageInfo {
        ...PaginatedPageInfoParts
      }
      nodes {
        ... on Microtrend {
          url
          videos
          initiators {
            id
            title
          }
          innovationTypes {
            id
            translations(locale: $locale) {
              locale
              title
            }
          }
          countries {
            code
            translations(locale: $locale) {
              locale
              title
            }
          }
          industries {
            id
            translations(locale: $locale) {
              locale
              title
            }
          }
          megatrends {
            id
            color
            translations(locale: $locale) {
              title
            }
          }
          macrotrends {
            id
            megatrend {
              id
              color
            }
            translations(locale: $locale) {
              title
            }
          }
        }
        ... on CompanyMicrotrend {
          url
          videos
          author {
            id
            firstName
            lastName
          }
          initiators {
            id
            title
          }
          innovationTypes {
            id
            translations(locale: $locale) {
              locale
              title
            }
          }
          countries {
            code
            translations(locale: $locale) {
              locale
              title
            }
          }
          industries {
            id
            translations(locale: $locale) {
              locale
              title
            }
          }
          megatrends {
            id
            color
            translations(locale: $locale) {
              title
            }
          }
          macrotrends {
            id
            megatrend {
              id
              color
            }
            translations(locale: $locale) {
              title
            }
          }
        }
        id
        images(width: $width, height: $height, resize: fill)
        identifiedAt
        translations(locale: $locale) {
          locale
          title
          description
        }
      }
    }
  }
}
    ${PaginatedPageInfoPartsFragmentDoc}`;

/**
 * __useMicrotrendsListTestSearchQuery__
 *
 * To use a Smart Query within a Vue component, call `useMicrotrendsListTestSearchQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     microtrendsListTestSearch: useMicrotrendsListTestSearchQuery({
 *       variables: {
 *         query: // value for 'query'
 *         filter: // value for 'filter'
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *         locale: // value for 'locale'
 *         sort: // value for 'sort'
 *         width: // value for 'width'
 *         height: // value for 'height'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useMicrotrendsListTestSearchQuery = createSmartQueryOptionsFunction<
  MicrotrendsListTestSearchQuery,
  MicrotrendsListTestSearchQueryVariables,
  ApolloError
>(MicrotrendsListTestSearchDocument);

export const TrendFinderFacetsTestDocument = gql`
    query TrendFinderFacetsTest($query: String, $locale: Locale!) {
  search: directSearch(query: $query) {
    microtrends {
      facets {
        macrotrends {
          node {
            id
            image
            translations(locale: $locale) {
              title
              description
            }
            megatrend {
              id
              color
              image
              translations(locale: $locale) {
                title
                description
              }
            }
          }
        }
        megatrends {
          node {
            id
            color
            image
            translations(locale: $locale) {
              title
              description
            }
          }
        }
        industries {
          node {
            ...IndustryParts
          }
        }
        regions {
          node {
            ...RegionParts
          }
        }
        countries {
          node {
            ...CountryParts
            region {
              ...RegionParts
            }
          }
        }
        innovationType {
          node {
            ...InnovationTypeParts
          }
        }
        trendradars {
          node {
            ...TrendradarParts
          }
        }
      }
    }
  }
}
    ${IndustryPartsFragmentDoc}
${RegionPartsFragmentDoc}
${CountryPartsFragmentDoc}
${InnovationTypePartsFragmentDoc}
${TrendradarPartsFragmentDoc}`;

/**
 * __useTrendFinderFacetsTestQuery__
 *
 * To use a Smart Query within a Vue component, call `useTrendFinderFacetsTestQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     trendFinderFacetsTest: useTrendFinderFacetsTestQuery({
 *       variables: {
 *         query: // value for 'query'
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useTrendFinderFacetsTestQuery = createSmartQueryOptionsFunction<
  TrendFinderFacetsTestQuery,
  TrendFinderFacetsTestQueryVariables,
  ApolloError
>(TrendFinderFacetsTestDocument);

export const SearchCountDocument = gql`
    query SearchCount($query: String, $filter: SearchFiltersInput) {
  cnt: search(query: $query, filter: $filter) {
    microtrends {
      pageInfo {
        ...PaginatedPageInfoParts
      }
    }
    macrotrends {
      pageInfo {
        ...PaginatedPageInfoParts
      }
    }
    megatrends {
      pageInfo {
        ...PaginatedPageInfoParts
      }
    }
  }
}
    ${PaginatedPageInfoPartsFragmentDoc}`;

/**
 * __useSearchCountQuery__
 *
 * To use a Smart Query within a Vue component, call `useSearchCountQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     searchCount: useSearchCountQuery({
 *       variables: {
 *         query: // value for 'query'
 *         filter: // value for 'filter'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useSearchCountQuery = createSmartQueryOptionsFunction<
  SearchCountQuery,
  SearchCountQueryVariables,
  ApolloError
>(SearchCountDocument);

export const FacetsByIdDocument = gql`
    query FacetsById($ids: [ID!]!, $locale: Locale!) {
  nodes(ids: $ids) {
    ... on InnovationType {
      ...InnovationTypeParts
    }
    ... on Industry {
      ...IndustryParts
    }
    ... on MacrotrendInterface {
      id
      image
      translations(locale: $locale) {
        title
        description
      }
      megatrend {
        id
        color
        image
        translations(locale: $locale) {
          title
        }
      }
    }
    ... on MegatrendInterface {
      id
      color
      image
      translations(locale: $locale) {
        title
      }
      macrotrends {
        id
        translations(locale: $locale) {
          title
        }
        megatrend {
          id
          color
        }
      }
    }
    ... on Region {
      ...RegionParts
      countries {
        nodes {
          id
          translations(locale: de) {
            title
          }
        }
      }
    }
    ... on Country {
      ...CountryParts
      region {
        id
      }
    }
    ... on TrendRadar {
      id
      title
    }
  }
}
    ${InnovationTypePartsFragmentDoc}
${IndustryPartsFragmentDoc}
${RegionPartsFragmentDoc}
${CountryPartsFragmentDoc}`;

/**
 * __useFacetsByIdQuery__
 *
 * To use a Smart Query within a Vue component, call `useFacetsByIdQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     facetsById: useFacetsByIdQuery({
 *       variables: {
 *         ids: // value for 'ids'
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useFacetsByIdQuery = createSmartQueryOptionsFunction<
  FacetsByIdQuery,
  FacetsByIdQueryVariables,
  ApolloError
>(FacetsByIdDocument);

export const FacetsDocument = gql`
    query Facets($query: String, $locale: Locale!) {
  search: search(query: $query) {
    microtrends {
      facets {
        macrotrends {
          node {
            id
            color
            translations(locale: $locale) {
              title
            }
            megatrend {
              id
              translations(locale: $locale) {
                title
              }
            }
            ... on Macrotrend {
              deprecated
              successor {
                id
              }
            }
          }
        }
        megatrends {
          node {
            id
            color
            translations(locale: $locale) {
              title
            }
          }
        }
        industries {
          node {
            ...IndustryParts
          }
        }
        regions {
          node {
            ...RegionParts
          }
        }
        countries {
          node {
            ...CountryParts
            region {
              ...RegionParts
            }
          }
        }
        innovationType {
          node {
            ...InnovationTypeParts
          }
        }
        sdgs {
          node {
            id
            translations(locale: $locale) {
              title
            }
          }
        }
      }
    }
  }
}
    ${IndustryPartsFragmentDoc}
${RegionPartsFragmentDoc}
${CountryPartsFragmentDoc}
${InnovationTypePartsFragmentDoc}`;

/**
 * __useFacetsQuery__
 *
 * To use a Smart Query within a Vue component, call `useFacetsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     facets: useFacetsQuery({
 *       variables: {
 *         query: // value for 'query'
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useFacetsQuery = createSmartQueryOptionsFunction<
  FacetsQuery,
  FacetsQueryVariables,
  ApolloError
>(FacetsDocument);

export const TrendFacetsDocument = gql`
    query TrendFacets($query: String, $locale: Locale!) {
  trendtree: search(query: $query) {
    microtrends {
      facets {
        macrotrends {
          node {
            id
            translations(locale: $locale) {
              title
            }
            megatrend {
              id
              color
            }
          }
        }
        megatrends {
          node {
            id
            color
            translations(locale: $locale) {
              title
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTrendFacetsQuery__
 *
 * To use a Smart Query within a Vue component, call `useTrendFacetsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     trendFacets: useTrendFacetsQuery({
 *       variables: {
 *         query: // value for 'query'
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useTrendFacetsQuery = createSmartQueryOptionsFunction<
  TrendFacetsQuery,
  TrendFacetsQueryVariables,
  ApolloError
>(TrendFacetsDocument);

export const FacetsSearchDocument = gql`
    query FacetsSearch($query: String, $locale: Locale!) {
  search: search(query: $query) {
    microtrends {
      facets {
        macrotrends {
          node {
            id
            translations(locale: $locale) {
              title
            }
            megatrend {
              id
              color
              translations(locale: $locale) {
                title
              }
            }
          }
        }
        megatrends {
          node {
            id
            color
            translations(locale: $locale) {
              title
            }
          }
        }
        industries {
          node {
            ...IndustryParts
          }
        }
        regions {
          node {
            ...RegionParts
          }
        }
        countries {
          node {
            ...CountryParts
            region {
              ...RegionParts
            }
          }
        }
        innovationType {
          node {
            ...InnovationTypeParts
          }
        }
        trendradars {
          node {
            ...TrendradarParts
          }
        }
        sdgs {
          node {
            id
            translations(locale: $locale) {
              title
            }
          }
        }
      }
    }
  }
}
    ${IndustryPartsFragmentDoc}
${RegionPartsFragmentDoc}
${CountryPartsFragmentDoc}
${InnovationTypePartsFragmentDoc}
${TrendradarPartsFragmentDoc}`;

/**
 * __useFacetsSearchQuery__
 *
 * To use a Smart Query within a Vue component, call `useFacetsSearchQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     facetsSearch: useFacetsSearchQuery({
 *       variables: {
 *         query: // value for 'query'
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useFacetsSearchQuery = createSmartQueryOptionsFunction<
  FacetsSearchQuery,
  FacetsSearchQueryVariables,
  ApolloError
>(FacetsSearchDocument);

export const CopyTrendradarDraftDocument = gql`
    mutation copyTrendradarDraft($id: ID!, $input: CopyTrendRadarInput!) {
  trendRadar(id: $id) {
    copy(input: $input) {
      id
      title
    }
  }
}
    `;

/**
 * __copyTrendradarDraftMutation__
 *
 * To run a mutation, you call `copyTrendradarDraftMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = copyTrendradarDraftMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export const copyTrendradarDraftMutation = createMutationFunction<
  CopyTrendradarDraftMutation,
  CopyTrendradarDraftMutationVariables,
  ApolloError
>(CopyTrendradarDraftDocument);

export const CreatePanelDocument = gql`
    mutation createPanel($id: ID!) {
  trendRadar(id: $id) {
    createPanel {
      id
      panels {
        ...TrendRadarPanelParts
      }
    }
  }
}
    ${TrendRadarPanelPartsFragmentDoc}`;

/**
 * __createPanelMutation__
 *
 * To run a mutation, you call `createPanelMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = createPanelMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export const createPanelMutation = createMutationFunction<
  CreatePanelMutation,
  CreatePanelMutationVariables,
  ApolloError
>(CreatePanelDocument);

export const CreateTrendRadarDraftDocument = gql`
    mutation createTrendRadarDraft($input: CreateTrendRadarInput!) {
  createTrendRadar(input: $input) {
    id
  }
}
    `;

/**
 * __createTrendRadarDraftMutation__
 *
 * To run a mutation, you call `createTrendRadarDraftMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = createTrendRadarDraftMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export const createTrendRadarDraftMutation = createMutationFunction<
  CreateTrendRadarDraftMutation,
  CreateTrendRadarDraftMutationVariables,
  ApolloError
>(CreateTrendRadarDraftDocument);

export const DeletePanelDocument = gql`
    mutation deletePanel($id: ID!, $panelId: ID!) {
  trendRadar(id: $id) {
    deletePanel(panelId: $panelId) {
      id
      criteriaSetChangeable
      publishable
      hasUnpublishedChanges
      panels {
        ...TrendRadarPanelParts
      }
    }
  }
}
    ${TrendRadarPanelPartsFragmentDoc}`;

/**
 * __deletePanelMutation__
 *
 * To run a mutation, you call `deletePanelMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = deletePanelMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *     panelId: // value for 'panelId'
 *   },
 * });
 */
export const deletePanelMutation = createMutationFunction<
  DeletePanelMutation,
  DeletePanelMutationVariables,
  ApolloError
>(DeletePanelDocument);

export const DeleteSharingOptionsLogoDocument = gql`
    mutation DeleteSharingOptionsLogo($id: ID!) {
  trendRadar(id: $id) {
    deleteSharingOptionsLogo {
      id
      sharingOptions {
        image
        embedding {
          id
          enabled
        }
        publicView {
          id
          enabled
        }
      }
    }
  }
}
    `;

/**
 * __deleteSharingOptionsLogoMutation__
 *
 * To run a mutation, you call `deleteSharingOptionsLogoMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = deleteSharingOptionsLogoMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export const deleteSharingOptionsLogoMutation = createMutationFunction<
  DeleteSharingOptionsLogoMutation,
  DeleteSharingOptionsLogoMutationVariables,
  ApolloError
>(DeleteSharingOptionsLogoDocument);

export const DeleteTrendRadarDraftDocument = gql`
    mutation deleteTrendRadarDraft($id: ID!) {
  trendRadar(id: $id) {
    delete
  }
}
    `;

/**
 * __deleteTrendRadarDraftMutation__
 *
 * To run a mutation, you call `deleteTrendRadarDraftMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = deleteTrendRadarDraftMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export const deleteTrendRadarDraftMutation = createMutationFunction<
  DeleteTrendRadarDraftMutation,
  DeleteTrendRadarDraftMutationVariables,
  ApolloError
>(DeleteTrendRadarDraftDocument);

export const PublishTrendRadarDraftDocument = gql`
    mutation publishTrendRadarDraft($id: ID!, $description: String) {
  trendRadar(id: $id) {
    publish(description: $description) {
      id
      published
      publishable
      criteriaSetChangeable
      publishedId
    }
  }
}
    `;

/**
 * __publishTrendRadarDraftMutation__
 *
 * To run a mutation, you call `publishTrendRadarDraftMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = publishTrendRadarDraftMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *     description: // value for 'description'
 *   },
 * });
 */
export const publishTrendRadarDraftMutation = createMutationFunction<
  PublishTrendRadarDraftMutation,
  PublishTrendRadarDraftMutationVariables,
  ApolloError
>(PublishTrendRadarDraftDocument);

export const SetTrendRadarDraftEvaluationEnabledDocument = gql`
    mutation setTrendRadarDraftEvaluationEnabled($id: ID!, $enabled: Boolean!) {
  trendRadar(id: $id) {
    setEvaluationEnabled(enabled: $enabled) {
      id
      evaluationEnabled
    }
  }
}
    `;

/**
 * __setTrendRadarDraftEvaluationEnabledMutation__
 *
 * To run a mutation, you call `setTrendRadarDraftEvaluationEnabledMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = setTrendRadarDraftEvaluationEnabledMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *     enabled: // value for 'enabled'
 *   },
 * });
 */
export const setTrendRadarDraftEvaluationEnabledMutation = createMutationFunction<
  SetTrendRadarDraftEvaluationEnabledMutation,
  SetTrendRadarDraftEvaluationEnabledMutationVariables,
  ApolloError
>(SetTrendRadarDraftEvaluationEnabledDocument);

export const SetSharingOptionsLogoDocument = gql`
    mutation SetSharingOptionsLogo($id: ID!, $logo: FileUpload!) {
  trendRadar(id: $id) {
    setSharingOptionsLogo(logo: $logo) {
      id
      sharingOptions {
        image
        embedding {
          id
          enabled
        }
        publicView {
          id
          enabled
        }
      }
    }
  }
}
    `;

/**
 * __setSharingOptionsLogoMutation__
 *
 * To run a mutation, you call `setSharingOptionsLogoMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = setSharingOptionsLogoMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *     logo: // value for 'logo'
 *   },
 * });
 */
export const setSharingOptionsLogoMutation = createMutationFunction<
  SetSharingOptionsLogoMutation,
  SetSharingOptionsLogoMutationVariables,
  ApolloError
>(SetSharingOptionsLogoDocument);

export const SetSharingOptionsDocument = gql`
    mutation SetSharingOptions($id: ID!, $input: SetSharingOptionsInput!) {
  trendRadar(id: $id) {
    setSharingOptions(input: $input) {
      embedding {
        id
        enabled
      }
      publicView {
        id
        enabled
      }
    }
  }
}
    `;

/**
 * __setSharingOptionsMutation__
 *
 * To run a mutation, you call `setSharingOptionsMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = setSharingOptionsMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export const setSharingOptionsMutation = createMutationFunction<
  SetSharingOptionsMutation,
  SetSharingOptionsMutationVariables,
  ApolloError
>(SetSharingOptionsDocument);

export const UnpublishTrendRadarDraftDocument = gql`
    mutation unpublishTrendRadarDraft($id: ID!) {
  trendRadar(id: $id) {
    unpublish {
      id
      published
      publishable
      publishedId
      criteriaSetChangeable
    }
  }
}
    `;

/**
 * __unpublishTrendRadarDraftMutation__
 *
 * To run a mutation, you call `unpublishTrendRadarDraftMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = unpublishTrendRadarDraftMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export const unpublishTrendRadarDraftMutation = createMutationFunction<
  UnpublishTrendRadarDraftMutation,
  UnpublishTrendRadarDraftMutationVariables,
  ApolloError
>(UnpublishTrendRadarDraftDocument);

export const UpdateTrendRadarDraftDocument = gql`
    mutation updateTrendRadarDraft($id: ID!, $input: UpdateTrendRadarInput!, $locale: Locale!) {
  trendRadar(id: $id) {
    update(input: $input) {
      ...TrendRadarDraftParts
    }
  }
}
    ${TrendRadarDraftPartsFragmentDoc}`;

/**
 * __updateTrendRadarDraftMutation__
 *
 * To run a mutation, you call `updateTrendRadarDraftMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = updateTrendRadarDraftMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *     locale: // value for 'locale'
 *   },
 * });
 */
export const updateTrendRadarDraftMutation = createMutationFunction<
  UpdateTrendRadarDraftMutation,
  UpdateTrendRadarDraftMutationVariables,
  ApolloError
>(UpdateTrendRadarDraftDocument);

export const LoadRecommendedActionPreviewDocument = gql`
    query loadRecommendedActionPreview($input: RecommendedActionPreviewInput!) {
  recommendedActionPreview(input: $input)
}
    `;

/**
 * __useLoadRecommendedActionPreviewQuery__
 *
 * To use a Smart Query within a Vue component, call `useLoadRecommendedActionPreviewQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     loadRecommendedActionPreview: useLoadRecommendedActionPreviewQuery({
 *       variables: {
 *         input: // value for 'input'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useLoadRecommendedActionPreviewQuery = createSmartQueryOptionsFunction<
  LoadRecommendedActionPreviewQuery,
  LoadRecommendedActionPreviewQueryVariables,
  ApolloError
>(LoadRecommendedActionPreviewDocument);

export const LoadTrendRadarDraftEvaluationsDocument = gql`
    query loadTrendRadarDraftEvaluations($id: ID!, $locale: Locale!) {
  trendradar: node(id: $id) {
    ... on TrendRadarDraft {
      id
      evaluations {
        id
        evaluationCount
        perception
        macrotrend {
          id
          color
          translations(locale: $locale) {
            locale
            title
          }
          megatrend {
            id
            color
            translations(locale: $locale) {
              locale
              title
            }
          }
        }
        overrideEvaluation {
          ...TrendRadarDraftEvaluationParts
        }
        averageEvaluation {
          ...TrendRadarDraftEvaluationParts
        }
        panelEvaluations {
          panel {
            id
            title
          }
          averageEvaluation {
            ...TrendRadarDraftEvaluationParts
          }
        }
      }
    }
  }
}
    ${TrendRadarDraftEvaluationPartsFragmentDoc}`;

/**
 * __useLoadTrendRadarDraftEvaluationsQuery__
 *
 * To use a Smart Query within a Vue component, call `useLoadTrendRadarDraftEvaluationsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     loadTrendRadarDraftEvaluations: useLoadTrendRadarDraftEvaluationsQuery({
 *       variables: {
 *         id: // value for 'id'
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useLoadTrendRadarDraftEvaluationsQuery = createSmartQueryOptionsFunction<
  LoadTrendRadarDraftEvaluationsQuery,
  LoadTrendRadarDraftEvaluationsQueryVariables,
  ApolloError
>(LoadTrendRadarDraftEvaluationsDocument);

export const LoadTrendRadarDraftFlagsDocument = gql`
    query loadTrendRadarDraftFlags($id: ID!) {
  trendradar: node(id: $id) {
    ... on TrendRadarDraft {
      id
      publishable
      hasUnpublishedChanges
      criteriaSetChangeable
    }
  }
}
    `;

/**
 * __useLoadTrendRadarDraftFlagsQuery__
 *
 * To use a Smart Query within a Vue component, call `useLoadTrendRadarDraftFlagsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     loadTrendRadarDraftFlags: useLoadTrendRadarDraftFlagsQuery({
 *       variables: {
 *         id: // value for 'id'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useLoadTrendRadarDraftFlagsQuery = createSmartQueryOptionsFunction<
  LoadTrendRadarDraftFlagsQuery,
  LoadTrendRadarDraftFlagsQueryVariables,
  ApolloError
>(LoadTrendRadarDraftFlagsDocument);

export const LoadTrendRadarDraftDocument = gql`
    query loadTrendRadarDraft($id: ID!, $locale: Locale!) {
  trendradar: node(id: $id) {
    ...TrendRadarDraftParts
  }
}
    ${TrendRadarDraftPartsFragmentDoc}`;

/**
 * __useLoadTrendRadarDraftQuery__
 *
 * To use a Smart Query within a Vue component, call `useLoadTrendRadarDraftQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     loadTrendRadarDraft: useLoadTrendRadarDraftQuery({
 *       variables: {
 *         id: // value for 'id'
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useLoadTrendRadarDraftQuery = createSmartQueryOptionsFunction<
  LoadTrendRadarDraftQuery,
  LoadTrendRadarDraftQueryVariables,
  ApolloError
>(LoadTrendRadarDraftDocument);

export const SetTrendRadarPanelEnabledDocument = gql`
    mutation setTrendRadarPanelEnabled($trendRadarId: ID!, $panelId: ID!, $enabled: Boolean!) {
  trendRadar(id: $trendRadarId) {
    panel(id: $panelId) {
      setEnabled(enabled: $enabled) {
        ...TrendRadarPanelParts
      }
    }
  }
}
    ${TrendRadarPanelPartsFragmentDoc}`;

/**
 * __setTrendRadarPanelEnabledMutation__
 *
 * To run a mutation, you call `setTrendRadarPanelEnabledMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = setTrendRadarPanelEnabledMutation(this, {
 *   variables: {
 *     trendRadarId: // value for 'trendRadarId'
 *     panelId: // value for 'panelId'
 *     enabled: // value for 'enabled'
 *   },
 * });
 */
export const setTrendRadarPanelEnabledMutation = createMutationFunction<
  SetTrendRadarPanelEnabledMutation,
  SetTrendRadarPanelEnabledMutationVariables,
  ApolloError
>(SetTrendRadarPanelEnabledDocument);

export const UpdateMacrotrendsDocument = gql`
    mutation updateMacrotrends($trendRadarId: ID!, $panelId: ID!, $macrotrendIds: [ID!]!) {
  trendRadar(id: $trendRadarId) {
    panel(id: $panelId) {
      updateMacrotrends(macrotrendIds: $macrotrendIds) {
        ...TrendRadarPanelParts
      }
    }
  }
}
    ${TrendRadarPanelPartsFragmentDoc}`;

/**
 * __updateMacrotrendsMutation__
 *
 * To run a mutation, you call `updateMacrotrendsMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = updateMacrotrendsMutation(this, {
 *   variables: {
 *     trendRadarId: // value for 'trendRadarId'
 *     panelId: // value for 'panelId'
 *     macrotrendIds: // value for 'macrotrendIds'
 *   },
 * });
 */
export const updateMacrotrendsMutation = createMutationFunction<
  UpdateMacrotrendsMutation,
  UpdateMacrotrendsMutationVariables,
  ApolloError
>(UpdateMacrotrendsDocument);

export const UpdatePanelDocument = gql`
    mutation updatePanel($trendRadarId: ID!, $panelId: ID!, $input: UpdateTrendRadarPanelInput!) {
  trendRadar(id: $trendRadarId) {
    panel(id: $panelId) {
      update(input: $input) {
        ...TrendRadarPanelParts
      }
    }
  }
}
    ${TrendRadarPanelPartsFragmentDoc}`;

/**
 * __updatePanelMutation__
 *
 * To run a mutation, you call `updatePanelMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = updatePanelMutation(this, {
 *   variables: {
 *     trendRadarId: // value for 'trendRadarId'
 *     panelId: // value for 'panelId'
 *     input: // value for 'input'
 *   },
 * });
 */
export const updatePanelMutation = createMutationFunction<
  UpdatePanelMutation,
  UpdatePanelMutationVariables,
  ApolloError
>(UpdatePanelDocument);

export const CreateTrendRadarDocument = gql`
    mutation createTrendRadar($input: CreateTrendRadarInput!, $locale: Locale = null) {
  createTrendRadar(input: $input) {
    ... on TrendRadarDraft {
      id
      publishedId
      title
      description
      managers {
        ...TrendradarUserParts
      }
      published
      publishable
      hasUnpublishedChanges
      criteriaSetChangeable
      criteriaSet {
        id
        criterias {
          ...CriteriaParts
        }
      }
    }
  }
}
    ${TrendradarUserPartsFragmentDoc}
${CriteriaPartsFragmentDoc}`;

/**
 * __createTrendRadarMutation__
 *
 * To run a mutation, you call `createTrendRadarMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = createTrendRadarMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *     locale: // value for 'locale'
 *   },
 * });
 */
export const createTrendRadarMutation = createMutationFunction<
  CreateTrendRadarMutation,
  CreateTrendRadarMutationVariables,
  ApolloError
>(CreateTrendRadarDocument);

export const DeleteOverrideDocument = gql`
    mutation deleteOverride($id: ID!, $macrotrendId: ID!, $locale: Locale!, $width: Int, $height: Int) {
  trendRadar(id: $id) {
    deleteOverride(macrotrendId: $macrotrendId) {
      id
      publishedId
      title
      description
      image
      published
      publishable
      hasUnpublishedChanges
      evaluationEnabled
      criteriaSet {
        id
        criterias {
          ...CriteriaParts
        }
      }
      evaluations {
        id
        macrotrend {
          ...TrendradarMacrotrendParts
        }
        overrideEvaluation {
          ...TrendradarEvaluationParts
        }
        averageEvaluation {
          ...TrendradarEvaluationParts
        }
        evaluationCount
        perception
      }
    }
  }
}
    ${CriteriaPartsFragmentDoc}
${TrendradarMacrotrendPartsFragmentDoc}
${TrendradarEvaluationPartsFragmentDoc}`;

/**
 * __deleteOverrideMutation__
 *
 * To run a mutation, you call `deleteOverrideMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = deleteOverrideMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *     macrotrendId: // value for 'macrotrendId'
 *     locale: // value for 'locale'
 *     width: // value for 'width'
 *     height: // value for 'height'
 *   },
 * });
 */
export const deleteOverrideMutation = createMutationFunction<
  DeleteOverrideMutation,
  DeleteOverrideMutationVariables,
  ApolloError
>(DeleteOverrideDocument);

export const RepublishTrendradarDocument = gql`
    mutation republishTrendradar($id: ID!) {
  trendRadar(id: $id) {
    republish {
      id
      publishedId
      title
      description
      image
      published
      publishable
      hasUnpublishedChanges
      evaluationEnabled
    }
  }
}
    `;

/**
 * __republishTrendradarMutation__
 *
 * To run a mutation, you call `republishTrendradarMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = republishTrendradarMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export const republishTrendradarMutation = createMutationFunction<
  RepublishTrendradarMutation,
  RepublishTrendradarMutationVariables,
  ApolloError
>(RepublishTrendradarDocument);

export const OverrideEvaluationDocument = gql`
    mutation overrideEvaluation($id: ID!, $input: OverrideEvaluationInput!, $locale: Locale!, $width: Int, $height: Int) {
  trendRadar(id: $id) {
    overrideEvaluation(input: $input) {
      id
      publishedId
      title
      description
      image
      published
      publishable
      hasUnpublishedChanges
      evaluationEnabled
      criteriaSet {
        id
        criterias {
          ...CriteriaParts
        }
      }
      evaluations {
        id
        macrotrend {
          ...TrendradarMacrotrendParts
        }
        overrideEvaluation {
          ...TrendradarEvaluationParts
        }
        averageEvaluation {
          ...TrendradarEvaluationParts
        }
        evaluationCount
        perception
      }
    }
  }
}
    ${CriteriaPartsFragmentDoc}
${TrendradarMacrotrendPartsFragmentDoc}
${TrendradarEvaluationPartsFragmentDoc}`;

/**
 * __overrideEvaluationMutation__
 *
 * To run a mutation, you call `overrideEvaluationMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = overrideEvaluationMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *     locale: // value for 'locale'
 *     width: // value for 'width'
 *     height: // value for 'height'
 *   },
 * });
 */
export const overrideEvaluationMutation = createMutationFunction<
  OverrideEvaluationMutation,
  OverrideEvaluationMutationVariables,
  ApolloError
>(OverrideEvaluationDocument);

export const SetPercptionDocument = gql`
    mutation setPercption($id: ID!, $input: SetPerceptionInput!, $locale: Locale!, $width: Int, $height: Int) {
  trendRadar(id: $id) {
    setPerception(input: $input) {
      id
      publishedId
      image
      published
      publishable
      hasUnpublishedChanges
      evaluations {
        id
        macrotrend {
          ...TrendradarMacrotrendParts
        }
        overrideEvaluation {
          ...TrendradarEvaluationParts
        }
        averageEvaluation {
          ...TrendradarEvaluationParts
        }
        evaluationCount
        perception
      }
    }
  }
}
    ${TrendradarMacrotrendPartsFragmentDoc}
${TrendradarEvaluationPartsFragmentDoc}`;

/**
 * __setPercptionMutation__
 *
 * To run a mutation, you call `setPercptionMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = setPercptionMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *     locale: // value for 'locale'
 *     width: // value for 'width'
 *     height: // value for 'height'
 *   },
 * });
 */
export const setPercptionMutation = createMutationFunction<
  SetPercptionMutation,
  SetPercptionMutationVariables,
  ApolloError
>(SetPercptionDocument);

export const TrendradarsDocument = gql`
    query Trendradars($page: Int!, $pageSize: Int!) {
  trendradars: trendRadars(page: $page, pageSize: $pageSize) {
    nodes {
      id
      title
    }
  }
}
    `;

/**
 * __useTrendradarsQuery__
 *
 * To use a Smart Query within a Vue component, call `useTrendradarsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     trendradars: useTrendradarsQuery({
 *       variables: {
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useTrendradarsQuery = createSmartQueryOptionsFunction<
  TrendradarsQuery,
  TrendradarsQueryVariables,
  ApolloError
>(TrendradarsDocument);

export const CountRadarsDocument = gql`
    query countRadars {
  trendradars: trendRadars {
    pageInfo {
      ...PaginatedPageInfoParts
    }
  }
  participations: trendRadarParticipations {
    pageInfo {
      ...PaginatedPageInfoParts
    }
  }
}
    ${PaginatedPageInfoPartsFragmentDoc}`;

/**
 * __useCountRadarsQuery__
 *
 * To use a Smart Query within a Vue component, call `useCountRadarsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     countRadars: useCountRadarsQuery({
 *       variables: {},
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useCountRadarsQuery = createSmartQueryOptionsFunction<
  CountRadarsQuery,
  CountRadarsQueryVariables,
  ApolloError
>(CountRadarsDocument);

export const LoadTrendradarsGalleryDocument = gql`
    query loadTrendradarsGallery($locale: Locale, $page: Int!, $pageSize: Int!) {
  trendradars: trendRadars(page: $page, pageSize: $pageSize) {
    nodes {
      id
      ...DeprecatedMacrotrendsParts
      managers {
        id
      }
      title
      image
    }
  }
}
    ${DeprecatedMacrotrendsPartsFragmentDoc}`;

/**
 * __useLoadTrendradarsGalleryQuery__
 *
 * To use a Smart Query within a Vue component, call `useLoadTrendradarsGalleryQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     loadTrendradarsGallery: useLoadTrendradarsGalleryQuery({
 *       variables: {
 *         locale: // value for 'locale'
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useLoadTrendradarsGalleryQuery = createSmartQueryOptionsFunction<
  LoadTrendradarsGalleryQuery,
  LoadTrendradarsGalleryQueryVariables,
  ApolloError
>(LoadTrendradarsGalleryDocument);

export const InnovationFieldDetailDocument = gql`
    query InnovationFieldDetail($id: ID!, $locale: Locale!, $width: Int, $height: Int) {
  innovationField: node(id: $id) {
    ... on InnovationField {
      ...InnovationFieldParts
      contactPerson {
        id
        firstName
        lastName
        email
        avatar
        jobPosition
      }
      macrotrends {
        ...MacrotrendInterfaceParts
      }
    }
  }
}
    ${InnovationFieldPartsFragmentDoc}
${MacrotrendInterfacePartsFragmentDoc}`;

/**
 * __useInnovationFieldDetailQuery__
 *
 * To use a Smart Query within a Vue component, call `useInnovationFieldDetailQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     innovationFieldDetail: useInnovationFieldDetailQuery({
 *       variables: {
 *         id: // value for 'id'
 *         locale: // value for 'locale'
 *         width: // value for 'width'
 *         height: // value for 'height'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useInnovationFieldDetailQuery = createSmartQueryOptionsFunction<
  InnovationFieldDetailQuery,
  InnovationFieldDetailQueryVariables,
  ApolloError
>(InnovationFieldDetailDocument);

export const TrendRadarInnovationFieldsDocument = gql`
    query TrendRadarInnovationFields($id: ID!, $page: Int, $pageSize: Int) {
  node(id: $id) {
    ... on PublishedTrendRadar {
      id
      innovationFields(pageSize: $pageSize, page: $page) {
        nodes {
          id
          title
          description
          image(width: 50, height: 50, resize: fill)
          macrotrends {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTrendRadarInnovationFieldsQuery__
 *
 * To use a Smart Query within a Vue component, call `useTrendRadarInnovationFieldsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     trendRadarInnovationFields: useTrendRadarInnovationFieldsQuery({
 *       variables: {
 *         id: // value for 'id'
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useTrendRadarInnovationFieldsQuery = createSmartQueryOptionsFunction<
  TrendRadarInnovationFieldsQuery,
  TrendRadarInnovationFieldsQueryVariables,
  ApolloError
>(TrendRadarInnovationFieldsDocument);

export const InnovationProjectDetailsDocument = gql`
    query InnovationProjectDetails($id: ID!, $locale: Locale!, $width: Int, $height: Int) {
  innovationProject: node(id: $id) {
    ... on InnovationProject {
      ...InnovationProjectParts
      participants {
        id
        avatar
        firstName
        lastName
        jobPosition
        email
      }
      macrotrends {
        ...MacrotrendInterfaceParts
      }
    }
  }
}
    ${InnovationProjectPartsFragmentDoc}
${MacrotrendInterfacePartsFragmentDoc}`;

/**
 * __useInnovationProjectDetailsQuery__
 *
 * To use a Smart Query within a Vue component, call `useInnovationProjectDetailsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     innovationProjectDetails: useInnovationProjectDetailsQuery({
 *       variables: {
 *         id: // value for 'id'
 *         locale: // value for 'locale'
 *         width: // value for 'width'
 *         height: // value for 'height'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useInnovationProjectDetailsQuery = createSmartQueryOptionsFunction<
  InnovationProjectDetailsQuery,
  InnovationProjectDetailsQueryVariables,
  ApolloError
>(InnovationProjectDetailsDocument);

export const TrendRadarInnovationProjectsDocument = gql`
    query TrendRadarInnovationProjects($id: ID!) {
  node(id: $id) {
    ... on PublishedTrendRadar {
      id
      innovationProjects(page: 1, pageSize: 40) {
        nodes {
          id
          title
          image(width: 50, height: 50, resize: fill)
          macrotrends {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTrendRadarInnovationProjectsQuery__
 *
 * To use a Smart Query within a Vue component, call `useTrendRadarInnovationProjectsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     trendRadarInnovationProjects: useTrendRadarInnovationProjectsQuery({
 *       variables: {
 *         id: // value for 'id'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useTrendRadarInnovationProjectsQuery = createSmartQueryOptionsFunction<
  TrendRadarInnovationProjectsQuery,
  TrendRadarInnovationProjectsQueryVariables,
  ApolloError
>(TrendRadarInnovationProjectsDocument);

export const LoadTrendradarsListDocument = gql`
    query loadTrendradarsList($locale: Locale, $page: Int!, $pageSize: Int!, $sort: TrendRadarSort) {
  trendradars: trendRadars(page: $page, pageSize: $pageSize, sort: $sort) {
    nodes {
      id
      ...DeprecatedMacrotrendsParts
      title
      image
      updatedAt
      managers {
        id
        firstName
        lastName
      }
      innovationFields {
        nodes {
          id
          title
        }
      }
      innovationProjects {
        nodes {
          id
          title
        }
      }
    }
  }
}
    ${DeprecatedMacrotrendsPartsFragmentDoc}`;

/**
 * __useLoadTrendradarsListQuery__
 *
 * To use a Smart Query within a Vue component, call `useLoadTrendradarsListQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     loadTrendradarsList: useLoadTrendradarsListQuery({
 *       variables: {
 *         locale: // value for 'locale'
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *         sort: // value for 'sort'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useLoadTrendradarsListQuery = createSmartQueryOptionsFunction<
  LoadTrendradarsListQuery,
  LoadTrendradarsListQueryVariables,
  ApolloError
>(LoadTrendradarsListDocument);

export const LoadParticipationDocument = gql`
    query loadParticipation($id: ID!, $locale: Locale!) {
  participation: node(id: $id) {
    ... on TrendRadarParticipation {
      id
      title
      description
      evaluationEnabled
      criteriaSet {
        criterias {
          ...CriteriaParts
        }
      }
      updatedAt
      evaluations {
        id
        macrotrend {
          ... on MacrotrendInterface {
            id
            color
            translations(locale: $locale) {
              locale
              title
            }
            megatrend {
              id
              color
              translations(locale: $locale) {
                title
              }
            }
          }
        }
        evaluation {
          id
          values {
            value
            criteria {
              ...CriteriaParts
            }
          }
          recommendedAction
          readinessAssessment
        }
        perception
      }
    }
  }
}
    ${CriteriaPartsFragmentDoc}`;

/**
 * __useLoadParticipationQuery__
 *
 * To use a Smart Query within a Vue component, call `useLoadParticipationQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     loadParticipation: useLoadParticipationQuery({
 *       variables: {
 *         id: // value for 'id'
 *         locale: // value for 'locale'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useLoadParticipationQuery = createSmartQueryOptionsFunction<
  LoadParticipationQuery,
  LoadParticipationQueryVariables,
  ApolloError
>(LoadParticipationDocument);

export const LoadParticipationsDocument = gql`
    query loadParticipations($sort: TrendRadarParticipationSort) {
  trendRadarParticipations(page: 1, pageSize: 100, sort: $sort) {
    nodes {
      id
      title
      image
      updatedAt
    }
  }
}
    `;

/**
 * __useLoadParticipationsQuery__
 *
 * To use a Smart Query within a Vue component, call `useLoadParticipationsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     loadParticipations: useLoadParticipationsQuery({
 *       variables: {
 *         sort: // value for 'sort'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useLoadParticipationsQuery = createSmartQueryOptionsFunction<
  LoadParticipationsQuery,
  LoadParticipationsQueryVariables,
  ApolloError
>(LoadParticipationsDocument);

export const LoadPublishedDocument = gql`
    query loadPublished($id: ID!, $locale: Locale = null, $width: Int, $height: Int) {
  trendradar: node(id: $id) {
    ... on PublishedTrendRadar {
      id
      draftId
      managers {
        ...TrendradarUserParts
      }
      title
      description
      image
      updatedAt
      criteriaSet {
        id
        criterias {
          ...CriteriaParts
        }
        translations(locale: $locale) {
          locale
          title
          readinessAssessment {
            learn
            preserve
            make
            buy
          }
          recommendedAction {
            actTitle
            actDescription
            prepareTitle
            prepareDescription
            watchTitle
            watchDescription
            outOfScopeTitle
            outOfScopeDescription
          }
        }
      }
      evaluations {
        id
        macrotrend {
          ...TrendradarMacrotrendParts
        }
        evaluation {
          ...TrendradarEvaluationParts
        }
        perception
      }
      innovationFields(pageSize: 50) {
        nodes {
          id
          title
          macrotrends {
            id
          }
        }
        pageInfo {
          totalCount
        }
      }
      innovationProjects {
        nodes {
          id
          title
          macrotrends {
            id
          }
        }
        pageInfo {
          totalCount
        }
      }
      extendedSourcesACT: posts(category: extendedSources, recommendedAction: ACT) {
        ...PostCountParts
      }
      extendedSourcesPREPARE: posts(
        category: extendedSources
        recommendedAction: PREPARE
      ) {
        ...PostCountParts
      }
      extendedSourcesWATCH: posts(category: extendedSources, recommendedAction: WATCH) {
        ...PostCountParts
      }
      chancesACT: posts(category: chances, recommendedAction: ACT) {
        ...PostCountParts
      }
      chancesPREPARE: posts(category: chances, recommendedAction: PREPARE) {
        ...PostCountParts
      }
      chancesWATCH: posts(category: chances, recommendedAction: WATCH) {
        ...PostCountParts
      }
      risksACT: posts(category: risks, recommendedAction: ACT) {
        ...PostCountParts
      }
      risksPREPARE: posts(category: risks, recommendedAction: PREPARE) {
        ...PostCountParts
      }
      risksWATCH: posts(category: risks, recommendedAction: WATCH) {
        ...PostCountParts
      }
      ...DeprecatedMacrotrendsParts
    }
  }
}
    ${TrendradarUserPartsFragmentDoc}
${CriteriaPartsFragmentDoc}
${TrendradarMacrotrendPartsFragmentDoc}
${TrendradarEvaluationPartsFragmentDoc}
${PostCountPartsFragmentDoc}
${DeprecatedMacrotrendsPartsFragmentDoc}`;

/**
 * __useLoadPublishedQuery__
 *
 * To use a Smart Query within a Vue component, call `useLoadPublishedQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     loadPublished: useLoadPublishedQuery({
 *       variables: {
 *         id: // value for 'id'
 *         locale: // value for 'locale'
 *         width: // value for 'width'
 *         height: // value for 'height'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useLoadPublishedQuery = createSmartQueryOptionsFunction<
  LoadPublishedQuery,
  LoadPublishedQueryVariables,
  ApolloError
>(LoadPublishedDocument);

export const LoadWorkspacesForSelectDocument = gql`
    query loadWorkspacesForSelect($locale: Locale, $width: Int, $height: Int) {
  updateableWorkspaces(sort: {field: title, direction: asc}) {
    id
    title
    trends(type: macrotrend, page: 1, pageSize: 250) {
      nodes {
        trend {
          ...TrendradarMacrotrendParts
        }
      }
    }
  }
}
    ${TrendradarMacrotrendPartsFragmentDoc}`;

/**
 * __useLoadWorkspacesForSelectQuery__
 *
 * To use a Smart Query within a Vue component, call `useLoadWorkspacesForSelectQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     loadWorkspacesForSelect: useLoadWorkspacesForSelectQuery({
 *       variables: {
 *         locale: // value for 'locale'
 *         width: // value for 'width'
 *         height: // value for 'height'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useLoadWorkspacesForSelectQuery = createSmartQueryOptionsFunction<
  LoadWorkspacesForSelectQuery,
  LoadWorkspacesForSelectQueryVariables,
  ApolloError
>(LoadWorkspacesForSelectDocument);

export const SendFeedbackDocument = gql`
    mutation sendFeedback($input: SendFeedbackInput!) {
  sendFeedback(input: $input)
}
    `;

/**
 * __sendFeedbackMutation__
 *
 * To run a mutation, you call `sendFeedbackMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = sendFeedbackMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export const sendFeedbackMutation = createMutationFunction<
  SendFeedbackMutation,
  SendFeedbackMutationVariables,
  ApolloError
>(SendFeedbackDocument);

export const UiDocument = gql`
    query ui {
  ui {
    showUniverseUpdate
    showAutomaticUniverseUpdate
  }
}
    `;

/**
 * __useUiQuery__
 *
 * To use a Smart Query within a Vue component, call `useUiQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     ui: useUiQuery({
 *       variables: {},
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useUiQuery = createSmartQueryOptionsFunction<
  UiQuery,
  UiQueryVariables,
  ApolloError
>(UiDocument);

export const DeleteAvatarDocument = gql`
    mutation deleteAvatar {
  me {
    deleteAvatar {
      ...UserParts
    }
  }
}
    ${UserPartsFragmentDoc}`;

/**
 * __deleteAvatarMutation__
 *
 * To run a mutation, you call `deleteAvatarMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = deleteAvatarMutation(this, {
 *   variables: {},
 * });
 */
export const deleteAvatarMutation = createMutationFunction<
  DeleteAvatarMutation,
  DeleteAvatarMutationVariables,
  ApolloError
>(DeleteAvatarDocument);

export const UploadAvatarDocument = gql`
    mutation uploadAvatar($input: UploadAvatarInput!) {
  me {
    uploadAvatar(input: $input) {
      ...UserParts
    }
  }
}
    ${UserPartsFragmentDoc}`;

/**
 * __uploadAvatarMutation__
 *
 * To run a mutation, you call `uploadAvatarMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = uploadAvatarMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export const uploadAvatarMutation = createMutationFunction<
  UploadAvatarMutation,
  UploadAvatarMutationVariables,
  ApolloError
>(UploadAvatarDocument);

export const LogoutDocument = gql`
    mutation logout {
  logout(path: "app")
}
    `;

/**
 * __logoutMutation__
 *
 * To run a mutation, you call `logoutMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = logoutMutation(this, {
 *   variables: {},
 * });
 */
export const logoutMutation = createMutationFunction<
  LogoutMutation,
  LogoutMutationVariables,
  ApolloError
>(LogoutDocument);

export const ChangePasswordDocument = gql`
    mutation changePassword($input: ChangePasswordInput!) {
  me {
    changePassword(input: $input) {
      ...UserParts
    }
  }
}
    ${UserPartsFragmentDoc}`;

/**
 * __changePasswordMutation__
 *
 * To run a mutation, you call `changePasswordMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = changePasswordMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export const changePasswordMutation = createMutationFunction<
  ChangePasswordMutation,
  ChangePasswordMutationVariables,
  ApolloError
>(ChangePasswordDocument);

export const UpdateProfileDocument = gql`
    mutation updateProfile($input: UpdateProfileInput!) {
  me {
    updateProfile(input: $input) {
      ...UserParts
    }
  }
}
    ${UserPartsFragmentDoc}`;

/**
 * __updateProfileMutation__
 *
 * To run a mutation, you call `updateProfileMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = updateProfileMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export const updateProfileMutation = createMutationFunction<
  UpdateProfileMutation,
  UpdateProfileMutationVariables,
  ApolloError
>(UpdateProfileDocument);

export const SetInsightsUpdatesSeenDocument = gql`
    mutation SetInsightsUpdatesSeen {
  me {
    setInsightsUpdatesSeen {
      ...UserParts
    }
  }
}
    ${UserPartsFragmentDoc}`;

/**
 * __setInsightsUpdatesSeenMutation__
 *
 * To run a mutation, you call `setInsightsUpdatesSeenMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = setInsightsUpdatesSeenMutation(this, {
 *   variables: {},
 * });
 */
export const setInsightsUpdatesSeenMutation = createMutationFunction<
  SetInsightsUpdatesSeenMutation,
  SetInsightsUpdatesSeenMutationVariables,
  ApolloError
>(SetInsightsUpdatesSeenDocument);

export const SetLastFeatureUpdateDocument = gql`
    mutation SetLastFeatureUpdate {
  me {
    setLastFeatureUpdate {
      ...UserParts
    }
  }
}
    ${UserPartsFragmentDoc}`;

/**
 * __setLastFeatureUpdateMutation__
 *
 * To run a mutation, you call `setLastFeatureUpdateMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = setLastFeatureUpdateMutation(this, {
 *   variables: {},
 * });
 */
export const setLastFeatureUpdateMutation = createMutationFunction<
  SetLastFeatureUpdateMutation,
  SetLastFeatureUpdateMutationVariables,
  ApolloError
>(SetLastFeatureUpdateDocument);

export const SetSeenIntroductionVideoDocument = gql`
    mutation SetSeenIntroductionVideo {
  me {
    setSeenIntroductionVideo {
      ...UserParts
    }
  }
}
    ${UserPartsFragmentDoc}`;

/**
 * __setSeenIntroductionVideoMutation__
 *
 * To run a mutation, you call `setSeenIntroductionVideoMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = setSeenIntroductionVideoMutation(this, {
 *   variables: {},
 * });
 */
export const setSeenIntroductionVideoMutation = createMutationFunction<
  SetSeenIntroductionVideoMutation,
  SetSeenIntroductionVideoMutationVariables,
  ApolloError
>(SetSeenIntroductionVideoDocument);

export const ProfileDocument = gql`
    query Profile {
  profile: me {
    ...UserParts
  }
}
    ${UserPartsFragmentDoc}`;

/**
 * __useProfileQuery__
 *
 * To use a Smart Query within a Vue component, call `useProfileQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     profile: useProfileQuery({
 *       variables: {},
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useProfileQuery = createSmartQueryOptionsFunction<
  ProfileQuery,
  ProfileQueryVariables,
  ApolloError
>(ProfileDocument);

export const UserSelectDocument = gql`
    query UserSelect {
  users {
    id
    title
    firstName
    lastName
    email
    avatar
    roles
  }
}
    `;

/**
 * __useUserSelectQuery__
 *
 * To use a Smart Query within a Vue component, call `useUserSelectQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     userSelect: useUserSelectQuery({
 *       variables: {},
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useUserSelectQuery = createSmartQueryOptionsFunction<
  UserSelectQuery,
  UserSelectQueryVariables,
  ApolloError
>(UserSelectDocument);

export const AcceptAllMicroTrendsDocument = gql`
    mutation AcceptAllMicroTrends($workspaceId: ID!, $searchAgentId: ID!, $searchAgentTrendType: SearchAgentTrendType!, $pageSize: Int!) {
  workspace(id: $workspaceId) {
    acceptSearchAgentTrends(
      input: {id: $searchAgentId, type: $searchAgentTrendType}
    ) {
      ...WorkspaceViewParts
    }
  }
}
    ${WorkspaceViewPartsFragmentDoc}`;

/**
 * __acceptAllMicroTrendsMutation__
 *
 * To run a mutation, you call `acceptAllMicroTrendsMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = acceptAllMicroTrendsMutation(this, {
 *   variables: {
 *     workspaceId: // value for 'workspaceId'
 *     searchAgentId: // value for 'searchAgentId'
 *     searchAgentTrendType: // value for 'searchAgentTrendType'
 *     pageSize: // value for 'pageSize'
 *   },
 * });
 */
export const acceptAllMicroTrendsMutation = createMutationFunction<
  AcceptAllMicroTrendsMutation,
  AcceptAllMicroTrendsMutationVariables,
  ApolloError
>(AcceptAllMicroTrendsDocument);

export const AcceptMicrotrendDocument = gql`
    mutation AcceptMicrotrend($workspaceId: ID!, $workspaceIds: [ID!]!, $nodeIds: [ID!]!) {
  addNodesToWorkspaces(input: {nodeIds: $nodeIds, workspaceIds: $workspaceIds}) {
    id
    title
    searchAgents {
      nodes {
        id
        trendCounts(workspaceId: $workspaceId) {
          new
          unvoted
          accepted
          rejected
        }
      }
    }
  }
}
    `;

/**
 * __acceptMicrotrendMutation__
 *
 * To run a mutation, you call `acceptMicrotrendMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = acceptMicrotrendMutation(this, {
 *   variables: {
 *     workspaceId: // value for 'workspaceId'
 *     workspaceIds: // value for 'workspaceIds'
 *     nodeIds: // value for 'nodeIds'
 *   },
 * });
 */
export const acceptMicrotrendMutation = createMutationFunction<
  AcceptMicrotrendMutation,
  AcceptMicrotrendMutationVariables,
  ApolloError
>(AcceptMicrotrendDocument);

export const AddNodesToWorkspacesDocument = gql`
    mutation addNodesToWorkspaces($nodeIds: [ID!]!, $workspaceIds: [ID!]!) {
  addNodesToWorkspaces(input: {nodeIds: $nodeIds, workspaceIds: $workspaceIds}) {
    id
    title
  }
}
    `;

/**
 * __addNodesToWorkspacesMutation__
 *
 * To run a mutation, you call `addNodesToWorkspacesMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = addNodesToWorkspacesMutation(this, {
 *   variables: {
 *     nodeIds: // value for 'nodeIds'
 *     workspaceIds: // value for 'workspaceIds'
 *   },
 * });
 */
export const addNodesToWorkspacesMutation = createMutationFunction<
  AddNodesToWorkspacesMutation,
  AddNodesToWorkspacesMutationVariables,
  ApolloError
>(AddNodesToWorkspacesDocument);

export const CopyWorkspaceDocument = gql`
    mutation copyWorkspace($id: ID!, $title: String!) {
  workspace(id: $id) {
    copy(title: $title) {
      id
      title
      description
      participants {
        nodes {
          ...WorkspaceUserParts
        }
      }
    }
  }
}
    ${WorkspaceUserPartsFragmentDoc}`;

/**
 * __copyWorkspaceMutation__
 *
 * To run a mutation, you call `copyWorkspaceMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = copyWorkspaceMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *     title: // value for 'title'
 *   },
 * });
 */
export const copyWorkspaceMutation = createMutationFunction<
  CopyWorkspaceMutation,
  CopyWorkspaceMutationVariables,
  ApolloError
>(CopyWorkspaceDocument);

export const CreateTrendradarDocument = gql`
    mutation createTrendradar($id: ID!) {
  workspace(id: $id) {
    createTrendRadar
  }
}
    `;

/**
 * __createTrendradarMutation__
 *
 * To run a mutation, you call `createTrendradarMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = createTrendradarMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export const createTrendradarMutation = createMutationFunction<
  CreateTrendradarMutation,
  CreateTrendradarMutationVariables,
  ApolloError
>(CreateTrendradarDocument);

export const CreateWorkspaceDocument = gql`
    mutation createWorkspace($input: WorkspaceInput!) {
  createWorkspace(input: $input) {
    id
    title
    description
    participants {
      nodes {
        ...WorkspaceUserParts
      }
    }
  }
}
    ${WorkspaceUserPartsFragmentDoc}`;

/**
 * __createWorkspaceMutation__
 *
 * To run a mutation, you call `createWorkspaceMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = createWorkspaceMutation(this, {
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export const createWorkspaceMutation = createMutationFunction<
  CreateWorkspaceMutation,
  CreateWorkspaceMutationVariables,
  ApolloError
>(CreateWorkspaceDocument);

export const DeleteWorkspaceDocument = gql`
    mutation deleteWorkspace($id: ID!) {
  workspace(id: $id) {
    delete
  }
}
    `;

/**
 * __deleteWorkspaceMutation__
 *
 * To run a mutation, you call `deleteWorkspaceMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = deleteWorkspaceMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export const deleteWorkspaceMutation = createMutationFunction<
  DeleteWorkspaceMutation,
  DeleteWorkspaceMutationVariables,
  ApolloError
>(DeleteWorkspaceDocument);

export const JoinWorkspaceDocument = gql`
    mutation joinWorkspace($id: ID!, $pageSize: Int = 50) {
  workspace(id: $id) {
    join {
      id
      participating
      participants(page: null, pageSize: $pageSize) {
        nodes {
          ...WorkspaceUserParts
        }
        pageInfo {
          totalCount
        }
      }
    }
  }
}
    ${WorkspaceUserPartsFragmentDoc}`;

/**
 * __joinWorkspaceMutation__
 *
 * To run a mutation, you call `joinWorkspaceMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = joinWorkspaceMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *     pageSize: // value for 'pageSize'
 *   },
 * });
 */
export const joinWorkspaceMutation = createMutationFunction<
  JoinWorkspaceMutation,
  JoinWorkspaceMutationVariables,
  ApolloError
>(JoinWorkspaceDocument);

export const LeaveWorkspaceDocument = gql`
    mutation leaveWorkspace($id: ID!) {
  workspace(id: $id) {
    leave
  }
}
    `;

/**
 * __leaveWorkspaceMutation__
 *
 * To run a mutation, you call `leaveWorkspaceMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = leaveWorkspaceMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export const leaveWorkspaceMutation = createMutationFunction<
  LeaveWorkspaceMutation,
  LeaveWorkspaceMutationVariables,
  ApolloError
>(LeaveWorkspaceDocument);

export const RejectAllMicroTrendsDocument = gql`
    mutation RejectAllMicroTrends($workspaceId: ID!, $searchAgentId: ID!, $searchAgentTrendType: SearchAgentTrendType!, $pageSize: Int!) {
  workspace(id: $workspaceId) {
    rejectSearchAgentTrends(
      input: {id: $searchAgentId, type: $searchAgentTrendType}
    ) {
      ...WorkspaceViewParts
    }
  }
}
    ${WorkspaceViewPartsFragmentDoc}`;

/**
 * __rejectAllMicroTrendsMutation__
 *
 * To run a mutation, you call `rejectAllMicroTrendsMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = rejectAllMicroTrendsMutation(this, {
 *   variables: {
 *     workspaceId: // value for 'workspaceId'
 *     searchAgentId: // value for 'searchAgentId'
 *     searchAgentTrendType: // value for 'searchAgentTrendType'
 *     pageSize: // value for 'pageSize'
 *   },
 * });
 */
export const rejectAllMicroTrendsMutation = createMutationFunction<
  RejectAllMicroTrendsMutation,
  RejectAllMicroTrendsMutationVariables,
  ApolloError
>(RejectAllMicroTrendsDocument);

export const RejectMicrotrendDocument = gql`
    mutation RejectMicrotrend($workspaceId: ID!, $microtrendId: ID!) {
  workspace(id: $workspaceId) {
    rejectMicrotrend(id: $microtrendId) {
      id
      title
      searchAgents {
        nodes {
          id
          trendCounts(workspaceId: $workspaceId) {
            new
            unvoted
            accepted
            rejected
          }
        }
      }
    }
  }
}
    `;

/**
 * __rejectMicrotrendMutation__
 *
 * To run a mutation, you call `rejectMicrotrendMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = rejectMicrotrendMutation(this, {
 *   variables: {
 *     workspaceId: // value for 'workspaceId'
 *     microtrendId: // value for 'microtrendId'
 *   },
 * });
 */
export const rejectMicrotrendMutation = createMutationFunction<
  RejectMicrotrendMutation,
  RejectMicrotrendMutationVariables,
  ApolloError
>(RejectMicrotrendDocument);

export const RemoveDocument = gql`
    mutation remove($workspaceId: ID!, $nodeIds: [ID!]!) {
  workspace(id: $workspaceId) {
    removeNodes(input: {ids: $nodeIds}) {
      id
    }
  }
}
    `;

/**
 * __removeMutation__
 *
 * To run a mutation, you call `removeMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = removeMutation(this, {
 *   variables: {
 *     workspaceId: // value for 'workspaceId'
 *     nodeIds: // value for 'nodeIds'
 *   },
 * });
 */
export const removeMutation = createMutationFunction<
  RemoveMutation,
  RemoveMutationVariables,
  ApolloError
>(RemoveDocument);

export const UpdateWorkspaceTrendPositionDocument = gql`
    mutation UpdateWorkspaceTrendPosition($id: ID!, $input: WorkspaceTrendPositionInput!) {
  workspace(id: $id) {
    setWorkspaceTrendPosition(input: $input) {
      id
    }
  }
}
    `;

/**
 * __updateWorkspaceTrendPositionMutation__
 *
 * To run a mutation, you call `updateWorkspaceTrendPositionMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = updateWorkspaceTrendPositionMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export const updateWorkspaceTrendPositionMutation = createMutationFunction<
  UpdateWorkspaceTrendPositionMutation,
  UpdateWorkspaceTrendPositionMutationVariables,
  ApolloError
>(UpdateWorkspaceTrendPositionDocument);

export const WorkspaceUnvoteDocument = gql`
    mutation WorkspaceUnvote($id: ID!, $trendId: ID!) {
  workspace(id: $id) {
    unvote(trendId: $trendId) {
      votes
      userVote
    }
  }
}
    `;

/**
 * __workspaceUnvoteMutation__
 *
 * To run a mutation, you call `workspaceUnvoteMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = workspaceUnvoteMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *     trendId: // value for 'trendId'
 *   },
 * });
 */
export const workspaceUnvoteMutation = createMutationFunction<
  WorkspaceUnvoteMutation,
  WorkspaceUnvoteMutationVariables,
  ApolloError
>(WorkspaceUnvoteDocument);

export const UpdateWorkspaceDocument = gql`
    mutation updateWorkspace($id: ID!, $input: WorkspaceInput!, $pageSize: Int = 50) {
  workspace(id: $id) {
    update(input: $input) {
      ...WorkspaceViewParts
    }
  }
}
    ${WorkspaceViewPartsFragmentDoc}`;

/**
 * __updateWorkspaceMutation__
 *
 * To run a mutation, you call `updateWorkspaceMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = updateWorkspaceMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *     pageSize: // value for 'pageSize'
 *   },
 * });
 */
export const updateWorkspaceMutation = createMutationFunction<
  UpdateWorkspaceMutation,
  UpdateWorkspaceMutationVariables,
  ApolloError
>(UpdateWorkspaceDocument);

export const UpdateUserSettingsDocument = gql`
    mutation updateUserSettings($id: ID!, $input: UpdateUserSettingsInput!) {
  workspace(id: $id) {
    updateUserSettings(input: $input) {
      notificationInterval
    }
  }
}
    `;

/**
 * __updateUserSettingsMutation__
 *
 * To run a mutation, you call `updateUserSettingsMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = updateUserSettingsMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export const updateUserSettingsMutation = createMutationFunction<
  UpdateUserSettingsMutation,
  UpdateUserSettingsMutationVariables,
  ApolloError
>(UpdateUserSettingsDocument);

export const WorkspaceVoteDocument = gql`
    mutation WorkspaceVote($id: ID!, $input: WorkspaceVoteInput!) {
  workspace(id: $id) {
    vote(input: $input) {
      votes
      userVote
    }
  }
}
    `;

/**
 * __workspaceVoteMutation__
 *
 * To run a mutation, you call `workspaceVoteMutation` within a Vue component and pass it
 * your Vue app instance along with any options that fit your needs.
 *
 * @param app, a reference to your Vue app instance (which must have a `$apollo` property)
 * @param options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate
 * @param client (optional), which can be an instance of `DollarApollo` or the `mutate()` function provided by an `<ApolloMutation>` component
 *
 * @example
 * const { success, data, errors } = workspaceVoteMutation(this, {
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export const workspaceVoteMutation = createMutationFunction<
  WorkspaceVoteMutation,
  WorkspaceVoteMutationVariables,
  ApolloError
>(WorkspaceVoteDocument);

export const DetailsShortDocument = gql`
    query detailsShort($id: ID!) {
  workspace: node(id: $id) {
    ... on Workspace {
      id
      title
      description
      participating
      private
      searchAgentsTrendCounts {
        new
        unvoted
      }
      trends(page: 1, pageSize: 5, sort: {field: createdAt, direction: desc}) {
        nodes {
          trend {
            ... on MicrotrendInterface {
              id
              images(width: 620, height: 280, resize: fit)
            }
            ... on MacrotrendInterface {
              id
              image(width: 620, height: 280, resize: fit)
            }
          }
        }
        pageInfo {
          totalCount
        }
      }
      searchAgents {
        nodes {
          id
          title
          trendCounts(workspaceId: $id) {
            new
            unvoted
            accepted
            rejected
          }
        }
      }
    }
  }
}
    `;

/**
 * __useDetailsShortQuery__
 *
 * To use a Smart Query within a Vue component, call `useDetailsShortQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     detailsShort: useDetailsShortQuery({
 *       variables: {
 *         id: // value for 'id'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useDetailsShortQuery = createSmartQueryOptionsFunction<
  DetailsShortQuery,
  DetailsShortQueryVariables,
  ApolloError
>(DetailsShortDocument);

export const WorkspaceEditDocument = gql`
    query workspaceEdit($id: ID!) {
  node(id: $id) {
    ... on Workspace {
      id
      title
      description
      private
      participants(page: 1, pageSize: 99) {
        nodes {
          ...WorkspaceUserParts
        }
      }
    }
  }
}
    ${WorkspaceUserPartsFragmentDoc}`;

/**
 * __useWorkspaceEditQuery__
 *
 * To use a Smart Query within a Vue component, call `useWorkspaceEditQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     workspaceEdit: useWorkspaceEditQuery({
 *       variables: {
 *         id: // value for 'id'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useWorkspaceEditQuery = createSmartQueryOptionsFunction<
  WorkspaceEditQuery,
  WorkspaceEditQueryVariables,
  ApolloError
>(WorkspaceEditDocument);

export const ExportUrlDocument = gql`
    query exportUrl($id: ID!, $sort: WorkspaceExportSort, $filter: WorkspaceTrendFilter) {
  workspaceXlsxExportUrl: node(id: $id) {
    ... on Workspace {
      id
      xlsxExportUrl(sort: $sort, filter: $filter)
    }
  }
}
    `;

/**
 * __useExportUrlQuery__
 *
 * To use a Smart Query within a Vue component, call `useExportUrlQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     exportUrl: useExportUrlQuery({
 *       variables: {
 *         id: // value for 'id'
 *         sort: // value for 'sort'
 *         filter: // value for 'filter'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useExportUrlQuery = createSmartQueryOptionsFunction<
  ExportUrlQuery,
  ExportUrlQueryVariables,
  ApolloError
>(ExportUrlDocument);

export const WorkspacesGalleryDocument = gql`
    query workspacesGallery($page: Int!, $pageSize: Int!, $type: WorkspaceTrendType) {
  workspaces(page: $page, pageSize: $pageSize) {
    nodes {
      id
      deprecatedMacrotrends {
        id
        translations {
          title
        }
      }
      title
      description
      updatedAt
      private
      participating
      participants(page: 1, pageSize: 5) {
        pageInfo {
          totalCount
        }
        nodes {
          ...WorkspaceUserParts
        }
      }
      trends(
        type: $type
        page: 1
        pageSize: 6
        sort: {field: createdAt, direction: desc}
      ) {
        pageInfo {
          totalCount
        }
        nodes {
          trend {
            ... on MicrotrendInterface {
              id
              images(width: 620, height: 280, gravity: sm)
            }
            ... on MacrotrendInterface {
              id
              image(width: 620, height: 280, gravity: sm)
            }
          }
        }
      }
      searchAgentsTrendCounts {
        new
        unvoted
      }
      ownerId
    }
    pageInfo {
      ...PaginatedPageInfoParts
    }
  }
}
    ${WorkspaceUserPartsFragmentDoc}
${PaginatedPageInfoPartsFragmentDoc}`;

/**
 * __useWorkspacesGalleryQuery__
 *
 * To use a Smart Query within a Vue component, call `useWorkspacesGalleryQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     workspacesGallery: useWorkspacesGalleryQuery({
 *       variables: {
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *         type: // value for 'type'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useWorkspacesGalleryQuery = createSmartQueryOptionsFunction<
  WorkspacesGalleryQuery,
  WorkspacesGalleryQueryVariables,
  ApolloError
>(WorkspacesGalleryDocument);

export const WorkspacesListDocument = gql`
    query workspacesList($page: Int!, $pageSize: Int!, $type: WorkspaceTrendType, $sort: WorkspaceSort) {
  workspaces(page: $page, pageSize: $pageSize, sort: $sort) {
    nodes {
      id
      deprecatedMacrotrends {
        id
        translations {
          title
        }
      }
      title
      description
      updatedAt
      private
      participating
      participants(page: 1, pageSize: 5) {
        pageInfo {
          totalCount
        }
        nodes {
          ...WorkspaceUserParts
        }
      }
      trends(
        type: $type
        page: 1
        pageSize: 1
        sort: {field: createdAt, direction: desc}
      ) {
        nodes {
          trend {
            ... on MicrotrendInterface {
              id
              images(width: 620, height: 280, resize: fit)
            }
            ... on MacrotrendInterface {
              id
              image(width: 620, height: 280, resize: fit)
            }
          }
        }
        pageInfo {
          totalCount
        }
      }
      searchAgentsTrendCounts {
        new
        unvoted
      }
    }
    pageInfo {
      ...PaginatedPageInfoParts
    }
  }
}
    ${WorkspaceUserPartsFragmentDoc}
${PaginatedPageInfoPartsFragmentDoc}`;

/**
 * __useWorkspacesListQuery__
 *
 * To use a Smart Query within a Vue component, call `useWorkspacesListQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     workspacesList: useWorkspacesListQuery({
 *       variables: {
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *         type: // value for 'type'
 *         sort: // value for 'sort'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useWorkspacesListQuery = createSmartQueryOptionsFunction<
  WorkspacesListQuery,
  WorkspacesListQueryVariables,
  ApolloError
>(WorkspacesListDocument);

export const WorkspacesOverviewDocument = gql`
    query workspacesOverview {
  workspaces(page: 1, pageSize: 6) {
    nodes {
      id
      title
      private
      participating
      searchAgentsTrendCounts {
        new
        unvoted
      }
      participants {
        nodes {
          ...WorkspaceUserParts
        }
        pageInfo {
          ...PaginatedPageInfoParts
        }
      }
    }
  }
}
    ${WorkspaceUserPartsFragmentDoc}
${PaginatedPageInfoPartsFragmentDoc}`;

/**
 * __useWorkspacesOverviewQuery__
 *
 * To use a Smart Query within a Vue component, call `useWorkspacesOverviewQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     workspacesOverview: useWorkspacesOverviewQuery({
 *       variables: {},
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useWorkspacesOverviewQuery = createSmartQueryOptionsFunction<
  WorkspacesOverviewQuery,
  WorkspacesOverviewQueryVariables,
  ApolloError
>(WorkspacesOverviewDocument);

export const SearchAgentsDocument = gql`
    query searchAgents($id: ID!, $page: Int, $pageSize: Int) {
  node(id: $id) {
    ... on Workspace {
      id
      title
      description
      searchAgents(page: $page, pageSize: $pageSize) {
        nodes {
          id
          title
          hasDeprecatedMacrotrends
          trendCounts(workspaceId: $id) {
            new
            unvoted
            accepted
            rejected
          }
        }
        pageInfo {
          ...PaginatedPageInfoParts
        }
      }
    }
  }
}
    ${PaginatedPageInfoPartsFragmentDoc}`;

/**
 * __useSearchAgentsQuery__
 *
 * To use a Smart Query within a Vue component, call `useSearchAgentsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     searchAgents: useSearchAgentsQuery({
 *       variables: {
 *         id: // value for 'id'
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useSearchAgentsQuery = createSmartQueryOptionsFunction<
  SearchAgentsQuery,
  SearchAgentsQueryVariables,
  ApolloError
>(SearchAgentsDocument);

export const WorkspaceTrendsDocument = gql`
    query workspaceTrends($id: ID!, $locale: Locale!, $type: WorkspaceTrendType, $page: Int, $pageSize: Int, $sort: WorkspaceTrendSort, $filter: WorkspaceTrendFilter, $width: Int, $height: Int) {
  node(id: $id) {
    ...TrendsParts
    ... on Workspace {
      id
      microtrend: trends(type: microtrend, filter: $filter) {
        pageInfo {
          totalCount
        }
      }
      macrotrend: trends(type: macrotrend) {
        pageInfo {
          totalCount
        }
      }
    }
  }
}
    ${TrendsPartsFragmentDoc}`;

/**
 * __useWorkspaceTrendsQuery__
 *
 * To use a Smart Query within a Vue component, call `useWorkspaceTrendsQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     workspaceTrends: useWorkspaceTrendsQuery({
 *       variables: {
 *         id: // value for 'id'
 *         locale: // value for 'locale'
 *         type: // value for 'type'
 *         page: // value for 'page'
 *         pageSize: // value for 'pageSize'
 *         sort: // value for 'sort'
 *         filter: // value for 'filter'
 *         width: // value for 'width'
 *         height: // value for 'height'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useWorkspaceTrendsQuery = createSmartQueryOptionsFunction<
  WorkspaceTrendsQuery,
  WorkspaceTrendsQueryVariables,
  ApolloError
>(WorkspaceTrendsDocument);

export const WorkspaceViewDocument = gql`
    query workspaceView($id: ID!, $pageSize: Int = 50) {
  workspace: node(id: $id) {
    ...WorkspaceViewParts
  }
}
    ${WorkspaceViewPartsFragmentDoc}`;

/**
 * __useWorkspaceViewQuery__
 *
 * To use a Smart Query within a Vue component, call `useWorkspaceViewQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     workspaceView: useWorkspaceViewQuery({
 *       variables: {
 *         id: // value for 'id'
 *         pageSize: // value for 'pageSize'
 *       },
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useWorkspaceViewQuery = createSmartQueryOptionsFunction<
  WorkspaceViewQuery,
  WorkspaceViewQueryVariables,
  ApolloError
>(WorkspaceViewDocument);

export const WorkspacesDocument = gql`
    query workspaces {
  workspaces(page: 1, pageSize: 250) {
    nodes {
      id
      title
      description
    }
    pageInfo {
      ...PaginatedPageInfoParts
    }
  }
}
    ${PaginatedPageInfoPartsFragmentDoc}`;

/**
 * __useWorkspacesQuery__
 *
 * To use a Smart Query within a Vue component, call `useWorkspacesQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     workspaces: useWorkspacesQuery({
 *       variables: {},
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useWorkspacesQuery = createSmartQueryOptionsFunction<
  WorkspacesQuery,
  WorkspacesQueryVariables,
  ApolloError
>(WorkspacesDocument);
